webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PaymentCanceled = exports.PaymentUnregistered = exports.PaymentRegistered = exports.PaymentDisputing = exports.PaymentSucceeded = exports.PaymentFailed = exports.PaymentOnTrial = undefined;
	
	var _keys = __webpack_require__(333);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularAnimate = __webpack_require__(371);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularUiRouter = __webpack_require__(373);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(448);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _bootstrapCssOnly = __webpack_require__(450);
	
	var _bootstrapCssOnly2 = _interopRequireDefault(_bootstrapCssOnly);
	
	var _components = __webpack_require__(459);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _pages = __webpack_require__(489);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _services = __webpack_require__(1329);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _directives = __webpack_require__(1341);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	var _auth = __webpack_require__(496);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _app = __webpack_require__(1349);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _angularUiNotification = __webpack_require__(1351);
	
	var _angularUiNotification2 = _interopRequireDefault(_angularUiNotification);
	
	var _angularSanitize = __webpack_require__(1353);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _ngCsv = __webpack_require__(1355);
	
	var _ngCsv2 = _interopRequireDefault(_ngCsv);
	
	__webpack_require__(1356);
	
	__webpack_require__(1357);
	
	__webpack_require__(1358);
	
	__webpack_require__(1489);
	
	var _angularMoment = __webpack_require__(1491);
	
	var _angularMoment2 = _interopRequireDefault(_angularMoment);
	
	var _momentTimezone = __webpack_require__(1492);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	__webpack_require__(1495);
	
	__webpack_require__(1496);
	
	__webpack_require__(1497);
	
	__webpack_require__(1499);
	
	__webpack_require__(1501);
	
	__webpack_require__(1509);
	
	__webpack_require__(1511);
	
	__webpack_require__(1513);
	
	__webpack_require__(1515);
	
	__webpack_require__(1516);
	
	__webpack_require__(1559);
	
	__webpack_require__(1560);
	
	var _ismobilejs = __webpack_require__(1562);
	
	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
	
	__webpack_require__(1563);
	
	__webpack_require__(1565);
	
	__webpack_require__(1566);
	
	__webpack_require__(1567);
	
	__webpack_require__(1576);
	
	__webpack_require__(1578);
	
	__webpack_require__(1580);
	
	var _angularTranslate = __webpack_require__(1581);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	__webpack_require__(1582);
	
	__webpack_require__(1583);
	
	__webpack_require__(1585);
	
	__webpack_require__(1586);
	
	__webpack_require__(1588);
	
	__webpack_require__(1590);
	
	__webpack_require__(1592);
	
	__webpack_require__(1594);
	
	__webpack_require__(1596);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var api_host = window.location.origin;
	
	var PaymentOnTrial = exports.PaymentOnTrial = 'T';
	var PaymentFailed = exports.PaymentFailed = 'F';
	var PaymentSucceeded = exports.PaymentSucceeded = 'C';
	var PaymentDisputing = exports.PaymentDisputing = 'X';
	var PaymentRegistered = exports.PaymentRegistered = 'R';
	var PaymentUnregistered = exports.PaymentUnregistered = 'U';
	var PaymentCanceled = exports.PaymentCanceled = 'Z';
	
	_angular2.default.module('app', [_angularUiRouter2.default, _angularUiBootstrap2.default, _components2.default, _pages2.default, _services2.default, _directives2.default, _angularMoment2.default, _angularAnimate2.default, _angularUiNotification2.default, _angularSanitize2.default, _ngCsv2.default, _angularTranslate2.default, 'validation', 'validation.rule', 'moment-picker', 'angularFileUpload', 'mwl.confirm', 'angular.filter', 'angular-loading-bar', 'satellizer', 'chart.js', 'fixed.table.header', 'ismobile', 'bw.paging', 'ngclipboard', 'vAccordion', 'ngFileSaver', 'angucomplete-alt', 'ngLoadingOverlay']).constant('ignoredForOverlay', ['pending-invitations', 'closing-hour', 'cashier-sales', 'orders', 'sessions', 'cashiers', 'profiles']).factory('AuthInterceptor', ["$q", "$injector", function ($q, $injector) {
	    "ngInject";
	
	    return {
	        request: function request(config) {
	            var AuthService = $injector.get('AuthService');
	            var $loadingOverlay = $injector.get('$loadingOverlay');
	            var shouldShowOverlay = !$injector.get('ignoredForOverlay').some(function (url) {
	                return config.url.includes(url);
	            });
	            var token = AuthService.getToken();
	            var accToken = AuthService.getAccountToken();
	            if (config.url.indexOf('/api/') > -1 && token) {
	                config.headers.Authorization = 'Bearer ' + token;
	            }
	            if (config.url.indexOf('/api/') > -1 && accToken) {
	                config.headers['X-Account-Token'] = accToken;
	            }
	            if (shouldShowOverlay || config.method !== "GET") {
	                $loadingOverlay.show();
	            }
	            return config;
	        },
	        response: function response(res) {
	            var AuthService = $injector.get('AuthService');
	            var $loadingOverlay = $injector.get('$loadingOverlay');
	            if (res.data.access_token) {
	                AuthService.saveToken(res.data.access_token);
	                delete res.data.access_token;
	            }
	            $loadingOverlay.hide();
	            return res;
	        }
	    };
	}]).factory('ErrorInterceptor', ["$q", "$injector", function ($q, $injector) {
	    "ngInject";
	
	    return {
	        request: function request(config) {
	            return config || $q.when(config);
	        },
	        responseError: function responseError(resp) {
	            var notify = $injector.get('Notification');
	            var $state = $injector.get('$state');
	            var excep = $injector.get('ExceptionsService');
	            var permissionService = $injector.get('ProfilePermissionsService');
	            var _ = $injector.get('$translate').instant;
	            var $loadingOverlay = $injector.get('$loadingOverlay');
	
	            if (resp && resp.status && resp.status == 401) {
	                notify.info(_('Su sesión ha expirado.'));
	                $state.go('login');
	
	                return $q.reject(resp);
	            }
	
	            if (resp && resp.data && resp.data.code) {
	                if (resp.data.code === 'PAYMENT_PENDING') {
	                    if (![PaymentOnTrial, PaymentRegistered, PaymentSucceeded].includes(resp.data.payment_status)) {
	                        if (permissionService.hasPermission('manage-subscription')) {
	                            $state.go(resp.data.payment_status === PaymentUnregistered ? 'accountSubscription' : 'accountInformation', { activeTab: 3 });
	                        } else {
	                            localStorage.removeItem('accToken');
	                            localStorage.removeItem('accPayStatus');
	                            localStorage.removeItem('currentProfile');
	
	                            $state.go('paymentNotice');
	                        }
	                    }
	
	                    return $q.reject(resp);
	                }
	
	                notify.error(excep.getErrorMessage(resp.data.code));
	            } else if (resp && resp.data && resp.data.msg) {
	                notify.error(resp.data.msg);
	            } else if (resp && resp.data && resp.data.errors) {
	                notify.error(_('El formulario no ha podido ser validado, intente nuevamente.'));
	            } else {
	                notify.error(_("Ha ocurrido un error con nuestros servidores, estará siendo resuelto en la mayor brevedad posible."));
	            }
	
	            $loadingOverlay.hide();
	            return $q.reject(resp);
	        }
	    };
	}]).factory('PaymentNotificationInterceptor', ["$q", "$injector", function ($q, $injector) {
	    "ngInject";
	
	    return {
	        request: function request(config) {
	            return config || $q.when(config);
	        },
	        response: function response(resp) {
	            var notify = $injector.get('Notification');
	            var suscriptionService = $injector.get('SubscriptionService');
	            var localStorage = $injector.get('$window').localStorage;
	
	            var status = resp.data.payment_status;
	            var trialPeriodEnding = resp.data.on_trial_until || undefined;
	            if (status) {
	                localStorage.accPayStatus = status;
	                localStorage.trialPeriodEnding = trialPeriodEnding;
	
	                suscriptionService.updatePaymentStatus(status);
	            }
	
	            return resp;
	        }
	    };
	}]).value('host', api_host).component('app', _app2.default).constant('moment', _momentTimezone2.default).filter('capitalise', function () {
	    return function (token) {
	        return token.split(' ').map(function (word) {
	            return word.replace(/\b\w/g, function (l) {
	                return l.toUpperCase();
	            });
	        }).join(' ');
	    };
	}).config(["$locationProvider", "$validationProvider", "$httpProvider", "$stateProvider", "$urlRouterProvider", "cfpLoadingBarProvider", "NotificationProvider", "$authProvider", "ChartJsProvider", "$windowProvider", "$translateProvider", "$compileProvider", "$loadingOverlayConfigProvider", function ($locationProvider, $validationProvider, $httpProvider, $stateProvider, $urlRouterProvider, cfpLoadingBarProvider, NotificationProvider, $authProvider, ChartJsProvider, $windowProvider, $translateProvider, $compileProvider, $loadingOverlayConfigProvider) {
	    "ngInject";
	
	    var enTranslation = __webpack_require__(1598);
	    var esTranslation = __webpack_require__(1599);
	    var frTranslation = __webpack_require__(1600);
	
	    var _window = $windowProvider.$get();
	    _window.isMobile = _ismobilejs2.default;
	
	    $loadingOverlayConfigProvider.defaultConfig('<!-- 1 -->\n        <div class="loader loader--style1" title="Loading...">\n         <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n          width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">\n         <path opacity="0.2" fill="#FF" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n           s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n           c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>\n         <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n           C22.32,8.481,24.301,9.057,26.013,10.047z">\n           <animateTransform attributeType="xml"\n             attributeName="transform"\n             type="rotate"\n             from="0 20 20"\n             to="360 20 20"\n             dur="0.5s"\n             repeatCount="indefinite"/>\n           </path>\n         </svg>\n        </div>');
	
	    $translateProvider.translations('es', esTranslation).translations('en', enTranslation).translations('fr', frTranslation).useSanitizeValueStrategy('escape').uniformLanguageTag('bcp47').determinePreferredLanguage(function () {
	        var locale = window.localStorage.userLanguage || window.navigator.language.split('-')[0];
	        return locale.toLowerCase();
	    }).fallbackLanguage('es');
	
	    $locationProvider.html5Mode(true).hashPrefix('!');
	    $validationProvider.showSuccessMessage = false;
	    $httpProvider.interceptors.push('AuthInterceptor');
	    $httpProvider.interceptors.push('ErrorInterceptor');
	    $httpProvider.interceptors.push('PaymentNotificationInterceptor');
	
	    $validationProvider.setExpression({
	        phone: /^$|^(\d{3}-?\d{3}-?\d{4})/,
	        url: /^$|((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
	        email: /^$|^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
	    });
	    $validationProvider.setDefaultMsg({
	        required: {
	            error: 'Este campo es requerido'
	        },
	        url: {
	            error: 'Debe digitar una URL valida'
	        },
	        email: {
	            error: 'Debe digitar un correo valido'
	        },
	        phone: {
	            error: 'Formato valido: 809-555-5555'
	        },
	        number: {
	            error: 'Debe digitar solo números'
	        },
	        minlength: {
	            error: 'Debe ser un dígito mayor'
	        },
	        maxlength: {
	            error: 'Debe ser un dígito menor'
	        }
	    });
	
	    $validationProvider.setValidMethod('watch');
	
	    $validationProvider.setErrorHTML(function (msg, element, attrs) {
	        return '<span class="text-danger text_danger_position animated fadeIn">' + msg + '</span>';
	    });
	    $urlRouterProvider.otherwise(function ($injector, $location) {
	        if ($location.path().toLowerCase() === '/') {
	            if ((0, _keys2.default)($location.search()).length > 0) return;
	            return '/login';
	        }
	        return '/404';
	    });
	
	    cfpLoadingBarProvider.includeSpinner = false;
	
	    NotificationProvider.setOptions({
	        startTop: 85
	    });
	
	    $authProvider.google({
	        url: api_host + '/api/auth/google',
	        clientId: '1092965499756-3cgtbkcq1a4mfpbojplhq4clgnpgb3go.apps.googleusercontent.com'
	    });
	    _window.stripe = _window.Stripe('pk_live_E9pFvsJq3tK84bYXYORZGn6l');
	    $compileProvider.debugInfoEnabled(false);
	
	    // if ('serviceWorker' in navigator) {
	    //     navigator.serviceWorker.register('service-worker.js')
	    //         .then(resp => console.log(`Service Worker registered in ${resp.scope}`));
	    // }
	}]).run(["$transitions", "amMoment", "$window", function ($transitions, amMoment, $window) {
	    "ngInject";
	
	    amMoment.changeLocale(($window.localStorage.userLanguage || $window.navigator.userLanguage || $window.navigator.language).toLowerCase());
	
	    $transitions.onBefore({
	        to: function to(state) {
	            return ['paymentNotice', 'profileSelection', 'accountRegistration', 'userControl', 'login', 'pendingInvitations', 'register', 'passwordRequest', 'passwordRecovery', 'recoverySuccess', 'requestSuccess'].indexOf(state.name) === -1;
	        }
	    }, function (trans) {
	        var auth = trans.injector().get('AuthService');
	        var service = trans.injector().get('ProfilePermissionsService');
	        if (!auth.isAuthenticated()) {
	            return trans.router.stateService.target('login');
	        }
	        if (!service.hasProfiles()) {
	            return trans.router.stateService.target('accountRegistration');
	        }
	        if (auth.isAuthenticated() && !service.getProfile()) {
	            return trans.router.stateService.target('profileSelection');
	        }
	    });
	
	    $transitions.onBefore({
	        to: 'login'
	    }, function (trans) {
	        var auth = trans.injector().get('AuthService');
	        var service = trans.injector().get('ProfilePermissionsService');
	        if (auth.isAuthenticated()) {
	            if (!!auth.getAccountToken()) {
	                var role = auth.getAccountRole();
	                if (role == 'ADMIN' || role == 'MASTER') {
	                    return trans.router.stateService.target('userControl');
	                } else {
	                    return trans.router.stateService.target('dashboard');
	                }
	            } else {
	                if (!service.hasProfiles()) {
	                    return trans.router.stateService.target('accountRegistration');
	                }
	
	                return trans.router.stateService.target('profileSelection');
	            }
	        }
	    });
	
	    $transitions.onBefore({
	        to: 'register'
	    }, function (trans) {
	        var auth = trans.injector().get('AuthService');
	        if (auth.isAuthenticated()) {
	            return trans.router.stateService.target('dashboard');
	        }
	    });
	
	    $transitions.onBefore({
	        to: function to(state) {
	            return state.data && state.data.authRequired;
	        }
	    }, function (trans) {
	        var auth = trans.injector().get('AuthService');
	        var window = trans.injector().get('$window');
	        if (!auth.isAuthenticated()) {
	            window.localStorage.removeItem('jwtToken');
	            window.localStorage.removeItem('accToken');
	            return trans.router.stateService.target('login');
	            // } else if (auth.isAuthenticated() && !auth.hasAccount()){
	            //     return trans.router.stateService.target('profileSelection');
	        }
	    });
	
	    $transitions.onBefore({
	        to: function to(state) {
	            return state.data && state.data.authRequired && state.data.adminAccountRequired;
	        }
	    }, function (trans) {
	        var auth = trans.injector().get('AuthService');
	        var window = trans.injector().get('$window');
	        var role = auth.getAccountRole();
	        if (!(role == 'ADMIN' || role == 'MASTER')) {
	            window.localStorage.removeItem('jwtToken');
	            window.localStorage.removeItem('accToken');
	            return trans.router.stateService.target('login');
	        }
	    });
	
	    $transitions.onBefore({
	        to: function to(state) {
	            return state.data && state.data.permsRequired && state.data.permsRequired.length > 0;
	        }
	    }, function (trans) {
	        var service = trans.injector().get('ProfilePermissionsService');
	        var notify = trans.injector().get('Notification');
	        var $q = trans.injector().get('$q');
	        var $state = trans.injector().get('$state');
	        var permsRequired = trans.to().data.permsRequired;
	        var hasPerm = service.isAdmin() || service.hasAtLeastOneOf(permsRequired);
	
	        if (!hasPerm) {
	            if (trans.from() == trans.to()) {
	                return $state.target('dashboard');
	            } else {
	                notify.warning({
	                    message: "No tiene permiso para acceder a esta funcionalidad, contacte a su administrador."
	                });
	                return $q(function (resolve, reject) {
	                    reject();
	                });
	            }
	        } else {
	            return $q(function (resolve, reject) {
	                resolve();
	            });
	        }
	    });
	    $transitions.onBefore({
	        to: function to(state) {
	            return state.data && !state.data.paymentExempt;
	        }
	    }, function (trans) {
	        var localStorage = trans.injector().get('$window').localStorage;
	        var status = localStorage.getItem('accPayStatus');
	        var service = trans.injector().get('ProfilePermissionsService');
	        var $state = trans.injector().get('$state');
	        var authService = trans.injector().get('AuthService');
	
	        var role = authService.getAccountRole();
	        if (role == 'ADMIN' || role == 'MASTER') {
	            return $state.target('userControl');
	        }
	
	        if (![PaymentOnTrial, PaymentRegistered, PaymentSucceeded].includes(status)) {
	            if (service.hasPermission('manage-subscription')) {
	                if (status === PaymentUnregistered) {
	                    return $state.target('accountSubscription');
	                }
	
	                return $state.target('accountInformation', {
	                    activeTab: 3
	                });
	            } else {
	                localStorage.removeItem('accToken');
	                localStorage.removeItem('accPayStatus');
	                localStorage.removeItem('currentProfile');
	
	                return $state.target('paymentNotice');
	            }
	        };
	    });
	}]);

/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _menu = __webpack_require__(460);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _adminMenu = __webpack_require__(472);
	
	var _adminMenu2 = _interopRequireDefault(_adminMenu);
	
	var _countries = __webpack_require__(478);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _timezones = __webpack_require__(483);
	
	var _timezones2 = _interopRequireDefault(_timezones);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.componentModule', [_menu2.default, _adminMenu2.default, _countries2.default, _timezones2.default]).name;
	
	exports.default = componentModule;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _menu = __webpack_require__(462);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuModule = _angular2.default.module('menu', [_angularjs2.default]).component('menu', _menu2.default).name;
	
	exports.default = menuModule;

/***/ }),
/* 461 */,
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menu = __webpack_require__(463);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _menu3 = __webpack_require__(464);
	
	var _menu4 = _interopRequireDefault(_menu3);
	
	__webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuComponent = {
	  bindings: {
	    profiles: '<',
	    closingHour: '<'
	  },
	  template: _menu2.default,
	  controller: _menu4.default
	};
	
	exports.default = menuComponent;

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	module.exports = " <nav class=\"navbar navbar-fixed-top headerbar\">\n    <div class=\"container-fluid\">\n        <a class=\"navbar-brand hidden-sm hidden-xs\" ui-sref=\"dashboard\">\n        <img class=\"pi-circle\" src=\"img/pi_logo.svg\">\n        </a>\n        <!-- <div class=\"menu_icon\" ng-click=\"menuOpened = !menuOpened\" ng-class=\"{'open': menuOpened}\" menu-trigger>\n                <span></span>\n            </div> \n        -->\n        <div class=\"menu-icon\" ng-click=\"menuOpened = !menuOpened\"\n            ng-class=\"{'effect1': menuOpened}\" menu-trigger>\n            <div class=\"menu-icon-line\"></div>\n        </div>\n        <div class=\"user_access\">\n            <div uib-dropdown>\n                <div class=\"user_info\" uib-dropdown-toggle auto-close=\"outsideClick\">\n                    <i class=\"fa fa-user\" aria-hidden=\"true\"></i>\n                </div>\n                <span class=\"pull-right user_basic_infos text-right\">\n                    {{$ctrl.currentProfile.account_name}}<br><small class=\"user_time\">{{ $ctrl.actualDate | amUtc | amDateFormat:'LL' }}</small>\n                </span>\n                <ul uib-dropdown-menu class=\"dropdown-menu user_drop\" ng-class=\"{'manageable_height':$ctrl.profiles.length >= 17 }\">\n\n                    <li ng-repeat=\"profile in $ctrl.profiles\" class=\"clickable\"\n                            ng-click=\"$ctrl.useProfile(profile.account_id)\" ng-if=\"profile.is_active\">\n                        <a>\n                            {{ profile.account_name }}\n                        </a>\n                    </li>\n                    <li role=\"separator\" class=\"divider\"></li>\n                    <li>\n                        <a ui-sref=\"accountInformation\" ng-click=\"\">\n                            <i class=\"fa fa-info-circle\"></i> {{'Información de cuenta' | translate}}\n                        </a>\n                    </li>\n                    <li>\n                        <a ng-click=\"$ctrl.logout()\">\n                            <i class=\"fa fa-power-off\"></i> {{'Salir' | translate}}\n                        </a>\n                    </li>\n                </ul>\n            </div>  \n        </div>\n        <div class=\"user_access\">\n            <div uib-dropdown>\n                <div ng-class=\"{'bell_notification': $ctrl.invitationsPending.length > 0, 'bell_non': $ctrl.invitationsPending.length == 0}\" ng-disabled=\"$ctrl.invitationsPending.length == 0\" uib-dropdown-toggle auto-close=\"outsideClick\" >\n                    <i class=\"fa fa-bell\" aria-hidden=\"true\"></i>\n                </div>\n                <ul uib-dropdown-menu class=\"notification-menu bell_drop\">\n                    <li ng-repeat=\"invitation in $ctrl.invitationsPending track by $index\" >\n                        <a ng-click=\"$ctrl.acceptInvitation(invitation, $index)\">\n                            <i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> {{'Invitación pendiente de' | translate}} {{invitation.account_name}}\n                        </a>\n                    </li>\n                </ul>\n            </div>  \n        </div>\n        <span class=\"label label-danger pull-right mt-3 mr-3 bagforpay\" ng-if=\"$ctrl.isPaymentPending\" if-perm show-if=\"manage-subscription\">\n            <a ui-sref=\"accountInformation({activeTab: 3})\">{{ 'Pago Pendiente' | translate }}</a>\n        </span>\n        <span class=\"label label-warning pull-right mt-3 mr-3 bagforpay\" ng-if=\"$ctrl.isOnTrial\" if-perm show-if=\"manage-subscription\">\n            <a ui-sref=\"accountInformation({activeTab: 3})\">\n                {{ 'Suscribete antes de' | translate }}\n                <br /><i>{{ $ctrl.trialPeriodEnding | amUtc | amDateFormat:'LL' }}</i>\n            </a>\n        </span>\n\n\n    </div>\n</nav>\n<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-sm-3 col-md-2 sidebar_custom\" ng-class=\"{'sidebar_custom_m': !menuOpened}\" tap-outside=\"menuOpened = !menuOpened\" hidden-class=\"sidebar_custom_m\">\n            <div class=\"nav_circle_logo\">\n                <span>\n                    <a ui-sref=\"dashboard\">\n                        <img class=\"pi-circle-menu visible-xs visible-sm\" src=\"img/pi_logo_white.svg\">\n                    </a>\n                </span>\n            </div>\n            <v-accordion class=\"vAccordion--default menu-acordion\">\n                <v-pane>\n                    <v-pane-header class=\"vpersonclass\">\n                        <span><i><img src=\"img/report-icon.svg\" alt=\"\"></i>{{'Reportes' | translate}}</span>\n                    </v-pane-header>\n                    <v-pane-content class=\"vpersonclasscontent\">\n                        <ul if-perm show-if=\"sales-report, products-statistics, oth-bills, account-bills, products-list, sales-by-vendor\">\n                            <li ui-sref-active='active'><a ui-sref=\"salesReport\" href=\"#\" title=\"Ventas\" if-perm show-if=\"sales-report\">{{'Ventas' | translate}}</a></li>\n                            <li ui-sref-active=\"active\"><a ui-sref=\"salesDetailsReport\" href=\"#\" title=\"Detalles de Ventas\" if-perm show-if=\"sales-report\">{{'Detalles de Ventas' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"salesByProducts\" href=\"#\" title=\"Ventas por Articulos\" if-perm show-if=\"products-statistics\">{{'Ventas por Artículos' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"oth\" href=\"#\" title=\"Desc.s/OTH\" if-perm show-if=\"oth-bills\">{{'Desc.s/OTH' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"findInvoice\" href=\"#\" title=\"Localización de Facturas\" if-perm show-if=\"account-bills\">{{'Localización de Facturas' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"listArticles\" href=\"#\" title=\"Listado de Articulos\" if-perm show-if=\"products-list\">{{'Listado de Artículos' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"salesByVendor\" href=\"#\" title=\"Ventas por Vendedor\" if-perm show-if=\"sales-by-vendor\">{{'Ventas por Vendedor' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"printedUnclosed\" href=\"#\" title=\"Facturas sin cerrar\" if-perm show-if=\"sales-by-vendor\">{{'Facturas sin cerrar' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"paymentOnly\" href=\"#\" title=\"Facturas de pago único\" if-perm show-if=\"sales-by-vendor\">{{'Facturas de pago único' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"dailyClosing\" href=\"#\" title=\"Cierre diario\" if-perm show-if=\"daily-closing\">{{'Cierre diario' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"printedBills\" href=\"#\" title=\"Facturas impresas\">{{'Facturas impresas' | translate}}</a></li>\n                            <li ui-sref-active=\"active\"><a ui-sref=\"salesBySubfamily\" href=\"#\"  title=\"Ventas por etiquetas\">{{'Ventas por etiquetas' | translate}}</a></li>\n                            <li ui-sref-active=\"active\"><a ui-sref=\"salesByFiscalNumber\" href=\"#\" title=\"Ventas por Tipo de Comprobante\">{{'Ventas por Tipo de Comprobante' | translate}}</a></li>\n                        </ul>\n                    </v-pane-content>\n                </v-pane>\n\n                <v-pane>\n                    <v-pane-header class=\"vpersonclass\">\n                        <i><img src=\"img/print-icon.svg\" alt=\"\"></i> {{'Impresora Fiscal' | translate}}\n                    </v-pane-header>\n                    <v-pane-content class=\"vpersonclasscontent\">\n                        <ul>\n                            <li ui-sref-active='active'><a ui-sref=\"invoiceNcf\" href=\"#\" title=\"Ncf de Facturas\" if-perm show-if=\"view-ncf, create-ncf\">{{'NCF de Facturas' | translate}}</a></li>\n                            <li ui-sref-active='active'>\n                                <a ui-sref=\"fiscalSalesAnalyser\" href=\"#\" title=\"Analizador de Archivos\" if-perm show-if=\"sales-analyser\">{{'Analizador de Archivos' | translate}}</a>\n                            </li>\n                            <li ui-sref-active='active'>\n                                <a ui-sref=\"fiscalSalesZreport\" href=\"#\" title=\"Reporte Z\" if-perm show-if=\"sales-zreport\">{{'Reporte Z' | translate}}</a>\n                            </li>\n                        </ul>\n                    </v-pane-content>\n                </v-pane>\n\n                <v-pane>\n                    <v-pane-header class=\"vpersonclass\">\n                        <i><img src=\"img/data-icon.svg\" alt=\"\"></i> {{'Datos' | translate}}\n                    </v-pane-header>\n                    <v-pane-content class=\"vpersonclasscontent\">\n                        <ul if-perm show-if=\"view-backup, upload-backup, view-dtt, upload-dtt, process-dtts\">\n                            <li ui-sref-active='active'><a ui-sref=\"backups\" href=\"#\" title=\"Backups\" if-perm show-if=\"view-backup, upload-backup\">{{'Backups' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"dtts\" href=\"#\" title=\"Dtts\" if-perm show-if=\"view-dtt, upload-dtt, process-dtts\">{{'Dtts' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"rawMaterials\" href=\"#\" title=\"Materias Brutas\" if-perm show-if=\"view-materials\">{{'Materias Primas' | translate}}</a></li>                            \n                            <li ui-sref-active='active'><a ui-sref=\"collected\" href=\"#\" title=\"Dtts Colectados\" if-perm show-if=\"view-dtt, upload-dtt, process-dtts\">{{'Journals Colectados' | translate}}</a></li>\n                        </ul>\n                    </v-pane-content>\n                </v-pane>\n\n                <v-pane>\n                    <v-pane-header class=\"vpersonclass\">\n                        <i><img src=\"img/config-icon.svg\" alt=\"\"></i> {{'Configuración' | translate}}\n                    </v-pane-header>\n                    <v-pane-content class=\"vpersonclasscontent\">\n                        <ul if-perm show-if=\"invite-user, view-profiles, manage-perms, view-closing-hour, view-pos, register-pos\">\n                            <li ui-sref-active='active'><a ui-sref=\"pointOfSales\" href=\"#\" title=\"Puntos de Ventas\" if-perm show-if=\"view-pos, register-pos\">{{'Puntos de Ventas' | translate}}</a></li>\n                            <li ui-sref-active=\"active\"><a ui-sref=\"handies\" href=\"#\" title=\"Handies\" if-perm show-if=\"view-handies\">{{'Handies' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"collectors\" href=\"#\" title=\"Colectores\" if-perm show-if=\"view-collectors, register-collectors\">{{'Colectores' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ng-click=\"$ctrl.openModalClosingHour()\" href=\"#\" title=\"Horario de Cierre\" if-perm show-if=\"view-closing-hour\">{{'Horario de Cierre' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"permissions\" href=\"#\" title=\"Ver Usuarios\" if-perm show-if=\"invite-user, view-profiles, manage-perms\">{{'Administrar Usuarios' | translate}}</a></li>\n                            <li ui-sref-active='active'><a ui-sref=\"inviteUsers\" href=\"#\" title=\"Ver Usuarios\" if-perm show-if=\"invite-user, view-profiles, manage-perms\">{{'Invitar Usuarios' | translate}}</a></li>\n                        </ul>\n                    </v-pane-content>\n                </v-pane>\n            </v-accordion>\n\n\n        <div class=\"user_language_icon\">\n            <div uib-dropdown>\n                <div class=\"user_language\" uib-dropdown-toggle auto-close=\"outsideClick\">\n                    <i class=\"fa fa-globe\" aria-hidden=\"true\"></i>\n                </div>\n                <ul uib-dropdown-menu class=\"dropdown-menu language_drop\">\n                    <li ng-class=\"{'language_active': $ctrl.userLanguage=='es'}\">\n                        <a ng-click=\"$ctrl.changeLanguage('es')\">\n                            ES\n                        </a>\n                    </li>\n                    <li ng-class=\"{'language_active': $ctrl.userLanguage=='en'}\">\n                        <a ng-click=\"$ctrl.changeLanguage('en')\">\n                            EN\n                        </a>\n                    </li>\n                    <li ng-class=\"{'language_active': $ctrl.userLanguage=='fr'}\">\n                        <a ng-click=\"$ctrl.changeLanguage('fr')\">\n                            FR\n                        </a>\n                    </li>\n\n                </ul>\n            </div>  \n        </div>\n        </div>\n    </div>\n</div>\n\n<script type='text/ng-template' id=\"closing-hour-template.html\">\n\t<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t{{'Horario de Cierre' | translate}}\n            <a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    </h3>\n  </div>\n  <div class=\"modal-body\" id=\"modal-body\">\n\t\t<form name=\"closingHourForm\" novalidate>\t\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"description\">{{'Hora de Corte' | translate}}: </label>\n\t\t\t\t<select name=\"closingHour\" ng-model=\"hour\" validator=\"required\" class=\"form-control input_py\">\t\n\t\t\t\t\t<option value=\"01:00\">01:00 / 1am</option>\n\t\t\t\t\t<option value=\"02:00\">02:00 / 2am</option>\n\t\t\t\t\t<option value=\"03:00\">03:00 / 3am</option>\n\t\t\t\t\t<option value=\"04:00\">04:00 / 4am</option>\n\t\t\t\t\t<option value=\"05:00\">05:00 / 5am</option>\n\t\t\t\t\t<option value=\"06:00\">06:00 / 6am</option>\n\t\t\t\t\t<option value=\"07:00\">07:00 / 7am</option>\n\t\t\t\t\t<option value=\"08:00\">08:00 / 8am</option>\n\t\t\t\t\t<option value=\"09:00\">09:00 / 9am</option>\n\t\t\t\t\t<option value=\"10:00\">10:00 / 10am</option>\n\t\t\t\t\t<option value=\"11:00\">11:00 / 11am</option>\n\t\t\t\t\t<option value=\"12:00\">12:00 / 12am</option>\n\t\t\t\t\t<option value=\"13:00\">13:00 / 1pm</option>\n\t\t\t\t\t<option value=\"14:00\">14:00 / 2pm</option>\n\t\t\t\t\t<option value=\"15:00\">15:00 / 3pm</option>\n\t\t\t\t\t<option value=\"16:00\">16:00 / 4pm</option>\n\t\t\t\t\t<option value=\"17:00\">17:00 / 5pm</option>\n\t\t\t\t\t<option value=\"18:00\">18:00 / 6pm</option>\n\t\t\t\t\t<option value=\"19:00\">19:00 / 7pm</option>\n\t\t\t\t\t<option value=\"20:00\">20:00 / 8pm</option>\n\t\t\t\t\t<option value=\"21:00\">21:00 / 9pm</option>\n\t\t\t\t\t<option value=\"22:00\">22:00 / 10pm</option>\n\t\t\t\t\t<option value=\"23:00\">23:00 / 11pm</option>\n\t\t\t\t\t<option value=\"24:00\">24:00 / 12pm</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar pull-right\" validation-submit=\"closingHourForm\" \n\t\t\t\tng-click=\"updateHour()\" if-perm disable-if=\"edit-closing-hour\">{{'Actualizar' | translate}}\n\t\t</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n\t</div>\n</script>\n\n<script type='text/ng-template' id=\"invite-user-template.html\">\n\t<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t{{'Invitar Usuario' | translate}}\n            <a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    </h3>\n  </div>\n  <div class=\"modal-body\" id=\"modal-body\">\n\t\t<form name=\"inviteForm\" novalidate>\t\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"description\">{{'Email' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"email\" ng-model=\"emails\" class=\"form-control input_py\" placeholder=\"Email (pueden ser varios separados por coma)\" \n                    validator=\"multiemail,required\" autofocus>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar pull-right\" validation-submit=\"inviteForm\" \n\t\t\t\tng-click=\"inviteUser()\"  if-perm disable-if=\"invite-user\">{{'Enviar' | translate}}\n\t\t</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n\t</div>\n</script>\n\n\n<script type='text/ng-template' id=\"account-profiles-template.html\">\n    <div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">\n            {{'Usuarios en esta Cuenta' | translate}}\n    </h3>\n  </div>\n  <div class=\"modal-body\" id=\"modal-body\">\n        <table id=\"bootstrap-table\" class=\"table table-hover\">\n            <thead>\n                <tr>\n                    <th>{{'Nombre' | translate}}</th>\n                    <th>{{'Correo Electronico' | translate}}</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat=\"profile in accountProfiles\">\n                    <td data-label=\"Nombre\">{{ profile.name }}</td>\n                    <td data-label=\"Correo Electronico\">{{ profile.email }}</td>\n                    <!--<td class=\"td-actions text-right\" >\n                        <div class=\"table-icons text-right\">\n                            <button rel=\"tooltip\" title=\"\"\n                                class=\"btn btn-simple btn-danger btn-icon\"\n                                mwl-confirm\n                                title=\"'¿Esta seguro?'\"\n                                message=\"ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?\"\n                                confirm-text=\"Eliminar\"\n                                cancel-text=\"Cancelar\"\n                                placement=\"left\"\n                                on-confirm=\"$ctrl.removeProfile(profile)\"\n                                on-cancel=\"\"\n                                confirm-button-type=\"danger\"\n                                cancel-button-type=\"default\">\n                                <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                            </button>\n                        </div>\n                    </td>-->\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n    </div>\n</script>\n\n<script type='text/ng-template' id=\"grace-period-end-notice-template.html\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" id=\"modal-title\">\n            {{'Qué bueno que estes aquí'|translate}}\n        </h3>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n        <p>Estamos super contentos de que estes con nosotros y de que nuestro sistema haya sido de utilidad para ti.</p>\n        <p>Estamos comprometidos con estar siempre aquí para ti y ahora iniciamos una nueva etapa en la que estaremos mejorando nuestros servicios para poder brindarte una mejor experiencia.</p>\n        <p>\n            <i>Tu tiempo de prueba ya ha caducado, por eso es necesario que actualices tu información de pago antes del<i>\n            <strong>{{ trialPeriodEnding | amUtc | amDateFormat:'LL' }}</strong>.\n        </p>\n        <p>Gracias!</p>\n    </div>\n    <div class=\"modal-footer\" ng-if=\"canPaySubscription\">\n        <button type=\"button\" class=\"btn btn-primary btn_standar\" ng-click=\"navigateToPayments()\">{{'Subscribirme'|translate}}</button>\n    </div>\n</script>"

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _app = __webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuController = function () {
	  function menuController($state, AuthService, $window, LoginService, $uibModal, ContentService, Notification, moment, $validation, ProfilePermissionsService, $translate, amMoment, SubscriptionService, AccountInformationService) {
	    (0, _classCallCheck3.default)(this, menuController);
	
	    this.state = $state;
	    this.AuthService = AuthService;
	    this.$window = $window;
	    this.LoginService = LoginService;
	    this.modal = $uibModal;
	    this.service = ContentService;
	    this.notify = Notification;
	    this.moment = moment;
	    this.permissionsService = ProfilePermissionsService;
	    this.trans = $translate;
	    this.am = amMoment;
	    this.suscriptionService = SubscriptionService;
	    this.accountService = AccountInformationService;
	  }
	
	  (0, _createClass3.default)(menuController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.actualDate = this.moment();
	
	      this.subscriptions.push(this.LoginService.getUserProfiles().subscribe(function (profiles) {
	        _this.profiles = profiles;
	        _this.currentProfile = profiles.find(function (p) {
	          return p.account_id === _this.AuthService.parseJwt(_this.AuthService.getAccountToken()).id;
	        });
	        _this.userLanguage = _this.$window.localStorage.userLanguage || _this.currentProfile.language;
	      }));
	      this.invitationsPending = [];
	      this.subscriptions.push(this.service.checkInvitations().subscribe(function (resp) {
	        return _this.invitationsPending = resp.invitations;
	      }, function (resp) {
	        return _this.invitationsPending = [];
	      }));
	
	      this.subscriptions.push(this.suscriptionService.paymentStatus().subscribe(function (status) {
	        _this.isPaymentPending = ![_app.PaymentOnTrial, _app.PaymentRegistered, _app.PaymentSucceeded].includes(status);
	        _this.isOnTrial = _app.PaymentOnTrial === status;
	        _this.trialPeriodEnding = _this.$window.localStorage.trialPeriodEnding;
	
	        if (_this.isPaymentPending) {
	          if (_this.permissionsService.hasPermission('manage-subscription')) {
	            _this.state.go(status === _app.PaymentUnregistered ? 'accountSubscription' : 'accountInformation', { activeTab: 3 });
	          } else {
	            _this.$window.localStorage.removeItem('accToken');
	            _this.$window.localStorage.removeItem('accPayStatus');
	            _this.$window.localStorage.removeItem('currentProfile');
	
	            _this.state.go('paymentNotice');
	          }
	        } else if (_this.isOnTrial && !_this.suscriptionService.wasGraceNoticeDisplayed()) {
	          _this.openGracePeriodEndModel();
	          _this.suscriptionService.setGraceNoticeDisplayed();
	        }
	      }));
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	      this.service.stopCheckingInvitations();
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      this.subscriptions.push(this.AuthService.logout().subscribe(function (data) {
	        _this2.$window.localStorage.removeItem('jwtToken');
	        _this2.$window.localStorage.removeItem('accToken');
	        _this2.$window.localStorage.removeItem('userLanguage');
	        _this2.state.go('login');
	      }));
	    }
	  }, {
	    key: 'openGracePeriodEndModel',
	    value: function openGracePeriodEndModel() {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'md',
	        templateUrl: 'grace-period-end-notice-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", function controller($scope, $state, $uibModalInstance) {
	          "ngInject";
	
	          $scope.canPaySubscription = that.permissionsService.hasPermission('manage-subscription');
	          $scope.trialPeriodEnding = that.trialPeriodEnding;
	          $scope.navigateToPayments = function () {
	            that.state.go('accountInformation', {
	              activeTab: 3
	            });
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openModalClosingHour',
	    value: function openModalClosingHour() {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'closing-hour-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", function controller($scope, $state, $uibModalInstance) {
	          "ngInject";
	
	          that.subscriptions.push(that.service.getClosingHour().subscribe(function (hour) {
	            return $scope.hour = hour || "01:00";
	          }));
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.updateHour = function () {
	            that.subscriptions.push(that.service.updateClosingHour($scope.hour).subscribe(function (resp) {
	              that.notify.success('El horario de ciere ha sido actualizado exitosamente.!');
	              $scope.closeThisDialog();
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openModalInviteUser',
	    value: function openModalInviteUser() {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'invite-user-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "$validation", function controller($scope, $state, $uibModalInstance, $validation) {
	          "ngInject";
	
	          $scope.emails = '';
	          $validation.setExpression({
	            multiemail: /^$|^(([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\,(\s)?)?)+$/
	          }).setDefaultMsg({
	            multiemail: {
	              error: "No es un correo o listado de correos válido"
	            }
	          });
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.inviteUser = function () {
	            that.subscriptions.push(that.service.inviteUser($scope.emails).subscribe(function (resp) {
	              that.notify.success('Usuario invitado exitosamente.!');
	              $scope.closeThisDialog();
	            }, function (error) {
	              that.notify.warning('Es posible que alguna de las invitaciones hayan sido enviadas');
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openModalProfiles',
	    value: function openModalProfiles() {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'account-profiles-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$uibModalInstance", function controller($scope, $uibModalInstance) {
	          "ngInject";
	
	          $scope.accountProfiles = [];
	          that.subscriptions.push(that.service.getAccountProfiles().subscribe(function (profiles) {
	            return $scope.accountProfiles = profiles.map(function (profile) {
	              profile.name = profile.name || '-';
	              profile.email = profile.email || '-';
	              return profile;
	            });
	          }, function (error) {
	            return $scope.accountProfiles = [];
	          }));
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'useProfile',
	    value: function useProfile(accountId) {
	      var _this3 = this;
	
	      var _ = this.trans.instant;
	      this.subscriptions.push(this.LoginService.getAccountToken(accountId).subscribe(function (accToken) {
	        if (!accToken) {
	          _this3.notify.error(_("Ha ocurrido un durante el cambio de perfil, intente nuevamente"));
	          return;
	        }
	        _this3.AuthService.saveAccountToken(accToken);
	        _this3.permissionsService.setProfile(_this3.profiles.find(function (p) {
	          return p.account_id === accountId;
	        }));
	
	        var role = _this3.AuthService.getAccountRole();
	        if (role == 'ADMIN' || role == 'MASTER') {
	          _this3.state.go('userControl');
	        } else {
	          _this3.state.reload();
	        }
	      }));
	    }
	  }, {
	    key: 'acceptInvitation',
	    value: function acceptInvitation(invitation, idx) {
	      var _this4 = this;
	
	      this.subscriptions.push(this.service.acceptInvitation({ invitation: invitation }).subscribe(function (resp) {
	        _this4.invitationsPending.splice(idx, 1);_this4.notify.success("Invitación aceptada de manera exitosa.");_this4.state.reload();
	      }, function (resp) {}));
	    }
	  }, {
	    key: 'changeLanguage',
	    value: function changeLanguage(language) {
	      var _this5 = this;
	
	      if (language != this.userLanguage) {
	        this.trans.use(language.toLowerCase());
	        this.am.changeLocale(language.toLowerCase());
	        this.subscriptions.push(this.service.chooseLanguage(language).subscribe(function (user) {
	          _this5.$window.localStorage.userLanguage = user.language;
	          _this5.userLanguage = user.language;
	        }));
	      }
	    }
	  }]);
	  return menuController;
	}();
	
	exports.default = menuController;
	
	
	menuController.$inject = ['$state', 'AuthService', '$window', 'LoginService', '$uibModal', 'ContentService', 'Notification', 'moment', '$validation', 'ProfilePermissionsService', '$translate', 'amMoment', 'SubscriptionService', 'AccountInformationService'];

/***/ }),
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(471);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./menu.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "menu .menu-acordion v-pane{margin-bottom:5px}menu .vpersonclass{color:#fff;border-bottom:none!important;margin:0!important;padding:5px 10px!important;transition:.3s ease-out}menu .vpersonclass:after,menu .vpersonclass:before{background-color:#fff!important;right:10px!important}menu .vpersonclass:focus,menu .vpersonclass:hover{background:#0a2638!important;color:#fff!important}menu .vpersonclass:focus{background:none!important;color:#fff!important}menu .vpersonclasscontent{color:#fff}menu .vpersonclasscontent div{padding-bottom:5px!important;background:#082333}menu .vpersonclasscontent ul{margin:0}menu .vpersonclasscontent ul,menu .vpersonclasscontent ul li{padding:0;list-style:none;text-align:left}menu .vpersonclasscontent ul li a{display:block;padding:8px;padding-left:2em;text-decoration:none;border-bottom:1px solid hsla(0,0%,100%,.1);color:#fff;transition:.3s ease-out}menu .vpersonclasscontent ul li a:hover{background:hsla(0,0%,100%,.25)!important}menu .vpersonclasscontent ul li a:before{content:\"\\F111\";font-family:FontAwesome;float:left;margin-left:-20px;margin-top:5px;font-size:10px;color:#fff}menu .sidebar_custom .menu-acordion{flex-grow:1}menu .sidebar_custom .user_language_icon{flex-grow:0;text-align:center;padding-bottom:20px}menu .navbar-brand{padding:25px 15px 26px 22px;width:203px}menu .pi-circle{width:100%}", ""]);
	
	// exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _adminMenu = __webpack_require__(473);
	
	var _adminMenu2 = _interopRequireDefault(_adminMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminMenuModule = _angular2.default.module('AdminMenu', [_angularjs2.default]).component('adminmenu', _adminMenu2.default).name;
	
	exports.default = AdminMenuModule;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adminMenu = __webpack_require__(474);
	
	var _adminMenu2 = _interopRequireDefault(_adminMenu);
	
	var _adminMenu3 = __webpack_require__(475);
	
	var _adminMenu4 = _interopRequireDefault(_adminMenu3);
	
	__webpack_require__(476);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminMenuComponent = {
	  bindings: {
	    profiles: '<',
	    closingHour: '<'
	  },
	  template: _adminMenu2.default,
	  controller: _adminMenu4.default
	};
	
	exports.default = AdminMenuComponent;

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-fixed-top headerbar\">\n    <div class=\"container-fluid\">\n        <a class=\"navbar-brand hidden-sm hidden-xs\" ui-sref=\"dashboard\">\n           <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n        </a>\n        <div class=\"menu_icon\" ng-click=\"menuOpened = !menuOpened\" ng-class=\"{'open': menuOpened}\">\n            <span></span>\n        </div>\n        <div class=\"user_access\">\n            <div uib-dropdown>\n                <div class=\"user_info\" uib-dropdown-toggle auto-close=\"outsideClick\">\n                    <i class=\"fa fa-user\" aria-hidden=\"true\"></i>\n                </div>\n                <span class=\"pull-right user_basic_infos text-right\">\n                    {{ 'Administrador' }}<br><small class=\"full-width\">{{ $ctrl.actualDate | amUtc | amDateFormat:'LL' }}</small>\n                </span>\n                <ul uib-dropdown-menu class=\"dropdown-menu user_drop\">\n                    <li ng-repeat=\"profile in $ctrl.profiles\" class=\"clickable\" ng-click=\"$ctrl.useProfile(profile.account_id)\">\n                        <a>\n                            {{ profile.account_name }}\n                        </a>\n                    </li>\n                    <li>\n                        <a ng-click=\"$ctrl.logout()\">\n                            <i class=\"fa fa-power-off\"></i> Salir\n                        </a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div class=\"user_access\">\n            <div uib-dropdown>\n                <div class=\"bell_notification\" uib-dropdown-toggle auto-close=\"outsideClick\" ng-disabled=\"$ctrl.invitationsPending.length <= 0\">\n                    <i class=\"fa fa-bell\" aria-hidden=\"true\"></i>\n                </div>\n                <ul uib-dropdown-menu class=\"notification-menu bell_drop\">\n                    <li ng-repeat=\"invitation in $ctrl.invitationsPending track by $index\">\n                        <a ng-click=\"$ctrl.acceptInvitation(invitation, $index)\">\n                            <i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> Invitación pendiente de {{invitation.account_name}}\n                        </a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</nav>"

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminMenuController = function () {
	  function AdminMenuController($state, AuthService, $window, LoginService, $uibModal, ContentService, Notification, moment, $validation, ProfilePermissionsService) {
	    (0, _classCallCheck3.default)(this, AdminMenuController);
	
	    this.state = $state;
	    this.AuthService = AuthService;
	    this.$window = $window;
	    this.LoginService = LoginService;
	    this.modal = $uibModal;
	    this.service = ContentService;
	    this.notify = Notification;
	    this.moment = moment;
	    this.permissionsService = ProfilePermissionsService;
	  }
	
	  (0, _createClass3.default)(AdminMenuController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.actualDate = this.moment();
	
	      this.subscriptions.push(this.LoginService.getUserProfiles().subscribe(function (profiles) {
	        _this.profiles = profiles;
	        _this.currentProfile = profiles.find(function (p) {
	          return p.account_id === _this.AuthService.parseJwt(_this.AuthService.getAccountToken()).id;
	        });
	      }));
	
	      this.subscriptions.push(this.service.checkInvitations().subscribe(function (resp) {
	        return _this.invitationsPending = resp.invitations;
	      }, function (resp) {
	        return _this.invitationsPending = [];
	      }));
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	      this.service.stopCheckingInvitations();
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      this.subscriptions.push(this.AuthService.logout().subscribe(function (data) {
	        _this2.$window.localStorage.removeItem('jwtToken');
	        _this2.$window.localStorage.removeItem('accToken');
	        _this2.state.go('login');
	      }));
	    }
	  }, {
	    key: 'openModalClosingHour',
	    value: function openModalClosingHour() {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'closing-hour-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", function controller($scope, $state, $uibModalInstance) {
	          "ngInject";
	
	          that.subscriptions.push(that.service.getClosingHour().subscribe(function (hour) {
	            return $scope.hour = hour || "01:00";
	          }));
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.updateHour = function () {
	            that.subscriptions.push(that.service.updateClosingHour($scope.hour).subscribe(function (resp) {
	              that.notify.success('El horario de ciere ha sido actualizado exitosamente.!');
	              $scope.closeThisDialog();
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openModalInviteUser',
	    value: function openModalInviteUser() {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'invite-user-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "$validation", function controller($scope, $state, $uibModalInstance, $validation) {
	          "ngInject";
	
	          $scope.emails = '';
	          $validation.setExpression({
	            multiemail: /^$|^(([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\,(\s)?)?)+$/
	          }).setDefaultMsg({
	            multiemail: {
	              error: "No es un correo o listado de correos válido"
	            }
	          });
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.inviteUser = function () {
	            that.subscriptions.push(that.service.inviteUser($scope.emails).subscribe(function (resp) {
	              that.notify.success('Usuario invitado exitosamente.!');
	              $scope.closeThisDialog();
	            }, function (error) {
	              that.notify.warning('Es posible que alguna de las invitaciones hayan sido enviadas');
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openModalProfiles',
	    value: function openModalProfiles() {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'account-profiles-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$uibModalInstance", function controller($scope, $uibModalInstance) {
	          "ngInject";
	
	          $scope.accountProfiles = [];
	          that.subscriptions.push(that.service.getAccountProfiles().subscribe(function (profiles) {
	            return $scope.accountProfiles = profiles.map(function (profile) {
	              profile.name = profile.name || '-';
	              profile.email = profile.email || '-';
	              return profile;
	            });
	          }, function (error) {
	            return $scope.accountProfiles = [];
	          }));
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'useProfile',
	    value: function useProfile(accountId) {
	      var _this3 = this;
	
	      this.subscriptions.push(this.LoginService.getAccountToken(accountId).subscribe(function (accToken) {
	        if (!accToken) {
	          _this3.notify.error("Ha ocurrido un error durante el cambio de perfil, intente nuevamente");
	          return;
	        }
	        _this3.AuthService.saveAccountToken(accToken);
	        _this3.permissionsService.setProfile(_this3.profiles.find(function (p) {
	          return p.account_id === accountId;
	        }));
	        var role = _this3.AuthService.getAccountRole();
	        if (role == 'ADMIN' || role == 'MASTER') {
	          _this3.state.reload();
	        } else {
	          _this3.state.go('dashboard');
	        }
	      }));
	    }
	  }, {
	    key: 'acceptInvitation',
	    value: function acceptInvitation(invitation, idx) {
	      var _this4 = this;
	
	      this.subscriptions.push(this.service.acceptInvitation({ invitation: invitation }).subscribe(function (resp) {
	        _this4.invitationsPending.splice(idx, 1);_this4.notify.success("Invitación aceptada de manera exitosa.");_this4.state.reload();
	      }, function (resp) {}));
	    }
	  }]);
	  return AdminMenuController;
	}();
	
	exports.default = AdminMenuController;
	
	
	AdminMenuController.$inject = ['$state', 'AuthService', '$window', 'LoginService', '$uibModal', 'ContentService', 'Notification', 'moment', '$validation', 'ProfilePermissionsService'];

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(477);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./admin-menu.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./admin-menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "adminmenu{display:block;list-style-type:disc;-webkit-margin-before:1em;-webkit-margin-after:1em;-webkit-margin-start:0;-webkit-margin-end:0;-webkit-padding-start:40px}", ""]);
	
	// exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _countries = __webpack_require__(479);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var countriesModule = _angular2.default.module('countries', [_angularjs2.default]).component('countries', _countries2.default).name;
	
	exports.default = countriesModule;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _countries = __webpack_require__(480);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	__webpack_require__(481);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var countriesComponent = {
	  bindings: {
	    countries: '<',
	    selected: '<',
	    disabled: '<',
	    onSelect: '&'
	  },
	  template: _countries2.default
	};
	
	exports.default = countriesComponent;

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	module.exports = "<select name=\"country\" class=\"form-control form-accede\" ng-init=\"$ctrl.initial\" ng-model=\"$ctrl.selected\" ng-change=\"$ctrl.onSelect({country: $ctrl.selected})\"\n        ng-disabled=\"$ctrl.disabled\">\n  <option value=\"\" disabled>Seleccione un País</option>\n  <option ng-repeat=\"country in $ctrl.countries\" value=\"{{ country.code }}\">\n    {{ country.name }}\n  </option>\n</select>"

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(482);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./countries.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./countries.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".countries{color:red}", ""]);
	
	// exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _timezones = __webpack_require__(484);
	
	var _timezones2 = _interopRequireDefault(_timezones);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timezonesModule = _angular2.default.module('timezones', [_angularjs2.default]).component('timezones', _timezones2.default).name;
	
	exports.default = timezonesModule;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _timezones = __webpack_require__(485);
	
	var _timezones2 = _interopRequireDefault(_timezones);
	
	var _timezones3 = __webpack_require__(486);
	
	var _timezones4 = _interopRequireDefault(_timezones3);
	
	__webpack_require__(487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timezonesComponent = {
	  bindings: {
	    timezones: '<',
	    selected: '<',
	    disabled: '<',
	    onSelect: '&'
	  },
	  template: _timezones2.default,
	  controller: _timezones4.default
	};
	
	exports.default = timezonesComponent;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	module.exports = "\n    <select name=\"timezone\" class=\"form-control form-accede\" ng-init=\"$ctrl.initial\" ng-model=\"$ctrl.selected\" ng-change=\"$ctrl.onSelect({timezone: $ctrl.selected})\"\n            ng-disabled=\"$ctrl.disabled\" >\n      <option value=\"\" disabled>Seleccione una Zona horaria</option>\n      <option ng-repeat=\"timezone in $ctrl.timezones\" value=\"{{ timezone.timezones }}\">\n        {{ timezone.timezones }}\n      </option>\n    </select>\n\n\n"

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timezonesController = function timezonesController() {
	  (0, _classCallCheck3.default)(this, timezonesController);
	};
	
	exports.default = timezonesController;
	
	
	timezonesController.$inject = [];

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(488);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./timezones.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./timezones.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".timezones{color:red}", ""]);
	
	// exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(490);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _register = __webpack_require__(952);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _dashboard = __webpack_require__(958);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _salesByProducts = __webpack_require__(1026);
	
	var _salesByProducts2 = _interopRequireDefault(_salesByProducts);
	
	var _backups = __webpack_require__(1032);
	
	var _backups2 = _interopRequireDefault(_backups);
	
	var _dtts = __webpack_require__(1059);
	
	var _dtts2 = _interopRequireDefault(_dtts);
	
	var _findInvoice = __webpack_require__(1071);
	
	var _findInvoice2 = _interopRequireDefault(_findInvoice);
	
	var _invoiceNcf = __webpack_require__(1077);
	
	var _invoiceNcf2 = _interopRequireDefault(_invoiceNcf);
	
	var _listArticles = __webpack_require__(1083);
	
	var _listArticles2 = _interopRequireDefault(_listArticles);
	
	var _oth = __webpack_require__(1089);
	
	var _oth2 = _interopRequireDefault(_oth);
	
	var _pointOfSales = __webpack_require__(1098);
	
	var _pointOfSales2 = _interopRequireDefault(_pointOfSales);
	
	var _salesReport = __webpack_require__(1104);
	
	var _salesReport2 = _interopRequireDefault(_salesReport);
	
	var _passwordRecovery = __webpack_require__(1110);
	
	var _passwordRecovery2 = _interopRequireDefault(_passwordRecovery);
	
	var _accountInformation = __webpack_require__(1117);
	
	var _accountInformation2 = _interopRequireDefault(_accountInformation);
	
	var _salesByVendor = __webpack_require__(1124);
	
	var _salesByVendor2 = _interopRequireDefault(_salesByVendor);
	
	var _accountRegistration = __webpack_require__(1130);
	
	var _accountRegistration2 = _interopRequireDefault(_accountRegistration);
	
	var _passwordRequest = __webpack_require__(1136);
	
	var _passwordRequest2 = _interopRequireDefault(_passwordRequest);
	
	var _permissions = __webpack_require__(1142);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _error = __webpack_require__(1148);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _profileSelection = __webpack_require__(1154);
	
	var _profileSelection2 = _interopRequireDefault(_profileSelection);
	
	var _userControl = __webpack_require__(1160);
	
	var _userControl2 = _interopRequireDefault(_userControl);
	
	var _collectors = __webpack_require__(1166);
	
	var _collectors2 = _interopRequireDefault(_collectors);
	
	var _collected = __webpack_require__(1172);
	
	var _collected2 = _interopRequireDefault(_collected);
	
	var _pendingInvitations = __webpack_require__(1178);
	
	var _pendingInvitations2 = _interopRequireDefault(_pendingInvitations);
	
	var _billPaymentOnly = __webpack_require__(1184);
	
	var _billPaymentOnly2 = _interopRequireDefault(_billPaymentOnly);
	
	var _printedUnclosed = __webpack_require__(1190);
	
	var _printedUnclosed2 = _interopRequireDefault(_printedUnclosed);
	
	var _fiscalSalesAnalyser = __webpack_require__(1197);
	
	var _fiscalSalesAnalyser2 = _interopRequireDefault(_fiscalSalesAnalyser);
	
	var _fiscalSalesVisualizer = __webpack_require__(1215);
	
	var _fiscalSalesVisualizer2 = _interopRequireDefault(_fiscalSalesVisualizer);
	
	var _fiscalSalesZreport = __webpack_require__(1221);
	
	var _fiscalSalesZreport2 = _interopRequireDefault(_fiscalSalesZreport);
	
	var _dailyClosing = __webpack_require__(1227);
	
	var _dailyClosing2 = _interopRequireDefault(_dailyClosing);
	
	var _inviteUsers = __webpack_require__(1233);
	
	var _inviteUsers2 = _interopRequireDefault(_inviteUsers);
	
	var _printedBills = __webpack_require__(1239);
	
	var _printedBills2 = _interopRequireDefault(_printedBills);
	
	var _salesByCategory = __webpack_require__(1245);
	
	var _salesByCategory2 = _interopRequireDefault(_salesByCategory);
	
	var _requestSuccess = __webpack_require__(1251);
	
	var _requestSuccess2 = _interopRequireDefault(_requestSuccess);
	
	var _recoverySuccess = __webpack_require__(1257);
	
	var _recoverySuccess2 = _interopRequireDefault(_recoverySuccess);
	
	var _paymentNotice = __webpack_require__(1263);
	
	var _paymentNotice2 = _interopRequireDefault(_paymentNotice);
	
	var _handies = __webpack_require__(1269);
	
	var _handies2 = _interopRequireDefault(_handies);
	
	var _subscription = __webpack_require__(1275);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _rawMaterials = __webpack_require__(1281);
	
	var _rawMaterials2 = _interopRequireDefault(_rawMaterials);
	
	var _rawMaterialArticles = __webpack_require__(1287);
	
	var _rawMaterialArticles2 = _interopRequireDefault(_rawMaterialArticles);
	
	var _salesBySubfamily = __webpack_require__(1293);
	
	var _salesBySubfamily2 = _interopRequireDefault(_salesBySubfamily);
	
	var _salesByFiscalNumber = __webpack_require__(1299);
	
	var _salesByFiscalNumber2 = _interopRequireDefault(_salesByFiscalNumber);
	
	var _salesDetailsReport = __webpack_require__(1305);
	
	var _salesDetailsReport2 = _interopRequireDefault(_salesDetailsReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pagesModule = _angular2.default.module('app.pagesModule', [_login2.default, _register2.default, _accountRegistration2.default, _dashboard2.default, _salesByProducts2.default, _backups2.default, _dtts2.default, _findInvoice2.default, _invoiceNcf2.default, _listArticles2.default, _oth2.default, _pointOfSales2.default, _salesReport2.default, _passwordRecovery2.default, _accountInformation2.default, _salesByVendor2.default, _passwordRequest2.default, _permissions2.default, _error2.default, _profileSelection2.default, _userControl2.default, _collectors2.default, _collected2.default, _pendingInvitations2.default, _billPaymentOnly2.default, _printedUnclosed2.default, _fiscalSalesAnalyser2.default, _fiscalSalesVisualizer2.default, _fiscalSalesZreport2.default, _dailyClosing2.default, _inviteUsers2.default, _printedBills2.default, _salesByCategory2.default, _requestSuccess2.default, _recoverySuccess2.default, _paymentNotice2.default, _handies2.default, _subscription2.default, _rawMaterials2.default, _rawMaterialArticles2.default, _salesBySubfamily2.default, _salesByFiscalNumber2.default, _salesDetailsReport2.default]).name;
	
	exports.default = pagesModule;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _login = __webpack_require__(491);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _auth = __webpack_require__(496);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _login3 = __webpack_require__(951);
	
	var _login4 = _interopRequireDefault(_login3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginModule = _angular2.default.module('Login', [_angularjs2.default]).component('login', _login2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('login', {
	    url: '/login',
	    views: {
	      'menu': "",
	      'content': {
	        component: 'login'
	      }
	    }
	  });
	}]).name;
	
	exports.default = LoginModule;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(492);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(493);
	
	var _login4 = _interopRequireDefault(_login3);
	
	__webpack_require__(494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginComponent = {
	  bindings: {},
	  template: _login2.default,
	  controller: _login4.default
	};
	
	exports.default = LoginComponent;

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n  <div class=\"wrapper\">\n  </div>\n\n  <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n    <form class=\"form-signin\" name=\"loginForm\" novalidate>\n      <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n      <h3 class=\"form-signin-heading\">{{'Ingresa con'| translate}}</h3>\n\n\n        <span class=\"group gplus-share full-width\">\n          <button class=\"gp full-width\" ng-click=\"$ctrl.authenticateOauth('google')\">\n            <i class=\"fa fa-google-plus\"></i>\n          </button>\n        </span>\n\n      <div class=\"strike\">\n        <span>O</span>\n      </div>\n      <div class=\"form-group\">\n        <input type=\"text\" name=\"email\" ng-model=\"$ctrl.email\" class=\"form-control input_py\" placeholder=\"{{'Usuario' | translate}}\" validator=\"required\"\n          auto-fill-sync autofocus>\n      </div>\n      <div class=\"form-group\">\n        <input type=\"password\" name=\"password\" ng-model=\"$ctrl.password\" class=\"form-control input_py\" placeholder=\"{{'Contraseña' | translate}}\" auto-fill-sync\n          validator=\"required\" valid-method=\"submit\">\n      </div>\n      <button class=\"btn btn-md btn-primary btn-block btn_py\" ng-click=\"$ctrl.login()\" type=\"submit\"\n          validation-submit=\"loginForm\" click-me-on-enter>\n        {{'Entrar' | translate}}\n      </button>\n      <p class=\"create-account pull-left\">\n        <a ui-sref=\"passwordRequest\"><i class=\"fa fa-key\" aria-hidden=\"true\"></i> {{'¿Olvidaste tu Contraseña?' | translate}}</a>\n      </p>\n      <p class=\"create-account\">\n        <a ui-sref=\"register\"><i class=\"fa fa-user-plus\" aria-hidden=\"true\"></i> {{'Registrate' | translate}}</a>\n      </p>\n    </form>\n  </div>\n\n</body>"

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginController = function () {
	  function LoginController(AuthService, $state, LoginService, $auth, Notification, ProfilePermissionsService, $window, ContentService) {
	    (0, _classCallCheck3.default)(this, LoginController);
	
	    this.AuthService = AuthService;
	    this.state = $state;
	    this.service = LoginService;
	    this.$auth = $auth;
	    this.notify = Notification;
	    this.permissionsService = ProfilePermissionsService;
	    this.$window = $window;
	    this.contentService = ContentService;
	  }
	
	  (0, _createClass3.default)(LoginController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.email = '';
	      this.password = '';
	
	      this.$window.localStorage.removeItem('jwtToken');
	      this.$window.localStorage.removeItem('accToken');
	      this.$window.localStorage.removeItem('currentProfile');
	      this.$window.localStorage.removeItem('google_state');
	      this.$window.localStorage.removeItem('profilesCount');
	      this.$window.localStorage.removeItem('__paypal_storage__');
	      this.$window.localStorage.removeItem('userlanguage');
	      this.$window.localStorage.removeItem('accPayStatus');
	      this.$window.localStorage.removeItem('trialPeriodEnding');
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'verifyProfile',
	    value: function verifyProfile(response) {
	      var invitations = response.data.invitations;
	      var profiles = response.data.profiles;
	
	      this.$window.localStorage.userLanguage = this.AuthService.getLanguage();
	
	      if (invitations.length > 0) {
	        this.state.go('pendingInvitations', { invitations: invitations, profiles: profiles });
	      } else if (profiles.length > 0) {
	        this.permissionsService.setProfilesCount(profiles.length);
	        this.state.go('profileSelection', { profiles: profiles, invitations: invitations });
	      } else {
	        this.state.go('accountRegistration', { invitations: invitations });
	      }
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      var _this = this;
	
	      var that = this;
	      this.subscriptions.push(this.AuthService.login(this.email, this.password).subscribe(function (response) {
	        return _this.verifyProfile(response);
	      }, function (err) {
	        return console.log(err);
	      }));
	    }
	  }, {
	    key: 'authenticateOauth',
	    value: function authenticateOauth(provider) {
	      var _this2 = this;
	
	      if (provider !== 'google') return;
	
	      this.$window.localStorage.removeItem('google_state');
	      this.$auth.authenticate(provider, { fields: ['invitations', 'profiles'] }).then(function (response) {
	        _this2.verifyProfile(response);
	      }).catch(function (error) {
	        if (error.message) {
	          _this2.notify.error(error.message);
	        } else if (error.data) {
	          _this2.notify.error(error.data.message, error.status);
	        } else {
	          _this2.notify.error(error);
	        }
	      });
	    }
	  }]);
	  return LoginController;
	}();
	
	exports.default = LoginController;
	
	
	LoginController.$inject = ['AuthService', '$state', 'LoginService', '$auth', 'Notification', 'ProfilePermissionsService', '$window', 'ContentService'];

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(495);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "login .full-width{width:100%!important}login #loading-bar .bar{background-color:#ce2616!important}.form-signin{background:#fff;max-width:330px;padding:30px 15px 60px;margin:13% auto;box-shadow:0 0 20px 0 rgba(0,0,0,.2),0 5px 5px 0 rgba(0,0,0,.24);text-align:center}.form-signin .checkbox,.form-signin .form-signin-heading{margin-bottom:15px;color:#24495e}.form-signin .checkbox{font-weight:400}.form-signin .form-control{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;font-size:16px}.form-signin input{text-align:center}.input_py:focus{border-color:#2196f3;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 2px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 2px rgba(102,175,233,.6)}#reset_password{float:right;padding-right:5px;color:#24495e;font-size:13px}.create-account{display:inline-block;float:right;margin:18px 0 0}.create-account a{color:#24495e;font-size:14px;text-decoration:none;cursor:pointer}.create-account a:after{content:\"\";display:block;width:0;height:2px;background:#24495e;transition:width .3s}.create-account a:hover:after{width:100%;-webkit-transition:width .3s;transition:width .3s}.container-social-btn{margin:15px auto;width:276px}.btn-fb{background:#395697;color:#fff}.btn-tw{background:#1da1f2;color:#fff}.group{display:inline-block;cursor:pointer}.group button{padding:10px 20px;font-size:16px;border-radius:2px;cursor:inherit;border:0;width:80px;color:#fff;outline:0;font-family:inherit;-webkit-transition:background-color .2s ease-in-out;-moz-transition:background-color .2s ease-in-out;-o-transition:background-color .2s ease-in-out;transition:background-color .2s ease-in-out}.fb{background-color:#306199}.fb:hover{background-color:#244872}.gp{background-color:#e93f2e}.gp:hover{background-color:#ce2616}.twitter{background-color:#26c4f1}.twitter:hover{background-color:#0eaad6}.strike{display:block;text-align:center;overflow:hidden;white-space:nowrap;padding:0 0 15px}.strike>span{position:relative;display:inline-block;color:#123b52}.strike>span:after,.strike>span:before{content:\"\";position:absolute;top:50%;width:9999px;height:1px;background:#123b52}.strike>span:before{right:100%;margin-right:15px}.strike>span:after{left:100%;margin-left:15px}.jump_formlogin{display:none}.recover_icon{font-size:60px!important;margin:15px 0 30px;color:#24495e}", ""]);
	
	// exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(497);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthService = function () {
	  function AuthService($window, $http, host) {
	    (0, _classCallCheck3.default)(this, AuthService);
	
	    this.$window = $window;
	    this.http = $http;
	    this.host = host;
	  }
	
	  (0, _createClass3.default)(AuthService, [{
	    key: 'login',
	    value: function login(email, password) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/sessions',
	        data: {
	          email: email, password: password,
	          fields: ['invitations', 'profiles']
	        }
	      }));
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this = this;
	
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/sessions',
	        data: {}
	      }).then(function (resp) {
	        _this.$window.localStorage.removeItem('jwtToken');
	        _this.$window.localStorage.removeItem('accToken');
	        _this.$window.localStorage.removeItem('currentProfile');
	        _this.$window.localStorage.removeItem('google_state');
	        _this.$window.localStorage.removeItem('profilesCount');
	        _this.$window.localStorage.removeItem('__paypal_storage__');
	        _this.$window.localStorage.removeItem('userlanguage');
	      }, function (resp) {}));
	    }
	  }, {
	    key: 'saveToken',
	    value: function saveToken(token) {
	      this.$window.localStorage.jwtToken = token;
	    }
	  }, {
	    key: 'getToken',
	    value: function getToken() {
	      return this.$window.localStorage.jwtToken;
	    }
	  }, {
	    key: 'saveAccountToken',
	    value: function saveAccountToken(token) {
	      this.$window.localStorage.accToken = token;
	    }
	  }, {
	    key: 'getAccountToken',
	    value: function getAccountToken() {
	      return this.$window.localStorage.accToken;
	    }
	  }, {
	    key: 'removeAccountToken',
	    value: function removeAccountToken() {
	      this.$window.localStorage.removeItem('accToken');
	    }
	  }, {
	    key: 'parseJwt',
	    value: function parseJwt(token) {
	      var base64Url = token.split('.')[1];
	      var base64 = base64Url.replace('-', '+').replace('_', '/');
	      return JSON.parse(this.$window.atob(base64));
	    }
	  }, {
	    key: 'isAuthenticated',
	    value: function isAuthenticated() {
	      var token = this.getToken();
	      if (token) {
	        var params = this.parseJwt(token);
	        return Math.round(new Date().getTime() / 1000) <= params.exp;
	      }
	      return false;
	    }
	  }, {
	    key: 'hasAccount',
	    value: function hasAccount() {
	      var token = this.getAccountToken();
	      if (token) {
	        var params = this.parseJwt(token);
	        return Math.round(new Date().getTime() / 1000) <= params.exp;
	      }
	      return false;
	    }
	  }, {
	    key: 'getAccountRole',
	    value: function getAccountRole() {
	      return this.parseJwt(this.getAccountToken()).role;
	    }
	  }, {
	    key: 'getProfile',
	    value: function getProfile() {
	      return JSON.parse(this.$window.localStorage.currentProfile);
	    }
	  }, {
	    key: 'getLanguage',
	    value: function getLanguage() {
	      return this.parseJwt(this.getToken()).user_claims.language;
	    }
	  }]);
	  return AuthService;
	}();
	
	exports.default = AuthService;
	
	
	AuthService.$inject = ['$window', '$http', 'host'];

/***/ }),
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(497);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginService = function () {
	  function LoginService($http, host, ProfilePermissionsService) {
	    (0, _classCallCheck3.default)(this, LoginService);
	
	    this.http = $http;
	    this.host = host;
	    this.permissionsService = ProfilePermissionsService;
	  }
	
	  (0, _createClass3.default)(LoginService, [{
	    key: 'getAccountToken',
	    value: function getAccountToken(accountId) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/users/current-profile',
	        data: { account_id: accountId }
	      }).then(function (resp) {
	        return resp.data.account_token;
	      }, function (resp) {
	        return console.log(resp.data);
	      }));
	    }
	  }, {
	    key: 'getUserProfiles',
	    value: function getUserProfiles() {
	      var _this = this;
	
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/users/profiles'
	      }).then(function (resp) {
	        var profiles = resp.data.profiles;
	        var currentProfile = _this.permissionsService.getProfile();
	
	        if (currentProfile && profiles && profiles.length > 0) {
	          var found = resp.data.profiles.find(function (p) {
	            return p.id === currentProfile.id;
	          });
	          if (found) {
	            _this.permissionsService.setProfile(found);
	          }
	        }
	
	        return profiles;
	      }, function (resp) {
	        return [];
	      }));
	    }
	  }, {
	    key: 'getUserlanguage',
	    value: function getUserlanguage() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/users',
	        params: { language: true }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return 'ES';
	      }));
	    }
	  }]);
	  return LoginService;
	}();
	
	exports.default = LoginService;
	
	
	LoginService.$inject = ['$http', 'host', 'ProfilePermissionsService'];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _register = __webpack_require__(953);
	
	var _register2 = _interopRequireDefault(_register);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegisterModule = _angular2.default.module('Register', [_angularjs2.default]).component('register', _register2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('register', {
	    url: '/register',
	    views: {
	      'menu': "",
	      'content': {
	        component: 'register'
	      }
	    }
	  });
	}]).name;
	
	exports.default = RegisterModule;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _register = __webpack_require__(954);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _register3 = __webpack_require__(955);
	
	var _register4 = _interopRequireDefault(_register3);
	
	__webpack_require__(956);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegisterComponent = {
	  bindings: {},
	  template: _register2.default,
	  controller: _register4.default
	};
	
	exports.default = RegisterComponent;

/***/ }),
/* 954 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n  <div class=\"wrapper\">\n  </div>\n  <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n    <form class=\"form-signin\" name=\"registrationForm\" novalidate>\n      <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n      <h3 class=\"form-signin-heading\">{{'Registrate con' | translate}}</h3>\n\n      <span class=\"group gplus-share full-width\">\n        <button class=\"gp full-width\" ng-click=\"$ctrl.authenticateOauth('google')\">\n          <i class=\"fa fa-google-plus\"></i>\n        </button>\n      </span>\n\n      <div class=\"strike\">\n        <span>O</span>\n      </div>\n      <div class=\"form-group\">\n        <input type=\"text\" name=\"name\" ng-model=\"$ctrl.user.name\" class=\"form-control input_py\" placeholder=\"Nombre\" validator=\"required\"\n          auto-fill-sync autofocus>\n      </div>\n      <div class=\"form-group\">\n        <input type=\"email\" name=\"email\" ng-model=\"$ctrl.user.email\" class=\"form-control input_py\" placeholder=\"E-mail\" auto-fill-sync\n          validator=\"required,email,available\" valid-method=\"blur\" autocomplete=\"off\">\n      </div>\n      <div class=\"form-group\">\n        <input type=\"password\" name=\"password\" ng-model=\"$ctrl.user.password\" class=\"form-control input_py\" placeholder=\"Contraseña\"\n          auto-fill-sync validator=\"required,minlength=8\" valid-method=\"submit\" autocomplete=\"off\">\n      </div>\n      <button class=\"btn btn-md btn-primary btn-block btn_py\" ng-click=\"$ctrl.register()\" type=\"submit\" \n            validation-submit=\"registrationForm\" ng-disabled=\"$ctrl.emailUnavailable\" click-me-on-enter>{{'Registrarme' | translate}}</button>\n      <p class=\"create-account\">\n        <a ui-sref=\"login\"><i class=\"fa fa-chevron-circle-left\" aria-hidden=\"true\"></i> {{'Volver al inicio' | translate}}</a>\n      </p>\n    </form>\n  </div>\n</body>"

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegisterController = function () {
	    function RegisterController(AuthService, $state, RegisterService, LoginService, $validation, $auth, ProfilePermissionsService, $window, ContentService, $translate) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, RegisterController);
	
	        this.authService = AuthService;
	        this.state = $state;
	        this.service = RegisterService;
	        this.loginService = LoginService;
	        this.$auth = $auth;
	        this.permissionsService = ProfilePermissionsService;
	        this.contentService = ContentService;
	        this.$window = $window;
	        this.trans = $translate.instant;
	        var _ = this.trans;
	        $validation.setExpression({
	            available: function available(value, scope, element, attrs) {
	                return _this.service.isEmailAvailability(value).toPromise().then(function (available) {
	                    _this.validForm = available;
	                    return available;
	                }, function (available) {
	                    return available;
	                });
	            }
	        }).setDefaultMsg({
	            available: {
	                error: _("Este dirección de correo no está disponible")
	            }
	        });
	    }
	
	    (0, _createClass3.default)(RegisterController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.subscriptions = [];
	
	            this.user = {};
	            this.validForm = false;
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.subscriptions.forEach(function (sub) {
	                return sub.unsubscribe();
	            });
	        }
	    }, {
	        key: 'register',
	        value: function register() {
	            var _this2 = this;
	
	            if (this.validForm) {
	                this.subscriptions.push(this.service.register(this.user.name, this.user.email, this.user.password).subscribe(function (data) {
	                    if (!_this2.authService.isAuthenticated()) {
	                        _this2.state.go('login');
	                    }
	                    _this2.verifyProfile();
	                }, function (err) {
	                    return console.log(err);
	                }));
	            }
	        }
	    }, {
	        key: 'verifyProfile',
	        value: function verifyProfile() {
	            var _this3 = this;
	
	            this.subscriptions.push(this.loginService.getUserProfiles().subscribe(function (profiles) {
	                _this3.subscriptions.push(_this3.contentService.getUserInvitations().subscribe(function (invitations) {
	                    if (invitations.length > 0) {
	                        _this3.state.go('pendingInvitations', { invitations: invitations, profiles: profiles });
	                    } else if (profiles.length > 0) {
	                        _this3.permissionsService.setProfilesCount(profiles.length);
	                        _this3.state.go('profileSelection', { profiles: profiles });
	                    } else {
	                        _this3.state.go('accountRegistration');
	                    }
	                }));
	            }));
	        }
	    }, {
	        key: 'authenticateOauth',
	        value: function authenticateOauth(provider) {
	            var _this4 = this;
	
	            if (provider !== 'google') return;
	
	            this.$window.localStorage.removeItem('google_state');
	            this.$auth.authenticate(provider).then(function () {
	                _this4.verifyProfile();
	            }).catch(function (error) {
	                if (error.message) {
	                    _this4.notify.error(error.message);
	                } else if (error.data) {
	                    _this4.notify.error(error.data.message, error.status);
	                } else {
	                    _this4.notify.error(error);
	                }
	            });
	        }
	    }]);
	    return RegisterController;
	}();
	
	exports.default = RegisterController;
	
	
	RegisterController.$inject = ['AuthService', '$state', 'RegisterService', 'LoginService', '$validation', '$auth', 'ProfilePermissionsService', '$window', 'ContentService', '$translate'];

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(957);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./register.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./register.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "register .full-width{width:100%!important}", ""]);
	
	// exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _dashboard = __webpack_require__(959);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _Rx = __webpack_require__(497);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardModule = _angular2.default.module('Dashboard', [_angularjs2.default]).component('dashboard', _dashboard2.default).filter('translate', function () {
	  return function (input, source) {
	    if (source.hasOwnProperty(input)) {
	      return source[input];
	    }
	    return input;
	  };
	}).filter('capitalize', function () {
	  return function (input) {
	    return input.split(' ').map(function (word) {
	      return word.substring(0, 1).toUpperCase() + word.substring(1).toLowerCase();
	    }).join(' ');
	  };
	}).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard', {
	    url: '/dashboard',
	    data: {
	      authRequired: true
	    },
	    views: {
	      'menu': {
	        component: 'menu'
	      },
	      'content': {
	        component: 'dashboard'
	      }
	    },
	    resolve: {
	      closingHourObservable: ["ContentService", "ProfilePermissionsService", "$q", function closingHourObservable(ContentService, ProfilePermissionsService, $q) {
	        return ProfilePermissionsService.hasPermission('view-closing-hour') ? ContentService.getClosingHour() : _Rx2.default.Observable.fromPromise($q(function (resolve, z) {
	          return resolve(undefined);
	        }));
	      }]
	    }
	  });
	}]).name;
	
	exports.default = DashboardModule;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dashboard = __webpack_require__(960);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(961);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	__webpack_require__(1024);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardComponent = {
	  bindings: {
	    profiles: '<',
	    closingHourObservable: '<'
	  },
	  template: _dashboard2.default,
	  controller: _dashboard4.default
	};
	
	exports.default = DashboardComponent;

/***/ }),
/* 960 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n  <h1 class=\"page-header\">{{'Dashboard' | translate}}</h1>\n  <div class=\"refresh\" ng-show=\"$ctrl.showLoader\">\n    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\" aria-hidden=\"true\"></i>\n  </div>\n  <div class=\"col-md-6\">\n    <h3 class=\"page-header\">{{'Órdenes Recientes' | translate}}</h3>\n    <!-- div. -->\n\n        \n    <div class=\"form-group col-md-6 no_padding_left\">\n      <div class=\" inputGroupContainer\">\n        <label for=\"user\" class=\"control-label\">{{'Filtrado por' | translate}}:</label>\n        <select class=\"form-control\" ng-model=\"$ctrl.filterBy\" ng-change=\"$ctrl.reapplyFirstWidgetFilters()\"\n           if-perm disable-if=\"recent-orders\">\n          <option value=\"\" selected>{{'Todo' | translate}}</option>\n          <option value=\"B\">{{'Mesa' | translate}}</option>\n          <!-- List of Cashiers (from today sales) -->\n          <option value=\"{{ cashier.id }}\" ng-repeat=\"cashier in $ctrl.cashiers\">\n            {{ cashier.name }}\n          </option>\n        </select>\n      </div>\n    </div>\n    <div class=\"form-group col-md-6 no_padding_right\">\n      <div class=\"inputGroupContainer\">\n        <label for=\"tcode\" class=\"control-label\">{{'Mesa' | translate}}</label>\n        <input name=\"tcode\" class=\"form-control\" type=\"text\" ng-disabled=\"$ctrl.filterBy !== 'B'\"\n          ng-model=\"$ctrl.tableCode\" ng-change=\"$ctrl.reapplyFirstWidgetFilters()\" ng-model-options=\"{debounce: 500}\"\n          if-perm disable-if=\"recent-orders\">\n      </div>\n    </div>\n    <div class=\"col-md-12 no_padding\" if-perm hide-if=\"recent-orders\">\n      <strong>{{'Usted no tiene permiso para visualizar las órdenes' | translate}}</strong>\n    </div>\n    <div class=\"col-md-12 no_padding\" if-perm show-if=\"recent-orders\" ng-if=\"!$ctrl.accountClosingHour\">\n      <strong>{{'La cuenta no dispone de un horario de cierre para visualizar las órdenes recientes' | translate}}.</strong><br />\n      <a ng-click=\"$ctrl.openModalClosingHour()\" href title=\"Horario de Cierre\" if-perm show-if=\"view-closing-hour\">{{'Por favor configurar aqui'|translate}}</a>\n    </div>\n    <div class=\"col-md-12 no_padding margin-top\" if-perm show-if=\"recent-orders\">\n      <div class=\"card\">\n      <div class=\"card-content\">\n      <div class=\"scroll_table_container\">\n      <table id=\"bootstrap-table\" class=\"table table-hover table-bordered\">\n        <thead fix-head class=\"hidden-xs hidden-sm\">\n          <tr>\n            <th class=\"text-left\" data-field=\"id\">\n              <div class=\"th-inner \">{{'Mesa' | translate}}</div>\n            </th>\n            <th class=\"text-left\" data-field=\"id\">\n              <div class=\"th-inner \">{{'Producto' | translate}}</div>\n            </th>\n            <th class=\"text-left\" data-field=\"id\">\n              <div class=\"th-inner \">{{'Precio' | translate}}</div>\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr class=\"text-center\" ng-repeat=\"order in $ctrl.orders\">\n            <td data-label=\"Mesa:\" class=\"text-center\" ng-class=\"{'text-danger': $ctrl.dangerousRows(order.description)}\">\n              {{ order.table_code }}\n            </td>\n            <td data-label=\"Producto:\" class=\"text-left\" ng-class=\"{'text-danger': $ctrl.dangerousRows(order.description)}\">\n              <span ng-if=\"!($ctrl.ordersCommands | contains: order.description)\">\n                ->\n              </span>{{ order.description | translate: $ctrl.ordersTranslations | capitalize }}\n              <div>Hora: {{order.timestamp | amUtc | amDateFormat:'hh:mm a'}}</div>\n            </td>\n            <td data-label=\"Precio:\" class=\"text-center\" ng-class=\"{'text-danger': $ctrl.dangerousRows(order.description)}\">\n              {{ order.total | currency }}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      </div>\n    </div>\n      </div>\n\n    </div>\n<!-- div -->\n\n  </div>\n\n  <div class=\"col-md-6\">\n    <h3 class=\"page-header\">{{'Ventas por Vendedor' | translate}}</h3>\n    <div class=\"form-group col-md-6 no_padding\">\n      <div class=\" inputGroupContainer\">\n        <label for=\"user\" class=\"control-label\">{{'Ventas' | translate}}:</label>\n        <select class=\"form-control\" ng-model=\"$ctrl.salesSince\" ng-change=\"$ctrl.reapplySecondWidgetFilters()\"\n          if-perm disable-if=\"recent-sales\">\n          <option value=\"10\">{{'Últimos 10 minutos' | translate}}</option>\n          <option value=\"30\">{{'Últimos 30 minutos' | translate}}</option>\n          <option value=\"60\">{{'Última Hora' | translate}}</option>\n          <option value=\"180\">{{'Últimas 3 Horas' | translate}}</option>\n          <option value=\"\" selected>{{'Hoy' | translate}}</option>\n          <option value=\"yesterday\">{{'Ayer' | translate}}</option>\n        </select>\n      </div>\n    </div>\n    <div class=\"col-md-12 no_padding\" if-perm hide-if=\"recent-sales\">\n      <strong>{{'Usted no tiene permiso para visualizar las ventas' | translate}}</strong>\n    </div>\n    <div class=\"col-md-12 no_padding\" if-perm show-if=\"recent-sales\" ng-if=\"!$ctrl.accountClosingHour\">\n      <strong>{{'La cuenta no dispone de un horario de cierre para visualizar las ventas' | translate}}.</strong><br />\n      <a ng-click=\"$ctrl.openModalClosingHour()\" href title=\"Horario de Cierre\" if-perm show-if=\"view-closing-hour\">{{'Por favor configurar aqui'|translate}}</a>\n    </div>\n    <div class=\"col-md-12 no_padding margin-top\" if-perm show-if=\"recent-sales\">\n      <div class=\"card\">\n      <div class=\"card-content\">\n    <div class=\"scroll_table_container\">\n      <table id=\"bootstrap-table\" class=\"table table-hover table-bordered\">\n        <thead fix-head class=\"hidden-xs hidden-sm\">\n          <tr>\n\n            <th class=\"text-left\" data-field=\"id\">\n              <div class=\"th-inner \">{{'Vendedor' | translate}}</div>\n            </th>\n            <th class=\"text-left\" data-field=\"id\">\n              <div class=\"th-inner \">{{'Ventas' | translate}}</div>\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr class=\"text-center\" ng-repeat=\"sale in $ctrl.sales\">\n            <td data-label=\"{{'Vendedor' | translate}}:\" class=\"text-center\">{{ sale.cashier }}</td>\n            <td data-label=\"{{'Ventas' | translate}}:\" class=\"text-right\">{{ sale.total | currency }}</td>\n          </tr>\n        </tbody>\n        <tfoot>\n          <tr>\n            <th data-field=\"name\" class=\"text-right\">\n              <div class=\"th-inner\">{{'Total' | translate}}</div>\n            </th>\n            <th data-field=\"salary\" class=\"text-right\">\n              <div class=\"th-inner\">{{ $ctrl.sales | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n            </th>\n          </tr>\n        </tfoot>\n      </table>\n      </div>\n\n    </div></div></div>\n\n  </div>\n\n\n</div>"

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _isNan = __webpack_require__(962);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _keys = __webpack_require__(333);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _crypto = __webpack_require__(965);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardController = function () {
	    function DashboardController(DashboardService, moment, ProfilePermissionsService, Notification, $translate, ContentService, $uibModal, AccountInformationService) {
	        (0, _classCallCheck3.default)(this, DashboardController);
	
	        this.service = DashboardService;
	        this.moment = moment;
	        this.permissionsService = ProfilePermissionsService;
	        this.notify = Notification;
	        this.trans = $translate.instant;
	        this.contentService = ContentService;
	        this.modal = $uibModal;
	        this.accountService = AccountInformationService;
	    }
	
	    (0, _createClass3.default)(DashboardController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this = this;
	
	            this.subscriptions = [];
	
	            var _ = this.trans;
	            this.ordersTranslations = {
	                APPLYDISCOUNT: "Discount",
	                BILLPAYMENT: "Close Bill",
	                BROKEN: "BROKEN",
	                DRAWERINTERACTION: "DRAWERINTERACTION",
	                INFORMATIONALORDER: "INFORMATIONALORDER",
	                INVOICEPRINTED: "Bill Print",
	                ITEMCANCELLATION: "Cancel Item",
	                ITEMRETURN: "Return Item",
	                NEWBILL: "New Bill",
	                NEWORDER: "-",
	                NEXTREQUESTED: "Request Next",
	                OTH: "OTH",
	                OTHINFO: "OTHINFO",
	                PAYMENTTYPECHANGED: "Change Payment Type",
	                REVERSEBYPAYMENTTYPECHANGED: "Rollback Payment Type Change",
	                SEPARATION: "SEPARATION",
	                TABLECANCELLATION: "Cancel Table",
	                TRANSFERINFO: "TRANSFERINFO",
	                TRANSFERITEMTOTABLE: "Transfer Item",
	                TRANSFERTABLETOCASHIER: "Transfer Vendor",
	                UNDODISCOUNT: "Rollback Discount"
	            };
	
	            this.currentProfile = this.permissionsService.getProfile();
	            this.profileTimezone = this.currentProfile.account_timezone;
	
	            this.accountClosingHour;
	
	            this.subscriptions.push(this.closingHourObservable.subscribe(function (closingHour) {
	                var recentOrdersPermission = _this.permissionsService.hasPermission('recent-orders');
	                var recentSalesPermission = _this.permissionsService.hasPermission('recent-sales');
	
	                if (recentOrdersPermission || recentSalesPermission) {
	                    if (closingHour && typeof closingHour === 'string') {
	                        _this.accountClosingHour = closingHour;
	                    }
	
	                    if (!_this.accountClosingHour) {
	                        return;
	                    }
	
	                    var currentDate = _this.moment().tz(_this.profileTimezone);
	                    if (_this.accountClosingHour && currentDate.hours() < Number(_this.accountClosingHour.replace(':00', '')) - 1) {
	                        // We're still in the previous day
	                        currentDate.hours(-1);
	                    }
	                    currentDate = currentDate.format();
	
	                    _this.ordersCommands = (0, _keys2.default)(_this.ordersTranslations);
	                    if (recentOrdersPermission) {
	                        _this.subscriptions.push(_this.service.getCashierList(currentDate).subscribe(function (cashiers) {
	                            return _this.cashiers = cashiers;
	                        }));
	                        _this.loadOrders(currentDate);
	                    }
	                    if (recentSalesPermission) {
	                        _this.loadSales(currentDate);
	                    }
	                }
	            }));
	        }
	    }, {
	        key: "$onDestroy",
	        value: function $onDestroy() {
	            this.service.stopAllPolling();
	            this.subscriptions.forEach(function (sub) {
	                return sub.unsubscribe();
	            });
	        }
	    }, {
	        key: "loadOrders",
	        value: function loadOrders(ordersDate) {
	            var _this2 = this;
	
	            this.subscriptions.push(this.service.getRecentOrders(ordersDate, this.cashierId, this.tableCode, this.widgetALimit).subscribe(function (data) {
	                return _this2.orders = data.orders;
	            }));
	        }
	    }, {
	        key: "loadSales",
	        value: function loadSales(salesDate, offset) {
	            var _this3 = this;
	
	            this.subscriptions.push(this.service.getRecentSales(salesDate, offset).subscribe(function (data) {
	                _this3.sales = data.sales;
	            }));
	        }
	    }, {
	        key: "reapplyFirstWidgetFilters",
	        value: function reapplyFirstWidgetFilters() {
	            if (this.filterBy === 'B') {
	                this.tableCode = this.tableCode || undefined;
	                this.cashierId = undefined;
	            } else if (!(0, _isNan2.default)(parseInt(this.filterBy))) {
	                this.cashierId = this.filterBy;
	                this.tableCode = undefined;
	            } else {
	                this.tableCode = undefined;
	            }
	
	            var currentDate = this.moment().tz(this.profileTimezone);
	            if (this.accountClosingHour && currentDate.hours() < Number(this.accountClosingHour.replace(':00', '')) - 1) {
	                // We're still in the previous day
	                currentDate.hours(-1);
	            }
	            currentDate = currentDate.format();
	            this.loadOrders(currentDate);
	        }
	    }, {
	        key: "reapplySecondWidgetFilters",
	        value: function reapplySecondWidgetFilters() {
	            var salesDate = this.moment().tz(this.profileTimezone),
	                offset;
	
	            if (this.salesSince == 'today') {
	                offset = undefined;
	            } else if (this.salesSince == 'yesterday') {
	                salesDate.subtract(1, 'days');
	                offset = undefined;
	            } else if (!(0, _isNan2.default)(parseInt(this.salesSince))) {
	                offset = this.salesSince;
	            }
	            this.loadSales(salesDate.format(), offset);
	        }
	    }, {
	        key: "dangerousRows",
	        value: function dangerousRows(desc) {
	            var dangerous = ['BILLPAYMENT', 'APPLYDISCOUNT'];
	            return dangerous.indexOf(desc) > -1;
	        }
	    }, {
	        key: "getTotal",
	        value: function getTotal(item) {
	            return item.total;
	        }
	    }, {
	        key: "openModalClosingHour",
	        value: function openModalClosingHour() {
	            var _ = this.trans;
	            var that = this;
	
	            this.modal.open({
	                animation: true,
	                size: 'lg',
	                templateUrl: 'closing-hour-template.html',
	                appendClassName: 'ngdialog-theme-plain',
	                controller: ["$scope", "$state", "$uibModalInstance", function controller($scope, $state, $uibModalInstance) {
	                    "ngInject";
	
	                    var subscription = that.contentService.getClosingHour().subscribe(function (hour) {
	                        return $scope.hour = hour || '01:00';
	                    });
	
	                    $scope.closeThisDialog = function () {
	                        $uibModalInstance.close();
	                        subscription.unsubscribe();
	                    };
	                    $scope.updateHour = function () {
	                        that.contentService.updateClosingHour($scope.hour).subscribe(function () {
	                            that.notify.success(_('El horario de ciere ha sido actualizado exitosamente.!'));
	                            $scope.closeThisDialog();
	                        });
	                        subscription.unsubscribe();
	                    };
	                }]
	            });
	        }
	    }]);
	    return DashboardController;
	}();
	
	exports.default = DashboardController;
	
	
	DashboardController.$inject = ['DashboardService', 'moment', 'ProfilePermissionsService', 'Notification', '$translate', 'ContentService', '$uibModal', 'AccountInformationService'];

/***/ }),
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1001 */,
/* 1002 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1025);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dashboard.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dashboard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:992px){Dashboard .no_padding_left,Dashboard .no_padding_right{padding:inherit!important}}", ""]);
	
	// exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _salesByProducts = __webpack_require__(1027);
	
	var _salesByProducts2 = _interopRequireDefault(_salesByProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesByProductsModule = _angular2.default.module('SalesByProducts', [_angularjs2.default]).component('salesByProducts', _salesByProducts2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesByProducts', {
	    url: '/sales-by-products',
	    data: {
	      authRequired: true,
	      permsRequired: ['products-statistics']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'salesByProducts'
	      }
	    }
	  });
	}]).name;
	
	exports.default = salesByProductsModule;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesByProducts = __webpack_require__(1028);
	
	var _salesByProducts2 = _interopRequireDefault(_salesByProducts);
	
	var _salesByProducts3 = __webpack_require__(1029);
	
	var _salesByProducts4 = _interopRequireDefault(_salesByProducts3);
	
	__webpack_require__(1030);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesByProductsComponent = {
	  bindings: {},
	  template: _salesByProducts2.default,
	  controller: _salesByProducts4.default
	};
	
	exports.default = salesByProductsComponent;

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{'Ventas por Artículos' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.articles.length || 0 }}\n                </span>\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form name=\"salesByArtForm\" class=\"hidden-xs\" novalidate>\n            <div class=\"form col-md-12 no-padding\">\n        \n                <input type=\"hidden\" name=\"sorter\" value=\"\">\n                \n                <input type=\"hidden\" name=\"cashier_id\" value=\"\">\n                \n                <input type=\"hidden\" name=\"pos_id\" value=\"\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>    \n                    <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" format=\"DD/MM/YYYY\" autocomplete=\"off\"\n\t\t\t\t\t\t\tid=\"from\" class=\"form-control input_py\" today=\"true\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\" readonly>\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>    \n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" id=\"to\" class=\"form-control input_py\"\n\t\t\t\t\t\t\tformat=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\" readonly>          \n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.findSalesByProducts()\">{{'Buscar' |translate}}</button>    \n                    </span>\n                </div>\n            </div>\n        </form>\n\t\t<form class=\"visible-xs\">\n            <div class=\"form_xs\">\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_left\">\n\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n\t\t\t\t\t<input class=\"form-control input_py\" name=\"from\" moment-picker=\"$ctrl.dateFrom\"\n\t\t\t\t\t\tng-model=\"$ctrl.dateFrom\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_right\">\n\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Hasta' | translate}}</p>\n\t\t\t\t\t<input class=\"form-control input_py\" name=\"to\" moment-picker=\"$ctrl.dateTo\"\n\t\t\t\t\t\tng-model=\"$ctrl.dateTo\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n\t\t\t\t</div>\n\t\t\t\t<button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findSalesByProducts()\">{{'Buscar' | translate}}</button>    \n            </div>\n        </form>\n    </div>\n\n\t\t<div class=\"col-md-12 table_container\">\n\t\t\t<div class=\"card\">\n\t\t\t\t<div class=\"card-content\">\n\t\t\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t\t\t\t\t<div class=\"columns pull-right\">\n\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-success dropdown-toggle\" data-toggle=\"dropdown\" ng-csv=\"$ctrl.articles\" csv-header=\"['Artículo','Cantidad Total','Cantidad Facturada','Total Facturado','Desc. por Artículo','Desc. Facturado','Cantidad OTH/Broken','Total OTH/Broken','Cantidad Cancelada','Total Cancelado','Cantidad Devuelta','Total Devuelto']\" csv-column-order=\"['description','total_qty','qty_billed','total_billed','item_discount','discount_billed','oth_qty','oth_total','cancelation_qty','cancelation_total','return_qty','return_total']\" filename=\"ventas-por-producto.csv\" ng-disabled=\"$ctrl.articles.length <= 0\" >\n\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-file-o\" aria-hidden=\"true\"></i> {{'Exportar CSV' | translate}}\n\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar búsqueda' | translate}}</label>\n\t\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t\t\t<thead class=\"col_width\">\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'description' ? '-description' : 'description'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable article_w\" ng-class=\"{'asc': orderedBy === 'description', 'desc': orderedBy === '-description'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Artículo' | translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th data-field=\"id\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'total_qty' ? '-total_qty' : 'total_qty'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'total_qty', 'desc': orderedBy === '-total_qty'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Cantidad Total' | translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th  data-field=\"name\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'qty_billed' ? '-qty_billed' : 'qty_billed'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable quanty_f\" ng-class=\"{'asc': orderedBy === 'qty_billed', 'desc': orderedBy === '-qty_billed'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Cantidad Facturada' | translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'total_billed' ? '-total_billed' : 'total_billed'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable quanty_f\" ng-class=\"{'asc': orderedBy === 'total_billed', 'desc': orderedBy === '-total_billed'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Total Facturado' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'item_discount' ? '-item_discount' : 'item_discount'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable total_f\" ng-class=\"{'asc': orderedBy === 'item_discount', 'desc': orderedBy === '-item_discount'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Descuento por Artículo' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th data-field=\"id\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'discount_billed' ? '-discount_billed' : 'discount_billed'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable quanty_f\" ng-class=\"{'asc': orderedBy === 'discount_billed', 'desc': orderedBy === '-discount_billed'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Descuento Facturado' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th data-field=\"id\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'oth_qty' ? '-oth_qty' : 'oth_qty'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable total_f\" ng-class=\"{'asc': orderedBy === 'oth_qty', 'desc': orderedBy === '-oth_qty'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Cantidad OTH/Broken' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th  data-field=\"name\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'oth_total' ? '-oth_total' : 'oth_total'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable total_f\" ng-class=\"{'asc': orderedBy === 'oth_total', 'desc': orderedBy === '-oth_total'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Total OTH/Broken' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'cancelation_qty' ? '-cancelation_qty' : 'cancelation_qty'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable quanty_f\" ng-class=\"{'asc': orderedBy === 'cancelation_qty', 'desc': orderedBy === '-cancelation_qty'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Cantidad Cancelada' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'cancelation_total' ? '-cancelation_total' : 'cancelation_total'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable quanty_f\" ng-class=\"{'asc': orderedBy === 'cancelation_total', 'desc': orderedBy === '-cancelation_total'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Total Cancelado' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'return_qty' ? '-return_qty' : 'return_qty'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable article_w\" ng-class=\"{'asc': orderedBy === 'return_qty', 'desc': orderedBy === '-return_qty'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Cantidad Devuelta' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"orderedBy = orderedBy === 'return_total' ? '-return_total' : 'return_total'\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable article_w\" ng-class=\"{'asc': orderedBy === 'return_total', 'desc': orderedBy === '-return_total'}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'Total Devuelto' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"article in $ctrl.articles | orderBy:orderedBy | filter:filterCrit as filtered\">\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Artículo\" class=\"text-center\">{{ article.description || 'Sin Desc. - Linea #' + article.line_number | translate}}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Cantidad total\" class=\"text-right\">{{ article.total_qty }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Cantidad facturada\" class=\"text-right\">{{ article.qty_billed }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total facturado\" class=\"text-right\">{{ article.total_billed | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Desc. por articulo\" class=\"text-right\">{{ article.item_discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Desc. facturado\" class=\"text-right\">{{ article.discount_billed | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Cantidad OTH/Broken\" class=\"text-right\">{{ article.oth_qty }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total OTH/Broken\" class=\"text-right\">{{ article.oth_total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Cantidad cancelada\" class=\"text-right\">{{ article.cancelation_qty }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total cancelado\" class=\"text-right\">{{ article.cancelation_total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Cantidad devuelta\" class=\"text-right\">{{ article.return_qty }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total devuelto\" class=\"text-right\">{{ article.return_total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t<tfoot>\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<th colspan=\"3\"></th>\n\t\t\t\t\t\t\t\t\t\t\t<th data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t\t\t\t\t\t<th data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t\t\t\t\t\t<th data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getOth | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t\t\t\t\t\t<th data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getVoid | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t<th></th>\n\t\t\t\t\t\t\t\t\t\t\t<th data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getReturned | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tfoot>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"fixed-table-pagination hidden\">\n\t\t\t\t\t\t\t\t<div class=\"pull-left pagination-detail\">\n\t\t\t\t\t\t\t\t\t<span class=\"page-list\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"btn-group dropup\">\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"page-size\">8</span> \n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</span>Filas visible\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"pull-right pagination\">\n\t\t\t\t\t\t\t\t\t<ul class=\"pagination\">\n\t\t\t\t\t\t\t\t\t<li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n\t\t\t\t\t\t\t\t\t<li class=\"page-number active\"><a href=\"\">1</a></li>\n\t\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">2</a></li>\n\t\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">3</a></li>\n\t\t\t\t\t\t\t\t\t<li class=\"page-next\"><a href=\"\">›</a></li>\n\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t<div class=\"clearfix\"></div>\n\t\t\t</div>\n\t\t\t</div>\n\t\t<!--  end card  -->\n\t\t</div>\n\t\t<!--  end card  -->\n</div>"

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByProductsController = function () {
	  function SalesByProductsController(ContentService, isMobile, moment) {
	    (0, _classCallCheck3.default)(this, SalesByProductsController);
	
	    this.service = ContentService;
	    this.isMobile = isMobile;
	    this.moment = moment;
	  }
	
	  (0, _createClass3.default)(SalesByProductsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	      this.dateFrom = undefined;
	      this.dateTo = undefined;
	      this.filter = '';
	      this.articles = [];
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'findSalesByProducts',
	    value: function findSalesByProducts() {
	      var _this = this;
	
	      this.subscriptions.push(this.service.findSalesByProducts({
	        date_from: this.dateFrom.format(),
	        date_to: this.dateTo.format()
	      }).subscribe(function (articles) {
	        return _this.articles = articles;
	      }, function (err) {
	        return console.log(err);
	      }));
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal(item) {
	      return item.total_billed;
	    }
	  }, {
	    key: 'getDiscount',
	    value: function getDiscount(item) {
	      return item.discount_billed;
	    }
	  }, {
	    key: 'getOth',
	    value: function getOth(item) {
	      return item.oth_total;
	    }
	  }, {
	    key: 'getVoid',
	    value: function getVoid(item) {
	      return item.cancelation_total;
	    }
	  }, {
	    key: 'getReturned',
	    value: function getReturned(item) {
	      return item.return_total;
	    }
	  }]);
	  return SalesByProductsController;
	}();
	
	exports.default = SalesByProductsController;
	
	
	SalesByProductsController.$inject = ['ContentService', 'isMobile', 'moment'];

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1031);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-products.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-products.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".ArticlesStatitics{color:red}", ""]);
	
	// exports


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _backups = __webpack_require__(1033);
	
	var _backups2 = _interopRequireDefault(_backups);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackupsModule = _angular2.default.module('Backups', [_angularjs2.default]).component('backups', _backups2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('backups', {
	    url: '/backups',
	    data: {
	      authRequired: true,
	      permsRequired: ['view-backup', 'upload-backup']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'backups',
	        bindings: {
	          backups: 'backups'
	        }
	      }
	    },
	    resolve: {
	      backups: ["ContentService", "ProfilePermissionsService", function backups(ContentService, ProfilePermissionsService) {
	        return ProfilePermissionsService.hasPermission('view-backup') ? ContentService.getBackupList() : {};
	      }]
	    }
	  });
	}]).name;
	
	exports.default = BackupsModule;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backups = __webpack_require__(1034);
	
	var _backups2 = _interopRequireDefault(_backups);
	
	var _backups3 = __webpack_require__(1035);
	
	var _backups4 = _interopRequireDefault(_backups3);
	
	__webpack_require__(1057);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackupsComponent = {
	  bindings: {
	    backups: '<'
	  },
	  template: _backups2.default,
	  controller: _backups4.default
	};
	
	exports.default = BackupsComponent;

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-10\">\n                {{'Backups' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.backupList.length || 0 }}\n                </span>\n            </div>\n            <div class=\"col-md-2 text-right\">\n                <a class=\"pull-right btn btn-success btn-sm btn_transitions upload_file\" href=\"\" \n                    data-container=\"[data-ajax_action_container]\" ng-click=\"$ctrl.openModalBackup()\"\n\t\t\t\t\tdata-interaction_type=\"b\" data-ajax_load=\"\"\n\t\t\t\t\t if-perm disable-if=\"upload-backup\">\n                    <span class=\"glyphicon glyphicon-plus\"></span>\n                    <span>{{'Subir Backups' | translate}}</span>\n                </a>\n            </div>\n\n<!-- Eliminar multimplex -->\n            <div class=\"col-md-2 col-xs-1 multi_delete\">\n                <a class=\"pull-right btn btn-warning btn-sm btn_transitions\" ng-if=\"$ctrl.multipleDelete.length > 1\"\n\t\t\t\t\tng-click=\"$ctrl.deleteMultiplesBackups();\" if-perm disable-if=\"remove-backup\">\n                    <i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i>\n                    <span>{{'Eliminar seleccionados' | translate}}</span>\n                </a>\n            </div>\n<!-- Eliminar multimplex -->\n\n        </div>\n    </h1>\n\n\n\t\t<div class=\"card\">\n\t\t\t<div class=\"card-content\">\n\t\t\t\t<div class=\"bootstrap-table\">\n\n\t\t\t\t\t\t<div class=\"columns columns-right pull-right hidden\">\n\t\t\t\t\t\t\t<div class=\"keep-open btn-group\" title=\"Columns\">\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-columns\"></i> <span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar backups' | translate}}</label>\n\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"select\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner \"><input name=\"btSelectAll\" type=\"checkbox\"></div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'filename' ? '-filename' : 'filename'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'filename', 'desc': orderedBy === '-filename'}\">{{'Nombre' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'title' ? '-title' : 'title'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'title', 'desc': orderedBy === '-title'}\">{{'Renombrado' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'timestamp' ? '-timestamp' : 'timestamp'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'timestamp', 'desc': orderedBy === '-timestamp'}\">{{'Subido en' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'filesize' ? '-filesize' : 'filesize'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'filesize', 'desc': orderedBy === '-filesize'}\">{{'Tamaño' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-right\" data-field=\"id\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{'Acciones' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"backup in $ctrl.backupList | orderBy:orderedBy | filter:filterCrit as filtered\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Eliminar\" class=\"bs-checkbox\">\n\t\t\t\t\t\t\t\t\t\t\t<input data-index=\"7\" name=\"btSelectItem\" type=\"checkbox\" ng-click=\"$ctrl.toggleCheckDelete(backup)\">\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Nombre:\" class=\"text-left\">\n\t\t\t\t\t\t\t\t\t\t\t<a class=\"clickable\" ng-click=\"$ctrl.downloadBackup(backup)\">{{ backup.filename }}</a>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Renombrado:\" class=\"text-left\">{{ backup.title }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Subido en:\" class=\"text-center\">{{ backup.timestamp | amDateFormat:'DD/MMM/YYYY HH:mm'  }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Tamaño:\" class=\"text-center\">{{ backup.filesize || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td class=\"td-actions text-right\" >\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"table-icons text-right\">\n\t\t\t\t\t\t\t\t\t\t\t\t<button rel=\"tooltip\" title=\"\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tclass=\"btn btn-simple btn-danger btn-icon\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tmwl-confirm\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"'¿Esta seguro?'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tmessage=\"{{'ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?' | translate}}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tconfirm-text=\"Eliminar\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tcancel-text=\"Cancelar\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tplacement=\"left\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ton-confirm=\"$ctrl.deleteBackup(backup)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ton-cancel=\"\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tconfirm-button-type=\"danger\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tcancel-button-type=\"default\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tif-perm disable-if=\"remove-backup\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!-- <div class=\"fixed-table-pagination\">\n\t\t\t\t\t\t<div class=\"pull-left pagination-detail\">\n\t\t\t\t\t\t\t<span class=\"page-list\">\n\t\t\t\t\t\t\t\t<span class=\"btn-group dropup\">\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"page-size\">8</span> \n\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</span>Filas visible\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"pull-right pagination\">\n\t\t\t\t\t\t\t<ul class=\"pagination\">\n\t\t\t\t\t\t\t<li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number active\"><a href=\"\">1</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">2</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">3</a></li>\n\t\t\t\t\t\t\t<li class=\"page-next\"><a href=\"\">›</a></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div> -->\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t<div class=\"clearfix\"></div>\n\t\t</div>\n\t\t</div>\n\t<!--  end card  -->\n\n\t<!--  end card  -->\n\n</div>\n\n<script type='text/ng-template' id=\"upload-backup-template.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t\t{{'Carga de Archivos de Backup' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\" ng-style=\"uploadingFiles && {animation: 'load 1.1s infinite linear'}\">\n\t\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n\t\t\t\t</a>\n\t\t</h3>\n  </div>\n  <div class=\"modal-body\" id=\"modal-body\" ng-show=\"!displayUploadedList\">\n\t\t<form name=\"backupForm\" novalidate>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"fileBackup\">{{'Cargar Backups' | translate}}:</label><i> {{ fileUploader.queue.length }} {{'seleccionado(s)' | translate}}</i>\n\t\t\t\t<input type=\"file\" nv-file-select uploader=\"fileUploader\" class=\"form-control input_py\" multiple/>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"modal-body\" id=\"modal-body\" ng-show=\"displayUploadedList\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12 text-center\"><strong>{{'Tus archivos subidos' | translate}}</strong></div>\n\t\t</div>\n\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': inMobileView, 'table-hover': !inMobileView}\">\n\t\t\t<thead><tr>\n\t\t\t\t<th class=\"text-left\" data-field=\"Nombre del archivo\">\n\t\t\t\t\t<div class=\"th-inner\">{{'Nombre del archivo' | translate}}</div>\n\t\t\t\t</th>\n\t\t\t</tr></thead>\n\t\t\t<tbody><tr ng-repeat=\"file in uploadedFiles\"><td>\n\t\t\t\t{{ file.filename }}\n\t\t\t</td></tr></tbody>\n\t\t</table>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\"\n\t\t\tng-click=\"closeThisDialog();\" ng-show=\"!displayUploadedList\">\n\t\t\t\t{{'Cancelar' | translate}}\n\t\t</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar pull-right\" validation-submit=\"backupForm\" \n\t\t\tng-click=\"uploadBackup()\" ng-show=\"!displayUploadedList\">\n\t\t\t\t{{'Subir' | translate}}\n\t\t</button>\n\t\t<button type=\"submit\" class=\"btn btn-default btn_standar pull-right\" validation-submit=\"backupForm\" \n\t\t\tng-click=\"clearQueue()\" ng-show=\"!displayUploadedList\">\n\t\t\t\t{{'Reiniciar' | translate}}\n\t\t</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar pull-right\" validation-submit=\"backupForm\" \n\t\t\tng-click=\"closeThisDialog()\" ng-show=\"displayUploadedList\">\n\t\t\t\t{{'Salir' | translate}}\n\t\t</button>\n\t</div>\n</script>"

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(1036);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackupsController = function () {
	  function BackupsController(ContentService, $uibModal, Notification, isMobile, ProfilePermissionsService, moment, FileSaver, Blob, $translate, AccountInformationService) {
	    (0, _classCallCheck3.default)(this, BackupsController);
	
	    this.service = ContentService;
	    this.modal = $uibModal;
	    this.notify = Notification;
	    this.isMobile = isMobile;
	    this.permissionsService = ProfilePermissionsService;
	    this.moment = moment;
	    this.FileSaver = FileSaver;
	    this.Blob = Blob;
	    this.trans = $translate.instant;
	    this.accountService = AccountInformationService;
	  }
	
	  (0, _createClass3.default)(BackupsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	
	      this.subscriptions.push(this.backups.subscribe(function (backupList) {
	        _this.backupList = backupList.map(function (i) {
	          i.timestamp = _this.moment.utc(i.timestamp).tz(_this.accountService.timezone);
	          return i;
	        });
	      }, function (error) {
	        return console.log("an error has ocurred");
	      }));
	
	      this.multipleDelete = [];
	    }
	  }, {
	    key: "$onDestroy",
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: "downloadBackup",
	    value: function downloadBackup(backup) {
	      var _this2 = this;
	
	      var _ = this.trans;
	      this.subscriptions.push(this.service.downloadBackup(backup.filename).subscribe(function (data) {
	        var file = new _this2.Blob([data.data]);
	        _this2.FileSaver.saveAs(file, backup.filename);
	      }, function () {
	        _this2.notify.error(_("Ha ocurrido un error tratando de descargar el backup, intente nuevamente"));
	      }));
	    }
	  }, {
	    key: "openModalBackup",
	    value: function openModalBackup() {
	      var _this3 = this;
	
	      var that = this;
	      var allowedExtensions = ['sav'];
	
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'upload-backup-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "FileUploader", "host", "AuthService", "cfpLoadingBar", "$translate", function controller($scope, $state, $uibModalInstance, FileUploader, host, AuthService, cfpLoadingBar, $translate) {
	          "ngInject";
	
	          $scope.inMobileView = that.inMobileView;
	          $scope.displayUploadedList = false;
	          $scope.uploadedFiles = [];
	          $scope.uploadingFiles = false;
	          var _ = $translate.instant;
	          var fileUploader = $scope.fileUploader = new FileUploader({
	            url: host + '/api/accounts/backup-files',
	            headers: {
	              Authorization: 'Bearer ' + AuthService.getToken(),
	              'X-Account-Token': AuthService.getAccountToken()
	            },
	            filters: [{
	              name: 'allowedFile',
	              fn: function fn(item) {
	                return allowedExtensions.indexOf(item.name.toLowerCase().split('.').slice(-1)[0]) > -1;
	              }
	            }]
	          });
	          fileUploader.onSuccessItem = function (item, response, status, headers) {
	            var uploadedItem = {
	              id: response.id,
	              filename: response.filename,
	              filesize: response.filesize,
	              title: response.title,
	              timestamp: that.moment.utc(response.timestamp).tz(_this3.accountService.timezone)
	            };
	            $scope.uploadedFiles.push(uploadedItem);
	
	            var foundAt = that.backupList.findIndex(function (i) {
	              return i.filename === uploadedItem.filename;
	            });
	            if (foundAt > -1) {
	              that.backupList.splice(foundAt, 1, uploadedItem);
	            } else {
	              that.backupList.unshift(uploadedItem);
	            }
	            console.log("File successfully uploded");
	          };
	          fileUploader.onErrorItem = function (item, response, status, headers) {
	            that.notify.error(_("Ha ocurrido un error tratando de subir los archivos, intente nuevamente"));
	            console.log("An error happened while uploading file");
	          };
	
	          fileUploader.onProgressAll = function (progress) {
	            cfpLoadingBar.set(progress / 100);
	          };
	
	          fileUploader.onCompleteAll = function (item, response, status, headers) {
	            $scope.displayUploadedList = true;
	            $scope.uploadingFiles = false;
	            cfpLoadingBar.complete();
	          };
	
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.uploadBackup = function () {
	            if (fileUploader.queue.length > 0) {
	              fileUploader.uploadAll();
	              cfpLoadingBar.start();
	              $scope.uploadingFiles = true;
	            }
	          };
	          $scope.clearQueue = function () {
	            fileUploader.clearQueue();
	          };
	        }]
	      });
	    }
	  }, {
	    key: "deleteBackup",
	    value: function deleteBackup(backup) {
	      var _this4 = this;
	
	      this.subscriptions.push(this.service.deleteBackup(backup.id).subscribe(function (resp) {
	        _this4.backupList.splice(_this4.backupList.indexOf(backup), 1);
	      }, function (error) {
	        console.log(error);
	      }));
	    }
	  }, {
	    key: "toggleCheckDelete",
	    value: function toggleCheckDelete(backup) {
	      if (this.multipleDelete.indexOf(backup) <= -1) {
	        this.multipleDelete.push(backup);
	      } else {
	        this.multipleDelete.splice(this.multipleDelete.indexOf(backup), 1);
	      }
	    }
	  }, {
	    key: "deleteMultiplesBackups",
	    value: function deleteMultiplesBackups() {
	      var _this5 = this;
	
	      if (this.multipleDelete.length > 1 && this.permissionsService.hasPermission('remove-backup')) {
	        var backupIdList = this.multipleDelete.map(function (backup) {
	          return backup.id;
	        });
	        this.subscriptions.push(this.service.deleteMultiplesBackups(backupIdList).subscribe(function (data) {
	          _this5.notify.success(_('Sus Backups han sido eliminados exitosamente.'));
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(_this5.multipleDelete), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var deleted = _step.value;
	
	              _this5.backupList.splice(_this5.backupList.indexOf(deleted), 1);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          _this5.multipleDelete = [];
	        }, function (error) {
	          return _this5.notify.error(_('Ups, en estos momentos no podemos eliminar sus backups. Intente nuevamente.'));
	        }));
	      }
	    }
	  }]);
	  return BackupsController;
	}();
	
	exports.default = BackupsController;
	
	
	BackupsController.$inject = ['ContentService', '$uibModal', 'Notification', 'isMobile', 'ProfilePermissionsService', 'moment', 'FileSaver', 'Blob', '$translate', 'AccountInformationService'];

/***/ }),
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1058);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./backups.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./backups.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".Backups{color:red}", ""]);
	
	// exports


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _dtts = __webpack_require__(1060);
	
	var _dtts2 = _interopRequireDefault(_dtts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DttsModule = _angular2.default.module('Dtts', [_angularjs2.default]).component('dtts', _dtts2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dtts', {
	    url: '/dtts',
	    data: {
	      authRequired: true,
	      permsRequired: ['view-dtt', 'upload-dtt', 'process-dtts']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'dtts',
	        bindings: { dttsObservable: 'dttsObservable' }
	      }
	    },
	    resolve: {
	      dttsObservable: ["ContentService", "ProfilePermissionsService", function dttsObservable(ContentService, ProfilePermissionsService) {
	        return ProfilePermissionsService.hasPermission('view-dtt') ? ContentService.getDttsList() : {};
	      }]
	    }
	  });
	}]).name;
	
	exports.default = DttsModule;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dtts = __webpack_require__(1061);
	
	var _dtts2 = _interopRequireDefault(_dtts);
	
	var _dtts3 = __webpack_require__(1062);
	
	var _dtts4 = _interopRequireDefault(_dtts3);
	
	__webpack_require__(1069);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DttsComponent = {
	  bindings: {
	    dttsObservable: '<'
	  },
	  template: _dtts2.default,
	  controller: _dtts4.default
	};
	
	exports.default = DttsComponent;

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-8\">\n                {{'DTTs' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.dtts.length || 0 }}\n                </span>\n            </div>\n            <div class=\"col-md-4 text-right\">\n\t\t\n\t\t\t\t<a class=\"btn btn-success btn-sm\" href=\"\" \n\t\t\t\t\tdata-container=\"[data-ajax_action_container]\" ng-click=\"$ctrl.processDtts()\" \n\t\t\t\t\tdata-interaction_type=\"b\" data-ajax_load=\"\" if-perm disable-if=\"process-dtts\">\n\t\t\t\t\t<span>{{'Procesar' | translate}}</span>\n\t\t\t\t</a>\n\t\t\t\t<a class=\"btn btn-success btn-sm upload_file\" href=\"\" \n\t\t\t\t\tdata-container=\"[data-ajax_action_container]\" ng-click=\"$ctrl.openModalDtt()\" \n\t\t\t\t\tdata-interaction_type=\"b\" data-ajax_load=\"\" if-perm disable-if=\"upload-dtt\">\n\t\t\t\t\t<span class=\"glyphicon glyphicon-plus\"></span>\n\t\t\t\t\t<span>{{'Subir DTTs' | translate}}</span>\n\t\t\t\t</a>\n\t\t\t\n            </div>\n        </div>\n    </h1>\n\t<div class=\"card\">\n\t\t<div class=\"card-content\">\n\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t<div class=\"analyser_margin \">\n\t\t\t\t\t\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-disabled=\"$ctrl.activeTab === 'A'\"\n\t\t\t\t\t\t\t\tng-click=\"$ctrl.activeTab='A'; $ctrl.dtts=$ctrl.dttsUnprocessed\">\n\t\t\t\t\t\t\t<i class=\"fa fa-ban\" aria-hidden=\"true\"></i> {{'No procesado' | translate}}\t\t\t\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-disabled=\"$ctrl.activeTab === 'P'\"\n\t\t\t\t\t\t\t\tng-click=\"$ctrl.activeTab='P'; $ctrl.dtts=$ctrl.dttsProcessed\"> \n\t\t\t\t\t\t\t<i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{'Procesado' | translate}}\t\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar dtts' | translate}}</label>\n\t\t\t\t\t</div> \n\t\t\t\t</div>\n\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<!--<th class=\"text-center\" data-field=\"id\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">Seleccionar</div>\n\t\t\t\t\t\t\t\t\t</th>-->\n\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'filename' ? '-filename' : 'filename'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'filename', 'desc': orderedBy === '-filename'}\">{{'Nombre del archivo' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'timestamp' ? '-timestamp' : 'timestamp'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'timestamp', 'desc': orderedBy === '-timestamp'}\">{{'Subido en' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'filesize' ? '-filesize' : 'filesize'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'filesize', 'desc': orderedBy === '-filesize'}\">{{'Tamaño' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"dtt in $ctrl.dtts | orderBy:orderedBy | filter:filterCrit as filtered\">\n\t\t\t\t\t\t\t\t\t<!--<td class=\"bs-checkbox text-left\"><input data-index=\"7\" name=\"btSelectItem\" type=\"checkbox\"></td>-->\n\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Nombre del archivo' | translate}}:\" class=\"text-left\">\n\t\t\t\t\t\t\t\t\t\t<a class=\"clickable\" ng-click=\"$ctrl.downloadDtt(dtt)\">{{ dtt.filename }}</a>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Subido en' | translate}}:\" class=\"text-center\">{{ dtt.timestamp | amDateFormat:'DD/MMM/YYYY HH:mm' }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Tamaño' | translate}}:\" class=\"text-center\">{{ $ctrl.formatSize(dtt.filesize) }}</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- <div paging\n\t\t\t\tpage=\"$ctrl.currentPage\"\n\t\t\t\tpage-size=\"100\"\n\t\t\t\ttotal=\"1000\"\n\t\t\t\tshow-prev-next=\"true\"\n\t\t\t\tshow-first-last=\"true\"\n\t\t\t\tpaging-action=\"$ctrl.changePage('Paging Clicked', page, pageSize, total)\">\n\t\t\t</div> -->\n\n\t\t</div>\n\t\t<div class=\"clearfix\"></div>\n\t</div>\n</div>\n<!-- \t\t\t\t\t\t<div class=\"fixed-table-pagination\">\n\t\t\t\t\t\t<div class=\"pull-left pagination-detail\">\n\t\t\t\t\t\t\t<span class=\"page-list\">\n\t\t\t\t\t\t\t\t<span class=\"btn-group dropup\">\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"page-size\">8</span> \n\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</span>Filas visible\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"pull-right pagination\">\n\t\t\t\t\t\t\t<ul class=\"pagination\">\n\t\t\t\t\t\t\t<li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number active\"><a href=\"\">1</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">2</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">3</a></li>\n\t\t\t\t\t\t\t<li class=\"page-next\"><a href=\"\">›</a></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div> -->\n\n<script type='text/ng-template' id=\"upload-dtt-template.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t{{'Carga de Archivos DTT' | translate}}\n\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\" ng-style=\"uploadingFiles && {animation: 'load 1.1s infinite linear'}\">\n\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n\t\t\t</a>\n\t\t</h3>\n\t\t<!-- <div class=\"spinner pull-right\" ng-show=\"uploadingFiles\"></div> -->\n  \t</div>\n  \t<div class=\"modal-body\" id=\"modal-body\" ng-show=\"!displayUploadedList\">\n\t\t<form name=\"dttForm\" novalidate>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"fileDtt\">{{'Cargar DTT' | translate}}:</label><i> {{ fileUploader.queue.length }} {{'seleccionado(s)' | translate}}</i>\n\t\t\t\t<input type=\"file\" nv-file-select uploader=\"fileUploader\" class=\"form-control input_py\" multiple />\n\t\t\t</div>\n\t\t</form>\n\t</div>\n  \t<div class=\"modal-body\" id=\"modal-body\" ng-show=\"displayUploadedList\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12 text-center\"><strong>{{'Tus archivos subidos' | translate}}</strong></div>\n\t\t</div>\n\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': inMobileView, 'table-hover': !inMobileView}\">\n\t\t\t<thead><tr>\n\t\t\t\t<th class=\"text-left\" data-field=\"Nombre del archivo\">\n\t\t\t\t\t<div class=\"th-inner\">{{'Nombre del archivo' | translate}}</div>\n\t\t\t\t</th>\n\t\t\t</tr></thead>\n\t\t\t<tbody><tr ng-repeat=\"file in uploadedFiles\"><td>\n\t\t\t\t{{ file.filename }}\n\t\t\t</td></tr></tbody>\n\t\t</table>\n\t</div>\n\t<div class=\"modal-footer\" ng-show=\"!displayUploadedList\">\n\t\t<button type=\"submit\" class=\"btn btn-default btn_standar\" validation-submit=\"dttForm\" \n\t\t\t\tng-click=\"clearQueue()\">{{'Reiniciar' | translate}}</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" validation-submit=\"dttForm\" \n\t\t\t\tng-click=\"uploadDtt()\">{{'Subir' | translate}}</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n\t</div>\n\t<div class=\"modal-footer\" ng-show=\"displayUploadedList\">\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" if-perm disable-if=\"process-dtts\" ng-click=\"processDtt()\">{{'Procesar' | translate}}</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n\t</div>\n</script>"

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNan = __webpack_require__(962);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _parseFloat = __webpack_require__(1063);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DttsController = function () {
	  function DttsController(ContentService, $uibModal, isMobile, Notification, moment, FileSaver, Blob, $translate, AccountService) {
	    (0, _classCallCheck3.default)(this, DttsController);
	
	    this.service = ContentService;
	    this.modal = $uibModal;
	    this.isMobile = isMobile;
	    this.notify = Notification;
	    this.moment = moment;
	    this.FileSaver = FileSaver;
	    this.Blob = Blob;
	    this.trans = $translate.instant;
	    this.accountService = AccountService;
	  }
	
	  (0, _createClass3.default)(DttsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      var _ = this.trans;
	      this.inMobileView = this.isMobile.phone;
	
	      this.subscriptions.push(this.dttsObservable.subscribe(function (dttFiles) {
	        _this.dttsProcessed = dttFiles.processed.map(function (i) {
	          i.timestamp = _this.moment.utc(i.timestamp).tz(_this.accountService.timezone);
	          return i;
	        });
	        _this.dttsUnprocessed = dttFiles.unprocessed.map(function (i) {
	          i.timestamp = _this.moment.utc(i.timestamp).tz(_this.accountService.timezone);
	          return i;
	        });
	        _this.dtts = _this.dttsUnprocessed;
	      }, function (error) {
	        return console.log(error);
	      }));
	      this.activeTab = 'A';
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'downloadDtt',
	    value: function downloadDtt(dtt) {
	      var _this2 = this;
	
	      var _ = this.trans;
	      this.subscriptions.push(this.service.downloadDTT(dtt.filename).subscribe(function (data) {
	        var file = new _this2.Blob([data.data], { type: 'text/plain;charset=utf-8' });
	        _this2.FileSaver.saveAs(file, dtt.filename);
	      }, function () {
	        _this2.notify.error(_("Ha ocurrido un error tratando de descargar el backup, intente nuevamente"));
	      }));
	    }
	  }, {
	    key: 'processDtts',
	    value: function processDtts() {
	      var external = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var _ = this.trans;
	      var response = this.service.triggerDttProcess();
	      if (external) {
	        return response;
	      } else {
	        this.subscriptions.push(response.subscribe(function () {
	          that.notify.success(_("Los archivos pendientes están siendo procesados"));
	        }));
	      }
	    }
	  }, {
	    key: 'changePage',
	    value: function changePage(str, page) {
	      var _this3 = this;
	
	      this.subscriptions.push(this.service.getDttsList(page).subscribe(function (dttFiles) {
	        _this3.dttsProcessed = dttFiles.processed.map(function (i) {
	          i.timestamp = _this3.moment.utc(i.timestamp).tz(_this3.accountService.timezone);
	          return i;
	        });
	        _this3.dttsUnprocessed = dttFiles.unprocessed.map(function (i) {
	          i.timestamp = _this3.moment.utc(i.timestamp).tz(_this3.accountService.timezone);
	          return i;
	        });
	        _this3.dtts = _this3.dttsUnprocessed;
	      }, function (error) {
	        return console.log(error);
	      }));
	    }
	  }, {
	    key: 'openModalDtt',
	    value: function openModalDtt() {
	      var _this4 = this;
	
	      var that = this;
	      var allowedExtensions = ['dtt'];
	      var _ = that.trans;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'upload-dtt-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "FileUploader", "host", "AuthService", "cfpLoadingBar", function controller($scope, $state, $uibModalInstance, FileUploader, host, AuthService, cfpLoadingBar) {
	          "ngInject";
	
	          $scope.inMobileView = that.inMobileView;
	          $scope.displayUploadedList = false;
	          $scope.uploadedFiles = [];
	          $scope.uploadingFiles = false;
	
	          var fileUploader = $scope.fileUploader = new FileUploader({
	            url: host + '/api/accounts/dtt-files',
	            headers: {
	              Authorization: 'Bearer ' + AuthService.getToken(),
	              'X-Account-Token': AuthService.getAccountToken()
	            },
	            filters: [{
	              name: 'allowedFile',
	              fn: function fn(item) {
	                // TODO: Display incorrect filetype message.
	                return allowedExtensions.indexOf(item.name.toLowerCase().split('.').slice(-1)[0]) > -1;
	              }
	            }]
	          });
	          fileUploader.onSuccessItem = function (item, response, status, headers) {
	            var uploadedItem = {
	              id: response.id,
	              filename: response.filename,
	              filesize: response.filesize,
	              timestamp: that.moment.utc(response.timestamp).tz(_this4.accountService.timezone)
	            };
	            $scope.uploadedFiles.push(uploadedItem);
	
	            var foundAt = that.dttsUnprocessed.findIndex(function (i) {
	              return i.filename === uploadedItem.filename;
	            });
	            if (foundAt > -1) {
	              that.dttsUnprocessed.splice(foundAt, 1, uploadedItem);
	            } else {
	              that.dttsUnprocessed.unshift(uploadedItem);
	            }
	          };
	          fileUploader.onErrorItem = function (item, response, status, headers) {
	            that.notify.error(_("Ha ocurrido un error tratando de subir los archivos, intente nuevamente"));
	            console.log("An error happened while uploading file");
	          };
	
	          fileUploader.onProgressAll = function (progress) {
	            cfpLoadingBar.set(progress / 100);
	          };
	
	          fileUploader.onCompleteAll = function () {
	            $scope.displayUploadedList = true;
	            $scope.uploadingFiles = false;
	            cfpLoadingBar.complete();
	          };
	
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.uploadDtt = function () {
	            if (fileUploader.queue.length > 0) {
	              fileUploader.uploadAll();
	              cfpLoadingBar.start();
	              $scope.uploadingFiles = true;
	            }
	          };
	          $scope.processDtt = function () {
	            that.subscriptions.push(that.processDtts(true).subscribe(function () {
	              that.notify.success(_("Los archivos están siendo procesados"));
	              $scope.closeThisDialog();
	              $scope.uploadedFiles = [];
	              $scope.displayUploadedList = false;
	            }));
	          };
	          $scope.clearQueue = function () {
	            fileUploader.clearQueue();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'formatSize',
	    value: function formatSize(value) {
	      var asNum = (0, _parseFloat2.default)(value);
	      return !(0, _isNan2.default)(asNum) ? asNum : '-';
	    }
	  }]);
	  return DttsController;
	}();
	
	exports.default = DttsController;
	
	
	DttsController.$inject = ['ContentService', '$uibModal', 'isMobile', 'Notification', 'moment', 'FileSaver', 'Blob', '$translate', 'AccountInformationService'];

/***/ }),
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1070);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dtts.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dtts.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".spinner{width:2em;height:2em;border-radius:100%;border:1px solid hsla(0,0%,100%,.2);border-left-color:#fff;-webkit-animation:load 1.1s infinite linear;animation:load 1.1s infinite linear}@-webkit-keyframes load{0%{-ms-transform:rotate(7deg);-webkit-transform:rotate(7deg);transform:rotate(7deg)}to{-ms-transform:rotate(1turn);-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes load{0%{-ms-transform:rotate(7deg);-webkit-transform:rotate(7deg);transform:rotate(7deg)}to{-ms-transform:rotate(1turn);-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _findInvoice = __webpack_require__(1072);
	
	var _findInvoice2 = _interopRequireDefault(_findInvoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FindInvoiceModule = _angular2.default.module('FindInvoice', [_angularjs2.default]).component('findInvoice', _findInvoice2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('findInvoice', {
	    url: '/find-invoice',
	    data: {
	      authRequired: true,
	      permsRequired: ['account-bills']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'findInvoice'
	      }
	    }
	  });
	}]).name;
	
	exports.default = FindInvoiceModule;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _findInvoice = __webpack_require__(1073);
	
	var _findInvoice2 = _interopRequireDefault(_findInvoice);
	
	var _findInvoice3 = __webpack_require__(1074);
	
	var _findInvoice4 = _interopRequireDefault(_findInvoice3);
	
	__webpack_require__(1075);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FindInvoiceComponent = {
	  bindings: {},
	  template: _findInvoice2.default,
	  controller: _findInvoice4.default
	};
	
	exports.default = FindInvoiceComponent;

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{'Localización de Facturas' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.invoices.length || 0 }}\n                </span>\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form name=\"findInvoiceForm\" class=\"hidden-sm hidden-xs\">\n            <div class=\"form col-md-12 no-padding\">\n        \n                <input type=\"hidden\" name=\"sorter\" value=\"\">\n                \n                <input type=\"hidden\" name=\"cashier_id\" value=\"\">\n                \n                <input type=\"hidden\" name=\"pos_id\" value=\"\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Fecha' | translate}}</label>    \n                    <input type=\"text\" name=\"date\" ng-model=\"$ctrl.date\" id=\"date\" class=\"form-control\"\n\t\t\t\t\t\t\tformat=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.date\" start-view=\"month\" readonly>\n                    <label for=\"to\" class=\"input-group-addon\">{{'Factura' | translate}}</label>    \n                    <input type=\"text\" name=\"invoice\" ng-model=\"$ctrl.invoice\" id=\"invoice\" class=\"form-control\">\n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.findInvoice()\">{{'Buscar' | translate}}</button>    \n                    </span>\n                </div>\n            </div>\n        </form>\n\t\t<form class=\"visible-xs visible-sm\">\n            <div class=\"form_xs\">\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_left\">\n\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n\t\t\t\t\t<input class=\"form-control input_py\" name=\"date\" ng-model=\"$ctrl.date\" \n\t\t\t\t\t\tmoment-picker=\"$ctrl.date\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\"\n\t\t\t\t\t\tstart-view=\"month\" readonly>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_right\">\n\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Factura' | translate}}</p>\n\t\t\t\t\t<input class=\"form-control input_py\" name=\"invoice\" ng-model=\"$ctrl.invoice\">\n\t\t\t\t</div>\n\t\t\t\t<button name=\"submitBtn\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.findInvoice()\">{{'Buscar' | translate}}</button>    \n            </div>\n        </form>\n    </div>\n\t<div class=\"col-md-12 table_container\">\n\t\t<div class=\"card\">\n\t\t\t<div class=\"card-content\">\n\t\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t\t\t\t<div class=\"columns pull-right\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-success dropdown-toggle\" data-toggle=\"dropdown\" ng-csv=\"$ctrl.getInvoices()\" csv-header=\"['Factura','Fecha','Hora','Mesa','NCF','Nombre','RNC','Desc.','Pax','Propina','% Ley','IVA','Total']\", csv-column-order=\"['number','date','time','table','ncf','name','rnc','discount','pax','extra_tip','tax10','tax16','total']\" filename=\"{{$ctrl.invoice}}.csv\" ng-disabled=\"$ctrl.invoices.length <= 0\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-file-o\" aria-hidden=\"true\"></i> {{'Exportar CSV' | translate}}\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar facturas' | translate}}</label>\n\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'number' ? '-number' : 'number'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'number', 'desc': orderedBy === '-number'}\">{{'Factura' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'date' ? '-date' : 'date'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'date', 'desc': orderedBy === '-date'}\">{{'Fecha' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'time' ? '-time' : 'time'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'time', 'desc': orderedBy === '-time'}\">{{'Hora' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'table' ? '-table' : 'table'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'table', 'desc': orderedBy === '-table'}\">{{'Mesa' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'ncf' ? '-ncf' : 'ncf'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'ncf', 'desc': orderedBy === '-ncf'}\">{{'NCF' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'name' ? '-name' : 'name'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'name', 'desc': orderedBy === '-name'}\">{{'Nombre' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'rnc' ? '-rnc' : 'rnc'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'rnc', 'desc': orderedBy === '-rnc'}\">{{'RNC' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'discount' ? '-discount' : 'discount'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'discount', 'desc': orderedBy === '-discount'}\">{{'Descuento' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'pax' ? '-pax' : 'pax'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'pax', 'desc': orderedBy === '-pax'}\">{{'Pax' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'extra_tip' ? '-extra_tip' : 'extra_tip'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'extra_tip', 'desc': orderedBy === '-extra_tip'}\">{{'Propina' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'tax10' ? '-tax10' : 'tax10'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'tax10', 'desc': orderedBy === '-tax10'}\">{{'% Ley' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'tax16' ? '-tax16' : 'tax16'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'tax16', 'desc': orderedBy === '-tax16'}\">{{'Impuesto IVA' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'total' ? '-total' : 'total'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'total', 'desc': orderedBy === '-total'}\">{{'Total' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"invoice in $ctrl.invoices | orderBy:orderedBy | filter:filterCrit as filtered\" ng-click=\"$ctrl.openBillDetails(invoice.id)\" if-perm disable-if=\"account-bills, invoice-orders\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Factura' | translate }}:\" class=\"text-center\">{{ invoice.number }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Fecha' | translate }}:\" class=\"text-center\">{{ invoice.date | amUtc | amDateFormat:'DD/MMM/YYYY' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Hora' | translate }}:\" class=\"text-center\">{{ invoice.time }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Mesa' | translate }}:\" class=\"text-center\">{{ invoice.table }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'NCF' | translate }}:\" class=\"text-center\">{{ invoice.ncf || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Nombre' | translate }}:\" class=\"text-center\">{{ invoice.name || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'RNC' | translate }}:\" class=\"text-center\">{{ invoice.rnc || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Descuento' | translate }}:\" class=\"text-right\">{{ invoice.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Pax' | translate }}:\" class=\"text-center\">{{ invoice.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Propina' | translate }}:\" class=\"text-right\">{{ invoice.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'% Ley' | translate }}:\" class=\"text-right\">{{ invoice.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Impuesto IVA' | translate }}:\" class=\"text-right\">{{ invoice.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Total' | translate }}:\" class=\"text-right\">{{ invoice.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t<tfoot>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"{{'Total Descuento' | translate }}:\" colspan=\"8\" data-field=\"name\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"{{'Total Pax' | translate }}:\" data-field=\"name\" class=\"text-center\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getPax | sum: 0 }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"{{'Total Propina' | translate }}:\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getExtraTip | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"{{'Total % Ley' | translate }}:\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTax10 | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"{{'Total IVA' | translate }}:\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTax16 | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"{{'Total' | translate }}:\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tfoot>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"fixed-table-pagination hidden\">\n\t\t\t\t\t\t\t<div class=\"pull-left pagination-detail\">\n\t\t\t\t\t\t\t\t<span class=\"page-list\">\n\t\t\t\t\t\t\t\t\t<span class=\"btn-group dropup\">\n\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"page-size\">8</span> \n\t\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t</span>Filas visible\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"pull-right pagination\">\n\t\t\t\t\t\t\t\t<ul class=\"pagination\">\n\t\t\t\t\t\t\t\t<li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-number active\"><a href=\"\">1</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">2</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">3</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-next\"><a href=\"\">›</a></li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t<div class=\"clearfix\"></div>\n\t\t</div>\n\t\t</div>\n\t<!--  end card  -->\n\t</div>\n\t<!--  end card  -->\n</div>\n\n<script type='text/ng-template' id=\"invoice-details-template.html\">\n\t<div class=\"modal-header\">\n    \t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t\tDetalle de Factura\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    \t</h3>\n  \t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n    <nav>\n        <ul class=\"Tabs\">\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: !showOrders}\" ng-click=\"showOrders=false\"\n\t\t\t\tif-perm disable-if=\"account-bills\">\n\t\t\t\t\t\t\t<a href=\"#\">Factura</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: showOrders}\" ng-click=\"getOrders(); showOrders=true\"\n\t\t\t\tif-perm disable-if=\"invoice-orders\">\n\t\t\t\t\t\t\t<a href=\"#\">Órdenes</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\">\n                <button class=\"btn btn-default pull-right\" ng-click=\"printToCart('printSectionId')\">\n                    <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                </button>\n            </li>\n            <li class=\"Tabs__presentation-slider\" role=\"presentation\"></li>\n        </ul>\n    </nav>\n\n<!-- start print -->\n\t\t<div id=\"printSectionId\" class=\"Section_Print\">\n\t\t\t<div class=\"Powered\">\n\t\t\t\t<span>RNC: </span>{{account.identification || '-'}} <br>\n\t\t\t\t<span>Dirección: </span>{{ account.address || '-'}} <br>\n\t\t\t\t<span>Telefono: </span>{{ account.phone || '-'}}\n\t\t\t</div>\n\t\t\t<div class=\"logo_invoice\">\n\t\t\t\t<img src=\"{{ logoUrl }}\" alt=\"\">\n\t\t\t</div>\n\t\t\t<div class=\"print_separator\"></div>\n\t\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-condensed tableforprint\">\n\t\t\t\t\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>No. Factura:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-right\">\n\t\t\t\t\t\t<strong>Fecha:</strong> <span>{{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise  }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>NCF:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\tRNC <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<!-- <tr>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Mesa No.:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Atendida por:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Pax:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr> -->\n\t\t\t\t\n\t\t\t\t<tr><td><hr></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th class=\"text-center\" \"3\">Detalles</th>\n\t\t\t\t\t<th class=\"text-center\">Cantidad</th>\n\t\t\t\t\t<th class=\"text-center\">Descuento</th>\n\t\t\t\t\t<th class=\"text-center\">Total</th>\n\t\t\t\t\t\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td class=\"text-center\" \"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.discount | currency }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.total | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"><hr></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>Notas:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>Subtotal</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\tComensales: <span>{{ invoice.pax }}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>Descuento</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.discount | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"2\">\n\t\t\t\t\t\t<span>Atentdido por: </span>\n\t\t\t\t\t\t<span>{{ invoice.cashier || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>% Ley:</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>IVA:</span> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>Exoneracion IVA:</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>Total:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{ invoice.total | currency }}</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<!-- <td \"3\">\n\t\t\t\t\t\t<strong>Impuestos incluidos:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td> -->\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\t\t</div>\n<!-- end print -->\n\n\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-bordered table-condensed\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>No. Factura:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>NCF:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>Fecha:</strong> {{ invoice.date | amUtc | amDateFormat:'DD/MMM/YYYY'  }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>Emitido a:</strong> {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>Mesa No.:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>Atendida por:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>Desc.:</strong> {{ invoice.discount | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>Pax:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>Total:</strong> {{ invoice.total | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>Impuestos incluidos:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>IVA:</strong> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>% Ley:</strong> {{ invoice.tax10 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th colspan=\"3\">Detalles</th>\n\t\t\t\t\t<th>Cantidad</th>\n\t\t\t\t\t<th>Total</th>\n\t\t\t\t\t<th>Desc.</th>\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td colspan=\"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.total | currency }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.discount | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=\"orders\" ng-show=\"showOrders\">\n\t\t\t<table id=\"pruena\" class=\"table table-bordered table-condensed\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Factura</th>\n\t\t\t\t\t\t<th>Acción</th>\n\t\t\t\t\t\t<th>Fecha</th>\n\t\t\t\t\t\t<th>Vendedor</th>\n\t\t\t\t\t\t<th>Estado</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat=\"order in orders\">\n\t\t\t\t\t\t<td data-label=\"Factura\">\n\t\t\t\t\t\t\t<a href=\"\" data-ajax_load=\"\" data-container=\"#billpayment\" class=\"btn btn-xs btn-primary\"\n\t\t\t\t\t\t\t\tng-click=\"fetchDetails(order)\">\n\t\t\t\t\t\t\t\t{{ order.id }}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td data-label=\"Acción\">{{ order.action || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Fecha\">{{ order.date | amUtc | amDateFormat:'DD/MMM/YYYY' }}</td>\n\t\t\t\t\t\t<td data-label=\"Vendedor\">{{ order.cashier || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Estado\">{{ order.status || '-' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t\t<table class=\"table table-bordered table-condensed\" ng-show=\"displayingOrder\">\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr><td colspan=\"4\">{{ displayingOrder.action || '-' }}</td></tr>\n\t\t\t\t\t<tr class=\"table_list_heading\">\n\t\t\t\t\t\t<th class=\"detail_table hidden-xs hidden-sm\" width=\"100\"><b>De la Factura</b></th>\n\t\t\t\t\t\t<td data-label=\"De la Factura:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.billid || '-' }}</td>\n\t\t\t\t\t\t<th class=\" hidden-xs hidden-sm\" width=\"100\"><b>Fecha</b></th>\n\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.date | amUtc | amDateFormat:'DD/MMM/YYYY' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>Vendedor:</b></th>\n\t\t\t\t\t\t<td data-label=\"Vendedor:\">{{ displayingOrder.cashier || '-' }}</td>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>Mesa:</b></th>\n\t\t\t\t\t\t<td data-label=\"Mesa:\" colspan=\"2\">{{ displayingOrder.table_type || '-' }} {{ displayingOrder.table_code || '' }}</td>\n\t\t\t\t\t</tr>\n\n\t\t\t\t\t<tr class=\"table_graund\" ng-repeat=\"detail in displayingOrder.details\">\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.name  || '-' }}</td>\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.qty  || 0 }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">\n\t\t\tSalir\n\t\t</button>\n\t</div>\n</script>\n"

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FindInvoiceController = function () {
	  function FindInvoiceController(ContentService, isMobile, moment, ProfilePermissionsService, $uibModal) {
	    (0, _classCallCheck3.default)(this, FindInvoiceController);
	
	    this.service = ContentService;
	    this.isMobile = isMobile;
	    this.moment = moment;
	    this.permissionsService = ProfilePermissionsService;
	    this.modal = $uibModal;
	  }
	
	  (0, _createClass3.default)(FindInvoiceController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	      this.date = undefined;
	
	      this.invoice = '';
	      this.invoices = [];
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'getInvoices',
	    value: function getInvoices() {
	      var _this = this;
	
	      return this.invoices.map(function (inv) {
	        var newInv = angular.copy(inv, {});
	        newInv.date = _this.moment(newInv.date).format('DD/MM/YYYY');
	        return newInv;
	      });
	    }
	  }, {
	    key: 'findInvoice',
	    value: function findInvoice() {
	      var _this2 = this;
	
	      this.subscriptions.push(this.service.findInvoice({
	        date: this.date.format(),
	        bill_id: this.invoice
	      }).subscribe(function (invoices) {
	        return _this2.invoices = invoices;
	      }, function (err) {
	        return console.log(err);
	      }));
	    }
	  }, {
	    key: 'getDiscount',
	    value: function getDiscount(item) {
	      return item.discount;
	    }
	  }, {
	    key: 'getPax',
	    value: function getPax(item) {
	      return item.pax;
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal(item) {
	      return item.total;
	    }
	  }, {
	    key: 'getExtraTip',
	    value: function getExtraTip(item) {
	      return item.extra_tip;
	    }
	  }, {
	    key: 'getTax10',
	    value: function getTax10(item) {
	      return item.tax10;
	    }
	  }, {
	    key: 'getTax16',
	    value: function getTax16(item) {
	      return item.tax16;
	    }
	  }, {
	    key: 'openBillDetails',
	    value: function openBillDetails(invoiceId) {
	      var that = this;
	      if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')) {
	        this.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'invoice-details-template.html',
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "$uibModalInstance", "AccountInformationService", function controller($scope, $uibModalInstance, AccountInformationService) {
	            "ngInject";
	
	            $scope.invoice = {};
	            $scope.orders = [];
	            $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
	            that.subscriptions.push(that.service.getInvoice(invoiceId).subscribe(function (invoice) {
	              return $scope.invoice = invoice;
	            }, function (error) {
	              return console.log("Error while getting the invoice");
	            }));
	
	            $scope.getOrders = function () {
	              if ($scope.orders.length <= 0) {
	                that.subscriptions.push(that.service.getOrders(invoiceId).subscribe(function (orders) {
	                  return $scope.orders = orders;
	                }, function (error) {
	                  return console.log("Error while getting the orders");
	                }));
	              }
	            };
	
	            that.subscriptions.push(AccountInformationService.getAccountInfo().subscribe(function (resp) {
	              $scope.account = resp;
	            }));
	
	            $scope.fetchDetails = function (order) {
	              if (!order.details || order.details.length <= 0) {
	                that.subscriptions.push(that.service.getOrderDetails(invoiceId, order.id).subscribe(function (details) {
	                  order.details = details;
	                  $scope.displayingOrder = order;
	                }, function (error) {
	                  return console.log("Error while getting the details for this order");
	                }));
	              }
	            };
	
	            $scope.printToCart = function (printSectionId) {
	              var innerContents = document.getElementById(printSectionId).innerHTML;
	              var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	              popupWinindow.document.open();
	              var styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              var styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              popupWinindow.document.write('<html><head><title>Imprimir factura #' + $scope.invoice.number + '</title><style>' + styleprint.innerHTML + '</style><style>' + styleprintBootstrap.innerHTML + '</style></head><body onload="window.print()">' + innerContents + '</html>');
	              popupWinindow.document.close();
	            };
	
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	          }]
	        });
	      }
	    }
	  }]);
	  return FindInvoiceController;
	}();
	
	exports.default = FindInvoiceController;
	
	
	FindInvoiceController.$inject = ['ContentService', 'isMobile', 'moment', 'ProfilePermissionsService', '$uibModal'];

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1076);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./find-invoice.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./find-invoice.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".FindInvoice{color:red}", ""]);
	
	// exports


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _invoiceNcf = __webpack_require__(1078);
	
	var _invoiceNcf2 = _interopRequireDefault(_invoiceNcf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceNcfModule = _angular2.default.module('InvoiceNcf', [_angularjs2.default]).component('invoiceNcf', _invoiceNcf2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('invoiceNcf', {
	    url: '/invoice-ncf',
	    data: {
	      authRequired: true,
	      permsRequired: ['view-ncf', 'create-ncf']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'invoiceNcf'
	      }
	    },
	    resolve: {
	      ncfObservable: ["ContentService", "ProfilePermissionsService", function ncfObservable(ContentService, ProfilePermissionsService) {
	        return ProfilePermissionsService.hasPermission('view-ncf') ? ContentService.getNcfList() : {};
	      }]
	    }
	  });
	}]).name;
	
	exports.default = InvoiceNcfModule;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invoiceNcf = __webpack_require__(1079);
	
	var _invoiceNcf2 = _interopRequireDefault(_invoiceNcf);
	
	var _invoiceNcf3 = __webpack_require__(1080);
	
	var _invoiceNcf4 = _interopRequireDefault(_invoiceNcf3);
	
	__webpack_require__(1081);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceNcfComponent = {
	  bindings: {
	    ncfObservable: '<'
	  },
	  template: _invoiceNcf2.default,
	  controller: _invoiceNcf4.default
	};
	
	exports.default = InvoiceNcfComponent;

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n\t<h1 class=\"page-header\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-10 col-sm-10 col-xs-11\">\n\t\t\t\t{{'Listado de NCFs' | translate}}\n\t\t\t\t<span class=\"badge badge-primary\">\n\t\t\t\t\t\t{{ $ctrl.nfcList.length || 0 }}\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-2\">\n\t\t\t\t<a class=\"float-right btn btn-success btn-sm btn_transitions\" href=\"\" \n\t\t\t\t\tng-click=\"$ctrl.openNCFModal()\"\n\t\t\t\t\tif-perm disable-if=\"create-ncf\">\n\t\t\t\t\t<span class=\"glyphicon glyphicon-plus\"></span>\n\t\t\t\t\t<span>{{'Registrar nuevo NCF' | translate}}</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</h1>\n\t<div class=\"col-md-12 table_container\">\n\t\t<div class=\"card\">\n\t\t\t<div class=\"card-content\">\n\t\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t\t\t\t<div class=\"columns columns-right pull-right hidden\">\n\t\t\t\t\t\t\t<div class=\"keep-open btn-group\" title=\"Columns\">\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-columns\"></i> <span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar ncf' | translate}}</label>\n\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'description' ? '-description' : 'description'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'description', 'desc': orderedBy === '-description'}\">{{'Descripción' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'sequence' ? '-sequence' : 'sequence'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'sequence', 'desc': orderedBy === '-sequence'}\">{{'Secuencia' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th class=\"text-right\" data-field=\"salary\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{'Acciones' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"ncf in $ctrl.ncfList | orderBy:orderedBy | filter:filterCrit as filtered\">\n\t\t\t\t\t\t\t\t\t<td data-label=\"Descripción\" class=\"text-center\">{{ ncf.description }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Secuencia\" class=\"text-center\">{{ ncf.sequence }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Acciones\" class=\"td-actions text-right\" >\n\t\t\t\t\t\t\t\t\t\t<div class=\"table-icons\">\n\t\t\t\t\t\t\t\t\t\t\t<a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-warning btn-icon\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.openNCFModal(ncf)\" \n\t\t\t\t\t\t\t\t\t\t\t\tdata-original-title=\"Editar\"\n\t\t\t\t\t\t\t\t\t\t\t\tif-perm disable-if=\"edit-ncf\">  \n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t<a rel=\"tooltip\" title=\"\"\n\t\t\t\t\t\t\t\t\t\t\t\tclass=\"btn btn-simple btn-danger btn-icon\"\n\t\t\t\t\t\t\t\t\t\t\t\tmwl-confirm\n\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{'¿Esta seguro?' | translate}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tmessage=\"{{'ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?' | translate}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tconfirm-text=\"Eliminar\"\n\t\t\t\t\t\t\t\t\t\t\t\tcancel-text=\"Cancelar\"\n\t\t\t\t\t\t\t\t\t\t\t\tplacement=\"left\"\n\t\t\t\t\t\t\t\t\t\t\t\ton-confirm=\"$ctrl.deleteNCF(ncf)\"\n\t\t\t\t\t\t\t\t\t\t\t\ton-cancel=\"\"\n\t\t\t\t\t\t\t\t\t\t\t\tconfirm-button-type=\"danger\"\n\t\t\t\t\t\t\t\t\t\t\t\tcancel-button-type=\"default\"\n\t\t\t\t\t\t\t\t\t\t\t\tif-perm disable-if=\"delete-ncf\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"fixed-table-pagination hidden\">\n\t\t\t\t\t\t<div class=\"pull-left pagination-detail\">\n\t\t\t\t\t\t\t<span class=\"page-list\">\n\t\t\t\t\t\t\t\t<span class=\"btn-group dropup\">\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"page-size\">8</span> \n\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</span>{{'Filas visible' | translate}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"pull-right pagination\">\n\t\t\t\t\t\t\t<ul class=\"pagination\">\n\t\t\t\t\t\t\t<li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number active\"><a href=\"\">1</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">2</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">3</a></li>\n\t\t\t\t\t\t\t<li class=\"page-next\"><a href=\"\">›</a></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"clearfix\"></div>\n\t\t</div>\n\t\t</div>\n\t<!--  end card  -->\n\t</div>\n\t\t<!--  end card  -->\n</div>\n\n<script type='text/ng-template' id=\"new-ncf-template.html\">\n\t<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\" ng-if=\"!ncfInvoice.id\">\n\t\t\t{{'Registrar Nuevo NCF' | translate}}\n\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    </h3>\n\t\t<h3 class=\"modal-title\" id=\"modal-title\" ng-if=\"!!ncfInvoice.id\">\n\t\t\t{{'Editar NCF' | translate}}\n\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    </h3>\n  </div>\n  <div class=\"modal-body\" id=\"modal-body\">\n\t\t<form name=\"ncfForm\" novalidate>\t\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"description\">{{'Descripción' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"description\" ng-model=\"ncfInvoice.description\" validator=\"required\"\n\t\t\t\t\t\t\t\tvalid-method=\"watch, submit\" class=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label for=\"sequence\">{{'Sequencia' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"sequence\" ng-model=\"ncfInvoice.sequence\" validator=\"required\"\n\t\t\t\t\t\t\t\tvalid-method=\"watch, submit\" class=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" validation-submit=\"ncfForm\" \n\t\t\t\t\t\tng-if=\"!!ncfInvoice.id\" ng-click=\"editNCF()\">{{'Editar' | translate}}</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" validation-submit=\"ncfForm\" \n\t\t\t\t\t\tng-if=\"!ncfInvoice.id\" ng-click=\"registerNCF()\">{{'Crear' | translate}}</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n\t</div>\n</script>"

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceNcfController = function () {
	  function InvoiceNcfController($state, $uibModal, ContentService, isMobile) {
	    (0, _classCallCheck3.default)(this, InvoiceNcfController);
	
	    this.modal = $uibModal;
	    this.$state = $state;
	    this.service = ContentService;
	    this.isMobile = isMobile;
	  }
	
	  (0, _createClass3.default)(InvoiceNcfController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	      this.subscriptions.push(this.ncfObservable.subscribe(function (ncfList) {
	        return _this.ncfList = ncfList;
	      }));
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'openNCFModal',
	    value: function openNCFModal(ncfInvoice) {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'new-ncf-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", function controller($scope, $state, $uibModalInstance) {
	          "ngInject";
	
	          $scope.ncfInvoice = ncfInvoice || {};
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.registerNCF = function () {
	            that.subscriptions.push(that.service.registerNCF($scope.ncfInvoice).subscribe(function (addedNcf) {
	              that.ncfList.push(addedNcf);
	              $scope.closeThisDialog();
	            }, function (error) {
	              console.log(error);
	            }));
	          };
	          $scope.editNCF = function () {
	            that.subscriptions.push(that.service.changeNCF($scope.ncfInvoice).subscribe(function (resp) {
	              $scope.closeThisDialog();
	            }, function (error) {
	              console.log(error);
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'deleteNCF',
	    value: function deleteNCF(ncf) {
	      var _this2 = this;
	
	      this.subscriptions.push(this.service.deleteNCF(ncf.id).subscribe(function (resp) {
	        _this2.ncfList.splice(_this2.ncfList.indexOf(ncf), 1);
	      }, function (error) {
	        console.log(error);
	      }));
	    }
	  }]);
	  return InvoiceNcfController;
	}();
	
	exports.default = InvoiceNcfController;
	
	
	InvoiceNcfController.$inject = ['$state', '$uibModal', 'ContentService', 'isMobile'];

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1082);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./invoice-ncf.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./invoice-ncf.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".InvoiceNcf{color:red}", ""]);
	
	// exports


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _listArticles = __webpack_require__(1084);
	
	var _listArticles2 = _interopRequireDefault(_listArticles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListArticlesModule = _angular2.default.module('ListArticles', [_angularjs2.default]).component('listArticles', _listArticles2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('listArticles', {
	    url: '/list-articles',
	    data: {
	      authRequired: true,
	      permsRequired: ['products-list']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'listArticles',
	        bindings: { articlesObservable: 'articlesObservable' }
	      }
	    },
	    resolve: {
	      articlesObservable: ["ContentService", function articlesObservable(ContentService) {
	        return ContentService.getArticlesList();
	      }]
	    }
	  });
	}]).name;
	
	exports.default = ListArticlesModule;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _listArticles = __webpack_require__(1085);
	
	var _listArticles2 = _interopRequireDefault(_listArticles);
	
	var _listArticles3 = __webpack_require__(1086);
	
	var _listArticles4 = _interopRequireDefault(_listArticles3);
	
	__webpack_require__(1087);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListArticlesComponent = {
	  bindings: {
	    articlesObservable: '<'
	  },
	  template: _listArticles2.default,
	  controller: _listArticles4.default
	};
	
	exports.default = ListArticlesComponent;

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{'Listado de Artículos' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.articles.length || 0 }}\n                </span>\n            </div>\n        </div>\n    </h1>\n\t<div class=\"col-md-12 table_container\">\n\t\t<div class=\"card\">\n\t\t\t<div class=\"card-content\">\n\t\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t\t\t\t<div class=\"columns pull-right\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-success dropdown-toggle\" data-toggle=\"dropdown\" ng-csv=\"$ctrl.articles\" csv-header=\"['Id', 'Descripcion', 'Referencia', 'Familia', 'Precio']\" csv-column-order=\"['id', 'description', 'reference', 'family', 'price']\" filename=\"listado_de_productos.csv\" ng-disabled=\"$ctrl.articles.length <= 0\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-file-o\" aria-hidden=\"true\"></i> {{'Exportar CSV' | translate}}\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar artículos' | translate}}</label>\n\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'id' ? '-id' : 'id'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'id', 'desc': orderedBy === '-id'}\">Id</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'description' ? '-description' : 'description'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'description', 'desc': orderedBy === '-description'}\">Descripcion</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'reference' ? '-reference' : 'reference'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'reference', 'desc': orderedBy === '-reference'}\">Referencia</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'family' ? '-family' : 'family'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'family', 'desc': orderedBy === '-family'}\">Familia</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'price' ? '-price' : 'price'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'price', 'desc': orderedBy === '-price'}\">Precio</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"article in $ctrl.articles | orderBy:orderedBy | filter:filterCrit as filtered\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'ID' | translate}}:\" class=\"text-right\">{{ article.id }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Descripción' | translate}}:\" class=\"text-center\">{{ article.description || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Referencia' | translate}}:\" class=\"text-center\">{{ article.reference || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Familia' | translate}}:\" class=\"text-center\">{{ article.family || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Precio' | translate}}:\" class=\"text-right\">{{ article.price | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"fixed-table-pagination hidden\">\n\t\t\t\t\t\t\t<div class=\"pull-left pagination-detail\">\n\t\t\t\t\t\t\t\t<span class=\"page-list\">\n\t\t\t\t\t\t\t\t\t<span class=\"btn-group dropup\">\n\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"page-size\">8</span> \n\t\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t</span>{{'Filas visible'| translate}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"pull-right pagination\">\n\t\t\t\t\t\t\t\t<ul class=\"pagination\">\n\t\t\t\t\t\t\t\t<li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-number active\"><a href=\"\">1</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">2</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">3</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-next\"><a href=\"\">›</a></li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t<div class=\"clearfix\"></div>\n\t\t</div>\n\t\t</div>\n\t<!--  end card  -->\n\t</div>\n\t<!--  end card  -->\n</div>\n"

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListArticlesController = function () {
	  function ListArticlesController(ContentService, isMobile) {
	    (0, _classCallCheck3.default)(this, ListArticlesController);
	
	    this.service = ContentService;
	    this.isMobile = isMobile;
	  }
	
	  (0, _createClass3.default)(ListArticlesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	      this.subscriptions.push(this.articlesObservable.subscribe(function (articles) {
	        return _this.articles = articles;
	      }, function (error) {
	        return console.log(error);
	      }));
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }]);
	  return ListArticlesController;
	}();
	
	exports.default = ListArticlesController;
	
	
	ListArticlesController.$inject = ['ContentService', 'isMobile'];

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1088);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./list-articles.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./list-articles.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".ListArticles{color:red}", ""]);
	
	// exports


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _oth = __webpack_require__(1090);
	
	var _oth2 = _interopRequireDefault(_oth);
	
	var _content = __webpack_require__(1095);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OthModule = _angular2.default.module('Oth', [_angularjs2.default]).component('oth', _oth2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('oth', {
	    url: '/oth',
	    data: {
	      authRequired: true,
	      permsRequired: ['oth-bills']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'oth'
	      }
	    }
	  });
	}]).name;
	
	exports.default = OthModule;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _oth = __webpack_require__(1091);
	
	var _oth2 = _interopRequireDefault(_oth);
	
	var _oth3 = __webpack_require__(1092);
	
	var _oth4 = _interopRequireDefault(_oth3);
	
	__webpack_require__(1093);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OthComponent = {
	  bindings: {},
	  template: _oth2.default,
	  controller: _oth4.default
	};
	
	exports.default = OthComponent;

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-8 col-sm-8 col-xs-12\">\n                {{'Desc.s/OTH' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{$ctrl.rows.length || 0}}\n                </span>\n            </div>\n        </div>\n    </h1>\n\n    <div id=\"printselect\">\n    \t<style>\n    \t\t.Section_Print{display: none; } .logo_invoice{margin: 20px 0 10px 0; border-bottom: 3px solid #24495e; padding: 10px; } .logo_invoice img{width: 115px; margin: 0 0 10px 0; } .Powered span{color: #123b52; font-weight: bold; background: } .tableforprint tr td hr{margin: 2px 0 2px 0; } .tableforprint tr td{border-top: 0 !important; }\n    \t</style>\n    </div>\n\n        <form class=\"hidden-xs\">\n            <div class=\"form\">\n        \n                <input type=\"hidden\" name=\"sorter\" value=\"\">\n                \n                <input type=\"hidden\" name=\"cashier_id\" value=\"\">\n                \n                <input type=\"hidden\" name=\"pos_id\" value=\"\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>\n\t\t\t\t\t<input class=\"form-control input_py\" name=\"from\" moment-picker=\"$ctrl.dateFrom\"\n\t\t\t\t\t\tng-model=\"$ctrl.dateFrom\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>\n\t\t\t\t\t<input class=\"form-control input_py\" name=\"to\" moment-picker=\"$ctrl.dateTo\"\n\t\t\t\t\t\tng-model=\"$ctrl.dateTo\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n\n                    <label for=\"group\" class=\"input-group-addon\">{{'Agrupado por' | translate}}</label>\n                    <select name=\"group\" ng-model=\"$ctrl.groupBy\" id=\"group\" class=\"form-control input_py\">\n                        <option value=\"0\" selected>{{'Totalizado por fecha' | translate}}</option>\n                        <option value=\"1\">{{'Totalizado por Camarero' | translate}}</option>\n                        <option value=\"2\">{{'Totalizado por Mesa' | translate}}</option>\n                        <option value=\"3\">{{'Totalizado por Factura' | translate}}</option>\n\t\t\t\t\t\t<option value=\"4\">{{'Totalizado por POS' | translate}}</option>\n\t\t\t\t\t\t<option value=\"5\">{{'Totalizado por Categoría' | translate}}</option>\n                    </select>   \n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findOth()\">{{'Buscar' | translate}}</button>    \n                    </span>\n                </div>\n            </div>\n        </form>\n\t\t<form class=\"visible-xs\">\n            <div class=\"form_xs\">\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_left\">\n\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n\t\t\t\t\t<input class=\"form-control input_py\" name=\"from\" moment-picker=\"$ctrl.dateFrom\"\n\t\t\t\t\t\tng-model=\"$ctrl.dateFrom\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_right\">\n\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Hasta' | translate}}</p>\n\t\t\t\t\t<input class=\"form-control input_py\" name=\"to\" moment-picker=\"$ctrl.dateTo\"\n\t\t\t\t\t\tng-model=\"$ctrl.dateTo\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n\t\t\t\t</div>\n\t\t\t\t  \n\t\t\t\t\t<p class=\"label_m\" for=\"group\">{{'Agrupado por' | translate}}:</p>\n                    <select name=\"group\" ng-model=\"$ctrl.groupBy\" id=\"group\" class=\"form-control form-group  input_py\">\n                        <option value=\"0\" selected>{{'Totalizado por fecha' | translate}}</option>\n                        <option value=\"1\">{{'Totalizado por Vendedor' | translate}}</option>\n                        <option value=\"2\">{{'Totalizado por Mesa' | translate}}</option>\n                        <option value=\"3\">{{'Totalizado por Factura' | translate}}</option>\n\t\t\t\t\t\t<option value=\"4\">{{'Totalizado por POS' | translate}}</option>\n\t\t\t\t\t\t<option value=\"5\">{{'Totalizado por Categoría' | translate}}</option>\n                    </select>\n                    <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findOth()\">{{'Buscar' | translate}}</button> \n\t\t\t\t   \n            </div>\n        </form>\n\t<div class=\"table_container\">\n\t\t<div class=\"card\">\n\t\t\t<div class=\"card-content\">\n\t\t\t\t<div class=\"columns pull-right\">\n\t\t\t\t\t\t<!-- <button type=\"button\" class=\"btn btn-success dropdown-toggle\" data-toggle=\"dropdown\"> -->\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-success\" ng-csv=\"$ctrl.getExportRows()\" csv-header=\"$ctrl.csvHeaders\" csv-column-order=\"$ctrl.csvHeaderOrder\" filename=\"reporte-de-ventas.csv\" ng-disabled=\"$ctrl.rows.length <= 0\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-file-o\" aria-hidden=\"true\"></i> {{'Exportar CSV' | translate}}\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<!-- </button> -->\n\n\t\t\t\t</div>\n\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t<div class=\"field\">\n\n\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar búsqueda' | translate}}</label>\n\n\t\t\t\t\t</div> \n\t\t\t\t</div>\n\t\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t<tr>\n\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-if=\"$ctrl.isGroupedByDate()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'date' ? '-date' : 'date'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'date', 'desc': $ctrl.orderedBy === '-date'}\">{{'Fecha' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-if=\"$ctrl.isGroupedByCashier()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'cashier' ? '-cashier' : 'cashier'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'cashier', 'desc': $ctrl.orderedBy === '-cashier'}\">{{'Vendedor' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-if=\"$ctrl.isGroupedByTable()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'table' ? '-table' : 'table'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'table', 'desc': $ctrl.orderedBy === '-table'}\">{{'Mesa' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"$ctrl.isGroupedByCategory()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'pifamm_name' ? '-pifamm_name' : 'pifamm_name'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'pifamm_name', 'desc': $ctrl.orderedBy === '-pifamm_name'}\">{{'Categoria' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\n\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'date' ? '-date' : 'date'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'date', 'desc': $ctrl.orderedBy === '-date'}\">{{'Fecha' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'name' ? '-name' : 'name'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'name', 'desc': $ctrl.orderedBy === '-name'}\">{{'Nombre' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'rnc' ? '-rnc' : 'rnc'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'rnc', 'desc': $ctrl.orderedBy === '-rnc'}\">{{'RNC' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\n\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-if=\"$ctrl.isGroupedByPOS()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'pos' ? '-pos' : 'pos'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'pos', 'desc': $ctrl.orderedBy === '-pos'}\">{{'POS' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\n\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'pax' ? '-pax' : 'pax'\" ng-if=\"!$ctrl.isGroupedByCategory()\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'pax', 'desc': $ctrl.orderedBy === '-pax'}\">{{'Pax' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th  data-field=\"name\" class=\"text-left\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'discount' ? '-discount' : 'discount'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'discount', 'desc': $ctrl.orderedBy === '-discount'}\">{{'Descuento' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'total' ? '-total' : 'total'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'total', 'desc': $ctrl.orderedBy === '-total'}\">{{'Total' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'extra_tip' ? '-extra_tip' : 'extra_tip'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'extra_tip', 'desc': $ctrl.orderedBy === '-extra_tip'}\">{{'Propina Extra' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'tax10' ? '-tax10' : 'tax10'\" ng-if=\"!$ctrl.isGroupedByCategory()\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'tax10', 'desc': $ctrl.orderedBy === '-tax10'}\">{{'% Ley' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\" class=\"text-left\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'tax16' ? '-tax16' : 'tax16'\" ng-if=\"!$ctrl.isGroupedByCategory()\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'tax16', 'desc': $ctrl.orderedBy === '-tax16'}\">{{'IVA' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByDate()\"\n\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.drillDownOnDate(row.date)\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Fecha' | translate}}:\" class=\"text-center\">{{ row.date | amUtc | amDateFormat:'LLLL' | capitalise }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Pax' | translate}}:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Descuento' | translate}}:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Total' | translate}}:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Propina extra' | translate}}:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'%Ley' | translate}}:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Impuesto IVA' | translate}}:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByCashier()\"\n\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.drillDownOnCashier(row.cashier_id)\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Cajero' | translate}}:\" class=\"text-center\">{{ row.cashier || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Pax' | translate}}:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Descuento' | translate}}:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Total' | translate}}:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Propina extra' | translate}}:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'%Ley' | translate}}:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Impuesto IVA' | translate}}:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-click=\"$ctrl.drillDownOnTable(row.table)\" ng-if=\"$ctrl.isGroupedByTable()\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Mesa' | translate}}:\" class=\"text-center\">{{ row.table }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Pax' | translate}}:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Desc.' | translate}}:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Total' | translate}}:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Prop.Extra' | translate}}:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'%Ley' | translate}}:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'IVA' | translate}}:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-click=\"$ctrl.drillDownOnCategory(row.pifamm_id, row.pifamm_name)\" ng-if=\"$ctrl.isGroupedByCategory()\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Categoria' | translate}}:\" class=\"text-center\">{{ row.pifamm_name || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Descuento' | translate}}:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Total' | translate}}:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByInvoice()\" \n\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.openBillDetails(row.id)\" if-perm disable-if=\"account-bills, invoice-orders\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Fecha' | translate}}:\" class=\"text-center\">{{ row.date | amUtc | amDateFormat:'DD/MMM/YYYY HH:mm' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Nombre' | translate}}:\" class=\"text-center\">{{ row.name || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'RNC' | translate}}:\" class=\"text-center\">{{ row.rnc || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Pax' | translate}}:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Descuento' | translate}}:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Total' | translate}}:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Propina extra' | translate}}:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'%Ley' | translate}}:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Impuesto IVA' | translate}}:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByPOS()\"\n\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.drillDownOnPOS(row.pos)\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'POS' | translate}}:\" class=\"text-center\">{{ row.pos }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Pax' | translate}}:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Descuento' | translate}}:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Total' | translate}}:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Propina Extra' | translate}}:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'% Ley' | translate}}:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Impuesto IVA' | translate}}:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t<tfoot>\n\t\t\t\t\t\t\t\t\t<tr  ng-if=\"!$ctrl.isGroupedByCategory()\">\n\t\t\t\t\t\t\t\t\t\t<th colspan=\"{{ $ctrl.isGroupedByInvoice() ? 5 : 3 }}\" data-field=\"name\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getExtraTip | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTax10 | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTax16 | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr ng-if=\"$ctrl.isGroupedByCategory()\" >\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Descuento:\"  data-field=\"name\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n                                        <th data-label=\"Total:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</tfoot>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"fixed-table-pagination hidden\">\n\t\t\t\t\t\t\t<div class=\"pull-left pagination-detail\">\n\t\t\t\t\t\t\t\t<span class=\"page-list\">\n\t\t\t\t\t\t\t\t\t<span class=\"btn-group dropup\">\n\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"page-size\">8</span> \n\t\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t</span>{{'Filas visibles' | translate}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"pull-right pagination\">\n\t\t\t\t\t\t\t\t<ul class=\"pagination\">\n\t\t\t\t\t\t\t\t\t<li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n\t\t\t\t\t\t\t\t\t<li class=\"page-number active\"><a href=\"\">1</a></li>\n\t\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">2</a></li>\n\t\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">3</a></li>\n\t\t\t\t\t\t\t\t\t<li class=\"page-next\"><a href=\"\">›</a></li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"clearfix\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!--<div ng-controller=\"myCtrl\">\n    <h1>AngularJS Print html templates</h1>\n    <form novalidate>\n      First Name:\n      <input type=\"text\" ng-model=\"firstName\" class=\"tb8\">\n      <br>\n      <br> Last Name:\n      <input type=\"text\" ng-model=\"lastName\" class=\"tb8\">\n      <br>\n      <br>\n      <button ng-click=\"Submit()\" class=\"button\">Submit</button>\n      <button ng-click=\"printToCart('printSectionId')\" class=\"button\">Print</button>\n    </form>\n  </div>-->\n\t\t</div>\n\t</div>\n\t<!--  end card -->\n\t<!--</div>-->\n\t<!--  end card  -->\n\t\n</div>\n\n\n\n<script type='text/ng-template' id=\"invoice-details-template.html\">\n\t<div class=\"modal-header\">\n    \t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t\t{{'Detalle de Factura' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    \t</h3>\n  \t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n    <nav>\n        <ul class=\"Tabs\">\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: !showOrders}\" ng-click=\"showOrders=false\"\n\t\t\t\tif-perm disable-if=\"account-bills\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Factura' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: showOrders}\" ng-click=\"getOrders(); showOrders=true\"\n\t\t\t\tif-perm disable-if=\"invoice-orders\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Órdenes' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\">\n                <button class=\"btn btn-default pull-right\" ng-click=\"printToCart('printSectionId')\">\n                    <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                </button>\n            </li>\n            <li class=\"Tabs__presentation-slider\" role=\"presentation\"></li>\n        </ul>\n    </nav>\n<!-- start print -->\n\t\t<div id=\"printSectionId\" class=\"Section_Print\">\n\t\t\t<div class=\"Powered\">\n\t\t\t\t<span>{{'RNC' | translate}}: </span>{{account.identification || '-'}} <br>\n\t\t\t\t<span>{{'Dirección' | translate}}: </span>{{ account.address || '-'}} <br>\n\t\t\t\t<span>{{'Telefono' | translate}}: </span>{{ account.phone || '-'}}\n\t\t\t</div>\n\t\t\t<div class=\"logo_invoice\">\n\t\t\t\t<img src=\"{{ logoUrl }}\" alt=\"\">\n\t\t\t</div>\n\t\t\t<div class=\"print_separator\"></div>\n\t\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-condensed tableforprint\">\n\t\t\t\t\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-right\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong><span>{{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise  }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th class=\"text-center\" \"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Descuento' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Total' | translate}}</th>\n\t\t\t\t\t\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td class=\"text-center\" \"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.discount | currency }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.total | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"><hr></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'Notas' | translate}}:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'Subtotal' | translate}}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{'Comensales' | translate}}: <span>{{ invoice.pax }}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'Descuento' | translate}}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.discount | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"2\">\n\t\t\t\t\t\t<span>{{'Atendido por' | translate}}: </span>\n\t\t\t\t\t\t<span>{{ invoice.cashier || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'% Ley' | translate}}:</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{'IVA' | translate}}:</span> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{'Exoneracion IVA' | translate}}:</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{ invoice.total | currency }}</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<!-- <td \"3\">\n\t\t\t\t\t\t<strong>Impuestos incluidos:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td> -->\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\t\t</div>\n<!-- end print -->\n\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-bordered table-condensed\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong> {{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise  }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Emitido a' | translate}}:</strong> {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Mesa No.' | translate}}:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Atendida por' | translate}}:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Descuento' | translate}}:</strong> {{ invoice.discount | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Pax' | translate}}:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong> {{ invoice.total | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Impuestos incluidos' | translate}}:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Impuesto IVA' | translate}}:</strong> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'% Ley' | translate}}:</strong> {{ invoice.tax10 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th colspan=\"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th>{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th>{{'Total' | translate}}</th>\n\t\t\t\t\t<th>{{'Desc.' | translate}}</th>\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td colspan=\"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.total | currency }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.discount | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=\"orders\" ng-show=\"showOrders\">\n\t\t\t<table id=\"pruena\" class=\"table table-bordered table-condensed\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>{{'Factura' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Acción' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Fecha' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Camarero' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Estado' | translate}}</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat=\"order in orders\">\n\t\t\t\t\t\t<td data-label=\"Factura\">\n\t\t\t\t\t\t\t<a href=\"\" data-ajax_load=\"\" data-container=\"#billpayment\" class=\"btn btn-xs btn-primary\"\n\t\t\t\t\t\t\t\tng-click=\"fetchDetails(order)\">\n\t\t\t\t\t\t\t\t{{ order.id }}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td data-label=\"{{'Acción' | translate}}\">{{ order.action || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"{{'Fecha' | translate}}\">{{ order.date | amUtc | amDateFormat:'LLLL' | capitalise }}</td>\n\t\t\t\t\t\t<td data-label=\"{{'Camarero' | translate}}\">{{ order.cashier || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"{{'Estado' | translate}}\">{{ order.status || '-' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t\t<table class=\"table table-bordered table-condensed\" ng-show=\"displayingOrder\">\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr><td colspan=\"4\">{{ displayingOrder.action || '-' }}</td></tr>\n\t\t\t\t\t<tr class=\"table_list_heading\">\n\t\t\t\t\t\t<th class=\"detail_table hidden-xs hidden-sm\" width=\"100\"><b>{{'De la Factura' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"{{'De la Factura' | translate}}:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.billid || '-' }}</td>\n\t\t\t\t\t\t<th class=\" hidden-xs hidden-sm\" width=\"100\"><b>{{'Fecha' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.date | amUtc | amDateFormat:'LLLL' | capitalise}}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>{{'Camarero' | translate}}:</b></th>\n\t\t\t\t\t\t<td data-label=\"{{'Vendedor' | translate}}:\">{{ displayingOrder.cashier || '-' }}</td>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>{{'Mesa' | translate}}:</b></th>\n\t\t\t\t\t\t<td data-label=\"Mesa:\" colspan=\"2\">{{ displayingOrder.table_type || '-' }} {{ displayingOrder.table_code || '' }}</td>\n\t\t\t\t\t</tr>\n\n\t\t\t\t\t<tr class=\"table_graund\" ng-repeat=\"detail in displayingOrder.details\">\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.name  || '-' }}</td>\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.qty  || 0 }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">\n\t\t\t{{'Salir' | translate}}\n\t\t</button>\n\t</div>\n</script>\n"

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OthController = function () {
	  function OthController(ContentService, $uibModal, moment, isMobile, ProfilePermissionsService, $state, $translate) {
	    (0, _classCallCheck3.default)(this, OthController);
	
	    this.service = ContentService;
	    this.modal = $uibModal;
	    this.moment = moment;
	    this.isMobile = isMobile;
	    this.permissionsService = ProfilePermissionsService;
	    this.state = $state;
	    this.trans = $translate.instant;
	  }
	
	  (0, _createClass3.default)(OthController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	      this.dateFrom = undefined;
	      this.dateTo = undefined;
	      this.groupBy = '0';
	      this.rows = [];
	      this.csvHeaderOrder = [];
	      this.csvHeaders = [];
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'findOth',
	    value: function findOth() {
	      var groupBy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	      var cashierId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	      var posId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      var _this = this;
	
	      var famId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	      var tableId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
	
	      this.subscriptions.push(this.service.findOth({
	        date_from: this.dateFrom.format(),
	        date_to: this.dateTo.format(),
	        group_by: groupBy || this.groupBy,
	        cashier_id: cashierId,
	        pos_id: posId,
	        fam_id: famId,
	        table_id: tableId
	      }).subscribe(function (othList) {
	        _this.rows = othList;
	        _this.reorderCsv();
	      }, function (err) {
	        console.log(err);
	      }));
	    }
	  }, {
	    key: 'getExportRows',
	    value: function getExportRows() {
	      var _this2 = this;
	
	      return this.rows.map(function (row) {
	        var newRow = angular.copy(row, {});
	        if (newRow.date) {
	          newRow.date = _this2.moment(newRow.date).format('DD/MM/YYYY');
	        }
	        return newRow;
	      });
	    }
	  }, {
	    key: 'openBillDetails',
	    value: function openBillDetails(invoiceId) {
	      var that = this;
	      if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')) {
	        this.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'invoice-details-template.html',
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "$uibModalInstance", "AccountInformationService", function controller($scope, $uibModalInstance, AccountInformationService) {
	            "ngInject";
	
	            $scope.invoice = {};
	            $scope.orders = [];
	            $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
	            that.subscriptions.push(that.service.getInvoice(invoiceId).subscribe(function (invoice) {
	              return $scope.invoice = invoice;
	            }, function (error) {
	              return console.log("Error while getting the invoice");
	            }));
	
	            that.subscriptions.push(AccountInformationService.getAccountInfo().subscribe(function (resp) {
	              $scope.account = resp;
	            }));
	
	            $scope.getOrders = function () {
	              if ($scope.orders.length <= 0) {
	                that.subscriptions.push(that.service.getOrders(invoiceId).subscribe(function (orders) {
	                  return $scope.orders = orders;
	                }, function (error) {
	                  return console.log("Error while getting the orders");
	                }));
	              };
	            };
	            $scope.fetchDetails = function (order) {
	              if (!order.details || order.details.length <= 0) {
	                that.subscriptions.push(that.service.getOrderDetails(invoiceId, order.id).subscribe(function (details) {
	                  order.details = details;
	                  $scope.displayingOrder = order;
	                }, function (error) {
	                  return console.log("Error while getting the details for this order");
	                }));
	              };
	            };
	
	            $scope.printToCart = function (printSectionId) {
	              var innerContents = document.getElementById(printSectionId).innerHTML;
	              var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	              popupWinindow.document.open();
	              var styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              var styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              popupWinindow.document.write('<html><head><title>Imprimir factura #' + $scope.invoice.number + '</title><style>' + styleprint.innerHTML + '</style><style>' + styleprintBootstrap.innerHTML + '</style></head><body onload="window.print()">' + innerContents + '</html>');
	              popupWinindow.document.close();
	            };
	
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	          }]
	        });
	      }
	    }
	  }, {
	    key: 'getDiscount',
	    value: function getDiscount(item) {
	      return item.discount;
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal(item) {
	      return item.total;
	    }
	  }, {
	    key: 'getExtraTip',
	    value: function getExtraTip(item) {
	      return item.extra_tip;
	    }
	  }, {
	    key: 'getTax10',
	    value: function getTax10(item) {
	      return item.tax10;
	    }
	  }, {
	    key: 'getTax16',
	    value: function getTax16(item) {
	      return item.tax16;
	    }
	  }, {
	    key: 'isGroupedByDate',
	    value: function isGroupedByDate() {
	      return !this.rows.length || this.rows[0].hasOwnProperty('date') && !this.rows[0].hasOwnProperty('rnc');
	    }
	  }, {
	    key: 'isGroupedByCashier',
	    value: function isGroupedByCashier() {
	      return this.rows.length && this.rows[0].hasOwnProperty('cashier');
	    }
	  }, {
	    key: 'isGroupedByTable',
	    value: function isGroupedByTable() {
	      return this.rows.length && this.rows[0].hasOwnProperty('table');
	    }
	  }, {
	    key: 'isGroupedByInvoice',
	    value: function isGroupedByInvoice() {
	      return this.rows.length && this.rows[0].hasOwnProperty('date') && this.rows[0].hasOwnProperty('rnc');
	    }
	  }, {
	    key: 'isGroupedByPOS',
	    value: function isGroupedByPOS() {
	      return this.rows.length && this.rows[0].hasOwnProperty('pos');
	    }
	  }, {
	    key: 'isGroupedByCategory',
	    value: function isGroupedByCategory() {
	      return this.rows.length && this.rows[0].hasOwnProperty('pifamm_id');
	    }
	  }, {
	    key: 'drillDownOnDate',
	    value: function drillDownOnDate(rowDate) {
	      this.dateFrom = this.moment(rowDate);
	      this.dateTo = this.moment(rowDate);
	      this.groupBy = '3';
	      this.findOth();
	    }
	  }, {
	    key: 'drillDownOnCashier',
	    value: function drillDownOnCashier(cashierId) {
	      this.groupBy = '3';
	      this.findOth('15', cashierId);
	    }
	  }, {
	    key: 'drillDownOnPOS',
	    value: function drillDownOnPOS(posId) {
	      this.groupBy = '3';
	      this.findOth('16', undefined, posId);
	    }
	  }, {
	    key: 'drillDownOnCategory',
	    value: function drillDownOnCategory(familyId, famName) {
	      this.state.go('salesByCategory', {
	        famId: familyId,
	        dateTo: this.dateTo,
	        dateFrom: this.dateFrom,
	        title: famName
	      });
	    }
	  }, {
	    key: 'drillDownOnTable',
	    value: function drillDownOnTable(tableId) {
	      this.groupBy = '3';
	      var table = parseInt(tableId.split('-')[0].trim()) * 10;
	      this.findOth('18', undefined, undefined, undefined, table);
	    }
	  }, {
	    key: 'reorderCsv',
	    value: function reorderCsv() {
	      this.getCsvHeaders();
	      this.getCsvHeaderOrder();
	    }
	  }, {
	    key: 'getCsvHeaders',
	    value: function getCsvHeaders() {
	      var _ = this.trans;
	      var usuals = [_('Pax'), _('Desc.'), _('Prop.Extra'), _('% Ley'), _('IVA'), _('Total')];
	      if (this.isGroupedByCashier()) {
	        this.csvHeaders = [_('Vendedor')].concat(usuals);
	      } else if (this.isGroupedByDate()) {
	        this.csvHeaders = [_('Fecha')].concat(usuals);
	      } else if (this.isGroupedByInvoice()) {
	        this.csvHeaders = [_('Fecha'), _('NCF'), _('RNC'), _('Nombre')].concat(usuals);
	      } else if (this.isGroupedByPOS()) {
	        this.csvHeaders = [_('POS')].concat(usuals);
	      } else if (this.isGroupedByTable()) {
	        this.csvHeaders = [_('Mesa')].concat(usuals);
	      }
	    }
	  }, {
	    key: 'getCsvHeaderOrder',
	    value: function getCsvHeaderOrder() {
	      var usuals = ["pax", "discount", "extra_tip", "tax10", "tax16", "total"];
	      if (this.isGroupedByCashier()) {
	        this.csvHeaderOrder = ['cashier'].concat(usuals);
	      } else if (this.isGroupedByDate()) {
	        this.csvHeaderOrder = ['date'].concat(usuals);
	      } else if (this.isGroupedByInvoice()) {
	        this.csvHeaderOrder = ['date', 'ncf', 'rnc', 'Nombre'].concat(usuals);
	      } else if (this.isGroupedByPOS()) {
	        this.csvHeaderOrder = ['pos'].concat(usuals);
	      } else if (this.isGroupedByTable()) {
	        this.csvHeaderOrder = ['table'].concat(usuals);
	      }
	    }
	  }]);
	  return OthController;
	}();
	
	exports.default = OthController;
	
	
	OthController.$inject = ['ContentService', '$uibModal', 'moment', 'isMobile', 'ProfilePermissionsService', '$state', '$translate'];

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1094);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./oth.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./oth.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(1096);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(497);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentService = function () {
	  function ContentService($http, host, $poller) {
	    (0, _classCallCheck3.default)(this, ContentService);
	
	    this.http = $http;
	    this.host = host;
	    this.$poller = $poller;
	  }
	
	  (0, _createClass3.default)(ContentService, [{
	    key: 'findOth',
	    value: function findOth(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/oth-bills',
	        params: data
	      }).then(function (resp) {
	        return resp.data.results;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getArticlesList',
	    value: function getArticlesList() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/products-list'
	      }).then(function (resp) {
	        return resp.data.results;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'findSalesByProducts',
	    value: function findSalesByProducts(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/sales-by-products',
	        params: data
	      }).then(function (resp) {
	        return resp.data.results;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'findSalesReport',
	    value: function findSalesReport(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/sales-report',
	        params: data
	      }).then(function (resp) {
	        return resp.data.results;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'findSalesByVendor',
	    value: function findSalesByVendor(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/sales-by-vendor',
	        params: data
	      }).then(function (resp) {
	        return resp.data.results;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'findInvoice',
	    value: function findInvoice(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/all-bills',
	        params: data
	      }).then(function (resp) {
	        return resp.data.invoices;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'getBackupList',
	    value: function getBackupList() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/backup-files'
	      }).then(function (resp) {
	        return resp.data.files;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'uploadBackup',
	    value: function uploadBackup(backup) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/backup-files',
	        data: { file: backup }
	      }));
	    }
	  }, {
	    key: 'deleteBackup',
	    value: function deleteBackup(backupId) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/backup-files/' + backupId
	      }));
	    }
	  }, {
	    key: 'deleteMultiplesBackups',
	    value: function deleteMultiplesBackups(idList) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/backup-files',
	        params: { deleted: idList.join() }
	      }));
	    }
	  }, {
	    key: 'getDttsList',
	    value: function getDttsList(page) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/dtt-files',
	        params: {
	          page: page
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'uploadDtt',
	    value: function uploadDtt(dtt) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/dtts',
	        data: { file: dtt }
	      }));
	    }
	  }, {
	    key: 'getPOSList',
	    value: function getPOSList() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/point-of-sales'
	      }).then(function (resp) {
	        return resp.data.points_of_sales;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'registerPOS',
	    value: function registerPOS(pointOfSales) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/point-of-sales',
	        data: {
	          name: pointOfSales.name,
	          number: pointOfSales.number,
	          site_number: pointOfSales.site_number,
	          port_number: pointOfSales.port_number,
	          ip_address: pointOfSales.ip_address
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'changePOS',
	    value: function changePOS(pointOfSales) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/accounts/point-of-sales/' + pointOfSales.id,
	        data: {
	          id: pointOfSales.id,
	          name: pointOfSales.name,
	          number: pointOfSales.number,
	          site_number: pointOfSales.site_number,
	          port_number: pointOfSales.port_number,
	          ip_address: pointOfSales.ip_address
	        }
	      }));
	    }
	  }, {
	    key: 'deletePOS',
	    value: function deletePOS(posId) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/point-of-sales/' + posId
	      }));
	    }
	  }, {
	    key: 'getNcfList',
	    value: function getNcfList() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/invoice-ncf'
	      }).then(function (resp) {
	        return resp.data.invoice_ncfs;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'registerNCF',
	    value: function registerNCF(ncfInvoice) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/invoice-ncf',
	        data: {
	          description: ncfInvoice.description,
	          sequence: ncfInvoice.sequence
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'changeNCF',
	    value: function changeNCF(ncfInvoice) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/accounts/invoice-ncf/' + ncfInvoice.id,
	        data: {
	          id: ncfInvoice.id,
	          description: ncfInvoice.description,
	          sequence: ncfInvoice.sequence
	        }
	      }));
	    }
	  }, {
	    key: 'deleteNCF',
	    value: function deleteNCF(ncfId) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/invoice-ncf/' + ncfId
	      }));
	    }
	  }, {
	    key: 'getClosingHour',
	    value: function getClosingHour() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/closing-hour'
	      }).then(function (resp) {
	        return resp.data.closing_hour;
	      }, function (error) {
	        return error;
	      }));
	    }
	  }, {
	    key: 'updateClosingHour',
	    value: function updateClosingHour(hour) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/accounts/closing-hour',
	        data: { hour: hour }
	      }));
	    }
	  }, {
	    key: 'getInvoice',
	    value: function getInvoice(invoiceId) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/all-bills/' + invoiceId
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getOrders',
	    value: function getOrders(invoiceId) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/invoices/' + invoiceId + '/orders'
	      }).then(function (resp) {
	        return resp.data.results;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getOrderDetails',
	    value: function getOrderDetails(invoiceId, orderId) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/invoices/' + invoiceId + '/orders/' + orderId
	      }).then(function (resp) {
	        return resp.data.results;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'inviteUser',
	    value: function inviteUser(emails, permissions) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/user-invitation',
	        data: { emails: emails, permissions: permissions }
	      }));
	    }
	  }, {
	    key: 'getAccountProfiles',
	    value: function getAccountProfiles() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/profiles'
	      }).then(function (resp) {
	        return resp.data.profiles;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'assignPerm',
	    value: function assignPerm(id, data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/accounts/permissions/' + id,
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'revokePerm',
	    value: function revokePerm(id, data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/permissions/' + id,
	        params: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'deleteProfile',
	    value: function deleteProfile(id) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/profiles/' + id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getUserInvitations',
	    value: function getUserInvitations() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/users/pending-invitations'
	      }).then(function (resp) {
	        return resp.data.invitations;
	      }, function (resp) {
	        return [];
	      }));
	    }
	  }, {
	    key: 'checkInvitations',
	    value: function checkInvitations() {
	      this.$poller.stopPolling(this.host + '/api/users/pending-invitations');
	      return this.$poller.startPolling(this.host + '/api/users/pending-invitations', {}, {}, 60000);
	    }
	  }, {
	    key: 'stopCheckingInvitations',
	    value: function stopCheckingInvitations() {
	      this.$poller.stopPolling(this.host + '/api/users/pending-invitations');
	    }
	  }, {
	    key: 'acceptInvitation',
	    value: function acceptInvitation(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/users/pending-invitations',
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getAccountInvitations',
	    value: function getAccountInvitations() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/user-invitation'
	      }).then(function (resp) {
	        return resp.data.invitations;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'cancelInvitation',
	    value: function cancelInvitation(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/user-invitation',
	        params: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'triggerDttProcess',
	    value: function triggerDttProcess() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PATCH',
	        url: this.host + '/api/accounts/unprocessed-dtts'
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp.data;
	      }));
	    }
	  }, {
	    key: 'getAvailableClientKeys',
	    value: function getAvailableClientKeys() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/available-client-keys'
	      }).then(function (resp) {
	        return resp.data.client_ids;
	      }, function (resp) {
	        return [];
	      }));
	    }
	  }, {
	    key: 'getCollectorsList',
	    value: function getCollectorsList() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/collectors'
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp.data;
	      }));
	    }
	  }, {
	    key: 'registerCollector',
	    value: function registerCollector(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/collectors',
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp.data;
	      }));
	    }
	  }, {
	    key: 'editCollector',
	    value: function editCollector(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/accounts/collectors/' + data.id,
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'deleteCollector',
	    value: function deleteCollector(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/collectors/' + data.id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'observePOS',
	    value: function observePOS(collector, pos) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/collectors/' + collector.id + '/pos',
	        data: {
	          pos_id: pos.id
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'unobservePOS',
	    value: function unobservePOS(collector, pos) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/collectors/' + collector.id + '/pos/' + pos.id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'startCollector',
	    value: function startCollector(collector) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PATCH',
	        url: this.host + '/api/accounts/collectors/' + collector.id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'stopCollector',
	    value: function stopCollector(collector) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PATCH',
	        url: this.host + '/api/accounts/collectors/' + collector.id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'collect',
	    value: function collect(collector) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/accounts/collectors/collect-now/' + collector.id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'collectAll',
	    value: function collectAll() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/collectors/collect-now'
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getJournalFiles',
	    value: function getJournalFiles() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/journal-files'
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'processJournals',
	    value: function processJournals() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PATCH',
	        url: this.host + '/api/accounts/unprocessed-journals'
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getPrintedUnclosed',
	    value: function getPrintedUnclosed(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/printed-unclosed',
	        params: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getPaymentOnlyBills',
	    value: function getPaymentOnlyBills(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/payment-only',
	        params: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'downloadBackup',
	    value: function downloadBackup(filename) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/backup-files/' + filename,
	        responseType: 'arraybuffer'
	      }));
	    }
	  }, {
	    key: 'downloadDTT',
	    value: function downloadDTT(filename) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/dtt-files/' + filename,
	        responseType: 'arraybuffer'
	      }));
	    }
	  }, {
	    key: 'findClosingHourReport',
	    value: function findClosingHourReport(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/daily-closing',
	        params: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'findPrintedBillsReport',
	    value: function findPrintedBillsReport(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/printed-bills',
	        params: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'findSalesByCategory',
	    value: function findSalesByCategory(data, fam_id) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/sales-by-category' + (fam_id ? '/' + fam_id : ''),
	        params: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'chooseLanguage',
	    value: function chooseLanguage(language) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PATCH',
	        url: this.host + '/api/users',
	        data: { language: language }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return undefined;
	      }));
	    }
	  }, {
	    key: 'registerMaterial',
	    value: function registerMaterial(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/raw-materials',
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'editMaterial',
	    value: function editMaterial(data, id) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/accounts/raw-materials/' + id,
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getAllMaterials',
	    value: function getAllMaterials() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/raw-materials'
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'changeMaterialExistence',
	    value: function changeMaterialExistence(data, id) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PATCH',
	        url: this.host + '/api/accounts/raw-materials/' + id,
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'deleteMaterial',
	    value: function deleteMaterial(id) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/raw-materials/' + id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'associateArticle',
	    value: function associateArticle(mid, aid, data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/raw-materials/' + mid + '/' + aid,
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'adjustArticleAmount',
	    value: function adjustArticleAmount(mid, aid, data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/raw-materials/' + mid + '/' + aid,
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'disassociateArticle',
	    value: function disassociateArticle(mid, aid) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/accounts/raw-materials/' + mid + '/' + aid
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getSalesByTag',
	    value: function getSalesByTag(data, sid) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/sales-by-tag' + (sid ? '/' + sid : ''),
	        params: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getSalesByNCF',
	    value: function getSalesByNCF(dateFrom, dateTo) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/sales-by-ncf',
	        params: {
	          date_to: dateTo,
	          date_from: dateFrom
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getCashiersBySearchTerm',
	    value: function getCashiersBySearchTerm(term) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/cashiers',
	        params: { q: term }
	      }).then(function (resp) {
	        return resp.data.rows;
	      }, function (resp) {
	        return [];
	      }));
	    }
	  }, {
	    key: 'getCategoriesBySearchTerm',
	    value: function getCategoriesBySearchTerm(term) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/categories',
	        params: { q: term }
	      }).then(function (resp) {
	        return resp.data.rows;
	      }, function (resp) {
	        return [];
	      }));
	    }
	  }, {
	    key: 'getTagsBySearchTerm',
	    value: function getTagsBySearchTerm(term) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/tags',
	        params: { q: term }
	      }).then(function (resp) {
	        return resp.data.rows;
	      }, function (resp) {
	        return [];
	      }));
	    }
	  }, {
	    key: 'getSalesDetails',
	    value: function getSalesDetails(dateFrom, dateTo, tablesRanges, cashiers, categories, tags) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/sales-details-report',
	        params: {
	          date_from: dateFrom,
	          date_to: dateTo,
	          table_ranges: (0, _stringify2.default)(tablesRanges),
	          cashiers: (0, _stringify2.default)(cashiers),
	          categories: (0, _stringify2.default)(categories),
	          tags: (0, _stringify2.default)(tags)
	        }
	      }).then(function (resp) {
	        return resp.data.rows;
	      }, function (resp) {
	        return [];
	      }));
	    }
	  }, {
	    key: 'getAccountHandies',
	    value: function getAccountHandies() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/accounts/handies'
	      }).then(function (resp) {
	        return resp.data.handies;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'registerHandy',
	    value: function registerHandy(data) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts/handies',
	        data: data
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'countAccountPointOfSales',
	    value: function countAccountPointOfSales() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        params: { just_count: true },
	        url: this.host + '/api/accounts/point-of-sales'
	      }).then(function (resp) {
	        return (resp.data || {}).points_of_sales || 0;
	      }, function (resp) {
	        return 0;
	      }));
	    }
	  }, {
	    key: 'countAccountHandies',
	    value: function countAccountHandies() {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        params: { just_count: true },
	        url: this.host + '/api/accounts/handies'
	      }).then(function (resp) {
	        return (resp.data || {}).handies || 0;
	      }, function (resp) {
	        return 0;
	      }));
	    }
	  }]);
	  return ContentService;
	}();
	
	exports.default = ContentService;
	
	
	ContentService.$inject = ['$http', 'host', '$poller'];

/***/ }),
/* 1096 */,
/* 1097 */,
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _pointOfSales = __webpack_require__(1099);
	
	var _pointOfSales2 = _interopRequireDefault(_pointOfSales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PointOfSalesModule = _angular2.default.module('PointOfSales', [_angularjs2.default]).component('pointOfSales', _pointOfSales2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('pointOfSales', {
	    url: '/point-of-sales',
	    data: {
	      authRequired: true,
	      permsRequired: ['view-pos', 'register-pos']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'pointOfSales'
	      }
	    },
	    resolve: {
	      posObservable: ["ContentService", "ProfilePermissionsService", function posObservable(ContentService, ProfilePermissionsService) {
	        return ProfilePermissionsService.hasPermission('view-pos') ? ContentService.getPOSList() : {};
	      }]
	    }
	  });
	}]).name;
	
	exports.default = PointOfSalesModule;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pointOfSales = __webpack_require__(1100);
	
	var _pointOfSales2 = _interopRequireDefault(_pointOfSales);
	
	var _pointOfSales3 = __webpack_require__(1101);
	
	var _pointOfSales4 = _interopRequireDefault(_pointOfSales3);
	
	__webpack_require__(1102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PointOfSalesComponent = {
	  bindings: {
	    posObservable: '<'
	  },
	  template: _pointOfSales2.default,
	  controller: _pointOfSales4.default
	};
	
	exports.default = PointOfSalesComponent;

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-10 col-sm-10 col-xs-11\">\n                {{'Puntos de Ventas (POS)' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.posList.length || 0 }}\n                </span>\n            </div>\n            <div class=\"col-md-2\">\n                <a class=\"float-right btn btn-success btn-sm btn_transitions\" href=\"\" ng-click=\"$ctrl.openPOSModal()\" if-perm disable-if=\"register-pos\">\n                    <span class=\"glyphicon glyphicon-plus\"></span>\n                    <span>{{'Registrar nuevo POS' | translate}}</span>\n                </a>\n            </div>\n        </div>\n    </h1>\n\n\t<div class=\"card\">\n\t\t<div class=\"card-content\">\n\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t\t\t<div class=\"columns columns-right pull-right hidden\">\n\t\t\t\t\t\t<div class=\"keep-open btn-group\" title=\"Columns\">\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-columns\"></i> <span class=\"caret\"></span>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar handies' | translate}}</label>\n\t\t\t\t\t\t</div> \n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'name' ? '-name' : 'name'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'name', 'desc': orderedBy === '-name'}\">{{'Nombre POS' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'number' ? '-number' : 'number'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'number', 'desc': orderedBy === '-number'}\">{{'Número POS' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th  class=\"text-center\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'site_number' ? '-site_number' : 'site_number'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'site_number', 'desc': orderedBy === '-site_number'}\">{{'Sitio del Número' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th  class=\"text-center\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'port_number' ? '-port_number' : 'port_number'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'port_number', 'desc': orderedBy === '-port_number'}\">{{'Puerto' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th  class=\"text-center\" data-field=\"salary\" ng-click=\"orderedBy = orderedBy === 'ip_address' ? '-ip_address' : 'ip_address'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'ip_address', 'desc': orderedBy === '-ip_address'}\">{{'Dirección IP' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th  class=\"text-right\" data-field=\"salary\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{'Acciones' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"pos in $ctrl.posList | orderBy:orderedBy | filter:filterCrit as filtered\">\n\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Nombre POS' | translate}}\" class=\"text-center\">{{ pos.name || '-' }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Número POS' | translate}}\" class=\"text-center\">{{ pos.number || '-' }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Sitio del Número' | translate}}\" class=\"text-center\">{{ pos.site_number || '-' }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Puerto' | translate}}\" class=\"text-center\">{{ pos.port_number || '-' }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Dirección IP' | translate}}\" class=\"text-center\">{{ pos.ip_address || '-' }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"{{'Acciones' | translate}}\" class=\"td-actions text-right\" >\n\t\t\t\t\t\t\t\t\t\t<div class=\"table-icons\">\n\t\t\t\t\t\t\t\t\t\t\t<a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-warning btn-icon\" ng-click=\"$ctrl.openPOSModal(pos)\" \n\t\t\t\t\t\t\t\t\t\t\t\tdata-original-title=\"Editar\" if-perm disable-if=\"edit-pos\">  \n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t<a rel=\"tooltip\" title=\"\"\n\t\t\t\t\t\t\t\t\t\t\t\tclass=\"btn btn-simple btn-danger btn-icon\"\n\t\t\t\t\t\t\t\t\t\t\t\tmwl-confirm\n\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{'¿Esta seguro?' | translate}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tmessage=\"{{'ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?' | translate}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tconfirm-text=\"{{'Eliminar' | translate}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tcancel-text=\"{{'Cancelar'  | translate}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tplacement=\"left\"\n\t\t\t\t\t\t\t\t\t\t\t\ton-confirm=\"$ctrl.deletePos(pos)\"\n\t\t\t\t\t\t\t\t\t\t\t\ton-cancel=\"\"\n\t\t\t\t\t\t\t\t\t\t\t\tconfirm-button-type=\"danger\"\n\t\t\t\t\t\t\t\t\t\t\t\tcancel-button-type=\"default\"\n\t\t\t\t\t\t\t\t\t\t\t\tif-perm disable-if=\"delete-pos\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"fixed-table-pagination hidden\">\n\t\t\t\t\t\t<div class=\"pull-left pagination-detail\">\n\t\t\t\t\t\t\t<span class=\"page-list\">\n\t\t\t\t\t\t\t\t<span class=\"btn-group dropup\">\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"page-size\">8</span> \n\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</span>{{'Filas visible'  | translate}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"pull-right pagination\">\n\t\t\t\t\t\t\t<ul class=\"pagination\">\n\t\t\t\t\t\t\t<li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number active\"><a href=\"\">1</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">2</a></li>\n\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">3</a></li>\n\t\t\t\t\t\t\t<li class=\"page-next\"><a href=\"\">›</a></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"clearfix\"></div>\n\t\t</div>\n\t</div>\n\t\t<!--  end card  -->\n</div>\n\n\n<script type='text/ng-template' id=\"new-pos-template.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-title\" ng-if=\"!pointOfSales.id\">\n\t\t\t\t{{'Registrar Punto de Venta' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n\t\t</h3>\n\t\t<h3 class=\"modal-title\" id=\"modal-title\" ng-if=\"!!pointOfSales.id\">\n\t\t\t\t{{'Editar Punto de Venta' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n\t\t</h3>\n\t</div>\n  \t<div class=\"modal-body\" id=\"modal-body\">\n\t\t<form name=\"posForm\" novalidate>\t\t\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t\t<label for=\"posname\">{{'Nombre POS' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"posname\" ng-model=\"pointOfSales.name\" validator=\"required\" \n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"posnumber\">{{'Número de POS' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"posnumber\"  ng-model=\"pointOfSales.number\" validator=\"required\"\n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"possitenumber\">{{'Número de Sitio POS' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"possitenumber\" ng-model=\"pointOfSales.site_number\" validator=\"required\" \n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"port\">{{'Número de Puerto' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"port\" ng-model=\"pointOfSales.port_number\" validator=\"required\" \n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"ip\">{{'Dirección IP' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"ip\" ng-model=\"pointOfSales.ip_address\" validator=\"required\" \n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" validation-submit=\"posForm\"\n\t\t\t\tng-if=\"!!pointOfSales.id\" ng-click=\"editPOS()\">{{'Editar' | translate}}</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" validation-submit=\"posForm\"\n\t\t\t\tng-if=\"!pointOfSales.id\" ng-click=\"registerPOS()\">{{'Crear' | translate}}</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n\t</div>\n</script>"

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PointOfSalesController = function () {
	  function PointOfSalesController($state, $uibModal, ContentService, isMobile) {
	    (0, _classCallCheck3.default)(this, PointOfSalesController);
	
	    this.modal = $uibModal;
	    this.$state = $state;
	    this.service = ContentService;
	    this.isMobile = isMobile;
	  }
	
	  (0, _createClass3.default)(PointOfSalesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	      this.subscriptions.push(this.posObservable.subscribe(function (posList) {
	        return _this.posList = posList;
	      }));
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'openPOSModal',
	    value: function openPOSModal(pointOfSales) {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'new-pos-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", function controller($scope, $state, $uibModalInstance) {
	          "ngInject";
	
	          $scope.pointOfSales = pointOfSales || {};
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.registerPOS = function () {
	            that.subscriptions.push(that.service.registerPOS($scope.pointOfSales).subscribe(function (newPOS) {
	              that.posList.push(newPOS);
	              $scope.closeThisDialog();
	            }, function (error) {
	              console.log(error);
	            }));
	          };
	          $scope.editPOS = function () {
	            that.subscriptions.push(that.service.changePOS($scope.pointOfSales).subscribe(function (resp) {
	              $scope.closeThisDialog();
	            }, function (error) {
	              console.log(error);
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'deletePos',
	    value: function deletePos(pos) {
	      var _this2 = this;
	
	      this.subscriptions.push(this.service.deletePOS(pos.id).subscribe(function (resp) {
	        _this2.posList.splice(_this2.posList.indexOf(pos), 1);
	      }, function (error) {
	        console.log(error);
	      }));
	    }
	  }]);
	  return PointOfSalesController;
	}();
	
	exports.default = PointOfSalesController;
	
	
	PointOfSalesController.$inject = ['$state', '$uibModal', 'ContentService', 'isMobile'];

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1103);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./point-of-sales.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./point-of-sales.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".PointOfSales{color:red}.modal-header{background:#2196f3;text-align:center;color:#f0f8ff;width:100.1%;border-radius:5px 5px 0 0}.modal-header h3{line-height:1}.btn_standar{min-width:110px}.btn_standar,.btn_transitions{transition:.3s ease-out}.table_container{margin:20px auto}@media (min-width:992px){.modal-lg{width:700px}}", ""]);
	
	// exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _salesReport = __webpack_require__(1105);
	
	var _salesReport2 = _interopRequireDefault(_salesReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesReportModule = _angular2.default.module('SalesReport', [_angularjs2.default]).component('salesReport', _salesReport2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesReport', {
	    url: '/sales-report',
	    data: {
	      authRequired: true,
	      permsRequired: ['sales-report']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'salesReport'
	      }
	    }
	  });
	}]).name;
	
	exports.default = SalesReportModule;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesReport = __webpack_require__(1106);
	
	var _salesReport2 = _interopRequireDefault(_salesReport);
	
	var _salesReport3 = __webpack_require__(1107);
	
	var _salesReport4 = _interopRequireDefault(_salesReport3);
	
	__webpack_require__(1108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesReportComponent = {
	  bindings: {},
	  template: _salesReport2.default,
	  controller: _salesReport4.default
	};
	
	exports.default = SalesReportComponent;

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{'Reporte de Ventas' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{$ctrl.rows.length || 0}}\n                </span>\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form class=\"hidden-xs\">\n            <div class=\"form col-md-12 no-padding\">\n\n                <input type=\"hidden\" name=\"sorter\" value=\"\">\n\n                <input type=\"hidden\" name=\"cashier_id\" value=\"\">\n\n                <input type=\"hidden\" name=\"pos_id\" value=\"\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>\n                    <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" value=\"\" id=\"from\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\" readonly>\n\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>    \n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" value=\"\" id=\"to\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\" readonly> \n                          \n                    <label for=\"group\" class=\"input-group-addon\">{{'Agrupado por' | translate}}</label>\n                    <select name=\"group\" ng-model=\"$ctrl.groupBy\" id=\"group\" class=\"form-control input_py\">\n\t\t\t\t\t\t\t<option value=\"0\">{{'Totalizado por Fecha' | translate}}</option>\n\t\t\t\t\t\t\t<option value=\"1\">{{'Totalizado por Camarero' | translate}}</option>\n\t\t\t\t\t\t\t<option value=\"2\">{{'Totalizado por Mesa' | translate}}</option>\n\t\t\t\t\t\t\t<option value=\"3\">{{'Totalizado por Factura' | translate}}</option>\n\t\t\t\t\t\t\t<option value=\"4\">{{'Totalizado por POS' | translate}}</option>\n\t\t\t\t\t\t\t<option value=\"5\">{{'Totalizado por Categoria' | translate}}</option>\n\t\t\t\t\t\t\t<option value=\"6\">{{'Totalizado por Etiqueta'|translate}}</option>\n                    </select>\n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findSalesReport()\">{{'Buscar' | translate}}</button>\n                    </span>\n                </div>\n            </div>\n        </form>\n\t\t<form class=\"visible-xs\">\n            <div class=\"form_xs\">\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_left\">\n\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n\t\t\t\t  <input class=\"form-control input_py\" name=\"from\" moment-picker=\"$ctrl.dateFrom\"\n\t\t\t\t\t\tng-model=\"$ctrl.dateFrom\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_right\">\n\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Hasta' | translate}}</p>\n\t\t\t\t\t<input class=\"form-control input_py\" name=\"to\" moment-picker=\"$ctrl.dateTo\"\n\t\t\t\t\t\tng-model=\"$ctrl.dateTo\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<p class=\"label_m\" for=\"group\">{{'Agrupado por' | translate}}:</p>\n                    <select name=\"group\" ng-model=\"$ctrl.groupBy\" id=\"group\" class=\"form-control input_py\">\n                        <option value=\"0\" selected>{{'Totalizado por fecha' | translate}}</option>\n                        <option value=\"1\">{{'Totalizado por Camarero' | translate}}</option>\n                        <option value=\"2\">{{'Totalizado por Mesa' | translate}}</option>\n                        <option value=\"3\">{{'Totalizado por Factura' | translate}}</option>\n\t\t\t\t\t\t<option value=\"4\">{{'Totalizado por POS'  | translate}}</option>\n\t\t\t\t\t\t<option value=\"5\">{{'Totalizado por Categoria' | translate}}</option>\t\t\t\t\t\t\n                    </select>\n\t\t\t\t</div>\n\t\t\t\t<button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findSalesReport()\">{{'Buscar' | translate}}</button>\n            </div>\n        </form>\n    </div>\n<!--  -->\n\t<div class=\"col-md-12 table_container no_padding\">\n\t\t<div class=\"card\">\n\t\t\t<div class=\"card-content\">\n\t\t\t\t<div class=\"bootstrap-table\">\n\n\t\t\t\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t\t\t\t<div class=\"columns pull-right\">\n\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-success\" ng-csv=\"$ctrl.getExportRows()\" csv-header=\"$ctrl.csvHeaders\" csv-column-order=\"$ctrl.csvHeaderOrder\" filename=\"reporte-de-ventas.csv\" ng-disabled=\"$ctrl.rows.length <= 0\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-file-o\" aria-hidden=\"true\"></i> {{'Exportar CSV' | translate}}\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-disabled=\"activeTab === 'charts' || !($ctrl.isGroupedByDate() || $ctrl.isGroupedByCashier() || $ctrl.isGroupedByPOS() || $ctrl.isGroupedByCategory())\"\n\t\t\t\t\t\t\t\t\t\tng-click=\"activeTab='charts'\"> \n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-pie-chart\" aria-hidden=\"true\"></i><span class=\"hidden-xs\">{{'Gráficos' | translate}}</span> \n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!activeTab || activeTab === 'results'\"\n\t\t\t\t\t\t\t\t\t\tng-click=\"activeTab='results'\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-table\" aria-hidden=\"true\"></i><span class=\"hidden-xs\">{{'Resultados' | translate}}</span>\n\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"orderedBy\"\n\t\t\t\t\t\t\t\t\tng-disabled=\"activeTab==='charts'\" ng-class=\"{'disabled': activeTab==='charts'}\" required>\n\t\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar ventas' | translate}}</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!--<div class=\"fixed-table-toolbar\">\n\t\t\t\t\t\t<div class=\"columns columns-right pull-right\">\n\t\t\t\t\t\t\t<div class=\"keep-open btn-group\" title=\"Columns\">\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-columns\"></i> <span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t\t<label for=\"input-search\">Filtrar ventas</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>-->\n\n\t\t\t\t\t<div class=\"fixed-table-container\" ng-show=\"!activeTab || activeTab==='results'\">\n\t\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t<tr ng-if=\"!$ctrl.isGroupedByTag()\">\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"$ctrl.isGroupedByDate()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'date' ? '-date' : 'date'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'date', 'desc': $ctrl.orderedBy === '-date'}\">{{'Fecha' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"$ctrl.isGroupedByCashier()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'cashier' ? '-cashier' : 'cashier'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'cashier', 'desc': $ctrl.orderedBy === '-cashier'}\">{{'Cajero' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"$ctrl.isGroupedByCategory()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'pifamm_name' ? '-pifamm_name' : 'pifamm_name'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'pifamm_name', 'desc': $ctrl.orderedBy === '-pifamm_name'}\">{{'Categoria' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"$ctrl.isGroupedByTag()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'tag' ? '-tag' : 'tag'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'pifamm_name', 'desc': $ctrl.orderedBy === '-pifamm_name'}\">{{'Etiqueta' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-if=\"$ctrl.isGroupedByTable()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'table' ? '-table' : 'table'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'table', 'desc': $ctrl.orderedBy === '-table'}\">{{'Mesa' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\n\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left td-datetime-width\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'date' ? '-date' : 'date'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'date', 'desc': $ctrl.orderedBy === '-date'}\">{{'Fecha' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'ncf' ? '-ncf' : 'ncf'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'ncf', 'desc': $ctrl.orderedBy === '-ncf'}\">{{'NCF' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'name' ? '-name' : 'name'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'name', 'desc': $ctrl.orderedBy === '-name'}\">{{'Nombre' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'rnc' ? '-rnc' : 'rnc'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'rnc', 'desc': $ctrl.orderedBy === '-rnc'}\">{{'RNC' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\n\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"$ctrl.isGroupedByPOS()\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'pos' ? '-pos' : 'pos'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'pos', 'desc': $ctrl.orderedBy === '-pos'}\">{{'POS' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\n\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"!($ctrl.isGroupedByCategory() || $ctrl.isGroupedByTag())\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'pax' ? '-pax' : 'pax'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'pax', 'desc': $ctrl.orderedBy === '-pax'}\">{{'Pax' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th  data-field=\"name\" class=\"text-left\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'discount' ? '-discount' : 'discount'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'discount', 'desc': $ctrl.orderedBy === '-discount'}\">{{'Descuento' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'total' ? '-total' : 'total'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'total', 'desc': orderedBy === '-total'}\">{{'Total' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"!($ctrl.isGroupedByCategory() || $ctrl.isGroupedByTag())\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'taxexemption' ? '-taxexemption' : 'taxexemption'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'taxexemption', 'desc': orderedBy === '-taxexemption'}\">{{'Exoneracion' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th ng-if=\"!($ctrl.isGroupedByCategory() || $ctrl.isGroupedByTag())\" class=\"text-left\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'extra_tip' ? '-extra_tip' : 'extra_tip'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'extra_tip', 'desc': $ctrl.orderedBy === '-extra_tip'}\">{{'Propina Extra' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" ng-if=\"!($ctrl.isGroupedByCategory() || $ctrl.isGroupedByTag())\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'tax10' ? '-tax10' : 'tax10'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'tax10', 'desc': $ctrl.orderedBy === '-tax10'}\">{{'% Ley' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th  data-field=\"salary\"  ng-if=\"!($ctrl.isGroupedByCategory() || $ctrl.isGroupedByTag())\"  class=\"text-left\" ng-click=\"$ctrl.orderedBy = $ctrl.orderedBy === 'tax16' ? '-tax16' : 'tax16'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': $ctrl.orderedBy === 'tax16', 'desc': $ctrl.orderedBy === '-tax16'}\">{{'Impuesto IVA' | translate}}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr ng-if=\"$ctrl.isGroupedByTag()\">\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"family\">\n\t\t\t\t\t\t\t\t\t\t\t{{'Categoría' | translate}}\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"tag\">\n\t\t\t\t\t\t\t\t\t\t\t{{'Etiqueta' | translate}}\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"discount\">\n\t\t\t\t\t\t\t\t\t\t\t{{'Desc.' | translate}}\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"total\">\n\t\t\t\t\t\t\t\t\t\t\t{{'Total' | translate}}\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\t\n\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByDate()\"\n\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.drillDownOnDate(row.date)\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"text-center\">{{ row.date | amUtc | amDateFormat:'DD-MMM-YYYY'}}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Pax:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Desc.:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Exoneracion:\" class=\"text-right\">{{ row.taxexemption | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Prop.Extra:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"%Ley:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"IVA:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByCategory()\" ng-click=\"$ctrl.goToItemDrilldown(row.pifamm_id, row.pifamm_name)\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Categoria:\" class=\"text-center\">{{ row.pifamm_name || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Descuento:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByCashier()\"\n\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.drillDownOnCashier(row.cashier_id)\">\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Vendedor:\" class=\"text-center\">{{ row.cashier || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Pax:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Desc.:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Exoneracion:\" class=\"text-right\">{{ row.taxexemption | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"Prop.Extra:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"%Ley:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t\t<td data-label=\"IVA:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByTable()\" ng-click=\"$ctrl.drillDownOnTable(row.table)\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Mesa:\" class=\"text-center\">{{ row.table }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Pax:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Desc.:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Exoneracion:\" class=\"text-right\">{{ row.taxexemption | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Prop.Extra:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"%Ley:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"IVA:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByInvoice()\"\n\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.openBillDetails(row.id)\" if-perm disable-if=\"account-bills, invoice-orders\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"text-center\">{{ row.date | amUtc | amDateFormat:'DD-MMM-YYYY hh:mm' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"NCF:\" class=\"text-center\">{{ row.ncf || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Nombre:\" class=\"text-center\">{{ row.name || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"RNC:\" class=\"text-center\">{{ row.rnc || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Pax:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Desc.:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Exoneracion:\" class=\"text-right\">{{ row.taxexemption | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Prop.Extra:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"%Ley:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"IVA:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByPOS()\"\n\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.drillDownOnPOS(row.pos)\">\n\t\t\t\t\t\t\t\t\t<td data-label=\"POS:\" class=\"text-center\">{{ row.pos }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Pax:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Desc.:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Total:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Exoneracion:\" class=\"text-right\">{{ row.taxexemption | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Prop.Extra:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"%Ley:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"IVA:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByTag()\">\n\t\t\t\t\t\t\t\t\t\t<td>{{row.family | lowercase | capitalise}}</td>\n\t\t\t\t\t\t\t\t\t\t<td>{{row.tag || '' | lowercase | capitalise}}</td>\n\t\t\t\t\t\t\t\t\t\t<td>{{row.discount | currency}}</td>\n\t\t\t\t\t\t\t\t\t\t<td>{{row.total | currency}}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t<tfoot>\n\t\t\t\t\t\t\t\t\t<tr ng-if=\"!$ctrl.isGroupedByCategory() && !$ctrl.isGroupedByTag()\">\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Pax:\" colspan=\"{{ $ctrl.isGroupedByInvoice() ? 5 : 2 }}\" data-field=\"name\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getPax | sum: 0 }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Desc.:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Exoneración:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTaxExemption | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Prop.Extra:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getExtraTip | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Propina:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTax10 | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total IVA:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTax16 | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\n\n\t\t\t\t\t\t\t\t\t<tr ng-if=\"$ctrl.isGroupedByCategory() || $ctrl.isGroupedByTag()\" >\n\t\t\t\t\t\t\t\t\t\t<th ng-if=\" $ctrl.isGroupedByTag()\"></th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Descuento:\"  data-field=\"name\" class=\"text-right\"></th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n                                        <th data-label=\"Total:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</tfoot>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"fixed-table-pagination hidden\">\n\t\t\t\t\t\t\t<div class=\"pull-left pagination-detail\">\n\t\t\t\t\t\t\t\t<span class=\"page-list\">\n\t\t\t\t\t\t\t\t\t<span class=\"btn-group dropup\">\n\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"page-size\">8</span>\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t</span>{{'Filas visible' | translate}}\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"pull-right pagination\">\n\t\t\t\t\t\t\t\t<ul class=\"pagination\">\n\t\t\t\t\t\t\t\t<li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-number active\"><a href=\"\">1</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">2</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-number\"><a href=\"\">3</a></li>\n\t\t\t\t\t\t\t\t<li class=\"page-next\"><a href=\"\">›</a></li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"fixed-table-container\" ng-show=\"activeTab==='charts'\">\n\t\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t\t<canvas ng-if=\"$ctrl.isGroupedByDate()\" class=\"chart chart-line\"\n\t\t\t\t\t\t\t\tchart-data=\"$ctrl.chartParams.data\"\n\t\t\t\t\t\t\t\tchart-labels=\"$ctrl.chartParams.labels\" chart-options=\"$ctrl.chartParams.options\"\n\t\t\t\t\t\t\t\tchart-dataset-override=\"$ctrl.chartParams.datasetOverride\"\n\t\t\t\t\t\t\t\tchart-series=\"$ctrl.chartParams.series\">\n\t\t\t\t\t\t\t</canvas>\n\t\t\t\t\t\t\t<canvas ng-if=\"$ctrl.isGroupedByCashier() || $ctrl.isGroupedByPOS()\" class=\"chart chart-pie\"\n\t\t\t\t\t\t\t\tchart-data=\"$ctrl.chartParams.data\"\n\t\t\t\t\t\t\t\tchart-labels=\"$ctrl.chartParams.labels\" chart-options=\"$ctrl.chartParams.options\"\n\t\t\t\t\t\t\t\tchart-dataset-override=\"$ctrl.chartParams.datasetOverride\"\n\t\t\t\t\t\t\t\tchart-series=\"$ctrl.chartParams.series\">\n\t\t\t\t\t\t\t</canvas>\n\t\t\t\t\t\t\t<canvas ng-if=\"$ctrl.isGroupedByCategory()\" class=\"chart chart-pie\"\n\t\t\t\t\t\t\t\tchart-data=\"$ctrl.chartParams.data\"\n\t\t\t\t\t\t\t\tchart-labels=\"$ctrl.chartParams.labels\" chart-options=\"$ctrl.chartParams.options\"\n\t\t\t\t\t\t\t\tchart-dataset-override=\"$ctrl.chartParams.datasetOverride\"\n\t\t\t\t\t\t\t\tchart-series=\"$ctrl.chartParams.series\">\n\t\t\t\t\t\t\t</canvas>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t<div class=\"clearfix\"></div>\n\t\t</div>\n\t\t</div>\n\t<!--  end card  -->\n\t</div>\n\t<!--  end card  -->\n</div>\n\n<script type='text/ng-template' id=\"invoice-details-template.html\">\n\t<div class=\"modal-header\">\n    \t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t{{'Detalle de Factura' | translate}}\n\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    \t</h3>\n  \t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n    <nav>\n        <ul class=\"Tabs\">\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: !ordersShown}\" ng-click=\"showInvoice()\"\n\t\t\t\tif-perm disable-if=\"account-bills\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Factura' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: ordersShown}\" ng-click=\"showOrders()\"\n\t\t\t\tif-perm disable-if=\"invoice-orders\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Órdenes' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\">\n                <button class=\"btn btn-default pull-right\" ng-click=\"printToCart('printSectionId')\">\n                    <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                </button>\n            </li>\n            <li class=\"Tabs__presentation-slider\" role=\"presentation\"></li>\n        </ul>\n    </nav>\n<!-- start print -->\n\t\t<div id=\"printSectionId\" class=\"Section_Print\">\n\t\t\t<div class=\"Powered\">\n\t\t\t\t<span>{{'RNC' | translate}}: </span>{{account.identification || '-'}} <br>\n\t\t\t\t<span>{{'Dirección' | translate}}: </span>{{ account.address || '-'}} <br>\n\t\t\t\t<span>{{'Telefono' | translate}}: </span>{{ account.phone || '-'}}\n\t\t\t</div>\n\t\t\t<div class=\"logo_invoice\">\n\t\t\t\t<img src=\"{{ logoUrl }}\" alt=\"\">\n\t\t\t</div>\n\t\t\t<div class=\"print_separator\"></div>\n\t\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-condensed tableforprint\">\n\t\t\t\t\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-right\" colspan=\"2\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong><span>{{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }} \n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<!-- <tr>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Mesa No.:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Atendida por:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Pax:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr> -->\n\t\t\t\t\n\t\t\t\t<tr>\n\t\t\t\t\t<th class=\"text-center\" \"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Descuento' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Total' | translate}}</th>\n\t\t\t\t\t\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td class=\"text-center\" \"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.discount | currency }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.total | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"><hr></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'Notas' | translate}}:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'Subtotal' | translate}}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{'Comensales' | translate}}: <span>{{ invoice.pax }}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'Descuento' | translate}}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.discount | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"2\">\n\t\t\t\t\t\t<span>{{'Atendido por' | translate}}: </span>\n\t\t\t\t\t\t<span>{{ invoice.cashier || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>% Ley:</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{'IVA' | translate}}:</span> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{'Exoneracion IVA' | translate}}:</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{ invoice.total | currency }}</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<!-- <td \"3\">\n\t\t\t\t\t\t<strong>Impuestos incluidos:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td> -->\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\t</div>\n\t<!-- end print -->\n\n\t<div class=\"invoice-detail\" ng-show=\"!ordersShown || ordersShown==='false'\"> \n\t\t\t<table class=\"table table-bordered table-condensed\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong> {{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Emitido a' | translate}}:</strong> {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Mesa No.' | translate}}:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Atendida por' | translate}}:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Descuento'  | translate}}:</strong> {{ invoice.discount | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Pax' | translate}}:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong> {{ invoice.total | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Impuestos incluidos' | translate}}:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Impuesto IVA' | translate}}:</strong> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'% Ley' | translate}}:</strong> {{ invoice.tax10 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n                <tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Exoneracion IVA' | translate}}:</strong> {{ invoice.taxexemption | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t&nbsp;\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"></td></tr>\n\t\t\t\t<tr class=\"hidden-xs hidden-sm\">\n\t\t\t\t\t<th colspan=\"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th>{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th>{{'Total' | translate}}</th>\n\t\t\t\t\t<th>{{'Desc.' | translate}}</th>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"table_graund\" ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td data-label=\"Detalles\" colspan=\"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td data-label=\"Cantidad\" class=\"text-right\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td data-label=\"Total\" class=\"text-right\">{{ detail.total | currency }}</td>\n\t\t\t\t\t<td data-label=\"Desc.\" class=\"text-right\">{{ detail.discount | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=\"orders\" ng-show=\"ordersShown\">\n\n\t\t\t<table class=\"table table-bordered table-condensed\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>{{'Factura' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Acción' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Fecha' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Vendedor' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Estado' | translate}}</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat=\"order in orders\">\n\t\t\t\t\t\t<td data-label=\"Factura\">\n\t\t\t\t\t\t\t<a href=\"\" data-ajax_load=\"\" data-container=\"#billpayment\" class=\"btn btn-xs btn-primary\"\n\t\t\t\t\t\t\t\tng-click=\"fetchDetails(order)\">\n\t\t\t\t\t\t\t\t{{ order.id }}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td data-label=\"Acción\">{{ order.action || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Fecha\">{{ order.date | amUtc | amDateFormat:'LLLL' | capitalise }}</td>\n\t\t\t\t\t\t<td data-label=\"Vendedor\">{{ order.cashier || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Estado\">{{ order.status || '-' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t\t\t<!--<span>Detalles</span>-->\n\t\t\t\t<table class=\"table table-bordered table-condensed\" ng-show=\"displayingOrder\">\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr><td colspan=\"4\">{{ displayingOrder.action || '-' }}</td></tr>\n\t\t\t\t\t\t<tr class=\"table_list_heading\">\n\t\t\t\t\t\t\t<th class=\"detail_table hidden-xs hidden-sm\" width=\"100\"><b>{{'De la Factura' | translate}}</b></th>\n\t\t\t\t\t\t\t<td data-label=\"De la Factura:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.billid || '-' }}</td>\n\t\t\t\t\t\t\t<th class=\" hidden-xs hidden-sm\" width=\"100\"><b>{{'Fecha' | translate}}</b></th>\n\t\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.date | amUtc | amDateFormat:'LLLL' | capitalise }}</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>{{'Vendedor' | translate}}:</b></th>\n\t\t\t\t\t\t\t<td data-label=\"Vendedor:\">{{ displayingOrder.cashier || '-' }}</td>\n\t\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>{{'Mesa' | translate}}:</b></th>\n\t\t\t\t\t\t\t<td data-label=\"Mesa:\" colspan=\"2\">{{ displayingOrder.table_type || '-' }} {{ displayingOrder.table_code || '' }}</td>\n\t\t\t\t\t\t</tr>\n\n\t\t\t\t\t\t<tr class=\"table_graund\" ng-repeat=\"detail in displayingOrder.details\">\n\t\t\t\t\t\t\t<td colspan=\"2\">{{ detail.name  || '-' }}</td>\n\t\t\t\t\t\t\t<td colspan=\"2\">{{ detail.qty  || 0 }}</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\n\t\t</div>\n\n\t</div>\n\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">\n\t\t\t{{'Salir' | translate}}\n\t\t</button>\n\t</div>\n</script>\n"

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesReportController = function () {
	  function SalesReportController(ContentService, $uibModal, moment, $filter, isMobile, ProfilePermissionsService, $state) {
	    (0, _classCallCheck3.default)(this, SalesReportController);
	
	    this.service = ContentService;
	    this.modal = $uibModal;
	    this.moment = moment;
	    this.filters = $filter;
	    this.isMobile = isMobile;
	    this.permissionsService = ProfilePermissionsService;
	    this.state = $state;
	  }
	
	  (0, _createClass3.default)(SalesReportController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	      this.groupBy = '0';
	      this.rows = [];
	      this.csvHeaderOrder = [];
	      this.csvHeaders = [];
	      this.dateFrom = undefined;
	      this.dateTo = undefined;
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'findSalesReport',
	    value: function findSalesReport() {
	      var groupBy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	      var cashierId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	      var posId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      var _this = this;
	
	      var famId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	      var tableId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
	
	      this.subscriptions.push(this.service.findSalesReport({
	        date_from: this.dateFrom.format(),
	        date_to: this.dateTo.format(),
	        group_by: groupBy || this.groupBy,
	        cashier_id: cashierId,
	        pos_id: posId,
	        fam_id: famId,
	        table_id: tableId
	      }).subscribe(function (resultSet) {
	        _this.rows = resultSet;
	        if (_this.isGroupedByDate()) {
	          _this.buildChartSalesReportByDate(resultSet);
	        } else if (_this.isGroupedByCashier()) {
	          _this.buildChartSalesReportByCashier(resultSet);
	        } else if (_this.isGroupedByTable()) {
	          _this.buildChartSalesReportByTable(resultSet);
	        } else if (_this.isGroupedByPOS()) {
	          _this.buildChartSalesReportByPOS(resultSet);
	        } else if (_this.isGroupedByCategory()) {
	          _this.buildChartSalesReportByCategory(resultSet);
	        }
	        _this.reorderCsv();
	      }, function (err) {
	        return console.log(err);
	      }));
	    }
	  }, {
	    key: 'openBillDetails',
	    value: function openBillDetails(invoiceId) {
	      var that = this;
	      var hasOrdersPermission = that.permissionsService.hasPermission('invoice-orders');
	      var hasBillsPermission = that.permissionsService.hasPermission('account-bills');
	      if (hasBillsPermission || hasOrdersPermission) {
	        this.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'invoice-details-template.html',
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "$uibModalInstance", "AccountInformationService", function controller($scope, $uibModalInstance, AccountInformationService) {
	            "ngInject";
	
	            $scope.invoice = {};
	            $scope.orders = [];
	            $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
	            $scope.showOrders = function () {
	              if (hasOrdersPermission) {
	                $scope.getOrders();
	                $scope.ordersShown = true;
	              }
	            };
	            $scope.showInvoice = function () {
	              if (hasBillsPermission) {
	                $scope.ordersShown = false;
	              }
	            };
	
	            that.subscriptions.push(AccountInformationService.getAccountInfo().subscribe(function (resp) {
	              $scope.account = resp;
	            }));
	
	            if (hasBillsPermission) {
	              that.subscriptions.push(that.service.getInvoice(invoiceId).subscribe(function (invoice) {
	                return $scope.invoice = invoice;
	              }, function (error) {
	                return console.log("Error while getting the invoice");
	              }));
	            }
	            $scope.getOrders = function () {
	              if ($scope.orders.length <= 0) {
	                that.subscriptions.push(that.service.getOrders(invoiceId).subscribe(function (orders) {
	                  return $scope.orders = orders;
	                }, function (error) {
	                  return console.log("Error while getting the orders");
	                }));
	              }
	            };
	            if (!hasBillsPermission) {
	              $scope.showOrders();
	            }
	            $scope.fetchDetails = function (order) {
	              if (!order.details || order.details.length <= 0) {
	                that.subscriptions.push(that.service.getOrderDetails(invoiceId, order.id).subscribe(function (details) {
	                  order.details = details;
	                  $scope.displayingOrder = order;
	                }, function (error) {
	                  return console.log("Error while getting the details for this order");
	                }));
	              } else {
	                $scope.displayingOrder = order;
	              }
	            };
	
	            $scope.printToCart = function (printSectionId) {
	              var innerContents = document.getElementById(printSectionId).innerHTML;
	              var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	              popupWinindow.document.open();
	              var styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              var styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              popupWinindow.document.write('<html><head><title>Imprimir factura #' + $scope.invoice.number + '</title><style>' + styleprint.innerHTML + '</style><style>' + styleprintBootstrap.innerHTML + '</style></head><body onload="window.print()">' + innerContents + '</html>');
	              popupWinindow.document.close();
	            };
	
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	          }]
	        });
	      }
	    }
	  }, {
	    key: 'goToItemDrilldown',
	    value: function goToItemDrilldown(famId, famName) {
	      this.state.go('salesByCategory', {
	        famId: famId,
	        dateTo: this.dateTo,
	        dateFrom: this.dateFrom,
	        title: famName
	      });
	    }
	  }, {
	    key: 'getExportRows',
	    value: function getExportRows() {
	      var _this2 = this;
	
	      return this.rows.map(function (row) {
	        var newRow = angular.copy(row, {});
	        if (newRow.date) {
	          newRow.date = _this2.moment(newRow.date).format('DD/MM/YYYY');
	        }
	        return newRow;
	      });
	    }
	  }, {
	    key: 'getDiscount',
	    value: function getDiscount(item) {
	      return item.discount;
	    }
	  }, {
	    key: 'getPax',
	    value: function getPax(item) {
	      return item.pax;
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal(item) {
	      return item.total;
	    }
	  }, {
	    key: 'getExtraTip',
	    value: function getExtraTip(item) {
	      return item.extra_tip;
	    }
	  }, {
	    key: 'getTaxExemption',
	    value: function getTaxExemption(item) {
	      return item.taxexemption;
	    }
	  }, {
	    key: 'getTax10',
	    value: function getTax10(item) {
	      return item.tax10;
	    }
	  }, {
	    key: 'getTax16',
	    value: function getTax16(item) {
	      return item.tax16;
	    }
	  }, {
	    key: 'isGroupedByDate',
	    value: function isGroupedByDate() {
	      return !this.rows.length || this.rows[0].hasOwnProperty('date') && !this.rows[0].hasOwnProperty('rnc');
	    }
	  }, {
	    key: 'isGroupedByCashier',
	    value: function isGroupedByCashier() {
	      return this.rows.length && this.rows[0].hasOwnProperty('cashier');
	    }
	  }, {
	    key: 'isGroupedByTable',
	    value: function isGroupedByTable() {
	      return this.rows.length && this.rows[0].hasOwnProperty('table');
	    }
	  }, {
	    key: 'isGroupedByInvoice',
	    value: function isGroupedByInvoice() {
	      return this.rows.length && this.rows[0].hasOwnProperty('date') && this.rows[0].hasOwnProperty('rnc');
	    }
	  }, {
	    key: 'isGroupedByPOS',
	    value: function isGroupedByPOS() {
	      return this.rows.length && this.rows[0].hasOwnProperty('pos');
	    }
	  }, {
	    key: 'isGroupedByCategory',
	    value: function isGroupedByCategory() {
	      return this.rows.length && this.rows[0].hasOwnProperty('pifamm_id');
	    }
	  }, {
	    key: 'isGroupedByTag',
	    value: function isGroupedByTag() {
	      return this.rows && this.rows.length && this.rows[0].hasOwnProperty('tag_id');
	    }
	  }, {
	    key: 'drillDownOnDate',
	    value: function drillDownOnDate(rowDate) {
	      this.dateFrom = this.moment(rowDate);
	      this.dateTo = this.moment(rowDate);
	      this.groupBy = '3';
	      this.findSalesReport();
	    }
	  }, {
	    key: 'drillDownOnCashier',
	    value: function drillDownOnCashier(cashierId) {
	      this.groupBy = '3';
	      this.findSalesReport('15', cashierId);
	    }
	  }, {
	    key: 'drillDownOnPOS',
	    value: function drillDownOnPOS(posId) {
	      this.groupBy = '3';
	      this.findSalesReport('16', undefined, posId);
	    }
	  }, {
	    key: 'drillDownOnCategory',
	    value: function drillDownOnCategory(famId) {
	      this.groupBy = '3';
	      this.findSalesReport('17', undefined, undefined, famId);
	    }
	  }, {
	    key: 'drillDownOnTable',
	    value: function drillDownOnTable(tableId) {
	      this.groupBy = '3';
	      var table = parseInt(tableId.split('-')[0].trim()) * 10;
	      this.findSalesReport('18', undefined, undefined, undefined, table);
	    }
	  }, {
	    key: 'buildChartSalesReportByDate',
	    value: function buildChartSalesReportByDate(dataset) {
	      var _this3 = this;
	
	      this.chartParams = {
	        labels: dataset.map(function (row) {
	          return _this3.moment(row.date).format('DD-MM-YYYY');
	        }),
	        data: [dataset.map(function (row) {
	          return row.total;
	        }), dataset.map(function (row) {
	          return row.pax;
	        })],
	        series: ['Ventas', 'Personas'],
	        datasetOverride: [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }],
	        options: {
	          scales: {
	            yAxes: [{ id: 'y-axis-1', type: 'linear', display: true, position: 'left' }, { id: 'y-axis-2', type: 'linear', display: true, position: 'right' }]
	          }
	        }
	      };
	    }
	  }, {
	    key: 'buildChartSalesReportByCashier',
	    value: function buildChartSalesReportByCashier(dataset) {
	      this.chartParams = {
	        labels: dataset.map(function (row) {
	          return row.cashier;
	        }),
	        data: dataset.map(function (row) {
	          return row.total;
	        }),
	        options: {
	          legend: {
	            display: true,
	            position: 'right'
	          }
	        }
	      };
	    }
	  }, {
	    key: 'buildChartSalesReportByTable',
	    value: function buildChartSalesReportByTable(dataset) {
	      // TODO: build scatter chart here
	    }
	  }, {
	    key: 'buildChartSalesReportByPOS',
	    value: function buildChartSalesReportByPOS(dataset) {
	      this.chartParams = {
	        labels: dataset.map(function (row) {
	          return row.pos;
	        }),
	        data: dataset.map(function (row) {
	          return row.total;
	        }),
	        options: {
	          legend: {
	            display: true,
	            position: 'right'
	          }
	        }
	      };
	    }
	  }, {
	    key: 'buildChartSalesReportByCategory',
	    value: function buildChartSalesReportByCategory(dataset) {
	      this.chartParams = {
	        labels: dataset.map(function (row) {
	          return row.pifamm_name;
	        }),
	        data: dataset.map(function (row) {
	          return row.total;
	        }),
	        options: {
	          legend: {
	            display: true,
	            position: 'right'
	          }
	        }
	      };
	    }
	  }, {
	    key: 'buildChartSalesReportByTag',
	    value: function buildChartSalesReportByTag(dataset) {
	      this.chartParams = {
	        labels: dataset.map(function (row) {
	          return row.tag;
	        }),
	        data: dataset.map(function (row) {
	          return row.total;
	        }),
	        options: {
	          legend: {
	            display: true,
	            position: 'right'
	          }
	        }
	      };
	    }
	  }, {
	    key: 'reorderCsv',
	    value: function reorderCsv() {
	      this.getCsvHeaders();
	      this.getCsvHeaderOrder();
	    }
	  }, {
	    key: 'getCsvHeaders',
	    value: function getCsvHeaders() {
	      var usuals = ['Pax', 'Desc.', 'Prop.Extra', '% Ley', 'IVA', 'Total'];
	      if (this.isGroupedByCashier()) {
	        this.csvHeaders = ['Vendedor', 'Exención'].concat(usuals);
	      } else if (this.isGroupedByDate()) {
	        this.csvHeaders = ['Fecha', 'Exención'].concat(usuals);
	      } else if (this.isGroupedByInvoice()) {
	        this.csvHeaders = ['Fecha', 'Exención', 'NCF', 'RNC', 'Nombre'].concat(usuals);
	      } else if (this.isGroupedByPOS()) {
	        this.csvHeaders = ['POS', 'Exención'].concat(usuals);
	      } else if (this.isGroupedByTable()) {
	        this.csvHeaders = ['Mesa', 'Exención'].concat(usuals);
	      } else if (this.isGroupedByCategory()) {
	        this.csvHeaders = ['Categoría'].concat(usuals);
	      }
	    }
	  }, {
	    key: 'getCsvHeaderOrder',
	    value: function getCsvHeaderOrder() {
	      var usuals = ["pax", "discount", "extra_tip", "tax10", "tax16", "total"];
	      if (this.isGroupedByCashier()) {
	        this.csvHeaderOrder = ['cashier', 'taxexemption'].concat(usuals);
	      } else if (this.isGroupedByDate()) {
	        this.csvHeaderOrder = ['date', 'taxexemption'].concat(usuals);
	      } else if (this.isGroupedByInvoice()) {
	        this.csvHeaderOrder = ['date', 'ncf', 'rnc', 'Nombre', 'taxexemption'].concat(usuals);
	      } else if (this.isGroupedByPOS()) {
	        this.csvHeaderOrder = ['pos', 'taxexemption'].concat(usuals);
	      } else if (this.isGroupedByTable()) {
	        this.csvHeaderOrder = ['table', 'taxexemption'].concat(usuals);
	      } else if (this.isGroupedByCategory()) {
	        this.csvHeaderOrder = ['pifamm_name'].concat(usuals);
	      }
	    }
	  }]);
	  return SalesReportController;
	}();
	
	exports.default = SalesReportController;
	
	
	SalesReportController.$inject = ['ContentService', '$uibModal', 'moment', '$filter', 'isMobile', 'ProfilePermissionsService', '$state'];

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1109);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-report.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-report.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "sales-report .td-datetime-width{width:16%}", ""]);
	
	// exports


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _passwordRecovery = __webpack_require__(1111);
	
	var _passwordRecovery2 = _interopRequireDefault(_passwordRecovery);
	
	var _passwordRecovery3 = __webpack_require__(1116);
	
	var _passwordRecovery4 = _interopRequireDefault(_passwordRecovery3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordRecoveryModule = _angular2.default.module('PasswordRecovery', [_angularjs2.default]).component('passwordRecovery', _passwordRecovery2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('passwordRecovery', {
	    url: '/password-recovery/{token}',
	    views: {
	      'menu': "",
	      'content': {
	        component: 'passwordRecovery'
	      }
	    }
	  });
	}]).name;
	
	exports.default = PasswordRecoveryModule;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _passwordRecovery = __webpack_require__(1112);
	
	var _passwordRecovery2 = _interopRequireDefault(_passwordRecovery);
	
	var _passwordRecovery3 = __webpack_require__(1113);
	
	var _passwordRecovery4 = _interopRequireDefault(_passwordRecovery3);
	
	__webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordRecoveryComponent = {
	  bindings: {},
	  template: _passwordRecovery2.default,
	  controller: _passwordRecovery4.default
	};
	
	exports.default = PasswordRecoveryComponent;

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n    <div class=\"wrapper\">\n    </div>\n\n    <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n        <form class=\"form-signin\" name=\"changePasswordForm\" novalidate>\n            <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n            <h3 class=\"form-signin-heading\">{{'Cambiar Contraseña' | translate}}</h3>\n            <div class=\"form-group\">\n                <input type=\"password\" name=\"password\" ng-model=\"$ctrl.password\" class=\"form-control input_py\" placeholder=\"{{'Contraseña' | translate}}\" \n                    validator=\"required\" valid-method=\"submit\">\n            </div>\n            <div class=\"form-group\">\n                <input type=\"password\" name=\"confirmPassword\" ng-model=\"$ctrl.confirmPassword\" class=\"form-control input_py\" placeholder=\"{{'Confirmar Contraseña' | translate}}\" \n                    validator=\"required\" valid-method=\"submit\">\n            </div>\n            <button class=\"btn btn-md btn-primary btn-block btn_py\" ng-click=\"$ctrl.changePassword()\" type=\"submit\"\n                    validation-submit=\"changePasswordForm\">{{'Cambiar Contraseña' | translate}}</button>\n        </form>\n    </div>\n</body>"

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordRecoveryController = function () {
	  function PasswordRecoveryController($state, PasswordRecoveryService, Notification, $translate) {
	    (0, _classCallCheck3.default)(this, PasswordRecoveryController);
	
	    this.state = $state;
	    this.service = PasswordRecoveryService;
	    this.recoveryToken = $state.params.token;
	    this.notify = Notification;
	    this.trans = $translate.instant;
	  }
	
	  (0, _createClass3.default)(PasswordRecoveryController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.password = '';
	      this.confirmPassword = '';
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword() {
	      var _this = this;
	
	      var _ = this.trans;
	      if (this.password === this.confirmPassword) {
	        this.subscriptions.push(this.service.changePassword(this.password, this.recoveryToken).subscribe(function (data) {
	          _this.state.go('recoverySuccess');
	        }, function (err) {
	          console.log(err);
	        }));
	      } else {
	        this.notify.warning(_('Las contraseñas deben coincidir'));
	      }
	    }
	  }]);
	  return PasswordRecoveryController;
	}();
	
	exports.default = PasswordRecoveryController;
	
	
	PasswordRecoveryController.$inject = ['$state', 'PasswordRecoveryService', 'Notification', '$translate'];

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1115);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./password-recovery.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./password-recovery.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".PasswordRecovery{color:red}", ""]);
	
	// exports


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(497);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordRecoveryService = function () {
	  function PasswordRecoveryService($http, host) {
	    (0, _classCallCheck3.default)(this, PasswordRecoveryService);
	
	    this.http = $http;
	    this.host = host;
	  }
	
	  (0, _createClass3.default)(PasswordRecoveryService, [{
	    key: 'changePassword',
	    value: function changePassword(password, token) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/password-recovery/' + token,
	        data: { password: password }
	      }));
	    }
	  }, {
	    key: 'requestPassword',
	    value: function requestPassword(email) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/password-recovery',
	        data: { email: email }
	      }));
	    }
	  }]);
	  return PasswordRecoveryService;
	}();
	
	exports.default = PasswordRecoveryService;
	
	
	PasswordRecoveryService.$inject = ['$http', 'host'];

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _accountInformation = __webpack_require__(1118);
	
	var _accountInformation2 = _interopRequireDefault(_accountInformation);
	
	var _accountInformation3 = __webpack_require__(1123);
	
	var _accountInformation4 = _interopRequireDefault(_accountInformation3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountInformationModule = _angular2.default.module('AccountInformation', [_angularjs2.default]).component('accountInformation', _accountInformation2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('accountInformation', {
	    url: '/account-information',
	    params: {
	      activeTab: null
	    },
	    data: {
	      authRequired: true,
	      paymentExempt: true
	    },
	    views: {
	      'menu': "menu",
	      'content': {
	        component: 'accountInformation',
	        bindings: {
	          accountInfo: 'accountInfo',
	          userObservable: 'userObservable',
	          pointOfSalesCount: 'pointOfSalesCount',
	          spinPadCount: 'spinPadCount',
	          pointOfSalesUnitPrice: 'pointOfSalesUnitPrice',
	          spinPadUnitPrice: 'spinPadUnitPrice'
	        }
	      }
	    },
	    resolve: {
	      accountInfo: ["AccountInformationService", "ProfilePermissionsService", function accountInfo(AccountInformationService, ProfilePermissionsService) {
	        return ProfilePermissionsService.hasPermission('edit-account') ? AccountInformationService.getAccountInfo() : {};
	      }],
	      countries: ["CountriesService", function countries(CountriesService) {
	        return CountriesService.getCountries();
	      }],
	      timezones: ["TimezonesService", function timezones(TimezonesService) {
	        return TimezonesService.getTimezones();
	      }],
	      userObservable: ["AccountInformationService", function userObservable(AccountInformationService) {
	        return AccountInformationService.getUser();
	      }],
	      activeTab: ["$transition$", function activeTab($transition$) {
	        return $transition$.params().activeTab;
	      }],
	      pointOfSalesCount: ["ContentService", function pointOfSalesCount(ContentService) {
	        return ContentService.countAccountPointOfSales().toPromise();
	      }],
	      spinPadCount: ["ContentService", function spinPadCount(ContentService) {
	        return ContentService.countAccountHandies().toPromise();
	      }],
	      pointOfSalesUnitPrice: function pointOfSalesUnitPrice() {
	        return 30.00;
	      },
	      spinPadUnitPrice: function spinPadUnitPrice() {
	        return 5.00;
	      }
	    }
	  });
	}]).name;
	
	exports.default = AccountInformationModule;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accountInformation = __webpack_require__(1119);
	
	var _accountInformation2 = _interopRequireDefault(_accountInformation);
	
	var _accountInformation3 = __webpack_require__(1120);
	
	var _accountInformation4 = _interopRequireDefault(_accountInformation3);
	
	__webpack_require__(1121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountInformationComponent = {
	  bindings: {
	    accountInfo: '<',
	    userObservable: '<',
	    accountProfiles: '<',
	    countries: '<',
	    timezones: '<',
	    activeTab: '<',
	    pointOfSalesCount: '<',
	    spinPadCount: '<',
	    pointOfSalesUnitPrice: '<',
	    spinPadUnitPrice: '<'
	  },
	  template: _accountInformation2.default,
	  controller: _accountInformation4.default
	};
	
	exports.default = AccountInformationComponent;

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n\n    <h2 class=\"page-header account_tab\">\n        <nav>\n            <ul class=\"Tabs\">\n                <li class=\"Tabs__tab Tab\" ng-class=\"{active: $ctrl.activeTab == 1}\" ng-click=\"$ctrl.activeTab=1\">\n                    <a href=\"#\">{{'Usuario' | translate}}</a>\n                </li>\n                <li class=\"Tabs__tab Tab\" ng-class=\"{active: $ctrl.activeTab == 2}\" ng-click=\"$ctrl.activeTab=2\" if-perm\n                    show-if=\"edit-account\">\n                    <a href=\"#\">{{'Cuenta' | translate}}</a>\n                </li>\n                <li class=\"Tabs__tab Tab\" ng-class=\"{active: $ctrl.activeTab == 3}\" ng-click=\"$ctrl.activeTab=3\" if-perm\n                    show-if=\"manage-subscription\">\n                    <a href=\"#\">{{'Pagos' | translate}}</a>\n                </li>\n                <li class=\"Tabs__presentation-slider\" role=\"presentation\"></li>\n            </ul>\n        </nav>\n\n    </h2>\n    <!-- Init-->\n\n    <div class=\"card col-md-12 col-sm-12\" ng-show=\"!$ctrl.activeTab || $ctrl.activeTab == 1\">\n        <div class=\"col-md-6 col-sm-6\">\n            <form class=\"form-horizontal\" name=\"userForm\" novalidate>\n                <h3>{{'Información General' | translate}}</h3>\n                <legend></legend>\n                <div class=\"form-group\">\n                    <label class=\"col-md-4 control-label\">{{'Usuario' | translate}}</label>\n                    <div class=\"col-md-8 inputGroupContainer\">\n                        <input name=\"user\" class=\"form-control input_py\" type=\"text\" ng-model=\"$ctrl.user.email\"\n                            disabled>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"col-md-4 control-label\">{{'Nombre(s)' | translate}}</label>\n                    <div class=\"col-md-8 inputGroupContainer\">\n                        <input name=\"firstName\" class=\"form-control input_py\" type=\"text\"\n                            ng-model=\"$ctrl.user.first_name\" validator=\"required\">\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"col-md-4 control-label\">{{'Apellido(s)' | translate}}</label>\n                    <div class=\"col-md-8 inputGroupContainer\">\n                        <input name=\"lastName\" class=\"form-control input_py\" type=\"text\"\n                            ng-model=\"$ctrl.user.last_name\">\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"col-md-4 control-label hidden-xs hidden-sm\"></label>\n                    <div class=\"col-md-4\">\n                        <button type=\"button\" validation-submit=\"userForm\" ng-click=\"$ctrl.renameUser()\"\n                            class=\"btn btn-primary\">\n                            {{'Cambiar Nombre' | translate}}\n                        </button>\n                    </div>\n                </div>\n                <h3>{{'Lenguaje' | translate}}</h3>\n                <legend></legend>\n                <div class=\"form-group\">\n                    <label class=\"col-md-4 control-label\">{{'Idioma' | translate}}</label>\n                    <div class=\"col-md-8 inputGroupContainer\">\n                        <select class=\"form-control input_py\" ng-model=\"$ctrl.user.language\">\n                            <option value=\"\" selected>{{'Seleccione un Idioma' | translate}}</option>\n                            <option value=\"ES\" selected>{{'Español' | translate}}</option>\n                            <option value=\"EN\" selected>{{'Inglés' | translate}}</option>\n                            <option value=\"FR\" selected>{{'Francés' | translate}}</option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"col-md-4 control-label hidden-xs hidden-sm\"></label>\n                    <div class=\"col-md-4\">\n                        <button type=\"button\" validation-submit=\"userForm\" ng-click=\"$ctrl.chooseLanguage()\"\n                            class=\"btn btn-primary\">\n                            {{'Cambiar Idioma' | translate}}\n                        </button>\n                    </div>\n                </div>\n\n            </form>\n        </div>\n\n        <div class=\"col-md-6 col-sm-6\">\n            <form class=\"form-horizontal\" name=\"passwordForm\" novalidate>\n                <h3>{{'Cambiar Contraseña' | translate}}</h3>\n                <legend></legend>\n                <div class=\"form-group\">\n                    <label class=\"col-md-4 control-label\">{{'Nueva Contraseña' | translate}}</label>\n                    <div class=\"col-md-8 inputGroupContainer\">\n                        <input name=\"password\" ng-model=\"$ctrl.password\" class=\"form-control input_py\" type=\"password\">\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"col-md-4 control-label hidden-xs hidden-sm\"></label>\n                    <div class=\"col-md-4\">\n                        <button type=\"button\" validation-submit=\"passwordForm\" ng-click=\"$ctrl.modifyPassword()\"\n                            class=\"btn btn-primary\">\n                            {{'Cambiar Contraseña' | translate}}\n                        </button>\n                    </div>\n                </div>\n                <h3>{{'Enlaza tu cuenta' | translate}}&nbsp;&nbsp;\n                    <span class=\"group gplus-share\">\n                        <button class=\"gp\" ng-click=\"$ctrl.linkToOauth('google')\"><i\n                                class=\"fa fa-google-plus\"></i></button>\n                    </span>\n                </h3>\n            </form>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.activeTab == 2\">\n        <div class=\"card col-md-12\" if-perm show-if=\"edit-account\">\n            <h3>{{'Información de la compañía' | translate}}</h3>\n            <legend></legend>\n            <div class=\"col-md-6 col-sm-6\">\n                <form class=\"form-horizontal profile_form\" name=\"accountInfo\" novalidate>\n\n                    <!-- Text input-->\n\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Identificación' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <input name=\"identification\" class=\"form-control input_py\" type=\"text\"\n                                ng-model=\"$ctrl.account.identification\">\n                        </div>\n                    </div>\n\n                    <!-- Text input-->\n\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Compañía' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <input class=\"form-control input_py\" type=\"text\" ng-model=\"$ctrl.account.name\"\n                                ng-disabled=\"true\">\n                        </div>\n                    </div>\n\n                    <!-- Text input-->\n\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Dirección' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <input name=\"address\" class=\"form-control input_py\" type=\"text\"\n                                ng-model=\"$ctrl.account.address\">\n                        </div>\n                    </div>\n\n                    <!-- Text input-->\n\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Teléfono' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer no-margin-span\">\n                            <input name=\"phone\" class=\"form-control input_py\" type=\"tel\" ng-model=\"$ctrl.account.phone\"\n                                validator=\"phone\" autocomplete=\"off\">\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"col-md-6 col-sm-6\">\n                <form class=\"form-horizontal profile_form\" name=\"accountInfo\" novalidate>\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'País' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <countries countries=\"$ctrl.countries\" selected=\"$ctrl.account.country\"\n                                on-select=\"$ctrl.onCountrySelect(country)\">\n                            </countries>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Idioma' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <select class=\"form-control input_py\" ng-model=\"$ctrl.account.language\">\n                                <option value=\"\" selected>{{'Seleccione un Idioma' | translate}}</option>\n                                <option value=\"ES\" selected>{{'Español' | translate}}</option>\n                                <option value=\"EN\" selected>{{'Inglés' | translate}}</option>\n                                <option value=\"FR\" selected>{{'Francés' | translate}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Moneda' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <select class=\"form-control input_py\" ng-model=\"$ctrl.account.currency\">\n                                <option value=\"\" selected>{{'Seleccione una moneda' | translate}}</option>\n                                <option value=\"DOP\" selected>DOP</option>\n                                <option value=\"USD\" selected>USD</option>\n                                <option value=\"EUR\" selected>EUR</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Zona horaria' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <timezones timezones=\"$ctrl.timezones\" selected=\"$ctrl.account.timezone\"\n                                on-select=\"$ctrl.onTimezoneSelect(timezone)\">\n                            </timezones>\n                        </div>\n                    </div>\n\n                </form>\n            </div>\n            <div class=\"form-group text-center\">\n                <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.saveInformation()\"\n                    validation-submit=\"accountInfo\" if-perm disable-if=\"edit-account\">\n                    {{'Guardar Información' | translate}}\n                </button>\n            </div>\n        </div>\n\n        <div class=\"card col-md-12 col-sm-12\" if-perm show-if=\"edit-account\">\n            <div class=\"col-md-6 col-sm-6\">\n                <h3>{{'Logo de la Compañía' | translate }}</h3>\n                <legend></legend>\n                <label class=\"col-md-4 control-label\">{{'Logo' | translate}}</label>\n                <div class=\"col-md-8\">\n                    <input type=\"file\" name=\"logo\" id=\"file\" nv-file-select uploader=\"$ctrl.fileUploader\"\n                        class=\"form-control input_py input_file\" ng-model=\"$ctrl.fileUploader\"\n                        (change)=\"$ctrl.uploadLogo()\" />\n                    <label for=\"file\" class=\"btn btn-tertiary labelFile\">\n                        <i class=\"icon fa fa-check\"></i>\n                        <span class=\"fileName\">{{ $ctrl.fileName }}</span>\n                    </label>\n                </div>\n\n                <label class=\"col-md-4 control-label hidden-xs hidden-sm\"></label>\n                <div class=\"col-md-4 margin-top\">\n                    <button class=\"btn btn-secondary\" ng-click=\"$ctrl.logoLightbox();\" ng-disabled=\"!$ctrl.logoName\">\n                        {{'Mostrar logo' | translate}}\n                    </button>\n                </div>\n\n            </div>\n            <div class=\"col-md-6 col-sm-6\">\n                <form class=\"form-horizontal profile_form\" name=\"registerAccountForm\" novalidate>\n                    <h3>{{'Crear nueva cuenta' | translate}}</h3>\n                    <legend></legend>\n                    <!-- Text input-->\n\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Nombre de Cuenta' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <input name=\"nameAccount\" class=\"form-control\" ng-model=\"$ctrl.nameAccount\" type=\"text\"\n                                validator=\"required\" valid-method=\"submit\">\n                        </div>\n                    </div>\n\n                    <!-- Button -->\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label hidden-xs hidden-sm\"></label>\n                        <div class=\"col-md-4\">\n                            <button type=\"button\" validation-submit=\"registerAccountForm\" class=\"btn btn-primary\"\n                                ng-click=\"$ctrl.createAccount()\">\n                                {{'Crear Cuenta' | translate}}\n                            </button>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"card\" ng-show=\"$ctrl.activeTab == 3\" if-perm show-if=\"manage-subscription\">\n        <div class=\"row\">\n            <div class=\"col-md-6 col-sm-6\">\n                <form class=\"form-horizontal\" id=\"sub-form\" name=\"subForm\" novalidate>\n                    <h3>{{'Método de pago' | translate}}</h3>\n                    <legend></legend>\n                    <!-- Text input-->\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Tarjetahabiente' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <input type=\"text\" name=\"cardholder\" validator=\"required\" class=\"form-control input_py\"\n                                ng-model=\"$ctrl.card.holder\">\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Email' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <input type=\"text\" name=\"card-email\" validator=\"required\" class=\"form-control input_py\"\n                                ng-model=\"$ctrl.card.email\">\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label\">{{'Tarjeta' | translate}}</label>\n                        <div class=\"col-md-8 inputGroupContainer\">\n                            <!-- a Stripe Element will be inserted here. -->\n                            <div id=\"card-element\"></div>\n                            <!-- Used to display form errors -->\n                            <div id=\"card-errors\" role=\"alert\"></div>\n                        </div>\n                    </div>\n\n                    <!-- Button -->\n                    <div class=\"form-group\">\n                        <label class=\"col-md-4 control-label hidden-xs hidden-sm\"></label>\n                        <div class=\"col-md-4\">\n                            <button class=\"btn btn-md btn-primary btn-block btn_py\" type=\"submit\"\n                                validation-submit=\"subForm\" ng-click=\"$ctrl.doSubscription()\" ng-if=\"$ctrl.isOnTrial\">{{'Iniciar Suscripción' | translate}}</button>\n                            <button class=\"btn btn-md btn-primary btn-block btn_py\" type=\"submit\"\n                                validation-submit=\"subForm\" ng-click=\"$ctrl.addPaymentMethod()\" ng-if=\"!$ctrl.isOnTrial\">{{'Añadir Método de Pago' | translate}}</button>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"col-md-6 col-sm-6\">\n                <h3>{{'Tarjetas' | translate}}</h3>\n                <div class=\"radio\" ng-repeat=\"card in $ctrl.cards track by card.token\">\n                    <label class=\"full-width\">\n                        <input type=\"radio\" name=\"optradio\"\n                                ng-model=\"$ctrl.defaultCard\"\n                                ng-change=\"$ctrl.setDefaultPaymentMethod(card)\"\n                                ng-checked=\"card.token === $ctrl.defaultCard\"\n                                ng-value=\"card.token\">\n                        **** **** **** {{ card.last4 }}\n                        <button \n                            mwl-confirm\n                            title=\"{{'¿Esta seguro?'|translate}}\"\n                            message=\"{{'ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?'|translate}}\"\n                            confirm-text=\"{{'Eliminar'|translate}}\"\n                            cancel-text=\"{{'Cancelar'|translate}}\"\n                            placement=\"left\"\n                            on-confirm=\"$ctrl.deletePaymentMethod(card, $index)\"\n                            on-cancel=\"\"\n                            confirm-button-type=\"danger\"\n                            cancel-button-type=\"default\"\n                            type=\"button\"\n                            class=\"btn btn-simple btn-danger btn-icon pull-right\"\n                            ng-if=\"card.token !== $ctrl.defaultCard\"\n                        ><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button>\n                    </label>\n                </div>\n            </div>\n        </div>\n        <div class=\"row mt-3\" ng-if=\"$ctrl.hasPendingPayment\">\n            <div class=\"col-md-12\">\n                <h3>{{'Detalles del pago pendiente' | translate}}</h3>\n                <table class=\"table table-striped mt-2\">\n                    <thead>\n                        <tr>\n                            <th>{{'Descripción' | translate}}</th>\n                            <th>{{'Cantidad' | translate}}</th>\n                            <th>{{'Precio' | translate}}</th>\n                            <th>{{'Total' | translate}}</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr>\n                            <td>{{'Puntos de Ventas' | translate}}</td>\n                            <td class=\"text-center\">{{ $ctrl.pointOfSalesCount }}</td>\n                            <td class=\"text-right\">{{ $ctrl.pointOfSalesUnitPrice | currency: 'USD ' }}</td>\n                            <td class=\"text-right\">{{ $ctrl.pointOfSalesUnitPrice * $ctrl.pointOfSalesCount | currency: 'USD ' }}</td>\n                        </tr>\n                        <tr ng-if=\"$ctrl.spinPadCount\">\n                            <td>{{'Handies' | translate}}</td>\n                            <td class=\"text-center\">{{ $ctrl.spinPadCount }}</td>\n                            <td class=\"text-right\">{{ $ctrl.spinPadUnitPrice | currency: 'USD ' }}</td>\n                            <td class=\"text-right\">{{ $ctrl.spinPadUnitPrice * $ctrl.spinPadCount | currency: 'USD ' }}</td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div class=\"row mt-3\" ng-if=\"$ctrl.hasPendingPayment\">\n            <div class=\"col-md-8\">\n            </div>\n            <div class=\"col-md-4\">\n                <table class=\"table table-sm text-right b-0\">\n                    <!-- <tr class=\"b-0\">\n                        <td class=\"b-0\"><strong>{{'Sub-Total' | translate}}</strong></td>\n                        <td class=\"text-right b-0\">3 700,00€</td>\n                    </tr>\n                    <tr class=\"b-0\">\n                        <td class=\"b-0\">{{'ITBIS' | translate}}</td>\n                        <td class=\"text-right b-0\">740,00€</td>\n                    </tr> -->\n\n                    <tr class=\"b-0\">\n                        <td class=\"b-0\"><strong>{{'Total' | translate}}</strong></td>\n                        <td class=\"text-right b-0\">{{ $ctrl.pointOfSalesUnitPrice * $ctrl.pointOfSalesCount + $ctrl.spinPadUnitPrice * $ctrl.spinPadCount | currency: 'USD ' }}</td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n        <!-- <button class=\"btn btn-md btn-danger btn-block margin-top\" type=\"submit\" ng-click=\"$ctrl.cancelSubscription()\">\n            {{'Cancelar Subscripción'|translate}}\n        </button> -->\n    </div>\n\n</div>\n\n<script type='text/ng-template' id=\"display-logo-template.html\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" id=\"modal-title\">\n            {{'Logo' | translate}}\n            <a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n        </h3>\n    </div>\n\n    <div class=\"modal-body\" id=\"modal-body\">\n        <div class=\"showlogo_container\">\n            <img src=\"{{ logoUrl }}\" alt=\"\">\n        </div>\n    </div>\n\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">\n            {{'Salir' | translate}}\n        </button>\n    </div>\n</script>"

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _app = __webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountInformationController = function () {
	    function AccountInformationController(AccountInformationService, $validation, Notification, $auth, SatellizerConfig, $state, $uibModal, FileUploader, host, AuthService, $window, $translate, SubscriptionService) {
	        (0, _classCallCheck3.default)(this, AccountInformationController);
	
	        this.service = AccountInformationService;
	        this.notify = Notification;
	        this.$auth = $auth;
	        this.satellizerConfig = SatellizerConfig;
	        this.state = $state;
	        this.modal = $uibModal;
	        this.host = host;
	        this.auth = AuthService;
	        this.$window = $window;
	        this.fileUploader = new FileUploader({
	            url: this.service.host + '/api/accounts/logo',
	            headers: {
	                Authorization: 'Bearer ' + this.auth.getToken(),
	                'X-Account-Token': this.auth.getAccountToken()
	            },
	            removeAfterUpload: true
	        });
	        this.trans = $translate.instant;
	        this.cards = [];
	        this.subscribe = SubscriptionService;
	        // $validation
	        //     .setExpression({
	        //         accountAvailable: (value, scope, element, attrs) => {
	        //             return this.service.isAccountAvailability(value).toPromise().then(
	        //                 (exists) => {
	        //                     this.accountUnavailable = false;
	        //                     if (!exists) {
	        //                         this.accountUnavailable = true;
	        //                     }
	        //                     return exists;
	        //                 }, (exists) => exists
	        //             );
	        //         }
	        //     })
	        //     .setDefaultMsg({
	        //         accountAvailable: {
	        //             error: "Esta cuenta no está disponible"
	        //         }
	        //     });
	    }
	
	    (0, _createClass3.default)(AccountInformationController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.subscriptions = [];
	
	            var _ = this.trans;
	            this.logoName = false;
	
	            this.subscriptions.push(this.accountInfo.subscribe(function (accountInfo) {
	                _this.account = accountInfo;
	                if (_this.account.phone === null) {
	                    _this.account.phone = null;
	                }
	
	                if (_this.account.country) {
	                    _this.subscriptions.push(_this.service.getTimezones(_this.account.country).subscribe(function (timezones) {
	                        return _this.timezones = timezones;
	                    }));
	                }
	
	                _this.account_id = _this.account.id;
	                _this.subscriptions.push(_this.service.getAccountLogo(_this.account_id, true).subscribe(function (resp) {
	                    if (resp && resp.hasOwnProperty('logo_name') && resp.logo_name) {
	                        _this.fileName = resp.logo_name;
	                        _this.logoName = true;
	                    } else if (resp && resp.hasOwnProperty('logo') && resp.logo) {
	                        _this.fileName = 'Logo';
	                        _this.logoName = true;
	                    } else {
	                        _this.fileName = _('Seleccionar logo');
	                    }
	                }, function (error) {
	                    _this.fileName = _('Seleccionar logo');
	                    _this.logoName = false;
	                }));
	            }, function (error) {
	                return console.log(error);
	            }));
	
	            this.subscriptions.push(this.userObservable.subscribe(function (user) {
	                return _this.user = user;
	            }, function (error) {
	                return console.log(error);
	            }));
	            this.nameAccount = '';
	            this.accountUnavailable = true;
	            this.fileUploader.onAfterAddingFile = function () {
	                _this.uploadLogo();
	            };
	            this.card = {};
	            this.stripe = this.$window.stripe;
	            var elements = this.stripe.elements();
	            var style = {
	                base: {
	                    color: '#32325d',
	                    lineHeight: '24px',
	                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
	                    fontSmoothing: 'antialiased',
	                    fontSize: '16px',
	                    '::placeholder': {
	                        color: '#000000'
	                    }
	                },
	                invalid: {
	                    color: '#fa755a',
	                    iconColor: '#fa755a'
	                }
	            };
	            this.cardElement = elements.create('card', { style: style });
	            this.cardElement.mount(document.getElementById('card-element'));
	            this.cardElement.addEventListener('change', function (event) {
	                var displayError = document.getElementById('card-errors');
	                if (event.error) {
	                    displayError.textContent = event.error.message;
	                } else {
	                    displayError.textContent = '';
	                }
	            });
	
	            this.subscriptions.push(this.subscribe.getCustomerCards().subscribe(function (data) {
	                if (data.cards && data.cards.length) {
	                    _this.defaultCard = data.cards.find(function (card) {
	                        return card.default;
	                    }).token;
	                    _this.cards = data.cards;
	                }
	            }));
	
	            this.isOnTrial = false;
	            this.hasPendingPayment = false;
	            this.subscriptions.push(this.subscribe.paymentStatus().subscribe(function (status) {
	                _this.isOnTrial = status === _app.PaymentOnTrial;
	                _this.hasPendingPayment = [_app.PaymentFailed, _app.PaymentDisputing, _app.PaymentRegistered, _app.PaymentUnregistered].indexOf(status) > -1;
	            }));
	
	            console.log('Point Of Sales: ' + this.pointOfSalesCount);
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.subscriptions.forEach(function (sub) {
	                return sub.unsubscribe();
	            });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.subscriptions.forEach(function (sub) {
	                return sub.unsubscribe();
	            });
	        }
	    }, {
	        key: 'renameUser',
	        value: function renameUser() {
	            var _this2 = this;
	
	            var _ = this.trans;
	            this.subscriptions.push(this.service.renameUser(this.user.first_name, this.user.last_name).subscribe(function (data) {
	                if (data !== undefined) {
	                    _this2.notify.success(_('Su nombre ha sido cambiado exitosamente'));
	                }
	            }));
	        }
	    }, {
	        key: 'chooseLanguage',
	        value: function chooseLanguage() {
	            var _this3 = this;
	
	            var _ = this.trans;
	            this.subscriptions.push(this.service.chooseLanguage(this.user.language).subscribe(function (data) {
	                if (data !== undefined) {
	                    _this3.notify.success(_('Su idioma ha sido cambiado exitosamente'));
	                    _this3.$window.localStorage.userLanguage = data.language;
	                    _this3.state.reload();
	                }
	            }));
	        }
	    }, {
	        key: 'modifyPassword',
	        value: function modifyPassword() {
	            var _this4 = this;
	
	            var _ = this.trans;
	            this.subscriptions.push(this.service.modifyPassword(this.password).subscribe(function (data) {
	                _this4.password = '';
	                _this4.notify.success(_('Su contraseña ha sido cambiada exitosamente'));
	            }));
	        }
	    }, {
	        key: 'saveInformation',
	        value: function saveInformation() {
	            var _this5 = this;
	
	            var _ = this.trans;
	            this.subscriptions.push(this.service.saveInformation({
	                identification: this.account.identification,
	                address: this.account.address,
	                phone: this.account.phone,
	                country: this.account.country,
	                timezone: this.account.timezone,
	                language: this.account.language,
	                currency: this.account.currency
	            }).subscribe(function (data) {
	                _this5.notify.success(_('La información fue guardada exitosamente'));
	            }));
	        }
	    }, {
	        key: 'uploadLogo',
	        value: function uploadLogo() {
	            var _this6 = this;
	
	            var _ = this.trans;
	            this.fileUploader.uploadAll();
	            this.fileUploader.onSuccessItem = function () {
	                _this6.fileName = _this6.fileUploader.queue[0].file.name;
	                _this6.logoName = true;
	                _this6.notify.success(_('El logo ha sido agregado exitosamente'));
	            };
	
	            this.fileUploader.onErrorItem = function () {
	                _this6.notify.error(_('El logo debe ser en un formato de imagen'));
	            };
	        }
	    }, {
	        key: 'createAccount',
	        value: function createAccount() {
	            var _this7 = this;
	
	            var _ = this.trans;
	            this.subscriptions.push(this.service.createAccount(this.nameAccount).subscribe(function (data) {
	                _this7.notify.success(_('Cuenta creada exitosamente'));
	                _this7.state.reload();
	            }));
	        }
	    }, {
	        key: 'linkToOauth',
	        value: function linkToOauth(provider) {
	            var _this8 = this;
	
	            var _ = this.trans;
	            if (provider !== 'google') return;
	
	            var currentUrl = this.satellizerConfig.providers[provider].url;
	            var splitBoundary = currentUrl.lastIndexOf('/');
	            this.satellizerConfig.providers[provider].url = [currentUrl.slice(0, splitBoundary), '/link', currentUrl.slice(splitBoundary)].join('');
	            this.$auth.authenticate(provider).then(function () {
	                _this8.notify.success(_('Ha enlazado su usuario a su cuenta exitosamente.'));
	                _this8.satellizerConfig.providers[provider].url = currentUrl;
	            }).catch(function (error) {
	                if (error.message) {
	                    _this8.notify.error(error.message);
	                } else if (error.data) {
	                    _this8.notify.error(error.data.message, error.status);
	                } else {
	                    _this8.notify.error(error);
	                }
	                _this8.satellizerConfig.providers[provider].url = currentUrl;
	            });
	        }
	    }, {
	        key: 'onCountrySelect',
	        value: function onCountrySelect(country) {
	            var _this9 = this;
	
	            this.account.country = country;
	            this.subscriptions.push(this.service.getTimezones(country).subscribe(function (timezones) {
	                _this9.timezones = timezones;
	            }));
	        }
	    }, {
	        key: 'onTimezoneSelect',
	        value: function onTimezoneSelect(timezone) {
	            this.account.timezone = timezone;
	        }
	    }, {
	        key: 'logoLightbox',
	        value: function logoLightbox() {
	            var that = this;
	            this.modal.open({
	                animation: true,
	                size: 'lg',
	                templateUrl: 'display-logo-template.html',
	                appendClassName: 'ngdialog-theme-plain',
	                controller: ["$scope", "$uibModalInstance", function controller($scope, $uibModalInstance) {
	                    "ngInject";
	
	                    $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.account_id + '?t=' + new Date().getTime();
	                    $scope.closeThisDialog = function () {
	                        return $uibModalInstance.close();
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'addPaymentMethod',
	        value: function addPaymentMethod() {
	            var _this10 = this;
	
	            var _ = this.trans;
	
	            this.stripe.createToken(this.cardElement).then(function (response) {
	                var token = response.token,
	                    error = response.error;
	
	                if (error) {
	                    var errorElement = document.getElementById('card-errors');
	                    errorElement.textContent = error.message;
	
	                    return;
	                }
	
	                var clientCard = angular.extend(_this10.card, token);
	                _this10.subscriptions.push(_this10.subscribe.addPaymentMethod(clientCard).subscribe(function () {
	                    _this10.cards.push({
	                        token: clientCard.card.id,
	                        default: false,
	                        last4: clientCard.card.last4
	                    });
	
	                    _this10.cardElement.clear();
	                    _this10.notify.success(_('Nueva tarjeta agregada.'));
	                }, function () {
	                    return _this10.notify.error(_("No ha sido posible agregar la tarjeta, intente nuevamente."));
	                }));
	            });
	        }
	    }, {
	        key: 'deletePaymentMethod',
	        value: function deletePaymentMethod(card, indexInArray) {
	            var _this11 = this;
	
	            if (card.default) {
	                return;
	            }
	
	            var _ = this.trans;
	            this.subscriptions.push(this.subscribe.deletePaymentMethod(card.token).subscribe(function () {
	                _this11.cards.splice(indexInArray, 1);
	                _this11.notify.success(_('Tarjeta eliminada.'));
	            }, function () {
	                return _this11.notify.error(_("No ha sido posible eliminar la tarjeta, intente nuevamente."));
	            }));
	        }
	    }, {
	        key: 'setDefaultPaymentMethod',
	        value: function setDefaultPaymentMethod(card) {
	            var _this12 = this;
	
	            if (card.default) {
	                return;
	            }
	
	            var _ = this.trans;
	            this.subscriptions.push(this.subscribe.setDefaultPaymentMethod(card.token).subscribe(function () {
	                _this12.cards.forEach(function (c) {
	                    if (c.default) {
	                        c.default = false;
	                    }
	                });
	                card.default = true;
	                _this12.defaultCard = card.token;
	            }, function () {
	                return _this12.notify.error(_("No ha sido posible cambiar el método de pago."));
	            }));
	        }
	    }, {
	        key: 'doSubscription',
	        value: function doSubscription() {
	            var _this13 = this;
	
	            var _ = this.trans;
	
	            this.stripe.createToken(this.cardElement).then(function (response) {
	                var token = response.token,
	                    error = response.error;
	
	                if (error) {
	                    var errorElement = document.getElementById('card-errors');
	                    errorElement.textContent = error.message;
	
	                    return;
	                }
	
	                var clientCard = angular.extend(_this13.card, token);
	                _this13.subscriptions.push(_this13.subscribe.subscribeCustomerViaStripe(clientCard).subscribe(function () {
	                    _this13.cards.push({
	                        token: clientCard.card.id,
	                        default: false,
	                        last4: clientCard.card.last4
	                    });
	
	                    // Ideally, we would reset the form instead, in order to avoid
	                    // the 'required field' message
	                    // this.card.holder = '';
	                    // this.card.email = '';
	
	                    _this13.cardElement.clear();
	                    _this13.notify.success(_("Usted ha sido suscrito de manera exitosa."));
	                }, function () {
	                    return _this13.notify.error(_("No ha sido posible procesar la suscripción, intente nuevamente."));
	                }));
	            });
	        }
	        // cancelSubscription() {
	        //     if (this.hasPendingPayment) { return; }
	
	        //     this.subscriptions.push(
	        //         this.subscribe.unsubscribe()
	        //             .subscribe(
	        //                 () => {
	        //                 },
	        //                 () => this.notify.error(_("No ha sido posible cancelar la suscripcion, intente nuevamente."))
	        //             )
	        //     );
	        // }
	
	    }]);
	    return AccountInformationController;
	}();
	
	exports.default = AccountInformationController;
	
	
	AccountInformationController.$inject = ['AccountInformationService', '$validation', 'Notification', '$auth', 'SatellizerConfig', '$state', '$uibModal', 'FileUploader', 'host', 'AuthService', '$window', '$translate', 'SubscriptionService'];

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1122);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./account-information.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./account-information.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".AccountInformation{color:red}.account_tab{padding-bottom:0}.no-margin-span span{position:absolute;width:100%}.StripeElement{background-color:#fff;height:40px;padding:7px 12px;border-radius:4px;border:1px solid #ccc;box-shadow:0 1px 3px 0 #e6ebf1;-webkit-transition:box-shadow .15s ease;transition:box-shadow .15s ease}.StripeElement--focus{border:1px solid #2196f3}.StripeElement--invalid{border-color:#a94442}.StripeElement--webkit-autofill{background-color:#fefde5!important}.full-width{width:100%!important}", ""]);
	
	// exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(497);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountInformationService = function () {
	    function AccountInformationService($http, host, AuthService) {
	        (0, _classCallCheck3.default)(this, AccountInformationService);
	
	        this.http = $http;
	        this.host = host;
	        this.authService = AuthService;
	    }
	
	    (0, _createClass3.default)(AccountInformationService, [{
	        key: 'getUser',
	        value: function getUser() {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'GET',
	                url: this.host + '/api/users'
	            }).then(function (resp) {
	                return resp.data;
	            }, function (resp) {
	                return {};
	            }));
	        }
	    }, {
	        key: 'getAccountInfo',
	        value: function getAccountInfo() {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'GET',
	                url: this.host + '/api/accounts'
	            }).then(function (resp) {
	                return resp.data;
	            }, function (resp) {
	                return resp;
	            }));
	        }
	    }, {
	        key: 'modifyPassword',
	        value: function modifyPassword(password) {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'PUT',
	                url: this.host + '/api/users/password',
	                data: { password: password }
	            }));
	        }
	    }, {
	        key: 'saveInformation',
	        value: function saveInformation(data) {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'PUT',
	                url: this.host + '/api/accounts',
	                data: data
	            }));
	        }
	    }, {
	        key: 'createAccount',
	        value: function createAccount(nameAccount) {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'POST',
	                url: this.host + '/api/accounts',
	                data: { company: nameAccount }
	            }));
	        }
	    }, {
	        key: 'isAccountAvailability',
	        value: function isAccountAvailability(nameAccount) {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'GET',
	                url: this.host + '/api/accounts/check-account',
	                params: { company: nameAccount }
	            }).then(function (resp) {
	                return !resp.data.exists;
	            }, function (resp) {
	                return false;
	            }));
	        }
	    }, {
	        key: 'renameUser',
	        value: function renameUser(firstName, lastName) {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'PATCH',
	                url: this.host + '/api/users',
	                data: { first_name: firstName, last_name: lastName }
	            }).then(function (resp) {
	                return resp.data;
	            }, function (resp) {
	                return undefined;
	            }));
	        }
	    }, {
	        key: 'getAccountLogo',
	        value: function getAccountLogo(accountId, logoName) {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'GET',
	                url: this.host + '/api/accounts/logo/' + accountId,
	                params: { logo_name: logoName }
	            }).then(function (resp) {
	                return resp.data;
	            }, function (resp) {
	                return undefined;
	            }));
	        }
	    }, {
	        key: 'getTimezones',
	        value: function getTimezones(country) {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'GET',
	                url: this.host + '/api/timezones',
	                params: { country: country }
	            }).then(function (resp) {
	                return resp.data.timezones;
	            }, function (resp) {
	                return undefined;
	            }));
	        }
	    }, {
	        key: 'chooseLanguage',
	        value: function chooseLanguage(language) {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'PATCH',
	                url: this.host + '/api/users',
	                data: { language: language }
	            }).then(function (resp) {
	                return resp.data;
	            }, function (resp) {
	                return undefined;
	            }));
	        }
	    }, {
	        key: 'getPaymentStatus',
	        value: function getPaymentStatus() {
	            return _Rx2.default.Observable.fromPromise(this.http({
	                method: 'GET',
	                url: this.host + '/api/accounts/payments/status'
	            }).then(function (resp) {
	                return resp.data;
	            }, function (resp) {
	                return undefined;
	            }));
	        }
	    }, {
	        key: 'timezone',
	        get: function get() {
	            return this.authService.getProfile().account_timezone;
	        }
	    }]);
	    return AccountInformationService;
	}();
	
	exports.default = AccountInformationService;
	
	
	AccountInformationService.$inject = ['$http', 'host', 'AuthService'];

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _salesByVendor = __webpack_require__(1125);
	
	var _salesByVendor2 = _interopRequireDefault(_salesByVendor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByVendorModule = _angular2.default.module('SalesByVendor', [_angularjs2.default]).component('salesByVendor', _salesByVendor2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesByVendor', {
	    url: '/sales-by-vendor',
	    data: {
	      authRequired: true,
	      permsRequired: ['sales-by-vendor']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'salesByVendor'
	      }
	    }
	  });
	}]).name;
	
	exports.default = SalesByVendorModule;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesByVendor = __webpack_require__(1126);
	
	var _salesByVendor2 = _interopRequireDefault(_salesByVendor);
	
	var _salesByVendor3 = __webpack_require__(1127);
	
	var _salesByVendor4 = _interopRequireDefault(_salesByVendor3);
	
	__webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByVendorComponent = {
	  bindings: {},
	  template: _salesByVendor2.default,
	  controller: _salesByVendor4.default
	};
	
	exports.default = SalesByVendorComponent;

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-8\">\n                {{'Ventas por Vendedor' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.rows.length || 0 }}\n                </span>\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form name=\"salesByVendorForm\" class=\"hidden-xs\">\n            <div class=\"form col-md-12 no-padding\">\n        \n                <input type=\"hidden\" name=\"sorter\" value=\"\">\n                \n                <input type=\"hidden\" name=\"cashier_id\" value=\"\">\n                \n                <input type=\"hidden\" name=\"pos_id\" value=\"\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>    \n                    <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" id=\"from\" class=\"form-control input_py\"\n\t\t\t\t\t\t\tformat=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\" readonly>\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>    \n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" id=\"to\" class=\"form-control input_py\"\n\t\t\t\t\t\t\tformat=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\" readonly>  \n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.findSalesByVendor()\">{{'Buscar' | translate}}</button>    \n                    </span>\n                </div>\n            </div>\n        </form>\n        <form class=\"visible-xs\">\n            <div class=\"form_xs\">\n                <div class=\"col-xs-6 form-group no_padding_left\">\n                    <p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n                    <input class=\"form-control input_py\" name=\"from\" moment-picker=\"$ctrl.dateFrom\"\n                        ng-model=\"$ctrl.dateFrom\" format=\"DD/MM/YYYY\" today=\"true\" autocomplete=\"off\" start-view=\"month\" readonly>\n                </div>\n                <div class=\"col-xs-6 form-group no_padding_right\">\n                    <p class=\"label_m\" for=\"desde\">{{'Hasta' | translate}}</p>\n                    <input class=\"form-control input_py\" name=\"to\" moment-picker=\"$ctrl.dateTo\"\n                        ng-model=\"$ctrl.dateTo\" format=\"DD/MM/YYYY\" today=\"true\" autocomplete=\"off\" start-view=\"month\" readonly>\n                </div>\n                <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findSalesByVendor()\">{{'Buscar' | translate}}</button>    \n            </div>\n        </form>\n    </div>\n\n\t<div class=\"col-md-12 table_container\">\n\t\t<div class=\"card\">\n\t\t\t<div class=\"card-content\">\n\t\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t\t<div class=\"fixed-table-toolbar\">\n\n\t\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar búsqueda' | translate}}</label>\n\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t</div>\n\t\t\t\t    </div>\n                    <div class=\"fixed-table-container\">\n                        <div class=\"fixed-table-body\">\n                            <div class=\"t_verdor\" ng-repeat=\"row in $ctrl.rows | filter:filterCrit as filtered\">\n                                <p class=\"label_verdor pull-left text-left\">{{ row.cashier }} <br> {{'Llave' | translate}} {{ row.cashier_key }}</p>\n                                <p class=\"label_verdor pull-right text-right\">{{'ITBIS' | translate}}: <span>{{ row.iva_total | currency }}  </span> <br> {{'% Ley' | translate}}: <span>{{ row.tax10_total | currency }}</span></p>\n                                <table id=\"bootstrap-table\" class=\"table table-hover\">\n                                    <thead>\n                                        <tr>\n                                            <th data-field=\"salary\" class=\"text-center\">\n                                                <div class=\"th-inner\"></div>\n                                            </th>\n                                            <th  data-field=\"salary\" class=\"text-center\">\n                                                <div class=\"th-inner\">{{'Cancelaciones' | translate}}</div>\n                                            </th>\n                                            <th  data-field=\"salary\" class=\"text-center\">\n                                                <div class=\"th-inner\">{{'OTH' | translate}}</div>\n                                            </th>\n                                            <th  data-field=\"salary\" class=\"text-center\">\n                                                <div class=\"th-inner\">{{'Broken/Lost' | translate}}</div>\n                                            </th>\n                                            <th  data-field=\"salary\" class=\"text-center\">\n                                                <div class=\"th-inner\">{{'Anul. Apres' | translate}}</div>\n                                            </th>\n                                            <th  data-field=\"salary\" class=\"text-right\">\n                                                <div class=\"th-inner\">{{'Efectivo' | translate}}</div>\n                                            </th>\n                                        </tr>\n                                    </thead>\n                                    <tbody>\n                                        <tr class=\"text-center\">\n                                            <td class=\"text-center\">{{'Unid' | translate}}</td>\n                                            <td data-label=\"{{'Cancelaciones' | translate}}:\" class=\"text-center\">{{ row.void_qty || 0 }}</td>\n                                            <td data-label=\"{{'OTH' | translate}}:\" class=\"text-center\">{{ row.oth_qty || 0 }}</td>\n                                            <td data-label=\"{{'Broken' | translate}}:\" class=\"text-center\">{{ row.broken_qty || 0 }}</td>\n                                            <td data-label=\"{{'Anul. Apres' | translate}}:\" class=\"text-center\">{{ row.return_qty || 0 }}</td>\n                                            <td data-label=\"{{'Efectivo' | translate}}:\" class=\"text-right\">{{ row.cash_qty || 0 }}</td>\n                                        </tr>\n                                        <tr class=\"text-center\">\n                                            <td class=\"text-center\">{{'VB' | translate}}</td>\n                                            <td data-label=\"{{'Cancelaciones' | translate}}:\" class=\"text-center\">{{ row.void_total | currency }}</td>\n                                            <td data-label=\"{{'OTH' | translate}}:\" class=\"text-center\">{{ row.oth_total | currency }}</td>\n                                            <td data-label=\"{{'Broken' | translate}}:\" class=\"text-center\">{{ row.broken_total | currency }}</td>\n                                            <td data-label=\"{{'Anul. Apres' | translate}}:\" class=\"text-center\">{{ row.return_total | currency }}</td>\n                                            <td data-label=\"{{'Efectivo' | translate}}:\" class=\"text-right\">{{ row.cash_total | currency }}</td>\n                                        </tr>\n                                        <tr class=\"text-center\">\n                                            <td class=\"text-center\">{{'Media' | translate}}</td>\n                                            <td data-label=\"{{'Media Cancelaciones' | translate}}:\" class=\"text-center\">{{ (row.void_total / row.void_qty || 0) | currency }}</td>\n                                            <td data-label=\"{{'Media OTH' | translate}}:\" class=\"text-center\">{{ (row.oth_total / row.oth_qty || 0) | currency }}</td>\n                                            <td data-label=\"{{'Media Broken' | translate}}:\" class=\"text-center\">{{ (row.broken_total / row.broken_qty || 0) | currency }}</td>\n                                            <td data-label=\"{{'Media Anul. Apres' | translate}}:\" class=\"text-center\">{{ (row.return_total / row.return_qty || 0) | currency }}</td>\n                                            <td data-label=\"{{'Media Efectivo' | translate}}:\" class=\"text-right\">{{ (row.cash_total / row.cash_qty || 0) | currency }}</td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n                        </div>\n                        <div class=\"fixed-table-pagination hidden\">\n                            <div class=\"pull-left pagination-detail\">\n                                <span class=\"page-list\">\n                                    <span class=\"btn-group dropup\">\n                                        <button type=\"button\" class=\"btn btn-default  dropdown-toggle\" data-toggle=\"dropdown\">\n                                            <span class=\"page-size\">8</span> \n                                            <span class=\"caret\"></span>\n                                        </button>\n                                    </span>{{'Filas visible' | translate}}\n                                    </span>\n                            </div>\n                            <div class=\"pull-right pagination\">\n                                <ul class=\"pagination\">\n                                <li class=\"page-pre disabled\"><a href=\"\">‹</a></li>\n                                <li class=\"page-number active\"><a href=\"\">1</a></li>\n                                <li class=\"page-number\"><a href=\"\">2</a></li>\n                                <li class=\"page-number\"><a href=\"\">3</a></li>\n                                <li class=\"page-next\"><a href=\"\">›</a></li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n\t\t\t    </div>\n\t\t\t<div class=\"clearfix\"></div>\n\t\t</div>\n\t\t</div>\n\t<!--  end card  -->\n\t</div>\n\t<!--  end card  -->\n</div>"

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByVendorController = function () {
	  function SalesByVendorController(ContentService, moment) {
	    (0, _classCallCheck3.default)(this, SalesByVendorController);
	
	    this.service = ContentService;
	    this.moment = moment;
	  }
	
	  (0, _createClass3.default)(SalesByVendorController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.dateFrom = undefined;
	      this.dateTo = undefined;
	      this.pointOfSales = '';
	      this.rows = [];
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'findSalesByVendor',
	    value: function findSalesByVendor() {
	      var _this = this;
	
	      this.subscriptions.push(this.service.findSalesByVendor({
	        date_from: this.dateFrom.format(),
	        date_to: this.dateTo.format()
	      }).subscribe(function (sales_by_vendor) {
	        return _this.rows = sales_by_vendor;
	      }, function (err) {
	        return console.log(err);
	      }));
	    }
	  }]);
	  return SalesByVendorController;
	}();
	
	exports.default = SalesByVendorController;
	
	
	SalesByVendorController.$inject = ['ContentService', 'moment'];

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1129);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-vendor.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-vendor.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".SalesByVendor{color:red}", ""]);
	
	// exports


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _accountRegistration = __webpack_require__(1131);
	
	var _accountRegistration2 = _interopRequireDefault(_accountRegistration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountRegistrationModule = _angular2.default.module('AccountRegistration', [_angularjs2.default]).component('accountRegistration', _accountRegistration2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('accountRegistration', {
	    params: {
	      profiles: null
	    },
	    data: {
	      authRequired: true,
	      paymentExempt: true,
	      permsRequired: []
	    },
	    views: {
	      'menu': "",
	      'content': {
	        component: 'accountRegistration'
	      }
	    },
	    resolve: {
	      invitations: ["$transition$", "$q", function invitations($transition$, $q) {
	        // NOTE: A call to ContentService.getUserInvitations() was being made, deacttivated
	        // in exchange of a parameter (for more info see commit 7f5215d1b).
	        var invitationsFromParams = $transition$.params().invitations || [];
	        return $q(function (resolve, reject) {
	          resolve(invitationsFromParams);
	        });
	      }],
	      countries: ["CountriesService", function countries(CountriesService) {
	        return CountriesService.getCountries();
	      }],
	      profiles: ["$transition$", function profiles($transition$) {
	        return $transition$.params().profiles || [];
	      }]
	    }
	  });
	}]).name;
	
	exports.default = AccountRegistrationModule;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accountRegistration = __webpack_require__(1132);
	
	var _accountRegistration2 = _interopRequireDefault(_accountRegistration);
	
	var _accountRegistration3 = __webpack_require__(1133);
	
	var _accountRegistration4 = _interopRequireDefault(_accountRegistration3);
	
	__webpack_require__(1134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountRegistrationComponent = {
	  bindings: {
	    profiles: '<',
	    invitations: '<',
	    countries: '<'
	  },
	  template: _accountRegistration2.default,
	  controller: _accountRegistration4.default
	};
	
	exports.default = AccountRegistrationComponent;

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n  <div class=\"wrapper\">\n  </div>\n  <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n    <form class=\"form-signin relative-pos\" id=\"account-registration-form\" name=\"regForm\" ng-submit=\"$ctrl.registerAccount()\" novalidate>\n\n      <div class=\"row invitations-row\" ng-show=\"$ctrl.invitations.length > 0\">\n        <div class=\"col-md-12 pull-right text-right\">\n          <a href ui-sref=\"pendingInvitations({invitations: $ctrl.invitations, profiles: $ctrl.profiles})\" class=\"text-warning\">\n            <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n             {{'Invitaciones pendientes' | translate}}\n          </a>\n        </div>\n      </div>\n\n      <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n      <h3 class=\"form-signin-heading\">{{'Crea tu Compañía' | translate}}</h3>\n\n      <div class=\"form-group\">\n        <input type=\"text\" name=\"name\" ng-model=\"$ctrl.account.name\" class=\"form-control input_py\" placeholder=\"Compañía\" validator=\"required\"\n          autofocus autocomplete=\"off\">\n      </div>\n\n      <div class=\"form-group\">\n        <countries countries=\"$ctrl.countries\" selected=\"$ctrl.account.country\"\n            on-select=\"$ctrl.onCountrySelect(country)\">\n        </countries>\n      </div>\n\n      <button class=\"btn btn-md btn-primary btn-block btn_py\" type=\"submit\" validation-submit=\"regForm\" ng-click=\"$ctrl.registerAccount()\">\n        {{'Crear' | translate}}\n      </button>\n      <p class=\"create-account pull-left\" ng-if=\"$ctrl.hasProfiles\">\n        <a ui-sref=\"profileSelection({profiles: $ctrl.profiles, invitations: $ctrl.invitations})\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i> Volver</a>\n      </p>\n      <br class=\"jump_formlogin\">  \n      <p class=\"create-account\">\n        <a ng-click=\"$ctrl.logout()\"><i class=\"fa fa-power-off\" aria-hidden=\"true\"></i> {{'Cerrar Sesión' | translate}}</a>\n      </p>\n    </form>\n  </div>\n</body>"

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountRegistrationController = function () {
	    function AccountRegistrationController(AuthService, $state, RegisterService, ProfilePermissionsService, $window) {
	        (0, _classCallCheck3.default)(this, AccountRegistrationController);
	
	        this.authService = AuthService;
	        this.service = RegisterService;
	        this.state = $state;
	        this.permissionsService = ProfilePermissionsService;
	
	        this.subscriptions = [];
	        this.window = $window;
	    }
	
	    (0, _createClass3.default)(AccountRegistrationController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.account = {
	                name: '',
	                country: 'DO'
	            };
	            this.hasProfiles = !!(this.window.localStorage.profilesCount && parseInt(this.window.localStorage.profilesCount) > 0);
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.subscriptions.forEach(function (sub) {
	                return sub.unsubscribe();
	            });
	        }
	    }, {
	        key: 'onCountrySelect',
	        value: function onCountrySelect(country) {
	            this.account.country = country;
	        }
	    }, {
	        key: 'registerAccount',
	        value: function registerAccount() {
	            var _this = this;
	
	            this.subscriptions.push(this.service.registerAccount(this.account.name, this.account.country).subscribe(function (data) {
	                if (data.account_token) {
	                    _this.profiles.push(data.profile);
	                    _this.permissionsService.setProfilesCount((parseInt(_this.window.localStorage.profilesCount) || 0) + 1);
	
	                    _this.authService.saveAccountToken(data.account_token);
	                    _this.permissionsService.setProfile(data.profile);
	                    _this.permissionsService.setProfilesCount((parseInt(_this.window.localStorage.profilesCount) || 0) + 1);
	
	                    _this.state.go('accountSubscription');
	                }
	            }, function (error) {}));
	            // }
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            var _this2 = this;
	
	            this.subscriptions.push(this.authService.logout().subscribe(function (data) {
	                return _this2.state.go('login');
	            }, function (error) {}));
	        }
	    }]);
	    return AccountRegistrationController;
	}();
	
	exports.default = AccountRegistrationController;
	
	
	AccountRegistrationController.$inject = ['AuthService', '$state', 'RegisterService', 'ProfilePermissionsService', '$window', 'SubscriptionService'];

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1135);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./account-registration.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./account-registration.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "account-registration .relative-pos{position:relative}account-registration .invitations-row{position:absolute;top:5px;right:15px}", ""]);
	
	// exports


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _passwordRequest = __webpack_require__(1137);
	
	var _passwordRequest2 = _interopRequireDefault(_passwordRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordRequestModule = _angular2.default.module('PasswordRequest', [_angularjs2.default]).component('passwordRequest', _passwordRequest2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('passwordRequest', {
	    url: '/password-request',
	    views: {
	      'menu': "",
	      'content': {
	        component: 'passwordRequest'
	      }
	    }
	  });
	}]).name;
	
	exports.default = PasswordRequestModule;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _passwordRequest = __webpack_require__(1138);
	
	var _passwordRequest2 = _interopRequireDefault(_passwordRequest);
	
	var _passwordRequest3 = __webpack_require__(1139);
	
	var _passwordRequest4 = _interopRequireDefault(_passwordRequest3);
	
	__webpack_require__(1140);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordRequestComponent = {
	  bindings: {},
	  template: _passwordRequest2.default,
	  controller: _passwordRequest4.default
	};
	
	exports.default = PasswordRequestComponent;

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n    <div class=\"wrapper\">\n    </div>\n\n    <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n        <form class=\"form-signin\" name=\"passwordRequestForm\" novalidate>\n            <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n            <h3 class=\"form-signin-heading\">{{'Recuperar Contraseña' | translate}}</h3>\n            <div class=\"form-group\">\n                <input type=\"email\" name=\"email\" ng-model=\"$ctrl.email\" class=\"form-control input_py\" placeholder=\"Email\" \n                    validator=\"email, required\" valid-method=\"submit\">\n            </div>\n            <button class=\"btn btn-md btn-primary btn-block btn_py\" ng-click=\"$ctrl.requestPassword()\" type=\"submit\"\n                    validation-submit=\"passwordRequestForm\">{{'Enviar Recuperación' | translate}}</button>\n          <p class=\"create-account\">\n            <a ui-sref=\"login\"><i class=\"fa fa-chevron-circle-left\" aria-hidden=\"true\"></i> {{'Volver al inicio' | translate}}</a>\n          </p>\n        </form>\n    </div>\n</body>"

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordRequestController = function () {
	  function PasswordRequestController($state, PasswordRecoveryService, Notification) {
	    (0, _classCallCheck3.default)(this, PasswordRequestController);
	
	    this.state = $state;
	    this.service = PasswordRecoveryService;
	    this.notify = Notification;
	  }
	
	  (0, _createClass3.default)(PasswordRequestController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.email = '';
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'requestPassword',
	    value: function requestPassword() {
	      var _this = this;
	
	      this.subscriptions.push(this.service.requestPassword(this.email).subscribe(function (data) {
	        _this.state.go('requestSuccess', { email: _this.email });
	      }, function (err) {
	        console.log(err);
	      }));
	    }
	  }]);
	  return PasswordRequestController;
	}();
	
	exports.default = PasswordRequestController;
	
	
	PasswordRequestController.$inject = ['$state', 'PasswordRecoveryService', 'Notification'];

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1141);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./password-request.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./password-request.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".PasswordRequest{color:red}", ""]);
	
	// exports


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _permissions = __webpack_require__(1143);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PermissionsModule = _angular2.default.module('Permissions', [_angularjs2.default]).component('permissions', _permissions2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("permissions", {
	    url: '/permissions',
	    data: {
	      authRequired: true,
	      permsRequired: ['manage-perm', 'invite-user', 'view-profiles']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'permissions'
	      }
	    }
	
	  });
	}]).name;
	
	exports.default = PermissionsModule;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _permissions = __webpack_require__(1144);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _permissions3 = __webpack_require__(1145);
	
	var _permissions4 = _interopRequireDefault(_permissions3);
	
	__webpack_require__(1146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PermissionsComponent = {
	  bindings: {},
	  template: _permissions2.default,
	  controller: _permissions4.default
	};
	
	exports.default = PermissionsComponent;

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-10 col-sm-10 col-xs-11\">\n                {{'Usuarios' | translate}}\n            </div>\n            <div class=\"col-md-2\">\n                <a class=\"float-right btn btn-success btn-sm btn_transitions\" href=\"\" \n                    ng-click=\"$ctrl.openModalInviteUser()\" if-perm disable-if=\"invite-user\">\n                    <span class=\"glyphicon glyphicon-plus\"></span>\n                    <span>{{'Invitar nuevo usuario' | translate}}</span>\n                </a>\n            </div>\n        </div>\n    </h1>\n    <div class=\"card\">\n        <div class=\"card-content\" >\n            <div class=\"bootstrap-table\">\n                <div class=\"fixed-table-toolbar\">\n                    <div class=\"columns pull-right\">\n                        <div class=\"keep-open btn-group\" title=\"Columns\">\n                            <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" ng-click=\"$ctrl.switchTab('invitations')\"\n                                ng-disabled=\"$ctrl.activeTab==='invitations'\" if-perm disable-if=\"invite-user\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> {{'Invitaciones' | translate}}    \n                            </button>\n                        </div>\n                    </div>\n                    <div class=\"columns columns-right pull-right\">\n                        <div class=\"keep-open btn-group\" title=\"Columns\">\n                            <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" ng-click=\"$ctrl.switchTab('users')\"\n                            ng-disabled=\"!$ctrl.activeTab || $ctrl.activeTab==='users'\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-user\" aria-hidden=\"true\"></i> {{'Usuarios' | translate}}\n\t\t\t\t\t\t\t</button>\n                        </div>\n                    </div>\n\n                    <div class=\"search col-md-4 \">\n                        <div class=\"field\">\n                            <input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterText.name\" required>\n                            <label for=\"input-search\">{{'Filtrar usuarios' | translate}}</label>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"fixed-table-container\" ng-show=\"!$ctrl.activeTab || $ctrl.activeTab === 'users'\">\n                    <table id=\"bootstrap-table\" class=\"table table-hover\">\n                        <thead>\n                            <tr>\n                                <th>{{'Nombre' | translate}}</th>\n                                <th>{{'Correo Electronico' | translate}}</th>\n                                <th width=\"5%\">{{'Administrador' | translate}}</th>\n                                <th width=\"5%\">{{'Acciones' | translate}}</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat=\"profile in $ctrl.accountProfiles | filter:filterText track by $index\">\n                                <td data-label=\"{{'Nombre' | translate}}\">{{ profile.name }}</td>\n                                <td data-label=\"{{'Correo Electronico' | translate}}\">{{ profile.email }}</td>\n                                <td data-label=\"{{'Administrador' | translate}}\" class=\"text-center\">\n                                    <span><i class=\"fa\" ng-class=\"{'fa-check': profile.is_admin, 'fa-times': !profile.is_admin}\" aria-hidden=\"true\"></i></span>\n                                </td>\n                                <td data-label=\"{{'Acciones' | translate}}\" class=\"text-center\">\n                                    <div class=\"table-icons\">\n                                        <a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-warning btn-icon\" \n                                            ng-click=\"$ctrl.openPermsModal(profile, $index)\" \n                                            data-original-title=\"{{'Editar' | translate}}\"\n                                            if-perm disable-if=\"manage-perm\">  \n                                            <i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i>\n                                        </a>\n                                        <a rel=\"tooltip\" title=\"\"\n                                            class=\"btn btn-simple btn-danger btn-icon\"\n                                            mwl-confirm\n                                            title=\"'{{¿Esta seguro?' | translate}}\"\n                                            message=\"{{'ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?' | translate}}\"\n                                            confirm-text=\"{{'Eliminar' | translate}}\"\n                                            cancel-text=\"{{'Cancelar' | translate}}\"\n                                            placement=\"left\"\n                                            on-confirm=\"$ctrl.deleteProfile(profile, $index)\"\n                                            on-cancel=\"\"\n                                            confirm-button-type=\"danger\"\n                                            cancel-button-type=\"default\"\n                                            if-perm disable-if=\"delete-user\"\n                                            is-disabled=\"$ctrl.currentProfile.id === profile.id\"\n                                            ng-disabled=\"$ctrl.currentProfile.id === profile.id\">\n                                            <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                                        </a>\n                                    </div>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n                <div class=\"fixed-table-container\" ng-show=\"$ctrl.activeTab === 'invitations'\">\n                    <table id=\"bootstrap-table\" class=\"table table-hover\">\n                        <thead>\n                            <tr>\n                                <th>{{'Correo' | translate}}</th>\n                                <th>{{'Fecha' | translate}}</th>\n                                <th width=\"5%\">{{'Acciones' | translate}}</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat=\"invitation in $ctrl.accountInvitations\">\n                                <td>{{invitation.email}}</td>\n                                <td>{{invitation.timestamp | amUtc | amLocal | amDateFormat:'LLL'}}</td>\n                                <td><div class=\"table-icons\">\n                                        <a rel=\"tooltip\" title=\"\"\n                                            class=\"btn btn-simple btn-danger btn-icon\"\n                                            mwl-confirm\n                                            title=\"{{'¿Esta seguro?' | translate}}\"\n                                            message=\"{{'ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?'  | translate}}\"\n                                            confirm-text=\"{{'Eliminar' | translate}}\"\n                                            cancel-text=\"{{'Cancelar' | translate}}\"\n                                            placement=\"left\"\n                                            on-confirm=\"$ctrl.cancelInvitation(invitation, $index)\"\n                                            on-cancel=\"\"\n                                            confirm-button-type=\"danger\"\n                                            cancel-button-type=\"default\"\n                                            if-perm disable-if=\"invite-user\">\n                                            <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                                        </a>\n                                    </div></td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"profile-perms-modal.html\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" id=\"modal-title\">\n            {{'Permisos de' | translate}} {{profile.name}}\n            <a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n        </h3>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-6 perms-padding\">\n                <div class=\"\" ng-repeat=\"perm in permsLeft track by $index\">\n                    <div class=\"checkbox_custom\">\n                        <label class=\"label_switch\" for=\"perm-{{perm.perm}}\">{{perm.label}}</label>\n                        <input type=\"checkbox\" id=\"checkbox1\" name=\"perm-{{perm.perm}}\" type=\"checkbox\" name=\"perm-{{perm.perm}}\"\n                        ng-model=\"permsLeft[$index].enabled\" ng-change=\"togglePermInProfile(perm)\"\n                        ng-disabled=\"(currentProfile.id === profile.id && perm.perm === 'is-admin') || (!currentProfile.is_admin && perm.perm === 'is-admin')\"\n                        ng-click=\"togglePerm(perm)\" class=\"pull-right\"/>\n                        <div class=\"switch\"></div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"col-md-6 perms-padding\">\n                <div class=\"\" ng-repeat=\"perm in permsRight track by $index\">\n                    <div class=\"checkbox_custom\">\n                        <label class=\"label_switch\" for=\"perm-{{perm.perm}}\">{{perm.label}}</label>\n                        <input type=\"checkbox\" id=\"checkbox{{$index}}\" name=\"perm-{{perm.perm}}\" type=\"checkbox\" name=\"perm-{{perm.perm}}\"\n                        ng-model=\"permsRight[$index].enabled\" ng-change=\"togglePermInProfile(perm)\"\n                        ng-disabled=\"(currentProfile.id === profile.id && perm.perm === 'is-admin') || (!currentProfile.is_admin && perm.perm === 'is-admin')\"\n                        ng-click=\"togglePerm(perm)\" class=\"pull-right\">\n                        <div class=\"switch\"></div>\n                    </div>\n                </div>\n            </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Salir' | translate}}</button>\n    </div>\n</script>\n"

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PermissionsController = function () {
	  function PermissionsController($uibModal, ContentService, Notification, ProfilePermissionsService, PermissionsService) {
	    (0, _classCallCheck3.default)(this, PermissionsController);
	
	    this.modal = $uibModal;
	    this.service = ContentService;
	    this.notify = Notification;
	    this.profilePerms = ProfilePermissionsService;
	    this.permsService = PermissionsService;
	  }
	
	  (0, _createClass3.default)(PermissionsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.activeTab = 'users';
	      this.currentProfile = this.profilePerms.getProfile();
	      if (this.profilePerms.hasPermission('view-profiles')) {
	        this.subscriptions.push(this.service.getAccountProfiles().subscribe(function (profiles) {
	          return _this.accountProfiles = profiles;
	        }, function (error) {
	          return _this.accountProfiles = [];
	        }));
	      } else {
	        this.activeTab = 'invitations';
	      }
	      if (this.profilePerms.hasPermission('invite-user')) {
	        this.subscriptions.push(this.service.getAccountInvitations().subscribe(function (invitations) {
	          return _this.accountInvitations = invitations;
	        }, function (error) {
	          return _this.invitations = null;
	        }));
	      }
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'switchTab',
	    value: function switchTab(tab) {
	      if (tab === 'invitations' && this.profilePerms.hasPermission('invite-user')) {
	        this.activeTab = tab;
	      } else if (tab === 'users' && this.profilePerms.hasPermission('view-profiles')) {
	        this.activeTab = tab;
	      }
	    }
	  }, {
	    key: 'openModalInviteUser',
	    value: function openModalInviteUser() {
	      var that = this;
	
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'invite-user-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "$validation", function controller($scope, $state, $uibModalInstance, $validation) {
	          "ngInject";
	
	          $scope.emails = '';
	          $scope.state = $state;
	          $validation.setExpression({
	            multiemail: /^$|^(([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\,(\s)?)?)+$/
	          }).setDefaultMsg({
	            multiemail: {
	              error: "No es un correo o listado de correos válido"
	            }
	          });
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.inviteUser = function () {
	            that.subscriptions.push(that.service.inviteUser($scope.emails).subscribe(function (resp) {
	              that.notify.success('Usuario invitado exitosamente.!');
	              $scope.state.reload();
	              $scope.closeThisDialog();
	            }, function (error) {
	              console.log(error);
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openPermsModal',
	    value: function openPermsModal(profile) {
	      var _this2 = this;
	
	      var that = this;
	      that.change = 0;
	      this.subscriptions.push(this.permsService.getPermissions().subscribe(function (permissions) {
	        _this2.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'profile-perms-modal.html',
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "ContentService", "$state", "$uibModalInstance", "PermissionsService", function controller($scope, ContentService, $state, $uibModalInstance, PermissionsService) {
	            "ngInject";
	
	            $scope.profile = profile;
	            $scope.currentProfile = that.currentProfile;
	            $scope.perms = permissions.map(function (perm) {
	              if (perm.perm === 'is-admin') {
	                perm.enabled = profile.is_admin;
	                return perm;
	              }
	              perm.enabled = profile.permissions.indexOf(perm.perm) != -1;
	              return perm;
	            });
	            $scope.totalPerms = $scope.perms.length;
	            $scope.permsLeft = $scope.perms.slice(0, $scope.totalPerms / 2);
	            $scope.permsRight = $scope.perms.slice($scope.totalPerms / 2, $scope.totalPerms);
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	            $scope.togglePermInProfile = function (permission) {
	              if (permission.enabled) {
	                if (permission.perm === 'is-admin') {
	                  profile.is_admin = true;
	                } else {
	                  profile.permissions.push(permission.perm);
	                }
	              } else {
	                if (permission.perm === 'is-admin') {
	                  profile.is_admin = false;
	                } else {
	                  profile.permissions.splice(profile.permissions.indexOf(permission.perm), 1);
	                }
	              }
	            };
	            $scope.togglePerm = function (permission, idx) {
	              if (!permission.enabled) {
	                that.subscriptions.push(that.service.assignPerm($scope.profile.id, {
	                  perm: permission.perm
	                }).subscribe(function (resp) {}, function (resp) {
	                  return $scope.perms[idx].enabled = false;
	                }));
	              } else {
	                that.subscriptions.push(that.service.revokePerm($scope.profile.id, {
	                  perm: permission.perm
	                }).subscribe(function (resp) {}, function (resp) {
	                  return $scope.perms[idx].enabled = true;
	                }));
	              }
	              that.change += 1;
	            };
	          }]
	        }).closed.then(function () {
	          if (that.change > 0) {
	            _this2.notify.success('Sus cambios han sido realizados satisfactoriamente');
	          }
	        });
	      }));
	    }
	  }, {
	    key: 'deleteProfile',
	    value: function deleteProfile(profile, idx) {
	      var _this3 = this;
	
	      var currentProfile = this.profilePerms.getProfile().id;
	      if (profile.id === currentProfile) {
	        this.notify.warning("Usted no puede borrar su propio perfil");
	        return;
	      }
	      this.subscriptions.push(this.service.deleteProfile(profile.id).subscribe(function (resp) {
	        return _this3.accountProfiles.splice(idx, 1);
	      }, function (resp) {}));
	    }
	  }, {
	    key: 'cancelInvitation',
	    value: function cancelInvitation(invitation, idx) {
	      var _this4 = this;
	
	      if (this.profilePerms.hasPermission('invite-user')) {
	        this.subscriptions.push(this.service.cancelInvitation({ email: invitation.email }).subscribe(function (resp) {
	          _this4.accountInvitations.splice(idx, 1);
	          _this4.notify.success("La invitación ha sido cancelada exitosamente");
	        }, function (resp) {}));
	      }
	    }
	  }]);
	  return PermissionsController;
	}();
	
	exports.default = PermissionsController;
	
	
	PermissionsController.$inject = ['$uibModal', 'ContentService', 'Notification', 'ProfilePermissionsService', 'PermissionsService'];

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1147);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./permissions.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./permissions.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".Permissions{color:red}.perms-padding{padding:5px 15px;border:1px solid #ccc;border-right:1px solid #ccc}.checkbox_custom{position:relative;margin-bottom:3px;padding-bottom:3px}@media (max-width:426px){.checkbox_custom{border-bottom:1px solid #ccc}}.checkbox_custom .label_switch{display:inline-block;vertical-align:middle;color:#000}.checkbox_custom .switch{position:relative;display:inline-block;float:right;width:42px;height:24px;vertical-align:middle;background:#bdc3c7;border-radius:12px;box-shadow:inset 0 2px 4px 0 hsla(240,0%,53%,.5);transition-property:background-color,box-shadow}.checkbox_custom .switch:after{content:\"\";position:absolute;top:-1px;left:-1px;width:26px;height:26px;z-index:2;background:#fff;border:1px solid #ddd;border-radius:100%;box-shadow:1px 1px 5px rgba(0,0,0,.2);transition-property:transform}.checkbox_custom .switch,.checkbox_custom .switch:after{transition-duration:.3s;transition-timing-function:ease}.checkbox_custom input{position:absolute;left:0;top:0;width:100%;height:100%;z-index:5;opacity:0;cursor:pointer}.checkbox_custom input:checked+.switch{background:#489fe5}.checkbox_custom input:checked+.switch:after{-webkit-transform:translate(18px);transform:translate(18px)}", ""]);
	
	// exports


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _error = __webpack_require__(1149);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Error404Module = _angular2.default.module('Error404', [_angularjs2.default]).component('error404', _error2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('error404', {
	    url: '/404',
	    views: {
	      'menu': "",
	      'content': {
	        component: 'error404'
	      }
	    }
	  });
	}]).name;
	
	exports.default = Error404Module;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _error = __webpack_require__(1150);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _error3 = __webpack_require__(1151);
	
	var _error4 = _interopRequireDefault(_error3);
	
	__webpack_require__(1152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Error404Component = {
	  bindings: {},
	  template: _error2.default,
	  controller: _error4.default
	};
	
	exports.default = Error404Component;

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"body-error\">\n    <section class=\"error_container\">\n        <i class=\"fa fa-exclamation-triangle\"></i>\n            <div class=\"text_error\">{{'Error 404' | translate}}</div>\n            <span>{{'La dirección no fue encontrada' | translate}}.</span>\n        <hr class=\"divider_error\">\n        <div class=\"countdown\">{{'Su navegador volverá a la página anterior en' | translate}} <span class=\"count\">15</span> {{'segundos' | translate}}. {{'Usted también puedes' | translate}}: </div>\n        <a ui-sref=\"dashboard\" class=\"return_error\"><i class=\"fa fa-reply\"></i> {{'Ir al inicio' | translate}}</a><br />\n    </section>\n</div>"

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Error404Controller = function Error404Controller() {
	  (0, _classCallCheck3.default)(this, Error404Controller);
	};
	
	exports.default = Error404Controller;
	
	
	Error404Controller.$inject = [];

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1153);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./error-404.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./error-404.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "error404 *{box-sizing:border-box}error404 div.body-error{display:flex;justify-content:center;align-items:center;height:100vh;background-color:#10354b;overflow-x:hidden}error404 .error_container{width:100vw;max-width:500px;height:100vh;max-height:700px;background-color:#123b52;text-align:center;font-size:20px;padding:25px;color:#fff}error404 .fa-exclamation-triangle{font-size:14pc;margin-top:25px;margin-bottom:25px}error404 .text_error{font-size:60px;margin-bottom:5px;font-weight:700}error404 .divider_error{margin:20px;border:none;height:1px;background-color:#bbb}error404 .return_error{color:#eee;display:inline-block;margin-top:8px;margin-bottom:8px;padding:2px;text-decoration:none;font-size:25px;border-bottom:1px solid transparent;transition:border-color .05s}error404 .return_error:focus,error404 .return_error:hover{border-bottom:solid;text-decoration:none;color:#fff;transition:.5s}error404 .countdown{margin-bottom:20px;display:inline-block;width:85%;font-size:16px}@media (max-width:426px){error404 .fa-exclamation-triangle{font-size:10pc;margin-top:25px;margin-bottom:25px}}", ""]);
	
	// exports


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _profileSelection = __webpack_require__(1155);
	
	var _profileSelection2 = _interopRequireDefault(_profileSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileSelectionModule = _angular2.default.module('ProfileSelection', [_angularjs2.default]).component('profileSelection', _profileSelection2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('profileSelection', {
	    params: {
	      profiles: null
	    },
	    data: {
	      authRequired: true,
	      paymentExempt: true,
	      permsRequired: []
	    },
	    views: {
	      'menu': "",
	      'content': {
	        component: 'profileSelection',
	        bindings: {
	          profiles: 'profiles'
	        }
	      }
	    },
	    resolve: {
	      profiles: ["$transition$", "$q", "LoginService", function profiles($transition$, $q, LoginService) {
	        var profilesFromParams = $transition$.params().profiles;
	        if (profilesFromParams) {
	          return $q(function (resolve, reject) {
	            resolve(profilesFromParams || []);
	          });
	        }
	
	        return LoginService.getUserProfiles().toPromise();
	      }],
	      invitations: ["$transition$", "$q", function invitations($transition$, $q) {
	        // NOTE: A call to ContentService.getUserInvitations() was being made, deacttivated
	        // in exchange of a parameter (for more info see commit 7f5215d1b).
	        var invitationsFromParams = $transition$.params().invitations || [];
	        return $q(function (resolve, reject) {
	          resolve(invitationsFromParams);
	        });
	      }]
	    }
	  });
	}]).name;
	
	exports.default = ProfileSelectionModule;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _profileSelection = __webpack_require__(1156);
	
	var _profileSelection2 = _interopRequireDefault(_profileSelection);
	
	var _profileSelection3 = __webpack_require__(1157);
	
	var _profileSelection4 = _interopRequireDefault(_profileSelection3);
	
	__webpack_require__(1158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileSelectionComponent = {
	  bindings: {
	    profiles: '<',
	    invitations: '<'
	  },
	  template: _profileSelection2.default,
	  controller: _profileSelection4.default
	};
	
	exports.default = ProfileSelectionComponent;

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n  <div class=\"wrapper\">\n  </div>\n  <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n    <form class=\"form-signin relative-pos\" name=\"accountRegistrationForm\" novalidate>\n\n      <div class=\"row invitations-row\" ng-show=\"$ctrl.invitations.length > 0\">\n        <div class=\"col-md-12 pull-right text-right\">\n          <a href ui-sref=\"pendingInvitations({invitations: $ctrl.invitations, profiles: $ctrl.profiles})\" class=\"text-warning\">\n            <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n             {{'Invitaciones pendientes' | translate}}\n          </a>\n        </div>\n      </div>\n\n      <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n      <h3 class=\"form-signin-heading\">\n        {{'Seleccione la compañía' | translate}}\n      </h3>\n\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"list-group\">\n            <button type=\"button\" class=\"list-group-item clickable\" ng-repeat=\"profile in $ctrl.profiles\"\n                ng-class=\"{disabled: !profile.is_active}\"\n                ng-click=\"profile.is_active && $ctrl.selectProfile(profile)\">\n              {{ profile.account_name }}\n              <i ng-if=\"['MASTER', 'ADMIN'].indexOf(profile.account_role) > -1\" class=\"glyphicon glyphicon-star pull-right\"\n                 style=\"line-height:1.5;\"></i>\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <p class=\"create-account pull-left\">\n        <a ui-sref=\"accountRegistration({profiles: $ctrl.profiles, invitations: $ctrl.invitations})\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> {{'Crear Compañía' | translate}}</a>\n      </p>\n      <br class=\"jump_formlogin\">\n      <p class=\"create-account\">\n        <a ng-click=\"$ctrl.logout()\"><i class=\"fa fa-power-off\" aria-hidden=\"true\"></i> {{'Cerrar Sesión' | translate}}</a>\n      </p>\n    </form>\n  </div>\n</body>"

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _app = __webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileSelectionController = function () {
	  function ProfileSelectionController(AuthService, $state, LoginService, ProfilePermissionsService, AccountInformationService, Notification) {
	    (0, _classCallCheck3.default)(this, ProfileSelectionController);
	
	    this.authService = AuthService;
	    this.state = $state;
	    this.loginService = LoginService;
	    this.permissionsService = ProfilePermissionsService;
	    this.accountInfoService = AccountInformationService;
	    this.notify = Notification;
	    this.subscriptions = [];
	  }
	
	  (0, _createClass3.default)(ProfileSelectionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	      this.permissionsService.setProfilesCount(this.profiles ? this.profiles.length : 0);
	      this.invitations = [];
	
	      this.authService.removeAccountToken();
	      this.permissionsService.clearProfile();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'selectProfile',
	    value: function selectProfile(profile) {
	      var _this = this;
	
	      this.subscriptions.push(this.loginService.getAccountToken(profile.account_id).subscribe(function (accountToken) {
	        if (!accountToken) {
	          return;
	        }
	
	        _this.authService.saveAccountToken(accountToken);
	        _this.permissionsService.setProfile(profile);
	
	        var role = _this.authService.parseJwt(accountToken).role;
	        if (['MASTER', 'ADMIN'].indexOf(role) > -1) {
	          _this.state.go('userControl');
	        } else {
	          _this.accountInfoService.getPaymentStatus().subscribe(function (data) {
	            if (![_app.PaymentOnTrial, _app.PaymentRegistered, _app.PaymentSucceeded].includes(data.payment_status)) {
	              if (_this.permissionsService.hasPermission('manage-subscription')) {
	                if (data.payment_status === _app.PaymentUnregistered) {
	                  return _this.state.go('accountSubscription');
	                }
	
	                return _this.state.go('accountInformation');
	              }
	
	              return _this.state.go('paymentNotice');
	            }
	
	            return _this.state.go('dashboard');
	          });
	        }
	      }));
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      this.subscriptions.push(this.authService.logout().subscribe(function (data) {
	        return _this2.state.go('login');
	      }, function (error) {}));
	    }
	  }]);
	  return ProfileSelectionController;
	}();
	
	exports.default = ProfileSelectionController;
	
	
	ProfileSelectionController.$inject = ['AuthService', '$state', 'LoginService', 'ProfilePermissionsService', 'AccountInformationService', 'Notification'];

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1159);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./profile-selection.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./profile-selection.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "profile-selection .relative-pos{position:relative}profile-selection .invitations-row{position:absolute;top:5px;right:15px}", ""]);
	
	// exports


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNan = __webpack_require__(962);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _parseFloat = __webpack_require__(1063);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _userControl = __webpack_require__(1161);
	
	var _userControl2 = _interopRequireDefault(_userControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserControlModule = _angular2.default.module('UserControl', [_angularjs2.default]).component('userControl', _userControl2.default).filter('fileSize', function () {
	  return function (input) {
	    var asNum = (0, _parseFloat2.default)(input);
	    return !(0, _isNan2.default)(asNum) ? asNum : '-';
	  };
	}).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('userControl', {
	    url: '/user-control',
	    data: {
	      authRequired: true,
	      adminAccountRequired: true,
	      paymentExempt: true
	    },
	    views: {
	      'menu': 'adminmenu',
	      'content': {
	        component: 'userControl'
	      }
	    },
	    resolve: {
	      accountsObservable: ["AdminService", function accountsObservable(AdminService) {
	        return AdminService.retrieveAllAccounts();
	      }]
	    }
	  });
	}]).name;
	
	exports.default = UserControlModule;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userControl = __webpack_require__(1162);
	
	var _userControl2 = _interopRequireDefault(_userControl);
	
	var _userControl3 = __webpack_require__(1163);
	
	var _userControl4 = _interopRequireDefault(_userControl3);
	
	__webpack_require__(1164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserControlComponent = {
	  bindings: {
	    accountsObservable: '<'
	  },
	  template: _userControl2.default,
	  controller: _userControl4.default
	};
	
	exports.default = UserControlComponent;

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 main\"><!-- col-md-offset-2 -->\n\t<h1 class=\"page-header ph_usercontrol\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-9\">\n\t\t\t\t{{'Control de Cuentas' | translate}}\n\t\t\t</div>\n\t\t\t<div class=\"col-md-3 text-right\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary action_btn\" ng-click=\"$ctrl.inviteUser()\">\n\t\t\t\t\t<i class=\"fa fa-users\" aria-hidden=\"true\"></i>\n\t\t\t\t</button>\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary action_btn\" ng-click=\"$ctrl.openAdminAccountModal()\" ng-if=\"$ctrl.isMaster\">\n\t\t\t\t\t<i class=\"fa fa-user-plus\" aria-hidden=\"true\"></i>\n\t\t\t\t</button>\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary action_btn\" ng-click=\"$ctrl.viewCollectorsList()\">\n\t\t\t\t\t{{'Colectores' | translate}}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</h1>\n\t<div class=\"col-md-12 account_list\" ng-if=\"!$ctrl.account\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-sm-12\">\n\t\t\t\t<div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"accType=='O' || !accType\" ng-click=\"$ctrl.getOperativeAccounts(); accType='O'\">>{{'Operativas' | translate}}</button>\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"accType=='A'\" ng-click=\"$ctrl.getAdminAccounts(); accType='A'\">{{'Administradoras' | translate}}</button>\t\t\t\t\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<br>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-sm-12\">\n\t\t\t    <input type=\"text\" class=\"form-control\" id=\"acc-filter-text\" ng-model=\"filterText\" placeholder=\"Filtrar cuentas\">\n\t\t\t</div>\n\t\t</div>\n\t\t<br>\n\t\t<div class=\"scroll-area\">\n\t\t\t<div class=\"media_account\" ng-class=\"{highlighted: $ctrl.account === account }\" ng-repeat=\"account in $ctrl.accounts |filter:filterText\">\n\t\t\t\t<a class=\"user_icon_container pull-left\" href=\"#\">\n\t\t\t\t\t<i class=\"fa fa-user\" aria-hidden=\"true\"></i>\n\t\t\t\t</a>\n\t\t\t\t<div class=\"media-body\">\n\t\t\t\t\t<h4 class=\"media-heading\">{{ account.name }}</h4>\n\t\t\t\t\t<h5 class=\"account-id\">ID: {{ account.id }}</h5>\n\t\t\t\t\t<hr style=\"margin:8px auto\">\n\t\t\t\t\t<a class=\"status_btn\" ng-class=\"{active_status: account.isActive, inactive_status: !account.isActive}\" href=\"#\">\n\t\t\t\t\t\t{{ account.isActive ? 'Activa' : 'Inactiva'  | translate}}\n\t\t\t\t\t</a>\n\t\t\t\t\t<a class=\"status_btn\" href=\"#\" ng-click=\"$ctrl.viewAccount(account)\">Ver</a>\n\t\t\t\t\t<a class=\"status_btn pull-right\" href=\"#\" ng-click=\"$ctrl.toggleAccountStatus(account)\"\n\t\t\t\t\t\t\tng-class=\"{inactivate_btn: account.isActive, activate_btn: !account.isActive}\">\n\t\t\t\t\t\t{{ account.isActive ? 'Desactivar' : 'Activar'  | translate }}\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"col-md-12\" ng-if=\"!!$ctrl.account\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-sm-12\">\n\t\t\t\t<h1>{{$ctrl.account.name}}</h1>\n\t\t\t\t<button class=\"btn btn-default pull-right\" ng-click=\"$ctrl.account = null\">\n\t\t\t\t\t<i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i> {{'Volver' | translate}}\t\t\t\t\t\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t\t<h3>{{$ctrl.account.description}}</h3>\n\t\t<v-accordion class=\"vAccordion--default\">\n\t\t\t<v-pane expanded>\n\t\t\t\t<v-pane-header>\n\t\t\t\t\t<h3>{{'Información' | translate}}</h3>\n\t\t\t\t</v-pane-header>\n\t\t\t\t<v-pane-content>\n\t\t\t\t\t<table class=\"table\">\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td> <span><strong>{{'Dirección' | translate}}</strong></span> <br>\n\t\t\t\t\t\t\t\t{{ $ctrl.account.address || 'N/A' }}</td>\n\t\t\t\t\t\t\t\t<td> <span><strong>{{'Ciudad' | translate}}</strong></span> <br>\n\t\t\t\t\t\t\t\t{{ $ctrl.account.city || 'N/A' }}</td>\n\t\t\t\t\t\t\t\t<td> <span><strong>{{'País' | translate}}</strong></span> <br>\n\t\t\t\t\t\t\t\t{{ $ctrl.account.country ||  'N/A' }}</td>\n\t\t\t\t\t\t\t\t<td> <span><strong>{{'Email' | translate}}</strong></span> <br>\n\t\t\t\t\t\t\t\t{{ $ctrl.account.email || 'N/A' }}</td>\n\t\t\t\t\t\t\t\t<td> <span><strong>{{'Identificación' | translate}}</strong></span> <br>\n\t\t\t\t\t\t\t\t{{ $ctrl.account.identification || 'N/A' }}</td>\n\t\t\t\t\t\t\t\t<td> <span><strong>{{'Código Postal' | translate}}</strong></span> <br>\n\t\t\t\t\t\t\t\t{{ $ctrl.account.zipcode || 'N/A' }}</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</v-pane-content>\n\t\t\t</v-pane>\n\t\t\t<v-pane ng-show=\"$ctrl.account.role !== 'ADMIN'\">\n\t\t\t\t<v-pane-header>\n\t\t\t\t\t<h3>{{'Colectores' | translate}}</h3>\n\t\t\t\t</v-pane-header>\n\t\t\t\t<v-pane-content>\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t<div class=\"col-md-12 text-center\">\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.openAssociationModal($ctrl.account.id)\">\n\t\t\t\t\t\t\t\t{{'Asociar colector' | translate}}\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div> \n\t\t\t\t\t</div>\n\t\t\t\t\t<table class=\"table table-hover table-condensed client-keys-table\">\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t<tr ng-repeat=\"col in $ctrl.account.collectors track by $index\">\n\t\t\t\t\t\t\t\t<td data-label=\"Nombre\" class=\"client-key\" colspan=\"3\">{{col.name}}</td>\n\t\t\t\t\t\t\t\t<td data-label=\"Client ID\" class=\"client-key\" id=\"key-{{$index}}\" colspan=\"6\">{{col.client_id}}</td>\n\t\t\t\t\t\t\t\t<td data-label=\"Acciones\" class=\"text-center\" colspan=\"2\">\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn copy-btn\" ng-click=\"$ctrl.openAccountCollectorModal(col)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button>\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn copy-btn\" ngclipboard data-clipboard-target=\"#key-{{ $index }}\" ngclipboard-success=\"$ctrl.copySucceed()\" ngclipboard-error=\"$ctrl.copyFailed(event)\"><i class=\"fa fa-files-o\" aria-hidden=\"true\"></i></button>\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn disass-btn\" ng-click=\"$ctrl.disassociateCollector($ctrl.account,  col.id, $index)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</v-pane-content>\n\t\t\t</v-pane>\n\n\t\t\t<v-pane>\n\t\t\t\t<v-pane-header>\n\t\t\t\t\t<h3>{{'Puntos de venta' | translate}}</h3>\n\t\t\t\t</v-pane-header>\n\t\t\t\t<v-pane-content>\n\t\t\t\t\t<button ng-click=\"$ctrl.openPointOfSaleCreationModal()\" type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> {{'Crear Punto de Venta' | translate}}</button>\n\t\t\t\t\t<table>\n\t\t\t\t\t\t<table class=\"table table-hover table-condensed client-keys-table\">\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr ng-repeat=\"pos in $ctrl.account.points track by $index\">\n\t\t\t\t\t\t\t\t\t<td>{{pos.name}}</td>\n\t\t\t\t\t\t\t\t\t<td>{{pos.number}}</td>\n\t\t\t\t\t\t\t\t\t<td>{{pos.ip_address}}</td>\n\t\t\t\t\t\t\t\t\t<td>{{pos.port_number}}</td>\n\t\t\t\t\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn copy-btn\" ng-click=\"$ctrl.openPointOfSaleCreationModal(pos)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<button \n\t\t\t\t\t\t\t\t\t\t\tmwl-confirm\n\t\t\t\t\t\t\t\t\t\t\ttitle=\"¿Esta seguro?\"\n\t\t\t\t\t\t\t\t\t\t\tmessage=\"ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?\"\n\t\t\t\t\t\t\t\t\t\t\tconfirm-text=\"Eliminar\"\n\t\t\t\t\t\t\t\t\t\t\tcancel-text=\"Cancelar\"\n\t\t\t\t\t\t\t\t\t\t\tplacement=\"left\"\n\t\t\t\t\t\t\t\t\t\t\ton-confirm=\"$ctrl.deletePOS(pos, $index)\"\n\t\t\t\t\t\t\t\t\t\t\ton-cancel=\"\"\n\t\t\t\t\t\t\t\t\t\t\tconfirm-button-type=\"danger\"\n\t\t\t\t\t\t\t\t\t\t\tcancel-button-type=\"default\"\n\t\t\t\t\t\t\t\t\t\t\ttype=\"button\" class=\"btn disass-btn\"\n\t\t\t\t\t\t\t\t\t\t><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</table>\n\t\t\t\t</v-pane-content>\n\t\t\t</v-pane>\n\t\t\t<v-pane>\n\t\t\t\t<v-pane-header>\n\t\t\t\t\t<h3>{{'Backups' | translate}}</h3>\n\t\t\t\t</v-pane-header>\n\t\t\t\t<v-pane-content>\n\t\t\t\t\t<button ng-click=\"$ctrl.openBackupUploadModal()\" type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> {{'Subir backup' | translate}}</button>\n\t\t\t\t\t<table class=\"table table-hover table-condensed client-keys-table\">\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t<tr ng-repeat=\"backup in $ctrl.account.backups track by $index\">\n\t\t\t\t\t\t\t\t<td>{{ backup.filename }}</td>\n\t\t\t\t\t\t\t\t<td>{{ backup.title }}</td>\n\t\t\t\t\t\t\t\t<td>{{ backup.timestamp | amDateFormat:'DD/MM/YYYY HH:mm' }}</td>\n\t\t\t\t\t\t\t\t<td>{{ backup.filesize || '-' }}</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</v-pane-content>\n\t\t\t</v-pane>\n\t\t\t<v-pane>\n\t\t\t\t<v-pane-header>\n\t\t\t\t\t<h3>{{'DTTs' | translate}}</h3>\n\t\t\t\t</v-pane-header>\n\t\t\t\t<v-pane-content>\n\t\t\t\t\t<div class=\"btn-group\" role=\"group\">\n\t\t\t\t\t\t<button ng-click=\"$ctrl.openDTTUploadModal()\" type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> {{'Subir DTT' | translate}}</button>\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.processDTTs()\">\n\t\t\t\t\t\t\t{{'Procesar DTTs' | translate}}\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<table class=\"table table-hover table-condensed client-keys-table\">\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t<tr ng-repeat=\"dtt in $ctrl.account.dtts track by $index\">\n\t\t\t\t\t\t\t\t<td>{{ dtt.filename }}</td>\n\t\t\t\t\t\t\t\t<td>{{ dtt.timestamp | amDateFormat:'DD/MMM/YYYY HH:mm' }}</td>\n\t\t\t\t\t\t\t\t<td>{{ dtt.filesize | fileSize }}</td>\n\t\t\t\t\t\t\t\t<td>{{ dtt.processed ? 'Procesado' : 'No procesado'  | translate}}</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</v-pane-content>\n\t\t\t</v-pane>\n\t\t\t<v-pane>\n\t\t\t\t<v-pane-header>\n\t\t\t\t\t<h3>{{'Perfiles' | translate}}</h3>\n\t\t\t\t</v-pane-header>\n\n\t\t\t\t<v-pane-content>\n\t\t\t\t\t<table class=\"table table-hover table-condensed client-keys-table\">\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t<tr ng-repeat=\"profile in $ctrl.account.profiles track by $index\">\n\t\t\t\t\t\t\t\t<td data-label=\"{{'Nombre' | translate}}\">\n\t\t\t\t\t\t\t\t\t{{ profile.name.trim().length > 0 ? profile.name : 'N/A' }}\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t<td data-label=\"Email\">{{ profile.email || 'N/A' }}</td>\n\t\t\t\t\t\t\t\t<td data-label=\"Rol\">{{ $ctrl.adminLabel[profile.is_admin] }}</td>\n\t\t\t\t\t\t\t\t<!--<td class=\"text-center\">\n\t\t\t\t\t\t\t\t\t<a rel=\"tooltip\" title=\"{{ 'Eliminar' }}\" class=\"btn btn-simple btn-danger btn-icon\"\n\t\t\t\t\t\t\t\t\t\t\tng-click=\"\">\n\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</td>-->\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</v-pane-content>\n\t\t\t</v-pane>\n\n\t\t</v-accordion>\n\n\t\t<!-- <div class=\"info_storage\">\n\t\t\t<div class=\"set-size charts-container\">\n\t\t\t\t<div class=\"pie-wrapper progress-45 style-2\">\n\t\t\t\t\t<span class=\"label\">45<span class=\"smaller\">%</span></span>\n\t\t\t\t\t<div class=\"pie\">\n\t\t\t\t\t\t<div class=\"left-side half-circle\"></div>\n\t\t\t\t\t\t<div class=\"right-side half-circle\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"shadow\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div> -->\n\t</div>\n\n</div>\n\n<script type=\"text/ng-template\" id=\"admin-account-form.html\">\n\t<div class=\"modal-header\">\n\t\t<h3>\n\t\t\t{{'Crear administrador' | translate}}\n            <a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n\t\t</h3>\n\t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n\t\t<form>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label for=\"admin-name\">{{'Nombre de la cuenta' | translate}}</label>\n\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"admin-name\" ng-model=\"adminInfo.name\">\n\t\t\t</div>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label for=\"admin-email\">{{'Email del usuario' | translate}}</label>\n\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"admin-email\" ng-model=\"adminInfo.email\">\n\t\t\t</div>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label for=\"admin-user-name\">{{'Nombre del usuario' | translate}}</label>\n\t\t\t\t<input type=\"\" class=\"form-control\" id=\"admin-user-name\" ng-model=\"adminInfo.username\">\n\t\t\t</div>\n\t\t</form>\n\t</div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary btn_standar pull-left\" ng-click=\"createAdmin()\">{{'Crear cuenta' | translate}}</button>\n    </div>\n\n</script>\n\n<script type='text/ng-template' id=\"invite-user-template.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t{{'Invitar Usuario' | translate}}\n\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n\t\t</h3>\n\t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n\t\t<form name=\"inviteForm\" novalidate>\t\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"description\">{{'Email' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"email\" ng-model=\"emails\" class=\"form-control input_py\" placeholder=\"Email (pueden ser varios separados por coma)\" \n                    validator=\"multiemail,required\" autofocus>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar pull-right\" validation-submit=\"inviteForm\" \n\t\t\t\tng-click=\"inviteUser()\"  if-perm disable-if=\"invite-user\">{{'Enviar'  | translate}}\n\t\t</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n\t</div>\n</script>\n<script type=\"text/ng-template\" id=\"collector-association-template.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t{{'Asociar colector' | translate}}\n\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n\t\t</h3>\n\t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n\t\t<form>\n\t\t\t<div class=\"input-group\" style=\"width:100%\">\n\t\t\t\t<label for=\"collector-chosen\">{{'Colector' | translate}}</label>\n\t\t\t\t<select id=\"collector-chosen\" class=\"form-control\" ng-model=\"collectorChosen\"> \n\t\t\t\t\t<option value=\"\" disabled>{{'Seleccione Uno' | translate}}</option>\n\t\t\t\t\t<option ng-repeat=\"col in collectors\" value=\"{{col.id}}\">{{col.name}} | {{col.client_id | limitTo:8}}</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-primary btn_standar\" ng-click=\"associateCollector(collectorChosen);\">{{'Asociar' | translate}}</button>\n\t</div>\n</script>\n\n<script type='text/ng-template' id=\"collector-list-template.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t{{'Colectores' | translate}}\n\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n\t\t</h3>\n\t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n\t\t<table class=\"table table-hover table-condensed client-keys-table\">\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat=\"col in collectors track by $index\">\n\t\t\t\t\t<td data-label=\"Nombre\" class=\"client-key\">{{col.name}}</td>\n\t\t\t\t\t<td data-label=\"Client ID\" class=\"client-key\" id=\"key-{{$index}}\">{{col.client_id}}</td>\n\t\t\t\t\t<td data-label=\"Acciones\"  class=\"text-center\">\n\t\t\t\t\t\t<button type=\"button\" class=\"btn disass-btn\" ng-click=\"deleteCollector(col.id, $index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar\" ng-click=\"closeThisDialog();\">{{'Cerrar' | translate}}</button>\n\t\t<button type=\"button\" class=\"btn btn-primary btn_standar\" ng-click=\"registerCollector();\">{{'Generar colector' | translate}}</button>\n\t</div>\n</script>\n<script type='text/ng-template' id=\"point-of-sale-creation-modal.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t{{ 'Punto de Venta' | translate }}\n\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n\t\t</h3>\n\t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n\t\t<form name=\"posForm\" novalidate>\t\t\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t\t<label for=\"posname\">{{ 'Nombre POS' | translate }}: </label>\n\t\t\t\t<input type=\"text\" name=\"posname\" ng-model=\"pointOfSales.name\" validator=\"required\" \n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"posnumber\">{{ 'Número de POS' | translate }}: </label>\n\t\t\t\t<input type=\"text\" name=\"posnumber\"  ng-model=\"pointOfSales.number\" validator=\"required\"\n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"possitenumber\">{{'Número de Sitio POS' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"possitenumber\" ng-model=\"pointOfSales.site_number\" validator=\"required\" \n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"port\">{{'Número de Puerto' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"port\" ng-model=\"pointOfSales.port_number\" validator=\"required\" \n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"ip\">{{'Dirección IP' | translate}}: </label>\n\t\t\t\t<input type=\"text\" name=\"ip\" ng-model=\"pointOfSales.ip_address\" validator=\"required\" \n\t\t\t\t\t\tclass=\"form-control input_py\">\t\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" validation-submit=\"posForm\"\n\t\t\t\tng-if=\"!!pointOfSales.id\" ng-click=\"editPOS()\">{{'Editar' | translate}}</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" validation-submit=\"posForm\"\n\t\t\t\tng-if=\"!pointOfSales.id\" ng-click=\"registerPOS()\">{{'Crear' | translate}}</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"collector-modal.html\">\n    <div class=\"modal-header\">\n        <div id=\"modal-title\" ng-if=\"!!collector.id\">\n            <h3>{{'Editar colector' | translate}}</h3>\n        </div>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n        <form name=\"collectorForm\" novalidate>\n            <div class=\"form-group full-width\" ng-if=\"!collector.id\">\n                <label for=\"collector-points\">{{'Puntos de venta' | translate}}</label>\n                <div ng-repeat=\"pos in posList track by $index\">\n                    <div class=\"checkbox_custom\">\n                        <label for=\"pos_{{pos.name}}\">{{pos.name}}</label>\n                        <input type=\"checkbox\" name=\"pos_{{pos.name}}\" ng-model=\"posList[$index].observed\" class=\"pull-right\" ng-disabled=\"pos.taken\">\n                        <div class=\"switch\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-group full-width\" ng-if=\"!!collector.id\">\n                <label for=\"collector-points\">{{'Puntos de venta' | translate}}</label>\n                <div ng-repeat=\"pos in posList track by $index\">\n                    <div class=\"checkbox_custom\">\n                        <label for=\"pos_{{pos.name}}\">{{pos.name}}</label>\n                        <input type=\"checkbox\" name=\"pos_{{pos.name}}\" ng-model=\"posList[$index].observed\" ng-change=\"togglePos(pos, $index)\" class=\"pull-right\" ng-disabled=\"pos.taken\">\n                        <div class=\"switch\"></div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cerrar' | translate}}</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"backup-upload-modal.html\">\n    <div class=\"modal-header\">\n        <div id=\"modal-title\" ng-if=\"!!collector.id\">\n            <h3>{{'Carga de archivos de backup' | translate}}</h3>\n        </div>\n    </div>\n\t<div class=\"modal-body\" id=\"modal-body\" ng-show=\"!displayUploadedList\">\n\t\t<form name=\"backupForm\" novalidate>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"fileBackup\">{{'Cargar Backups'| translate}}:</label><i> {{ fileUploader.queue.length }} {{'seleccionado(s)' | translate}}</i>\n\t\t\t\t<input type=\"file\" nv-file-select uploader=\"fileUploader\" class=\"form-control input_py\" multiple/>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"modal-body\" id=\"modal-body\" ng-show=\"displayUploadedList\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12 text-center\"><strong>{{'Tus archivos subidos' | translate}}</strong></div>\n\t\t</div>\n\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': inMobileView, 'table-hover': !inMobileView}\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th class=\"text-left\" data-field=\"Nombre del archivo\">\n\t\t\t\t\t\t<div class=\"th-inner\">{{'Nombre del archivo' | translate}}</div>\n\t\t\t\t\t</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat=\"file in uploadedFiles\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{ file.filename }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\" ng-show=\"!displayUploadedList\">\n\t\t\t\t{{'Cancelar' | translate}}\n\t\t</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar pull-right\" validation-submit=\"backupForm\" ng-click=\"uploadBackup()\"\n\t\t    ng-show=\"!displayUploadedList\">\n\t\t\t\t{{'Subir' | translate}}\n\t\t</button>\n\t\t<button type=\"submit\" class=\"btn btn-default btn_standar pull-right\" validation-submit=\"backupForm\" ng-click=\"clearQueue()\"\n\t\t    ng-show=\"!displayUploadedList\">\n\t\t\t\t{{'Reiniciar' | translate}}\n\t\t</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar pull-right\" validation-submit=\"backupForm\" ng-click=\"closeThisDialog()\"\n\t\t    ng-show=\"displayUploadedList\">\n\t\t\t\t{{'Salir' | translate}}\n\t\t</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"dtt-upload-modal.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\tCarga de Archivos DTT\n\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\" ng-style=\"uploadingFiles && {animation: 'load 1.1s infinite linear'}\">\n\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n\t\t\t</a>\n\t\t</h3>\n\t\t<!-- <div class=\"spinner pull-right\" ng-show=\"uploadingFiles\"></div> -->\n  \t</div>\n  \t<div class=\"modal-body\" id=\"modal-body\" ng-show=\"!displayUploadedList\">\n\t\t<form name=\"dttForm\" novalidate>\n\t\t\t<div class=\"form-group full-width\">\n\t\t\t\t<label for=\"fileDtt\">Cargar DTT:</label><i> {{ fileUploader.queue.length }} seleccionado(s)</i>\n\t\t\t\t<input type=\"file\" nv-file-select uploader=\"fileUploader\" class=\"form-control input_py\" multiple />\n\t\t\t</div>\n\t\t</form>\n\t</div>\n  \t<div class=\"modal-body\" id=\"modal-body\" ng-show=\"displayUploadedList\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12 text-center\"><strong>Tus archivos subidos</strong></div>\n\t\t</div>\n\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': inMobileView, 'table-hover': !inMobileView}\">\n\t\t\t<thead><tr>\n\t\t\t\t<th class=\"text-left\" data-field=\"Nombre del archivo\">\n\t\t\t\t\t<div class=\"th-inner\">Nombre del archivo</div>\n\t\t\t\t</th>\n\t\t\t</tr></thead>\n\t\t\t<tbody><tr ng-repeat=\"file in uploadedFiles\"><td>\n\t\t\t\t{{ file.filename }}\n\t\t\t</td></tr></tbody>\n\t\t</table>\n\t</div>\n\t<div class=\"modal-footer\" ng-show=\"!displayUploadedList\">\n\t\t<button type=\"submit\" class=\"btn btn-default btn_standar\" validation-submit=\"dttForm\" \n\t\t\t\tng-click=\"clearQueue()\">Reiniciar</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" validation-submit=\"dttForm\" \n\t\t\t\tng-click=\"uploadDtt()\">Subir</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">Cancelar</button>\n\t</div>\n\t<div class=\"modal-footer\" ng-show=\"displayUploadedList\">\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" if-perm disable-if=\"process-dtts\" ng-click=\"processDtt()\">Procesar</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">Cancelar</button>\n\t</div>\n\n</script>"

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserControlController = function () {
	  function UserControlController(AdminService, Notification, MasterService, $uibModal, ContentService, moment, $translate) {
	    (0, _classCallCheck3.default)(this, UserControlController);
	
	    this.service = AdminService;
	    this.notify = Notification;
	    this.master = MasterService;
	    this.modal = $uibModal;
	    this.content = ContentService;
	    this.moment = moment;
	    this.trans = $translate.instant;
	  }
	
	  (0, _createClass3.default)(UserControlController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      var _ = this.trans;
	      this.admins = [];
	      this.isMaster = this.master.isMasterAccount();
	      this.translations = {
	        ACTIVE: _('ACTIVA'),
	        INACTIVE: _('INACTIVA')
	      };
	
	      this.subscriptions.push(this.accountsObservable.subscribe(function (resp) {
	        _this.accounts = resp.accounts.map(function (acc) {
	          acc.isActive = acc.status === 'ACTIVE';
	          return acc;
	        });
	      }));
	
	      this.adminLabel = {
	        true: _('Administrador'),
	        false: _('Usuario')
	      };
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'getOperativeAccounts',
	    value: function getOperativeAccounts() {
	      var _this2 = this;
	
	      this.subscriptions.push(this.accountsObservable.subscribe(function (resp) {
	        _this2.accounts = resp.accounts.map(function (acc) {
	          acc.isActive = acc.status === 'ACTIVE';
	          return acc;
	        });
	      }));
	    }
	  }, {
	    key: 'getAdminAccounts',
	    value: function getAdminAccounts() {
	      var _this3 = this;
	
	      this.subscriptions.push(this.master.getAdminAccounts().subscribe(function (resp) {
	        _this3.accounts = resp.accounts.map(function (acc) {
	          acc.isActive = acc.status === 'ACTIVE';
	          return acc;
	        });
	      }));
	    }
	  }, {
	    key: 'viewAccount',
	    value: function viewAccount(account) {
	      var _this4 = this;
	
	      this.subscriptions.push(this.service.viewAccount(account).subscribe(function (resp) {
	        _this4.account = resp;
	        _this4.getAccountCollectors(resp);
	        _this4.getAccountProfiles(resp);
	        _this4.getAccountPointsOfSale(resp);
	        _this4.getAccountDTTs(resp);
	        _this4.getAccountBackups(resp);
	      }));
	    }
	  }, {
	    key: 'toggleAccountStatus',
	    value: function toggleAccountStatus(account) {
	      var _this5 = this;
	
	      this.subscriptions.push(this.service.toggleAccountStatus(account).subscribe(function (acc) {
	        acc.isActive = acc.status === 'ACTIVE';
	        _this5.accounts.splice(_this5.accounts.indexOf(account), 1, acc);
	      }));
	    }
	  }, {
	    key: 'getClientKeys',
	    value: function getClientKeys(account) {
	      var _this6 = this;
	
	      this.subscriptions.push(this.service.getClientKeys(account).subscribe(function (clientKeys) {
	        return _this6.account.clientKeys = clientKeys;
	      }));
	    }
	  }, {
	    key: 'getAccountProfiles',
	    value: function getAccountProfiles(account) {
	      var _this7 = this;
	
	      this.subscriptions.push(this.service.getAccountProfiles(account).subscribe(function (profiles) {
	        return _this7.account.profiles = profiles;
	      }));
	    }
	  }, {
	    key: 'getAccountPointsOfSale',
	    value: function getAccountPointsOfSale(account) {
	      var _this8 = this;
	
	      this.subscriptions.push(this.service.getAccountPointsOfSale(account).subscribe(function (points) {
	        return _this8.account.points = points;
	      }));
	    }
	  }, {
	    key: 'getAccountBackups',
	    value: function getAccountBackups(account) {
	      var _this9 = this;
	
	      this.subscriptions.push(this.service.getAccountBackups(account).subscribe(function (data) {
	        return _this9.account.backups = data.backups;
	      }));
	    }
	  }, {
	    key: 'getAccountDTTs',
	    value: function getAccountDTTs(account) {
	      var _this10 = this;
	
	      this.subscriptions.push(this.service.getAccountDTTs(account).subscribe(function (data) {
	        var processed = data.processed.map(function (file) {
	          file.processed = true;
	          return file;
	        });
	        var unprocessed = data.unprocessed.map(function (file) {
	          file.processed = false;
	          return file;
	        });
	        var dtts = processed.concat(unprocessed).sort(function (a, b) {
	          return new Date(a).valueOf() - new Date(b).valueOf();
	        });
	        _this10.account.dtts = dtts;
	      }));
	    }
	  }, {
	    key: 'generateKey',
	    value: function generateKey(account) {
	      var _this11 = this;
	
	      if (account) {
	        this.subscriptions.push(this.service.generateClientKey(account).subscribe(function (resp) {
	          return _this11.getClientKeys(account);
	        }));
	      }
	    }
	  }, {
	    key: 'removeKey',
	    value: function removeKey(account, clientKey) {
	      var _this12 = this;
	
	      if (account) {
	        this.subscriptions.push(this.service.removeClientKey(account, clientKey).subscribe(function () {
	          return _this12.account.clientKeys.splice(_this12.account.clientKeys.indexOf(clientKey), 1);
	        }));
	      };
	    }
	  }, {
	    key: 'getAccountCollectors',
	    value: function getAccountCollectors(account) {
	      var _this13 = this;
	
	      this.subscriptions.push(this.service.getAllCollectors(account.id).subscribe(function (data) {
	        return _this13.account.collectors = data.collectors;
	      }, function (resp) {
	        return console.log(resp);
	      }));
	    }
	  }, {
	    key: 'openAdminAccountModal',
	    value: function openAdminAccountModal() {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'admin-account-form.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "$validation", function controller($scope, $state, $uibModalInstance, $validation) {
	          "ngInject";
	
	          $scope.adminInfo = {};
	          $scope.createAdmin = function () {
	            that.subscriptions.push(that.master.createAdminAccount($scope.adminInfo).subscribe(function (data) {
	              $scope.closeThisDialog();
	            }, function (data) {}));
	          };
	          $scope.closeThisDialog = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'inviteUser',
	    value: function inviteUser() {
	      var _ = this.trans;
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'invite-user-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "$validation", function controller($scope, $state, $uibModalInstance, $validation) {
	          "ngInject";
	
	          $scope.emails = '';
	          $scope.state = $state;
	          $validation.setExpression({
	            multiemail: /^$|^(([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\,(\s)?)?)+$/
	          }).setDefaultMsg({
	            multiemail: {
	              error: _("No es un correo o listado de correos válido")
	            }
	          });
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.inviteUser = function () {
	            that.subscriptions.push(that.content.inviteUser($scope.emails).subscribe(function (resp) {
	              that.notify.success(_('Usuario invitado exitosamente.!'));
	              $scope.state.reload();
	              $scope.closeThisDialog();
	            }, function (error) {
	              console.log(error);
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openAssociationModal',
	    value: function openAssociationModal(aid) {
	      var _this14 = this;
	
	      var _ = this.trans;
	      var that = this;
	      this.subscriptions.push(this.service.getAllCollectors().subscribe(function (data) {
	        var collectors = data.collectors;
	        _this14.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: "collector-association-template.html",
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "$state", "$uibModalInstance", "$validation", function controller($scope, $state, $uibModalInstance, $validation) {
	            "ngInject";
	
	            $scope.collectors = collectors;
	            $scope.collectorChosen = collectors && collectors.length > 0 ? collectors[0].id : {};
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	            $scope.associateCollector = function (cid) {
	              if (!cid) {
	                return;
	              }
	
	              that.subscriptions.push(that.service.associateCollector(cid, aid).subscribe(function (resp) {
	                that.notify.success(_("Colector creado de manera exitosa."));that.account.collectors.push(resp.collector);$scope.closeThisDialog();
	              }, function (resp) {
	                return console.log(resp);
	              }));
	            };
	          }]
	        });
	      }));
	    }
	  }, {
	    key: 'openPointOfSaleCreationModal',
	    value: function openPointOfSaleCreationModal(pointOfSales) {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'point-of-sale-creation-modal.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "$validation", function controller($scope, $state, $uibModalInstance, $validation) {
	          "ngInject";
	
	          $scope.pointOfSales = pointOfSales || {};
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.registerPOS = function () {
	            that.subscriptions.push(that.service.registerPOS($scope.pointOfSales, that.account).subscribe(function (newPos) {
	              that.account.points.push(newPos);
	              $scope.closeThisDialog();
	            }));
	          };
	          $scope.editPOS = function () {
	            that.subscriptions.push(that.service.changePOS($scope.pointOfSales, that.account).subscribe(function () {
	              $scope.closeThisDialog();
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openCollectorsModal',
	    value: function openCollectorsModal(collectors) {
	      var _this15 = this;
	
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'collector-list-template.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "$validation", function controller($scope, $state, $uibModalInstance, $validation) {
	          "ngInject";
	
	          $scope.collectors = collectors;
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.registerCollector = function () {
	            return _this15.subscriptions.push(that.service.registerCollector().subscribe(function (data) {
	              $scope.collectors.push(data.collector);
	            }));
	          };
	          $scope.deleteCollector = function (cid, idx) {
	            return _this15.subscriptions.push(that.service.deleteCollector(cid).subscribe(function (data) {
	              return $scope.collectors.splice(idx, 1);
	            }));
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openAccountCollectorModal',
	    value: function openAccountCollectorModal(collector) {
	      var _ = this.trans;
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'collector-modal.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", function controller($scope, $state, $uibModalInstance) {
	          "ngInject";
	
	          $scope.collector = collector || {};
	
	          $scope.posList = that.account.points.map(function (pos) {
	            if ($scope.collector.hasOwnProperty('pos_list')) {
	              pos.observed = $scope.collector.pos_list.some(function (p) {
	                return p.id === pos.id;
	              });
	            } else {
	              pos.observed = false;
	            }
	            pos.taken = that.account.collectors.filter(function (col) {
	              if ($scope.collector) {
	                return $scope.collector.id != col.id;
	              } else {
	                return true;
	              }
	            }).filter(function (collector) {
	              return collector.pos_list.some(function (point) {
	                return point.id === pos.id;
	              });
	            }).length > 0;
	            return pos;
	          });
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.togglePos = function (pos, index) {
	            // TODO: Remove/Add from the current collector
	            if (pos.observed) {
	              that.subscriptions.push(that.service.observePOS($scope.collector, pos, that.account).subscribe(function (resp) {
	                if (!$scope.collector.pos_list) {
	                  $scope.collector.pos_list = [];
	                };
	                $scope.collector.pos_list.push(pos);
	                that.notify.success(_('El colector estar\xE1 ahora colectando datos del punto seleccionado.'));
	              }));
	            } else {
	              that.subscriptions.push(that.service.unobservePOS($scope.collector, pos, that.account).subscribe(function (resp) {
	                $scope.collector.pos_list.splice($scope.collector.pos_list.indexOf(pos), 1);
	                that.notify.success(collector.name + ' ya no estar\xE1 colectando datos de ' + pos.name + '.');
	              }));
	            }
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'viewCollectorsList',
	    value: function viewCollectorsList() {
	      var that = this;
	      this.subscriptions.push(this.service.getAllCollectors().subscribe(function (data) {
	        that.openCollectorsModal(data.collectors);
	      }));
	    }
	  }, {
	    key: 'registerCollector',
	    value: function registerCollector() {
	      var _this16 = this;
	
	      var _ = this.trans;
	      this.subscriptions.push(this.service.registerCollector().subscribe(function (resp) {
	        _this16.notify.success(_("Colector creado de manera exitosa."));
	      }, function (resp) {}));
	    }
	  }, {
	    key: 'associateCollector',
	    value: function associateCollector(aid, cid) {
	      this.subscriptions.push(this.service.associateCollector(aid, cid).subscribe(function (resp) {
	        console.log(resp);
	      }, function (resp) {}));
	    }
	  }, {
	    key: 'disassociateCollector',
	    value: function disassociateCollector(acc, cid, idx) {
	      this.subscriptions.push(this.service.disassociateCollector(cid, acc.id).subscribe(function (resp) {
	        acc.collectors.splice(idx, 1);
	      }, function (resp) {
	        console.log(resp);
	      }));
	    }
	  }, {
	    key: 'deletePOS',
	    value: function deletePOS(pos, idx) {
	      var _this17 = this;
	
	      this.subscriptions.push(this.service.deletePOS(pos, this.account).subscribe(function (resp) {
	        _this17.account.points.splice(idx, 1);
	      }));
	    }
	  }, {
	    key: 'copySucceed',
	    value: function copySucceed() {
	      var _ = this.trans;
	      this.notify.success(_("El Client Key ha sido copiado al portapapeles"));
	    }
	  }, {
	    key: 'copyFailed',
	    value: function copyFailed(event) {
	      var _ = this.trans;
	      this.notify.warning(_('No ha sido posible copiar el Client Key al portapapeles.'));
	    }
	  }, {
	    key: 'openDTTUploadModal',
	    value: function openDTTUploadModal() {
	      var _this18 = this;
	
	      var _ = this.trans;
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        appendClassName: 'ngdialog-theme-plain',
	        templateUrl: 'dtt-upload-modal.html',
	        controller: ["$scope", "$state", "$uibModalInstance", "FileUploader", "host", "AuthService", "cfpLoadingBar", function controller($scope, $state, $uibModalInstance, FileUploader, host, AuthService, cfpLoadingBar) {
	          "ngInject";
	
	          $scope.inMobileView = that.inMobileView;
	          $scope.displayUploadedList = false;
	          $scope.uploadedFiles = [];
	          $scope.uploadingFiles = false;
	          var fileUploader = $scope.fileUploader = new FileUploader({
	            url: host + '/api/admin/accounts/dtts',
	            headers: {
	              Authorization: 'Bearer ' + AuthService.getToken(),
	              'X-Account-Token': AuthService.getAccountToken()
	            },
	            formData: [{ account_id: that.account.id }]
	          });
	          fileUploader.onSuccessItem = function (item, response, status, headers) {
	            var uploadedItem = {
	              id: response.id,
	              filename: response.filename,
	              filesize: response.filesize,
	              timestamp: that.moment.utc(response.timestamp).tz(_this18.accountService.timezone)
	            };
	            $scope.uploadedFiles.push(uploadedItem);
	            that.account.backups.unshift(uploadedItem);
	          };
	          fileUploader.onErrorItem = function (item, response, status, headers) {
	            that.notify.error(_("Ha ocurrido un error tratando de subir los archivos, intente nuevamente"));
	            console.log("An error happened while uploading file");
	          };
	          fileUploader.onProgressAll = function (progress) {
	            cfpLoadingBar.set(progress / 100);
	          };
	
	          fileUploader.onCompleteAll = function () {
	            $scope.displayUploadedList = true;
	            $scope.uploadingFiles = false;
	            cfpLoadingBar.complete();
	          };
	
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	
	          $scope.uploadDtt = function () {
	            if (fileUploader.queue.length > 0) {
	              fileUploader.uploadAll();
	              cfpLoadingBar.start();
	              $scope.uploadingFiles = true;
	            }
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'openBackupUploadModal',
	    value: function openBackupUploadModal() {
	      var _this19 = this;
	
	      var _ = this.trans;
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        appendClassName: 'ngdialog-theme-plain',
	        templateUrl: 'backup-upload-modal.html',
	        controller: ["$scope", "$state", "$uibModalInstance", "FileUploader", "host", "AuthService", "cfpLoadingBar", function controller($scope, $state, $uibModalInstance, FileUploader, host, AuthService, cfpLoadingBar) {
	          "ngInject";
	
	          $scope.inMobileView = that.inMobileView;
	          $scope.displayUploadedList = false;
	          $scope.uploadedFiles = [];
	          $scope.uploadingFiles = false;
	          var fileUploader = $scope.fileUploader = new FileUploader({
	            url: host + '/api/admin/accounts/backups',
	            headers: {
	              Authorization: 'Bearer ' + AuthService.getToken(),
	              'X-Account-Token': AuthService.getAccountToken()
	            },
	            formData: [{ account_id: that.account.id }]
	          });
	          fileUploader.onSuccessItem = function (item, response, status, headers) {
	            var uploadedItem = {
	              id: response.id,
	              filename: response.filename,
	              filesize: response.filesize,
	              title: response.title,
	              timestamp: that.moment.utc(response.timestamp).tz(_this19.accountService.timezone)
	            };
	            $scope.uploadedFiles.push(uploadedItem);
	            that.account.dtts.unshift(uploadedItem);
	          };
	          fileUploader.onErrorItem = function () {
	            that.notify.error(_("Ha ocurrido un error tratando de subir los archivos, intente nuevamente"));
	          };
	          fileUploader.onProgressAll = function (progress) {
	            cfpLoadingBar.set(progress / 100);
	          };
	
	          fileUploader.onCompleteAll = function (item, response, status, headers) {
	            $scope.displayUploadedList = true;
	            $scope.uploadingFiles = false;
	            cfpLoadingBar.complete();
	          };
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.uploadBackup = function () {
	            if (fileUploader.queue.length > 0) {
	              fileUploader.uploadAll();
	              cfpLoadingBar.start();
	              $scope.uploadingFiles = true;
	            }
	          };
	          $scope.clearQueue = function () {
	            fileUploader.clearQueue();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'processDTTs',
	    value: function processDTTs() {
	      var _this20 = this;
	
	      var _ = this.trans;
	      this.subscriptions.push(this.service.processDTTs(this.account).subscribe(function () {
	        _this20.notify.success(_("DTTs procesados de manera existosa."));
	      }));
	    }
	  }]);
	  return UserControlController;
	}();
	
	exports.default = UserControlController;
	
	
	UserControlController.$inject = ['AdminService', 'Notification', 'MasterService', '$uibModal', 'ContentService', 'moment', '$translate'];

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1165);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./user-control.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./user-control.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".modal-body .account_list,user-control .account_list{padding:0;height:100%}.modal-body .info_account_list h1,user-control .info_account_list h1{text-align:center;margin:0}.modal-body .account_list.media_account.media-body,user-control .account_list.media_account.media-body{overflow-x:hidden;overflow-y:scroll}.modal-body .user_icon_container,user-control .user_icon_container{width:50px;height:50px;border:solid;border-radius:50%;overflow:hidden;font-size:42px;text-align:center;margin:0;padding:0}.modal-body .media_account,user-control .media_account{padding:10px;margin:0 0 10px;border-radius:4px;border:1px solid #ccc}.modal-body .media-body,user-control .media-body{padding:8px 0 0 10px}.modal-body .media-body a,user-control .media-body a{text-decoration:none}.modal-body .media .label,user-control .media .label{padding:5px 10px}.modal-body .dp,user-control .dp{border:10px solid #eee;transition:all .2s ease-in-out}.modal-body .account-id,user-control .account-id{color:#d3d3d3}.modal-body .copy-btn,user-control .copy-btn{padding:12px;border:1px solid #047bf8;color:#047bf8;border-radius:4px}.modal-body .copy-btn,.modal-body .disass-btn,user-control .copy-btn,user-control .disass-btn{line-height:1;display:inline-block;background-color:#fff;margin-right:2px;font-size:14px;margin-bottom:2px;margin-top:2px}.modal-body .disass-btn,user-control .disass-btn{padding:12px 14px;border:1px solid #c9302c;color:#c9302c;border-radius:4px}.modal-body .status_btn,user-control .status_btn{padding:3px 6px;line-height:1;display:inline-block;background-color:#fff;border:1px solid #047bf8;color:#047bf8;margin-right:2px;font-size:14px;border-radius:4px;margin-bottom:2px;margin-top:2px}.modal-body .status_btn.active_status,user-control .status_btn.active_status{border:1px solid #398439;color:#398439}.modal-body .status_btn.inactive_status,user-control .status_btn.inactive_status{border:1px solid #ac2925;color:#ac2925}.modal-body .status_btn.inactivate_btn,user-control .status_btn.inactivate_btn{color:#fff;background-color:#c9302c;border-color:#ac2925}.modal-body .status_btn.activate_btn,user-control .status_btn.activate_btn{color:#fff;background-color:#449d44;border-color:#398439}.modal-body .info_storage,user-control .info_storage{width:90%;height:60px;margin:15px auto;border-top:1px solid #ccc;border-bottom:1px solid #ccc}.modal-body .ph_usercontrol,user-control .ph_usercontrol{margin:60px 0 20px}.modal-body .scroll-area,user-control .scroll-area{height:500px;overflow-y:auto}.modal-body .set-size,user-control .set-size{font-size:10em}.modal-body .charts-container:after,user-control .charts-container:after{clear:both;content:\"\";display:table}.modal-body .pie-wrapper,user-control .pie-wrapper{height:1em;width:1em;float:left;margin:15px;position:relative}.modal-body .pie-wrapper:nth-child(3n+1),user-control .pie-wrapper:nth-child(3n+1){clear:both}.modal-body .pie-wrapper .pie,user-control .pie-wrapper .pie{height:100%;width:100%;clip:rect(0,1em,1em,.5em);left:0;position:absolute;top:0}.modal-body .pie-wrapper .pie .half-circle,user-control .pie-wrapper .pie .half-circle{height:100%;width:100%;border:.1em solid #3498db;border-radius:50%;clip:rect(0,.5em,1em,0);left:0;position:absolute;top:0}.modal-body .pie-wrapper .label,user-control .pie-wrapper .label{background:#34495e;border-radius:50%;bottom:.4em;color:#ecf0f1;cursor:default;display:block;font-size:.25em;left:.4em;line-height:2.6em;position:absolute;right:.4em;text-align:center;top:.5em;font-family:Lato,Tahoma,Geneva,sans-serif}.modal-body .pie-wrapper .label .smaller,user-control .pie-wrapper .label .smaller{color:#bdc3c7;font-size:.45em;padding-bottom:20px;vertical-align:super}.modal-body .pie-wrapper .shadow,user-control .pie-wrapper .shadow{height:100%;width:100%;border:.1em solid #bdc3c7;border-radius:50%}.modal-body .pie-wrapper.style-2 .label,user-control .pie-wrapper.style-2 .label{background:none;color:#7f8c8d}.modal-body .pie-wrapper.style-2 .label .smaller,user-control .pie-wrapper.style-2 .label .smaller{color:#bdc3c7}.modal-body .pie-wrapper.progress-45 .pie .right-side,user-control .pie-wrapper.progress-45 .pie .right-side{display:none}.modal-body .pie-wrapper.progress-45 .pie .half-circle,user-control .pie-wrapper.progress-45 .pie .half-circle{border-color:#1abc9c}.modal-body .pie-wrapper.progress-45 .pie .left-side,user-control .pie-wrapper.progress-45 .pie .left-side{-webkit-transform:rotate(162deg);transform:rotate(162deg)}.modal-body .client-keys-table,user-control .client-keys-table{table-layout:fixed;width:100%;margin-top:5px}.modal-body .client-keys-table td.client-key,user-control .client-keys-table td.client-key{overflow:hidden;text-overflow:ellipsis;border-right:unset;vertical-align:middle}.modal-body .action_btn,user-control .action_btn{line-height:1.5;display:inline-block;background-color:#fff;border:1px solid #047bf8;color:#047bf8;font-size:14px;border-radius:4px}", ""]);
	
	// exports


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _collectors = __webpack_require__(1167);
	
	var _collectors2 = _interopRequireDefault(_collectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectorsModule = _angular2.default.module('Collectors', [_angularjs2.default]).component('collectors', _collectors2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('collectors', {
	    url: '/collectors',
	    data: {
	      authRequired: true,
	      permsRequired: ['view-collectors']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'collectors'
	      }
	    },
	    resolve: {
	      collectorsObservable: ["ContentService", "ProfilePermissionsService", function collectorsObservable(ContentService, ProfilePermissionsService) {
	        return ProfilePermissionsService.hasPermission('view-collectors') ? ContentService.getCollectorsList() : {};
	      }],
	      posObservable: ["ContentService", "ProfilePermissionsService", function posObservable(ContentService, ProfilePermissionsService) {
	        return ProfilePermissionsService.hasPermission('view-pos') ? ContentService.getPOSList() : {};
	      }]
	    }
	  });
	}]).name;
	
	exports.default = CollectorsModule;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _collectors = __webpack_require__(1168);
	
	var _collectors2 = _interopRequireDefault(_collectors);
	
	var _collectors3 = __webpack_require__(1169);
	
	var _collectors4 = _interopRequireDefault(_collectors3);
	
	__webpack_require__(1170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectorsComponent = {
	  bindings: {
	    collectorsObservable: '<',
	    posObservable: '<'
	  },
	  template: _collectors2.default,
	  controller: _collectors4.default
	};
	
	exports.default = CollectorsComponent;

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-8 col-sm-10 col-xs-11\">\n                {{'Colectores' | translate}}\n            </div>\n            <div class=\"col-md-4 text-right\">\n                <div class=\"btn-group\">\n                    <a class=\"btn btn-success btn-sm btn_transitions\" href=\"\" ng-click=\"$ctrl.openCollectorsModal()\" if-perm disable-if=\"register-collectors\">\n                        <span class=\"glyphicon glyphicon-plus\"></span>\n                        <span>{{'Registrar colector' | translate}}</span>\n                    </a>\n                    <a class=\"btn btn-success btn-sm btn_transitions\" href=\"\" ng-click=\"$ctrl.collectAll()\" if-perm disable-if=\"register-collectors,edit-collectors\">\n                        <span><i class=\"fa fa-upload\" aria-hidden=\"true\"></i></span>\n                        <span>{{'Colectar' | translate}}</span>\n                    </a>\n                </div>\n            </div>\n        </div>\n    </h1>\n    <div class=\"card\">\n        <div class=\"card-content\">\n\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t<div class=\"fixed-table-toolbar\">\n                </div>\n            </div>\n            <div class=\"fixed-table-container\">\n                <div class=\"fixed-table-body\">\n                    <table id=\"bootstrap-table\" class=\"table\">\n                        <thead>\n                            <tr>\n                                <th>{{'Nombre' | translate}}</th>\n                                <th>{{'Puntos de venta' | translate}}</th>\n                                <th>{{'Estado' | translate}}</th>\n                                <th>{{'Acciones' | translate}}</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat=\"collector in $ctrl.collectors track by $index\">\n                                <td>{{collector.name}}</td>\n                                <td>{{collector.pos_list.length}}</td>\n                                <td> {{$ctrl.statuses[collector.status]}} </td>\n                                <td>\n\t\t\t\t\t\t\t\t    <div class=\"table-icons\">\n                                        <a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-warning btn-icon\" if-perm disable-if=\"edit-collectors\" ng-click=\"$ctrl.openCollectorsModal(collector)\">\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\" data-original-title=\"{{'Editar' | translate}}\"></i>\n                                        </a>\n                                        <a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-danger btn-icon\" ng-click=\"$ctrl.deleteCollector(collector, $index)\" if-perm disable-if=\"delete-collectors\">\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\" data-original-title=\"{{'Eliminar' | translate}}\" ></i>\n                                        </a>\n                                        <a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-info btn-icon\" ng-if=\"collector.status === 'STOPPED'\" ng-click=\"$ctrl.startCollector(collector, $index)\">\n                                            <i class=\"fa fa-play-circle\" aria-hidden=\"true\"></i>\n                                        </a>\n                                        <a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-info btn-icon\" ng-if=\"collector.status === 'COLLECTING'\" ng-click=\"$ctrl.stopCollector(collector, $index)\">\n                                            <i class=\"fa fa-pause-circle\" aria-hidden=\"true\"></i>\n                                        </a>\n                                        <a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-success btn-icon\" ng-click=\"$ctrl.collect(collector)\">\n                                            <i class=\"fa fa-upload\" aria-hidden=\"true\"></i>\n                                        </a>\n                                    </div>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<script type=\"text/ng-template\" id=\"collector-modal.html\">\n    <div class=\"modal-header\">\n        <div id=\"modal-title\" ng-if=\"!collector.id\">\n            <h3>{{'Nuevo colector' | translate}}</h3>\n        </div>\n        <div id=\"modal-title\" ng-if=\"!!collector.id\">\n            <h3>{{'Editar colector' | translate}}</h3>\n        </div>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n        <form name=\"collectorForm\" novalidate>\n            <div class=\"form-group full-width\" ng-if=\"!!collector.id\">\n                <label for=\"collector-name\">{{'Nombre' | translate}}</label>\n                <input class=\"form-control input_py\" type=\"text\" name=\"collector-name\" value=\"\" ng-model=\"collector.name\">\n            </div>\n            <div class=\"form-group full-width\">\n                <label for=\"collector-key\">{{'Identificador' | translate}}</label>\n                <input class=\"form-control input_py\" type=\"text\" name=\"collector-key\" value=\"\" ng-disabled=\"!!collector.id\" ng-model=\"collector.client_id\">\n            </div>\n            <div class=\"form-group full-width\" ng-if=\"!collector.id\">\n                <label for=\"collector-points\">{{'Puntos de venta' | translate}}</label>\n                <div ng-repeat=\"pos in posList track by $index\">\n                    <div class=\"checkbox_custom\">\n                        <label for=\"pos_{{pos.name}}\">{{pos.name}}</label>\n                        <input type=\"checkbox\" name=\"pos_{{pos.name}}\" ng-model=\"posList[$index].observed\" class=\"pull-right\" ng-disabled=\"pos.taken\">\n                        <div class=\"switch\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-group full-width\" ng-if=\"!!collector.id\">\n                <label for=\"collector-points\">{{'Puntos de venta' | translate}}</label>\n                <div ng-repeat=\"pos in posList track by $index\">\n                    <div class=\"checkbox_custom\">\n                        <label for=\"pos_{{pos.name}}\">{{pos.name}}</label>\n                        <input type=\"checkbox\" name=\"pos_{{pos.name}}\" ng-model=\"posList[$index].observed\" ng-change=\"togglePos(pos, $index)\" class=\"pull-right\" ng-disabled=\"pos.taken\">\n                        <div class=\"switch\"></div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" ng-if=\"!!collector.id\" ng-click=\"editCollector()\">{{'Editar' | translate}}</button>\n\t\t<button type=\"submit\" class=\"btn btn-primary btn_standar\" ng-if=\"!collector.id\" ng-click=\"registerCollector()\">{{'Crear' | translate}}</button>\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n\t</div>\n</script>"

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectorsController = function () {
	  function CollectorsController(ContentService, $uibModal, $state, Notification, $translate) {
	    (0, _classCallCheck3.default)(this, CollectorsController);
	
	    this.service = ContentService;
	    this.modal = $uibModal;
	    this.state = $state;
	    this.notify = Notification;
	    this.trans = $translate.instant;
	  }
	
	  (0, _createClass3.default)(CollectorsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.statuses = {
	        COLLECTING: 'Colectando',
	        STOPPED: 'Detenido'
	      };
	      this.collectors = [];
	      this.posList = [];
	      this.subscriptions.push(this.collectorsObservable.subscribe(function (collectorsList) {
	        return _this.collectors = collectorsList.collectors || [];
	      }));
	      this.subscriptions.push(this.posObservable.subscribe(function (posList) {
	        return _this.posList = posList || [];
	      }));
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'deleteCollector',
	    value: function deleteCollector(collector, idx) {
	      var _this2 = this;
	
	      this.subscriptions.push(this.service.deleteCollector(collector).subscribe(function () {
	        _this2.collectors.splice(idx, 1);
	      }));
	    }
	  }, {
	    key: 'startCollector',
	    value: function startCollector(collector, idx) {
	      var _this3 = this;
	
	      this.subscriptions.push(this.service.startCollector(collector).subscribe(function () {
	        _this3.collectors[idx].status = 'COLLECTING';
	      }));
	    }
	  }, {
	    key: 'stopCollector',
	    value: function stopCollector(collector, idx) {
	      var _this4 = this;
	
	      this.subscriptions.push(this.service.stopCollector(collector).subscribe(function () {
	        _this4.collectors[idx].status = 'STOPPED';
	      }));
	    }
	  }, {
	    key: 'collect',
	    value: function collect(collector) {
	      var _this5 = this;
	
	      var _ = this.trans;
	      this.subscriptions.push(this.service.collect(collector).subscribe(function () {
	        _this5.notify.success(_('Datos colectados de manera exitosa.'));
	      }));
	    }
	  }, {
	    key: 'collectAll',
	    value: function collectAll() {
	      var _this6 = this;
	
	      var _ = this.trans;
	      this.subscriptions.push(this.service.collectAll().subscribe(function () {
	        _this6.notify.success(_('Datos colectados de manera exitosa.'));
	      }));
	    }
	  }, {
	    key: 'openCollectorsModal',
	    value: function openCollectorsModal(collector) {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'collector-modal.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$state", "$uibModalInstance", "$translate", function controller($scope, $state, $uibModalInstance, $translate) {
	          "ngInject";
	
	          var _ = $translate.instant;
	          $scope.collector = collector || {};
	
	          $scope.posList = that.posList.map(function (pos) {
	            if ($scope.collector.hasOwnProperty('pos_list')) {
	              pos.observed = $scope.collector.pos_list.some(function (p) {
	                return p.id === pos.id;
	              });
	            } else {
	              pos.observed = false;
	            }
	            pos.taken = that.collectors.filter(function (col) {
	              if ($scope.collector) {
	                return $scope.collector.id != col.id;
	              } else {
	                return true;
	              }
	            }).filter(function (collector) {
	              return collector.pos_list.some(function (point) {
	                return point.id === pos.id;
	              });
	            }).length > 0;
	            return pos;
	          });
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.registerCollector = function () {
	            $scope.collector.pos_list = $scope.posList.filter(function (pos) {
	              return pos.observed && !pos.taken;
	            }).map(function (pos) {
	              return pos.id;
	            });
	            that.subscriptions.push(that.service.registerCollector($scope.collector).subscribe(function (newCollector) {
	              that.collectors.push(newCollector);
	              $scope.closeThisDialog();
	            }));
	          };
	          $scope.editCollector = function () {
	            that.subscriptions.push(that.service.editCollector($scope.collector).subscribe(function (newCollector) {
	              $scope.closeThisDialog();
	            }));
	          };
	          $scope.togglePos = function (pos, index) {
	            // TODO: Remove/Add from the current collector
	            if (pos.observed) {
	              that.subscriptions.push(that.service.observePOS($scope.collector, pos).subscribe(function (resp) {
	                if (!$scope.collector.pos_list) {
	                  $scope.collector.pos_list = [];
	                };
	                $scope.collector.pos_list.push(pos);
	                that.notify.success(_('El colector estar\xE1 ahora colectando datos del punto de venta seleccionado.'));
	              }));
	            } else {
	              that.subscriptions.push(that.service.unobservePOS(collector, pos).subscribe(function (resp) {
	                $scope.collector.pos_list.splice($scope.collector.pos_list.indexOf(pos), 1);
	                that.notify.success(_(collector.name + ' ya no estar\xE1 colectando datos de ' + pos.name + '.'));
	              }));
	            }
	          };
	        }]
	      });
	    }
	  }]);
	  return CollectorsController;
	}();
	
	exports.default = CollectorsController;
	
	
	CollectorsController.$inject = ['ContentService', '$uibModal', '$state', 'Notification', '$translate'];

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1171);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./collectors.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./collectors.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".Collectors{color:red}", ""]);
	
	// exports


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _collected = __webpack_require__(1173);
	
	var _collected2 = _interopRequireDefault(_collected);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectedModule = _angular2.default.module('Collected', [_angularjs2.default]).component('collected', _collected2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('collected', {
	    url: '/collected',
	    data: {
	      authRequired: true,
	      permsRequired: ['view-journals']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'collected'
	      }
	    },
	    resolve: {
	      collectedObservable: ["ContentService", "ProfilePermissionsService", function collectedObservable(ContentService, ProfilePermissionsService) {
	        return ProfilePermissionsService.hasPermission('view-journals') ? ContentService.getJournalFiles() : {};
	      }]
	    }
	  });
	}]).name;
	
	exports.default = CollectedModule;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _collected = __webpack_require__(1174);
	
	var _collected2 = _interopRequireDefault(_collected);
	
	var _collected3 = __webpack_require__(1175);
	
	var _collected4 = _interopRequireDefault(_collected3);
	
	__webpack_require__(1176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectedComponent = {
	  bindings: {
	    collectedObservable: '<'
	  },
	  template: _collected2.default,
	  controller: _collected4.default
	};
	
	exports.default = CollectedComponent;

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-8\">\n                {{'Journals colectados' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.dtts.length || 0 }}\n                </span>\n            </div>\n            <div class=\"col-md-4 text-right\">\n\t\t\t\t<a class=\"btn btn-success btn-sm\" href=\"\" \n\t\t\t\t\tdata-container=\"[data-ajax_action_container]\" ng-click=\"$ctrl.processNow()\" \n\t\t\t\t\tdata-interaction_type=\"b\" data-ajax_load=\"\" if-perm disable-if=\"process-journals\">\n\t\t\t\t\t<span>{{'Procesar' | translate}}</span>\n\t\t\t\t</a>\n            </div>\n        </div>\n    </h1>\n\t<div class=\"card\">\n\t\t<div class=\"card-content\">\n\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t\t<div class=\"columns columns-right pull-right\">\n\t\t\t\t\t\t<div class=\"keep-open btn-group\" title=\"Columns\">\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-disabled=\"$ctrl.activeTab === 'A'\"\n\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.activeTab='A'; $ctrl.dtts=$ctrl.dttsUnprocessed\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-ban\" aria-hidden=\"true\"></i> {{'No procesado' | translate}}\t\t\t\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"columns pull-right\">\n\t\t\t\t\t\t<div class=\"keep-open btn-group\" title=\"Columns\">\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-disabled=\"$ctrl.activeTab === 'P'\"\n\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.activeTab='P'; $ctrl.dtts=$ctrl.dttsProcessed\"> \n\t\t\t\t\t\t\t\t<i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{'Procesado' | translate}}\t\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar dtts' | translate}}</label>\n\t\t\t\t\t\t</div> \n\t\t\t\t\t</div>\n\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<!--<th class=\"text-center\" data-field=\"id\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">Seleccionar</div>\n\t\t\t\t\t\t\t\t\t</th>-->\n\t\t\t\t\t\t\t\t\t<th class=\"text-left\" data-field=\"id\" ng-click=\"orderedBy = orderedBy === 'filename' ? '-filename' : 'filename'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'filename', 'desc': orderedBy === '-filename'}\">{{'Nombre del archivo' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'timestamp' ? '-timestamp' : 'timestamp'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'timestamp', 'desc': orderedBy === '-timestamp'}\">{{'Subido en' | translate}}</div>\n\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t<th class=\"text-center\" data-field=\"name\" ng-click=\"orderedBy = orderedBy === 'filesize' ? '-filesize' : 'filesize'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner sortable\" ng-class=\"{'asc': orderedBy === 'filesize', 'desc': orderedBy === '-filesize'}\">{{'Tamaño' | translate}}</div>\n                                    </th>\n                                    <!-- <th class=\"text-center\" data-field=\"actions\">\n                                        Acciones\n                                    </th> -->\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr class=\"text-center\" ng-repeat=\"dtt in $ctrl.dtts | orderBy:orderedBy | filter:filterCrit as filtered\">\n\t\t\t\t\t\t\t\t\t<!--<td class=\"bs-checkbox text-left\"><input data-index=\"7\" name=\"btSelectItem\" type=\"checkbox\"></td>-->\n\t\t\t\t\t\t\t\t\t<td data-label=\"Nombre del archivo:\" class=\"text-left\">{{ dtt.filename }}</td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Subido en:\" class=\"text-center\">{{ dtt.timestamp | amDateFormat:'DD/MMM/YYYY HH:mm' }}</td>\n                                    <td data-label=\"Tamaño:\" class=\"text-center\">{{ $ctrl.formatSize(dtt.filesize) }}</td>\n                                    <!-- <td data-label=\"Acciones:\" class=\"text-center\">\n                                        <div class=\"table-icons\">\n                                            <a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-success btn-icon\" ng-click=\"processNow(dtt)\"> \n                                                <i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\n                                            </a>\n                                        </div>\n                                    </td> -->\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\t\t\t\t\t\t\n\t\t\t\t</div>\n            </div>\n        </div>\n        <div class=\"clearfix\"></div>\n\t\t</div>\n\t</div>\n\n</div>"

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectedController = function () {
	  function CollectedController($state, ContentService, Notification, $translate) {
	    (0, _classCallCheck3.default)(this, CollectedController);
	
	    this.state = $state;
	    this.service = ContentService;
	    this.notify = Notification;
	    this.trans = $translate.instant;
	  }
	
	  (0, _createClass3.default)(CollectedController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.dtts = [];
	      this.subscriptions.push(this.collectedObservable.subscribe(function (data) {
	        _this.dtts = data.dtts;
	      }));
	      this.activeTab = 'A';
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'processNow',
	    value: function processNow(dtt) {
	      var _this2 = this;
	
	      this.subscriptions.push(this.service.processJournals().subscribe(function (resp) {
	        return _this2.notify.success(_('Los journals están siendo procesados'));
	      }, function () {
	        return _this2.notify.error(_("Ha ocurrido un error tratando de procesar los journals, intente nuevamente"));
	      }));
	    }
	  }]);
	  return CollectedController;
	}();
	
	exports.default = CollectedController;
	
	
	CollectedController.$inject = ['$state', 'ContentService', 'Notification', '$translate'];

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1177);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./collected.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./collected.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".Collected{color:red}", ""]);
	
	// exports


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _pendingInvitations = __webpack_require__(1179);
	
	var _pendingInvitations2 = _interopRequireDefault(_pendingInvitations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingInvitationsModule = _angular2.default.module('PendingInvitations', [_angularjs2.default]).component('pendingInvitations', _pendingInvitations2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('pendingInvitations', {
	    data: {
	      authRequired: true,
	      paymentExempt: true,
	      permsRequired: []
	    },
	    params: {
	      invitations: null,
	      profiles: null
	    },
	    views: {
	      'menu': "",
	      'content': {
	        component: 'pendingInvitations'
	      }
	    },
	    resolve: {
	      invitations: ["$transition$", function invitations($transition$) {
	        return $transition$.params().invitations || [];
	      }],
	      profiles: ["$transition$", function profiles($transition$) {
	        return $transition$.params().profiles || [];
	      }]
	    }
	  });
	}]).name;
	
	exports.default = PendingInvitationsModule;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pendingInvitations = __webpack_require__(1180);
	
	var _pendingInvitations2 = _interopRequireDefault(_pendingInvitations);
	
	var _pendingInvitations3 = __webpack_require__(1181);
	
	var _pendingInvitations4 = _interopRequireDefault(_pendingInvitations3);
	
	__webpack_require__(1182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingInvitationsComponent = {
	  bindings: {
	    invitations: '<',
	    profiles: '<'
	  },
	  template: _pendingInvitations2.default,
	  controller: _pendingInvitations4.default
	};
	
	exports.default = PendingInvitationsComponent;

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n  <div class=\"wrapper\">\n  </div>\n  <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n    <form class=\"form-signin\" name=\"accountRegistrationForm\" novalidate>\n      <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n      <h3 class=\"form-signin-heading\">\n        {{'Invitaciones pendientes' | translate}}\n      </h3>\n\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"list-group\">\n            <button type=\"button\" class=\"list-group-item clickable\" ng-repeat=\"invitation in $ctrl.invitations track by $index\"\n                ng-click=\"$ctrl.acceptInvitation(invitation, $index)\">\n              {{'De' | translate}} {{ invitation.account_name }}\n            </button>\n          </div>\n        </div>\n      </div>\n\n\n      <p class=\"create-account pull-left\" ng-if=\"$ctrl.profiles.length > 0\">\n        <a ui-sref=\"profileSelection({profiles: $ctrl.profiles, invitations: $ctrl.invitations})\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i> {{'Seleccionar Compañia' | translate}}</a>\n      </p>\n      <p class=\"create-account pull-left\" ng-if=\"$ctrl.profiles.length == 0\">\n        <a ui-sref=\"accountRegistration({profiles: $ctrl.profiles, invitations: $ctrl.invitations})\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> {{Crear Compañía | translate}}</a>\n      </p>\n      <p class=\"create-account\">\n        <a ng-click=\"$ctrl.logout()\"><i class=\"fa fa-power-off\" aria-hidden=\"true\"></i> {{'Cerrar Sesión' | translate}}</a>\n      </p>\n    </form>\n  </div>\n</body>\n"

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingInvitationsController = function () {
	  function PendingInvitationsController(AuthService, $state, ContentService, ProfilePermissionsService) {
	    (0, _classCallCheck3.default)(this, PendingInvitationsController);
	
	    this.service = ContentService;
	    this.state = $state;
	    this.authService = AuthService;
	    this.permissionsService = ProfilePermissionsService;
	  }
	
	  (0, _createClass3.default)(PendingInvitationsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'acceptInvitation',
	    value: function acceptInvitation(invitation, idx) {
	      var _this = this;
	
	      this.subscriptions.push(this.service.acceptInvitation({ invitation: invitation }).subscribe(function (resp) {
	        _this.invitations.splice(idx, 1);
	        _this.state.go('profileSelection', { invitations: _this.invitations });
	      }, function (resp) {}));
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      this.subscriptions.push(this.authService.logout().subscribe(function (data) {
	        return _this2.state.go('login');
	      }, function (error) {}));
	    }
	  }]);
	  return PendingInvitationsController;
	}();
	
	exports.default = PendingInvitationsController;
	
	
	PendingInvitationsController.$inject = ['AuthService', '$state', 'ContentService', 'ProfilePermissionsService'];

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1183);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pending-invitations.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pending-invitations.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".PendingInvitations{color:red}", ""]);
	
	// exports


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _billPaymentOnly = __webpack_require__(1185);
	
	var _billPaymentOnly2 = _interopRequireDefault(_billPaymentOnly);
	
	var _content = __webpack_require__(1095);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BillPaymentOnlyModule = _angular2.default.module('BillPaymentOnly', [_angularjs2.default]).component('billpaymentonly', _billPaymentOnly2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('paymentOnly', {
	    url: '/payment-only',
	    data: {
	      authRequired: true
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'billpaymentonly'
	      }
	    }
	  });
	}]).name;
	
	exports.default = BillPaymentOnlyModule;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _billPaymentOnly = __webpack_require__(1186);
	
	var _billPaymentOnly2 = _interopRequireDefault(_billPaymentOnly);
	
	var _billPaymentOnly3 = __webpack_require__(1187);
	
	var _billPaymentOnly4 = _interopRequireDefault(_billPaymentOnly3);
	
	__webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BillPaymentOnlyComponent = {
	  bindings: {},
	  template: _billPaymentOnly2.default,
	  controller: _billPaymentOnly4.default
	};
	
	exports.default = BillPaymentOnlyComponent;

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{'Facturas de pago único' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.rows.length || 0 }}\n                </span>\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form class=\"hidden-xs\">\n            <div  class=\"form col-md-12 no-padding\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>    \n                    <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" today=\"true\" value=\"\" id=\"from\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\" readonly>\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>    \n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" today=\"true\" value=\"\" id=\"to\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\" readonly>       \n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findReport()\">{{'Buscar' | translate}}</button>    \n                    </span>\n                </div>\n            </div>\n        </form>\n        <form class=\"visible-xs\">\n            <div class=\"form_xs\">\n                <div class=\"col-xs-6 form-group no_padding_left\">\n                <p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n                  <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" today=\"true\" value=\"\" id=\"from\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\" readonly>\n                </div>\n                <div class=\"col-xs-6 form-group no_padding_right\">\n                    <p class=\"label_m\" for=\"desde\">{{'Hasta' | translate}}</p>\n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" today=\"true\" value=\"\" id=\"to\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\" readonly>   \n                </div>\n\n                <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findReport()\">{{'Buscar' | translate}}</button>\n            </div>\n        </form>\n    </div>\n    <div class=\"col-md-12 table_container no_padding\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <div class=\"fixed-table-toolbar\">\n                        <div class=\"search col-md-4\">\n                            <div class=\"field\">\n                                <input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n                                <label for=\"input-search\">{{'Filtrar búsqueda' | translate}}</label>\n                            </div> \n                        </div>\n                    </div>\n                    <div class=\"fixed-table-container\">\n                        <table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n                            <thead>\n                                <tr>\n                                    <th sort=\"$ctrl.orderedBy\" sort-by=\"billid\">{{'Número de factura' | translate}}</th>\n                                    <th sort=\"$ctrl.orderedBy\" sort-by=\"date\">{{'Fecha' | translate}}</th>\n                                    <th sort=\"$ctrl.orderedBy\" sort-by=\"pax\">{{'Pax' | translate}}</th>\n                                    <th sort=\"$ctrl.orderedBy\" sort-by=\"discount\">{{'Desc.' | translate}}</th>\n                                    <th sort=\"$ctrl.orderedBy\" sort-by=\"total\">{{'Total' | translate}}</th>\n                                    <th sort=\"$ctrl.orderedBy\" sort-by=\"tax10\">{{'% Ley' | translate}}</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr class=\"text-center clickable\" ng-click=\"$ctrl.openBillDetails(row.id)\" if-perm disable-if=\"account-bills, invoice-orders\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\">\n                                    <td data-label=\"{{'Número de factura' | translate}}:\"> {{row.billid}} </td>\n                                    <td data-label=\"{{'Fecha' | translate}}:\" class=\"text-center\"> {{row.date |  amUtc | amDateFormat:'LLL'}} </td>\n                                    <td data-label=\"{{'Pax' | translate}}:\" class=\"text-center\"> {{row.pax}} </td>\n                                    <td data-label=\"{{'Desc.' | translate}}:\" class=\"text-right\"> {{row.discount | currency }} </td>\n                                    <td data-label=\"{{'Total' | translate}}:\" class=\"text-right\"> {{row.total | currency }} </td>\n                                    <td data-label=\"{{'% Ley' | translate}}:\" class=\"text-right\"> {{row.tax10 | currency }} </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<script type='text/ng-template' id=\"invoice-details-template.html\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" id=\"modal-title\">\n                {{'Detalle de Factura' | translate}}\n                <a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n        </h3>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n    <nav>\n        <ul class=\"Tabs\">\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: !showOrders}\" ng-click=\"showOrders=false\"\n                if-perm disable-if=\"account-bills\">\n                            <a href=\"#\">{{'Factura' | translate}}</a>\n                        </li>\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: showOrders}\" ng-click=\"getOrders(); showOrders=true\"\n                if-perm disable-if=\"invoice-orders\">\n                            <a href=\"#\">{{'Órdenes' | translate}}</a>\n                        </li>\n            <li class=\"Tabs__tab Tab\">\n                <button class=\"btn btn-default pull-right\" ng-click=\"printToCart('printSectionId')\">\n                    <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                </button>\n            </li>\n            <li class=\"Tabs__presentation-slider\" role=\"presentation\"></li>\n        </ul>\n    </nav>\n<!-- start print -->\n        <div id=\"printSectionId\" class=\"Section_Print\">\n            <div class=\"Powered\">\n                <span>{{'RNC' | translate}}: </span>{{account.identification || '-'}} <br>\n                <span>{{'Dirección' | translate}}: </span>{{ account.address || '-'}} <br>\n                <span>{{'Teléfono' | translate}}: </span>{{ account.phone || '-'}}\n            </div>\n            <div class=\"logo_invoice\">\n                <img src=\"{{ logoUrl }}\" alt=\"\">\n            </div>\n            <div class=\"print_separator\"></div>\n            <div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n            <table class=\"table table-condensed tableforprint\">\n                \n                <tr>\n                    <td>\n                        <strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n                    </td>\n                    <td class=\"text-right\">\n                        <strong>{{'Fecha' | translate}}:</strong> <span>{{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise  }}</span>\n                    </td>\n                </tr>\n                <tr>\n                    <td>\n                        <strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n                    </td>\n                </tr>\n                <tr>\n                    <td>\n                        {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n                    </td>\n                </tr>\n                <tr>\n                    <td>\n                        {{'RNC' | translate}} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n                    </td>\n                </tr>\n                <!-- <tr>\n                    <td \"3\">\n                        <strong>Mesa No.:</strong> {{ invoice.table }}\n                    </td>\n                    <td \"3\">\n                        <strong>Atendida por:</strong> {{ invoice.cashier || '-' }}\n                    </td>\n                    <td \"3\">\n                        <strong>Pax:</strong> {{ invoice.pax }}\n                    </td>\n                </tr> -->\n                \n                <tr><td><hr></td></tr>\n                <tr>\n                    <th class=\"text-center\" \"3\">{{'Detalles' | translate}}</th>\n                    <th class=\"text-center\">{{'Cantidad' | translate}}</th>\n                    <th class=\"text-center\">{{'Descuento' | translate}}</th>\n                    <th class=\"text-center\">{{'Total' | translate}}</th>\n                    \n                </tr>\n                <tr ng-repeat=\"detail in invoice.details\">\n                    <td class=\"text-center\" \"3\">{{ detail.description || '-' }}</td>\n                    <td class=\"text-center\">{{ detail.quantity || 0 }}</td>\n                    <td class=\"text-center\">{{ detail.discount | currency }}</td>\n                    <td class=\"text-center\">{{ detail.total | currency }}</td>\n                </tr>\n                <tr><td colspan=\"6\"><hr></td></tr>\n                <tr>\n                    <td>\n                        <strong>{{'Notas' | translate}}:</strong>\n                    </td>\n                    <td>\n                        <span></span> \n                    </td>\n                    <td class=\"text-center\">\n                        <span>{{'Subtotal' | translate}}</span> \n                    </td>\n                    <td class=\"text-center\">\n                        <span>0.000</span>\n                    </td>\n                </tr>\n                <tr>\n                    <td>\n                        {{'Comensales' | translate}}: <span>{{ invoice.pax }}</span> \n                    </td>\n                    <td>\n                        <span></span> \n                    </td>\n                    <td class=\"text-center\">\n                        <span>{{'Descuento' | translate}}</span> \n                    </td>\n                    <td class=\"text-center\">\n                        <span>{{ invoice.discount | currency }}</span>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"2\">\n                        <span>{{'Atendido por' | translate}}: </span>\n                        <span>{{ invoice.cashier || '-' }}</span>\n                    </td>\n                    <td class=\"text-center\">\n                        <span>{{'% Ley' | translate}}:</span> \n                    </td>\n                    <td class=\"text-center\">\n                        <span>{{ invoice.tax10 | currency }}</span>\n                    </td>\n                </tr>\n                <tr class=\"text-center\">\n                    <td>\n                        <span></span> \n                    </td>\n                    <td>\n                        <span></span> \n                    </td>\n                    <td>\n                        <span>{{'IVA' | translate}}:</span> {{ invoice.tax16 | currency }}\n                    </td>\n                    <td>\n                        <span>{{ invoice.tax10 | currency }}</span>\n                    </td>\n                </tr>\n                <tr class=\"text-center\">\n                    <td>\n                        <span></span> \n                    </td>\n                    <td>\n                        <span></span> \n                    </td>\n                    <td>\n                        <span>{{'Exoneración IVA' | translate}}:</span>\n                    </td>\n                    <td>\n                        <span>0.000</span>\n                    </td>\n                </tr>\n                <tr class=\"text-center\">\n                    <td>\n                        <span></span> \n                    </td>\n                    <td>\n                        <span></span> \n                    </td>\n                    <td>\n                        <strong>{{'Total' | translate}}:</strong>\n                    </td>\n                    <td>\n                        <strong>{{ invoice.total | currency }}</strong>\n                    </td>\n                    <!-- <td \"3\">\n                        <strong>Impuestos incluidos:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n                    </td> -->\n                </tr>\n            </table>\n        </div>\n        </div>\n<!-- end print -->\n        <div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n            <table class=\"table table-bordered table-condensed\">\n                <tr>\n                    <td colspan=\"3\">\n                        <strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n                    </td>\n                    <td colspan=\"3\">\n                        <strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"3\">\n                        <strong>{{'Fecha' | translate}}:</strong> {{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise  }}\n                    </td>\n                    <td colspan=\"3\">\n                        <strong>{{'Emitido a' | translate}}:</strong> {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"3\">\n                        <strong>{{'Mesa No.' | translate}}:</strong> {{ invoice.table }}\n                    </td>\n                    <td colspan=\"3\">\n                        <strong>{{'Atendida por' | translate}}:</strong> {{ invoice.cashier || '-' }}\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"3\">\n                        <strong>{{'Desc.' | translate}}:</strong> {{ invoice.discount | currency }}\n                    </td>\n                    <td colspan=\"3\">\n                        <strong>{{'Pax' | translate}}:</strong> {{ invoice.pax }}\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"3\">\n                        <strong>{{'Total' | translate}}:</strong> {{ invoice.total | currency }}\n                    </td>\n                    <td colspan=\"3\">\n                        <strong>{{'Impuestos incluidos' | translate}}:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"3\">\n                        <strong>{{'IVA' | translate}}:</strong> {{ invoice.tax16 | currency }}\n                    </td>\n                    <td colspan=\"3\">\n                        <strong>{{'% Ley' | translate}}:</strong> {{ invoice.tax10 | currency }}\n                    </td>\n                </tr>\n                <tr><td colspan=\"6\"></td></tr>\n                <tr>\n                    <th colspan=\"3\">{{'Detalles' | translate}}</th>\n                    <th>{{'Cantidad' | translate}}</th>\n                    <th>{{'Total' | translate}}</th>\n                    <th>{{'Desc.' | translate}}</th>\n                </tr>\n                <tr ng-repeat=\"detail in invoice.details\">\n                    <td colspan=\"3\">{{ detail.description || '-' }}</td>\n                    <td class=\"text-right\">{{ detail.quantity || 0 }}</td>\n                    <td class=\"text-right\">{{ detail.total | currency }}</td>\n                    <td class=\"text-right\">{{ detail.discount | currency }}</td>\n                </tr>\n            </table>\n        </div>\n\n        <div class=\"orders\" ng-show=\"showOrders\">\n            <table id=\"pruena\" class=\"table table-bordered table-condensed\">\n                <thead>\n                    <tr>\n                        <th>{{'Factura' | translate}}</th>\n                        <th>{{'Acción' | translate}}</th>\n                        <th>{{'Fecha' | translate}}</th>\n                        <th>{{'Vendedor' | translate}}</th>\n                        <th>{{'Estado' | translate}}</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr ng-repeat=\"order in orders\">\n                        <td data-label=\"Factura\">\n                            <a href=\"\" data-ajax_load=\"\" data-container=\"#billpayment\" class=\"btn btn-xs btn-primary\"\n                                ng-click=\"fetchDetails(order)\">\n                                {{ order.id }}\n                            </a>\n                        </td>\n                        <td data-label=\"{{'Acción' | translate}}\">{{ order.action || '-' }}</td>\n                        <td data-label=\"{{'Fecha' | translate}}\">{{ order.date | amUtc | amDateFormat:'LLLL' | capitalise }}</td>\n                        <td data-label=\"{{'Vendedor' | translate}}\">{{ order.cashier || '-' }}</td>\n                        <td data-label=\"{{'Estado' | translate}}\">{{ order.status || '-' }}</td>\n                    </tr>\n                </tbody>\n            </table>\n\n            <table class=\"table table-bordered table-condensed\" ng-show=\"displayingOrder\">\n                <tbody>\n                    <tr><td colspan=\"4\">{{ displayingOrder.action || '-' }}</td></tr>\n                    <tr class=\"table_list_heading\">\n                        <th class=\"detail_table hidden-xs hidden-sm\" width=\"100\"><b>{{'De la Factura' | translate}}</b></th>\n                        <td data-label=\"{{'De la Factura' | translate}}:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.billid || '-' }}</td>\n                        <th class=\" hidden-xs hidden-sm\" width=\"100\"><b>{{'Fecha' | translate}}</b></th>\n                        <td data-label=\"{{'Fecha' | translate}}:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.date | amUtc | amDateFormat:'LLLL' | capitalise }}</td>\n                    </tr>\n                    <tr>\n                        <th class=\"hidden-xs hidden-sm\"><b>{{'Vendedor' | translate}}:</b></th>\n                        <td data-label=\"{{'Vendedor' | translate}}:\">{{ displayingOrder.cashier || '-' }}</td>\n                        <th class=\"hidden-xs hidden-sm\"><b>{{'Mesa' | translate}}:</b></th>\n                        <td data-label=\"{{'Mesa' | translate}}:\" colspan=\"2\">{{ displayingOrder.table_type || '-' }} {{ displayingOrder.table_code || '' }}</td>\n                    </tr>\n\n                    <tr class=\"table_graund\" ng-repeat=\"detail in displayingOrder.details\">\n                        <td colspan=\"2\">{{ detail.name  || '-' }}</td>\n                        <td colspan=\"2\">{{ detail.qty  || 0 }}</td>\n                    </tr>\n                </tbody>\n            </table>\n\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">\n            {{'Salir' | translate}}\n        </button>\n    </div>\n</script>"

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BillPaymentOnlyController = function () {
	  function BillPaymentOnlyController($state, ContentService, $uibModal, ProfilePermissionsService, moment, isMobile) {
	    (0, _classCallCheck3.default)(this, BillPaymentOnlyController);
	
	    this.state = $state;
	    this.service = ContentService;
	    this.modal = $uibModal;
	    this.permissionsService = ProfilePermissionsService;
	    this.moment = moment;
	    this.isMobile = isMobile;
	  }
	
	  (0, _createClass3.default)(BillPaymentOnlyController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	      this.dateFrom = undefined;
	      this.dateTo = undefined;
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'findReport',
	    value: function findReport() {
	      var _this = this;
	
	      this.subscriptions.push(this.service.getPaymentOnlyBills({
	        date_from: this.dateFrom.toISOString(),
	        date_to: this.dateTo.toISOString()
	      }).subscribe(function (data) {
	        return _this.rows = data.bills;
	      }));
	    }
	  }, {
	    key: 'openBillDetails',
	    value: function openBillDetails(invoiceId) {
	      var that = this;
	      if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')) {
	        this.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'invoice-details-template.html',
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "$uibModalInstance", "AccountInformationService", function controller($scope, $uibModalInstance, AccountInformationService) {
	            "ngInject";
	
	            $scope.invoice = {};
	            $scope.orders = [];
	            $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
	
	            that.subscriptions.push(that.service.getInvoice(invoiceId).subscribe(function (invoice) {
	              return $scope.invoice = invoice;
	            }, function (error) {
	              return console.log("Error while getting the invoice");
	            }));
	
	            that.subscriptions.push(AccountInformationService.getAccountInfo().subscribe(function (resp) {
	              $scope.account = resp;
	            }));
	
	            $scope.getOrders = function () {
	              if ($scope.orders.length <= 0) {
	                that.subscriptions.push(that.service.getOrders(invoiceId).subscribe(function (orders) {
	                  return $scope.orders = orders;
	                }, function (error) {
	                  return console.log("Error while getting the orders");
	                }));
	              }
	            };
	            $scope.fetchDetails = function (order) {
	              if (!order.details || order.details.length <= 0) {
	                that.subscriptions.push(that.service.getOrderDetails(invoiceId, order.id).subscribe(function (details) {
	                  order.details = details;
	                  $scope.displayingOrder = order;
	                }, function (error) {
	                  return console.log("Error while getting the details for this order");
	                }));
	              }
	            };
	
	            $scope.printToCart = function (printSectionId) {
	              var innerContents = document.getElementById(printSectionId).innerHTML;
	              var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	              popupWinindow.document.open();
	              var styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              var styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              popupWinindow.document.write('<html><head><title>Imprimir factura #' + $scope.invoice.number + '</title><style>' + styleprint.innerHTML + '</style><style>' + styleprintBootstrap.innerHTML + '</style></head><body onload="window.print()">' + innerContents + '</html>');
	              popupWinindow.document.close();
	            };
	
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	          }]
	        });
	      }
	    }
	  }]);
	  return BillPaymentOnlyController;
	}();
	
	exports.default = BillPaymentOnlyController;
	
	
	BillPaymentOnlyController.$inject = ['$state', 'ContentService', '$uibModal', 'ProfilePermissionsService', 'moment', 'isMobile'];

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1189);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./bill-payment-only.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./bill-payment-only.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".BillPaymentOnly{color:red}", ""]);
	
	// exports


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _printedUnclosed = __webpack_require__(1191);
	
	var _printedUnclosed2 = _interopRequireDefault(_printedUnclosed);
	
	var _content = __webpack_require__(1095);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _profilePermissions = __webpack_require__(1196);
	
	var _profilePermissions2 = _interopRequireDefault(_profilePermissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintedUnclosedModule = _angular2.default.module('PrintedUnclosed', [_angularjs2.default]).component('printedunclosed', _printedUnclosed2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('printedUnclosed', {
	    url: '/printed-unclosed',
	    data: {
	      authRequired: true
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'printedunclosed'
	      }
	    }
	  });
	}]).name;
	
	exports.default = PrintedUnclosedModule;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _printedUnclosed = __webpack_require__(1192);
	
	var _printedUnclosed2 = _interopRequireDefault(_printedUnclosed);
	
	var _printedUnclosed3 = __webpack_require__(1193);
	
	var _printedUnclosed4 = _interopRequireDefault(_printedUnclosed3);
	
	__webpack_require__(1194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintedUnclosedComponent = {
	  bindings: {},
	  template: _printedUnclosed2.default,
	  controller: _printedUnclosed4.default
	};
	
	exports.default = PrintedUnclosedComponent;

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{'Facturas sin cerrar' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{$ctrl.rows.length || 0}}\n                </span>\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form class=\"hidden-xs\">\n            <div  class=\"form col-md-12 no-padding\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>    \n                    <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" today=\"true\" value=\"\" id=\"from\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\" readonly>\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>    \n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" today=\"true\" value=\"\" id=\"to\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\" readonly>       \n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findReport()\">{{'Buscar' | translate}}</button>\n                    </span>\n                </div>\n            </div>\n        </form>\n        <form class=\"visible-xs\">\n            <div class=\"form_xs\">\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_left\">\n\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n\t\t\t\t  <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" today=\"true\" value=\"\" id=\"from\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\" readonly>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-6 form-group no_padding_right\">\n\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Hasta' | translate}}</p>\n\t\t\t\t\t<input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" today=\"true\" value=\"\" id=\"to\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\" readonly>    \n\t\t\t\t</div>\n\n\t\t\t\t<button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findReport()\">Buscar</button>\n            </div>\n        </form>\n    </div>\n    <div class=\"col-md-12 table_container no_padding\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n\t\t\t\t\t<div class=\"fixed-table-toolbar\">\n                        <div class=\"search col-md-4\">\n                            <div class=\"field\">\n                                <input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n                                <label for=\"input-search\">{{'Filtrar búsqueda' | translate}}</label>\n                            </div> \n                        </div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"fixed-table-container\">\n\t\t\t\t\t\t<table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t<th sort=\"$ctrl.orderedBy\" sort-by=\"billid\">{{'Número de factura' | translate}}</th>\n\t\t\t\t\t\t\t\t<th sort=\"$ctrl.orderedBy\" sort-by=\"date\">{{'Fecha' | translate}}</th>\n\t\t\t\t\t\t\t\t<th sort=\"$ctrl.orderedBy\" sort-by=\"pax\">{{'Pax' | translate}}</th>\n\t\t\t\t\t\t\t\t<th sort=\"$ctrl.orderedBy\" sort-by=\"discount\">{{'Desc.' | translate}}</th>\n\t\t\t\t\t\t\t\t<th sort=\"$ctrl.orderedBy\" sort-by=\"total\">{{'Total' | translate}}</th>\n\t\t\t\t\t\t\t\t<th sort=\"$ctrl.orderedBy\" sort-by=\"tax10\">{{'% Ley' | translate}}</th>\n\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr class=\"text-center clickable\" ng-click=\"$ctrl.openBillDetails(row.id)\" if-perm disable-if=\"account-bills, invoice-orders\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\">\n\t\t\t\t\t\t\t\t\t<td data-label=\"Número de factura:\" > {{row.billid}} </td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"text-center\"> {{row.date | amUtc | amDateFormat:'LLL'}} </td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Pax:\" class=\"text-center\"> {{ row.pax }} </td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Desc.:\" class=\"text-right\"> {{row.discount | currency }} </td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"Total:\" class=\"text-right\"> {{ row.total | currency }} </td>\n\t\t\t\t\t\t\t\t\t<td data-label=\"% Ley:\" class=\"text-right\"> {{ row.tax10 | currency }} </td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<script type='text/ng-template' id=\"invoice-details-template.html\">\n\t<div class=\"modal-header\">\n    \t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t\t{{'Detalle de Factura' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    \t</h3>\n  \t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n    <nav>\n        <ul class=\"Tabs\">\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: !showOrders}\" ng-click=\"showOrders=false\"\n\t\t\t\tif-perm disable-if=\"account-bills\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Factura' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: showOrders}\" ng-click=\"getOrders(); showOrders=true\"\n\t\t\t\tif-perm disable-if=\"invoice-orders\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Órdenes' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\">\n                <button class=\"btn btn-default pull-right\" ng-click=\"printToCart('printSectionId')\">\n                    <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                </button>\n            </li>\n            <li class=\"Tabs__presentation-slider\" role=\"presentation\"></li>\n        </ul>\n    </nav>\n\n<!-- start print -->\n\t\t<div id=\"printSectionId\" class=\"Section_Print\">\n\t\t\t<div class=\"Powered\">\n\t\t\t\t<span>{{'RNC' | translate}}: </span>{{account.identification || '-'}} <br>\n\t\t\t\t<span>{{'Dirección' | translate}}: </span>{{ account.address || '-'}} <br>\n\t\t\t\t<span>{{'Telefono' | translate}}: </span>{{ account.phone || '-'}}\n\t\t\t</div>\n\t\t\t<div class=\"logo_invoice\">\n\t\t\t\t<img src=\"{{ logoUrl }}\" alt=\"\">\n\t\t\t</div>\n\t\t\t<div class=\"print_separator\"></div>\n\t\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-condensed tableforprint\">\n\t\t\t\t\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-right\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong> <span>{{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise  }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{'RNC' | translate}} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<!-- <tr>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Mesa No.:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Atendida por:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Pax:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr> -->\n\t\t\t\t\n\t\t\t\t<tr><td><hr></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th class=\"text-center\" \"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Descuento' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Total' | translate}}</th>\n\t\t\t\t\t\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td class=\"text-center\" \"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.discount | currency }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.total | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"><hr></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'Notas' | translate}}:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'Subtotal' | translate}}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{'Comensales' | translate}}: <span>{{ invoice.pax }}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'Descuento' | translate}}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.discount | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"2\">\n\t\t\t\t\t\t<span>{{'Atendido por' | translate}}: </span>\n\t\t\t\t\t\t<span>{{ invoice.cashier || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'% Ley' | translate}}:</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{'IVA' | translate}}:</span> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{'Exoneracion IVA' | translate}}:</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{ invoice.total | currency }}</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<!-- <td \"3\">\n\t\t\t\t\t\t<strong>Impuestos incluidos:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td> -->\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\t\t</div>\n<!-- end print -->\n\n\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-bordered table-condensed\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong> {{ invoice.date | amUtc | amDateFormat:'DD/MMM/YYYY'  }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Emitido a' | translate}}:</strong> {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Mesa No.' | translate}}:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Atendida por' | translate}}:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Desc.' | translate}}:</strong> {{ invoice.discount | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Pax' | translate}}:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong> {{ invoice.total | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Impuestos incluidos' | translate}}:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'IVA' | translate}}:</strong> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'% Ley' | translate}}:</strong> {{ invoice.tax10 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th colspan=\"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th>{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th>{{'Total' | translate}}</th>\n\t\t\t\t\t<th>{{'Desc.' | translate}}</th>\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td colspan=\"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.total | currency }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.discount | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=\"orders\" ng-show=\"showOrders\">\n\t\t\t<table id=\"pruena\" class=\"table table-bordered table-condensed\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>{{'Factura' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Acción' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Fecha' | translate }}</th>\n\t\t\t\t\t\t<th>{{'Vendedor' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Estado' | translate}}</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat=\"order in orders\">\n\t\t\t\t\t\t<td data-label=\"Factura\">\n\t\t\t\t\t\t\t<a href=\"\" data-ajax_load=\"\" data-container=\"#billpayment\" class=\"btn btn-xs btn-primary\"\n\t\t\t\t\t\t\t\tng-click=\"fetchDetails(order)\">\n\t\t\t\t\t\t\t\t{{ order.id }}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td data-label=\"Acción\">{{ order.action || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Fecha\">{{ order.date | amUtc | amDateFormat:'DD/MMM/YYYY' }}</td>\n\t\t\t\t\t\t<td data-label=\"Vendedor\">{{ order.cashier || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Estado\">{{ order.status || '-' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t\t<table class=\"table table-bordered table-condensed\" ng-show=\"displayingOrder\">\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr><td colspan=\"4\">{{ displayingOrder.action || '-' }}</td></tr>\n\t\t\t\t\t<tr class=\"table_list_heading\">\n\t\t\t\t\t\t<th class=\"detail_table hidden-xs hidden-sm\" width=\"100\"><b>{{'De la Factura' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"De la Factura:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.billid || '-' }}</td>\n\t\t\t\t\t\t<th class=\" hidden-xs hidden-sm\" width=\"100\"><b>{{'Fecha' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.date | amUtc | amDateFormat:'LLL' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>{{'Vendedor' | translate}}:</b></th>\n\t\t\t\t\t\t<td data-label=\"Vendedor:\">{{ displayingOrder.cashier || '-' }}</td>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>Mesa:</b></th>\n\t\t\t\t\t\t<td data-label=\"Mesa:\" colspan=\"2\">{{ displayingOrder.table_type || '-' }} {{ displayingOrder.table_code || '' }}</td>\n\t\t\t\t\t</tr>\n\n\t\t\t\t\t<tr class=\"table_graund\" ng-repeat=\"detail in displayingOrder.details\">\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.name  || '-' }}</td>\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.qty  || 0 }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">\n\t\t\t{{'Salir' | translate}}\n\t\t</button>\n\t</div>\n</script>\n"

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintedUnclosedController = function () {
	  function PrintedUnclosedController($state, ContentService, $uibModal, ProfilePermissionsService, moment, isMobile) {
	    (0, _classCallCheck3.default)(this, PrintedUnclosedController);
	
	    this.state = $state;
	    this.service = ContentService;
	    this.modal = $uibModal;
	    this.permissionsService = ProfilePermissionsService;
	    this.moment = moment;
	    this.isMobile = isMobile;
	  }
	
	  (0, _createClass3.default)(PrintedUnclosedController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.inMobileView = this.isMobile.phone;
	      this.dateFrom = undefined;
	      this.dateTo = undefined;
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'findReport',
	    value: function findReport() {
	      var _this = this;
	
	      this.subscriptions.push(this.service.getPrintedUnclosed({
	        date_from: this.dateFrom.toISOString(),
	        date_to: this.dateTo.toISOString()
	      }).subscribe(function (data) {
	        return _this.rows = data.unclosed;
	      }));
	    }
	  }, {
	    key: 'openBillDetails',
	    value: function openBillDetails(invoiceId) {
	      var that = this;
	      if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')) {
	        this.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'invoice-details-template.html',
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "$uibModalInstance", "AccountInformationService", function controller($scope, $uibModalInstance, AccountInformationService) {
	            "ngInject";
	
	            that.subscriptions.push(AccountInformationService.getAccountInfo().subscribe(function (resp) {
	              $scope.account = resp;
	            }));
	
	            $scope.invoice = {};
	            $scope.orders = [];
	            $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
	
	            that.subscriptions.push(that.service.getInvoice(invoiceId).subscribe(function (invoice) {
	              return $scope.invoice = invoice;
	            }, function (error) {
	              return console.log("Error while getting the invoice");
	            }));
	
	            $scope.getOrders = function () {
	              if ($scope.orders.length <= 0) {
	                that.subscriptions.push(that.service.getOrders(invoiceId).subscribe(function (orders) {
	                  return $scope.orders = orders;
	                }, function (error) {
	                  return console.log("Error while getting the orders");
	                }));
	              }
	            };
	            $scope.fetchDetails = function (order) {
	              if (!order.details || order.details.length <= 0) {
	                that.subscriptions.push(that.service.getOrderDetails(invoiceId, order.id).subscribe(function (details) {
	                  order.details = details;
	                  $scope.displayingOrder = order;
	                }, function (error) {
	                  return console.log("Error while getting the details for this order");
	                }));
	              }
	            };
	
	            $scope.printToCart = function (printSectionId) {
	              var innerContents = document.getElementById(printSectionId).innerHTML;
	              var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	              popupWinindow.document.open();
	              var styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              var styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              popupWinindow.document.write('<html><head><title>Imprimir factura #' + $scope.invoice.number + '</title><style>' + styleprint.innerHTML + '</style><style>' + styleprintBootstrap.innerHTML + '</style></head><body onload="window.print()">' + innerContents + '</html>');
	              popupWinindow.document.close();
	            };
	
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	          }]
	        });
	      }
	    }
	  }]);
	  return PrintedUnclosedController;
	}();
	
	exports.default = PrintedUnclosedController;
	
	
	PrintedUnclosedController.$inject = ['$state', 'ContentService', '$uibModal', 'ProfilePermissionsService', 'moment', 'isMobile'];

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1195);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./printed-unclosed.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./printed-unclosed.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".PrintedUnclosed{color:red}", ""]);
	
	// exports


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(1096);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilePermissionsService = function () {
	  function ProfilePermissionsService($window) {
	    (0, _classCallCheck3.default)(this, ProfilePermissionsService);
	
	    this.$localStorage = $window.localStorage;
	  }
	
	  (0, _createClass3.default)(ProfilePermissionsService, [{
	    key: 'setProfilesCount',
	    value: function setProfilesCount(count) {
	      this.$localStorage.setItem('profilesCount', count);
	    }
	  }, {
	    key: 'hasProfiles',
	    value: function hasProfiles() {
	      return +this.$localStorage.getItem('profilesCount') > 0;
	    }
	  }, {
	    key: 'setProfile',
	    value: function setProfile(profile) {
	      this.$localStorage.setItem('currentProfile', (0, _stringify2.default)(profile));
	    }
	  }, {
	    key: 'getProfile',
	    value: function getProfile() {
	      return JSON.parse(this.$localStorage.getItem('currentProfile'));
	    }
	  }, {
	    key: 'clearProfile',
	    value: function clearProfile() {
	      this.$localStorage.removeItem('currentProfile');
	    }
	  }, {
	    key: 'isAdmin',
	    value: function isAdmin() {
	      return this.getProfile().is_admin;
	    }
	  }, {
	    key: 'hasPermission',
	    value: function hasPermission(perm) {
	      return this.isAdmin() ? true : this.getProfile().permissions.indexOf(perm) > -1;
	    }
	  }, {
	    key: 'hasAtLeastOneOf',
	    value: function hasAtLeastOneOf(permList) {
	      return this.isAdmin() || this.getProfile().permissions.some(function (perm) {
	        return permList.indexOf(perm) > -1;
	      });
	    }
	  }, {
	    key: 'hasAllOf',
	    value: function hasAllOf(permList) {
	      var profile = this.getProfile();
	      return this.isAdmin() || permList.every(function (perm) {
	        return profile.permissions.indexOf(perm) > -1;
	      });
	    }
	  }]);
	  return ProfilePermissionsService;
	}();
	
	exports.default = ProfilePermissionsService;
	
	
	ProfilePermissionsService.$inject = ['$window'];

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _fiscalSalesAnalyser = __webpack_require__(1198);
	
	var _fiscalSalesAnalyser2 = _interopRequireDefault(_fiscalSalesAnalyser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalSalesAnalyserModule = _angular2.default.module('FiscalSalesAnalyser', [_angularjs2.default]).component('fiscalSalesAnalyser', _fiscalSalesAnalyser2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('fiscalSalesAnalyser', {
	    url: '/fiscal-sales-analyser',
	    data: {
	      authRequired: true,
	      permsRequired: ['sales-analyser']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'fiscalSalesAnalyser'
	      }
	    }
	  });
	}]).name;
	
	exports.default = FiscalSalesAnalyserModule;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fiscalSalesAnalyser = __webpack_require__(1199);
	
	var _fiscalSalesAnalyser2 = _interopRequireDefault(_fiscalSalesAnalyser);
	
	var _fiscalSalesAnalyser3 = __webpack_require__(1200);
	
	var _fiscalSalesAnalyser4 = _interopRequireDefault(_fiscalSalesAnalyser3);
	
	__webpack_require__(1213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalSalesAnalyserComponent = {
	  bindings: {},
	  template: _fiscalSalesAnalyser2.default,
	  controller: _fiscalSalesAnalyser4.default
	};
	
	exports.default = FiscalSalesAnalyserComponent;

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n  <h1 class=\"page-header\">\n    <div class=\"row\">\n      <div class=\"col-md-12 col-sm-10 col-xs-11\">\n\t\t\t\t{{'Análisis de archivo de impresora fiscal' | translate}}\n      </div>\n    </div>\n  </h1>\n\n\t<div class=\"col-md-12 table_container no_padding\">\n\t\t<div class=\"card\">\n\t\t\t<div class=\"card-content\">\n\t\t\t\t<div class=\"bootstrap-table\">\n\n\t\t\t\t\t<div class=\"row fixed-table-toolbar\">\n\t\t\t\t\t\t<!-- <div class=\"search col-md-4\">\n\t\t\t\t\t\t\t<div class=\"field\">\n               \t\t\t\t\t <input type=\"file\" nv-file-select uploader=\"$ctrl.fileUploader\" \n               \t\t\t\t\t class=\"form-control\" id=\"sales-analyser-input\" multiple />\n\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t</div> -->\n\t\t\t\t\t\t \n\t\t\t\t\t\t<div class=\"col-md-3 col-sm-2 col-xs-12 analyser_margin \">\n\t\t\t\t\t\t\t<input type=\"file\" id=\"sales-analyser-input\" \n\t\t\t\t\t\t\tnv-file-select uploader=\"$ctrl.fileUploader\" class=\"form-control input_py input_file\" multiple/>\n\t\t\t\t\t\t  <label for=\"sales-analyser-input\" class=\"btn btn-tertiary labelFile\">\n\t\t\t\t\t\t    <i class=\"icon fa fa-check\"></i>\n\t\t\t\t\t\t    <span class=\"fileName\">{{ $ctrl.fileUploader.queue.length }} {{'en cola' | translate}}</span>\n\t\t\t\t\t\t  </label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"col-md-2 col-sm-2 col-xs-4 analyser_margin text-center\">\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.uploadAllFiles()\" ng-disabled=\"$ctrl.fileUploader.queue.length <= 0\">\n\t\t\t\t\t\t\t\t{{'Subir archivo' | translate}}\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"col-md-7 col-sm-7 col-xs-8 analyser_margin grup_btn\">\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-class=\"{'btn-primary':!($ctrl.results.length <= 0 || $ctrl.isCurrentlyUploading()), 'btn-default':($ctrl.results.length <= 0 || $ctrl.isCurrentlyUploading())}\" ng-click=\"$ctrl.setChartType('MONTH'); $ctrl.buildLineChart()\" ng-disabled=\"$ctrl.results.length <= 0 || $ctrl.isCurrentlyUploading()\">\n\t\t\t\t\t\t<i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\">{{'Mensual' | translate}}</span> \n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t<button type=\"button\" class=\"btn\" ng-class=\"{'btn-primary':!($ctrl.results.length <= 0 || $ctrl.isCurrentlyUploading()), 'btn-default':($ctrl.results.length <= 0 || $ctrl.isCurrentlyUploading())}\" ng-click=\"$ctrl.setChartType('HOUR'); $ctrl.buildBarChart()\" ng-disabled=\"$ctrl.results.length <= 0 || $ctrl.isCurrentlyUploading()\"> \n\t\t\t\t\t\t\t<i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\">{{'Por Hora' | translate}}</span>\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.clean($ctrl.activeChartType);\" ng-disabled=\"$ctrl.results.length <= 0 || $ctrl.isCurrentlyUploading()\">\n\t\t\t\t\t\t\t<i class=\"fa fa-eraser\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\">{{'Limpiar' | translate}}</span> \n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.export607()\" ng-disabled=\"$ctrl.results.length <= 0 || $ctrl.isCurrentlyUploading()\"> \n\t\t\t\t\t\t\t<i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\">{{'Exportar 607' | translate}}</span> \n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.summary()\" ng-disabled=\"$ctrl.results.length <= 0 || $ctrl.isCurrentlyUploading()\"> \n\t\t\t\t\t\t\t<i class=\"fa fa-files-o\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\">{{'Exportar Sumario' | translate}}</span> \n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n          </div>\n          \n          <div class=\"fixed-table-container\" ng-show=\"$ctrl.results\">\n\t\t\t\t\t\t<div class=\"fixed-table-body\">\n\t\t\t\t\t\t\t<canvas ng-if=\"!$ctrl.activeChartType || $ctrl.activeChartType == 'MONTH'\" class=\"chart chart-line\"\n\t\t\t\t\t\t\t\tchart-data=\"$ctrl.chartParams.data\"\n\t\t\t\t\t\t\t\tchart-labels=\"$ctrl.chartParams.labels\" chart-options=\"$ctrl.chartParams.options\"\n\t\t\t\t\t\t\t\tchart-dataset-override=\"$ctrl.chartParams.datasetOverride\"\n\t\t\t\t\t\t\t\tchart-series=\"$ctrl.chartParams.series\"></canvas>\n\t\t\t\t\t\t\t<canvas ng-if=\"$ctrl.activeChartType == 'HOUR'\" class=\"chart chart-bar\"\n\t\t\t\t\t\t\t\tchart-data=\"$ctrl.chartParams.data\"\n\t\t\t\t\t\t\t\tchart-labels=\"$ctrl.chartParams.labels\" chart-options=\"$ctrl.chartParams.options\"\n\t\t\t\t\t\t\t\tchart-dataset-override=\"$ctrl.chartParams.datasetOverride\"\n\t\t\t\t\t\t\t\tchart-colors=\"$ctrl.chartParams.colours\"\n\t\t\t\t\t\t\t\tchart-series=\"$ctrl.chartParams.series\"></canvas>\n\n            </div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n\t</div>\n</div>"

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(333);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _freeze = __webpack_require__(1201);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _toConsumableArray2 = __webpack_require__(1205);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalSalesAnalyserController = function () {
	  function FiscalSalesAnalyserController(FiscalPrinterService, $state, AuthService, FileUploader, moment, Q, cfpLoadingBar, Notification, FileSaver, Blob, $translate, $loadingOverlay) {
	    (0, _classCallCheck3.default)(this, FiscalSalesAnalyserController);
	
	    this.service = FiscalPrinterService;
	    this.state = $state;
	    this.auth = AuthService;
	    this.fileUploader = new FileUploader({
	      url: this.service.host + '/api/accounts/fiscal-printer/sales',
	      headers: {
	        Authorization: 'Bearer ' + this.auth.getToken(),
	        'X-Account-Token': this.auth.getAccountToken()
	      },
	      removeAfterUpload: true
	    });
	    this.moment = moment;
	    this.Q = Q;
	    this.loading = cfpLoadingBar;
	    this.notify = Notification;
	    this.FileSaver = FileSaver;
	    this.Blob = Blob;
	    this.trans = $translate.instant;
	    this.overlay = $loadingOverlay;
	  }
	
	  (0, _createClass3.default)(FiscalSalesAnalyserController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.processed = [];
	      this.activeChartType = '';
	      this.chartParams = {
	        data: [[], []],
	        labels: [],
	        datasetOverride: [],
	        options: {
	          elements: {
	            line: {
	              fill: false,
	              tension: 0
	            },
	            rectangle: {
	              backgroundColor: 'rgba(73,94,36,0.8)'
	            }
	          },
	          scales: {
	            yAxes: [{
	              ticks: {
	                beginAtZero: false
	              }
	            }]
	          }
	        },
	        series: ['Ingresos', 'VAT'],
	        colours: [{ backgroundColor: 'rgba(73,94,36,0.8)' }]
	      };
	      this.activeChartType = 'MONTH';
	      this.selectedFiles = [];
	      this.results = [];
	
	      var that = this;
	      this.fileUploader.onSuccessItem = function (item, response, status, headers) {
	        var _results;
	
	        (_results = _this.results).push.apply(_results, (0, _toConsumableArray3.default)(response.results));
	        that.loading.set(1 / that.fileUploader.queue.length - 0.01);
	        if (_this.fileUploader.queue.every(function (i) {
	          return !i.isUploading;
	        })) {
	          _this.loading.complete();
	        }
	      };
	
	      this.fileUploader.onCompleteAll = function (item, response, status, headers) {
	        // this.loading.complete();
	        _this.overlay.hide();
	        var _ = _this.trans;
	        _this.allTransactions = [];
	        _this.results[0].daily.forEach(function (dailySale) {
	          var _allTransactions;
	
	          return (_allTransactions = _this.allTransactions).push.apply(_allTransactions, (0, _toConsumableArray3.default)(dailySale.transactions));
	        });
	        _this.sortedTransactions = _this.allTransactions.sort(function (a, b) {
	          var transactionDateValue = a.transaction_date - b.transaction_date;
	          if (transactionDateValue == 0) {
	            return a.transaction_time - b.transaction_time;
	          } else {
	            return transactionDateValue;
	          }
	        }).filter(function (t) {
	          return t.sub_document_type != 2 && t.ncf != null;
	        }).map(function (value) {
	          value.tip_amount = 0;
	          if (value.tip == 0) {
	            value.tip_amount = Number(Number(value.vat2 / 0.18 * 0.1).toFixed(2));
	          }
	          value.cash_amount = value.cash_amount || 0;
	          value.check_amount = value.check_amount || 0;
	          value.coupon_amount = value.coupon_amount || 0;
	          value.card_payment = value.card_payment || 0;
	          value.credit_card_amount = value.credit_card_amount || 0;
	          value.other_amount = value.other_amount || 0;
	          value.charity = value.charity || 0;
	          value.credit_note_amount = value.credit_note_amount || 0;
	          value.other_amount_1 = value.other_amount_1 || 0;
	          value.other_amount_2 = value.other_amount_2 || 0;
	          value.other_amount_3 = value.other_amount_3 || 0;
	          value.other_amount_4 = value.other_amount_4 || 0;
	          value.card_payment = value.debit_card_amount + value.credit_card_amount;
	          value.other_amount = value.other_amount_1 + value.other_amount_2 + value.other_amount_3 + value.other_amount_4;
	
	          value.total_paid = value.cash_amount + value.check_amount + value.coupon_amount + value.card_payment + value.other_amount + value.charity + value.credit_note_amount;
	          value.exemption = Number(Number(value.amount - value.total_paid).toFixed(2));
	          value.ncf_id = value.ncf.match(/.+(B..).+/)[1];
	          if (value.affected_rnc != null) value.ncf_id = value.affected_rnc.match(/.+(B..).+/)[1];
	          value.ncf_id = value.ncf_id.toUpperCase();
	          value.subtotal = Number(Number(value.amount - value.tip_amount - value.vat).toFixed(2));
	          value.rnc_tipo = 3;
	          if (value.customer_rnc) {
	            if (new String(value.customer_rnc).length == 9) {
	              value.rnc_tipo = 2;
	            } else {
	              value.rnc_tipo = 1;
	            }
	          }
	          value.tipo_ingreso = 1;
	          value.retention_date = value.transaction_date;
	          value.vat_third = 0;
	          value.vat_perc = 0;
	          value.rent = 0;
	          value.isr = 0;
	          value.excise_tax = 0;
	          value.swap_amount = 0;
	
	          return value;
	        });
	
	        _this.validTransactions = _this.sortedTransactions.filter(function (t) {
	          return t.affected_rnc == null;
	        });
	        _this.creditNotes = _this.sortedTransactions.filter(function (t) {
	          return t.affected_rnc != null;
	        }).map(function (a) {
	          var affectedNcf = _this.sortedTransactions.filter(function (t) {
	            return t.ncf == a.affected_rnc;
	          })[0];
	          a.cash_amount = affectedNcf.cash_amount;
	          a.check_amount = affectedNcf.check_amount;
	          a.coupon_amount = affectedNcf.coupon_amount;
	          a.credit_card_amount = affectedNcf.credit_card_amount;
	          a.other_amount_1 = affectedNcf.other_amount_1;
	          a.other_amount_2 = affectedNcf.other_amount_2;
	          a.other_amount_3 = affectedNcf.other_amount_3;
	          a.other_amount_4 = affectedNcf.other_amount_4;
	          a.tip = affectedNcf.tip;
	          a.charity = affectedNcf.charity;
	          a.debit_card_amount = affectedNcf.debit_card_amount;
	          a.credit_note_amount = affectedNcf.credit_note_amount;
	          a.card_payment = affectedNcf.card_payment;
	          a.other_amount = affectedNcf.other_amount;
	          a.exemption = affectedNcf.exemption;
	          a.subtotal = affectedNcf.subtotal;
	
	          return a;
	        });
	        _this.exemptions = _this.sortedTransactions.filter(function (t) {
	          return t.sub_document_type == 1;
	        });
	
	        _this.countByNCF = { "B01": 0, "B02": 0, "B04": 0, "B14": 0, "B15": 0 };
	
	        _this.grandTotal = {
	          "tax": 0,
	          "sales": 0,
	          "total": 0,
	          "exemption": 0,
	          "count": 0
	        };
	
	        _this.summaryByNCFTransactions = {
	          "B01": {
	            "tax": 0,
	            "sales": 0,
	            "total": 0,
	            "exemption": 0
	          },
	          "B02": {
	            "tax": 0,
	            "sales": 0,
	            "total": 0,
	            "exemption": 0
	          },
	          "B14": {
	            "tax": 0,
	            "sales": 0,
	            "total": 0,
	            "exemption": 0
	          },
	          "B15": {
	            "tax": 0,
	            "sales": 0,
	            "total": 0,
	            "exemption": 0
	          }
	        };
	
	        _this.summaryByCreditNote = {
	          "B01": {
	            "tax": 0,
	            "sales": 0,
	            "total": 0,
	            "exemption": 0,
	            "count": 0
	          },
	          "B02": {
	            "tax": 0,
	            "sales": 0,
	            "total": 0,
	            "exemption": 0,
	            "count": 0
	          },
	          "B14": {
	            "tax": 0,
	            "sales": 0,
	            "total": 0,
	            "exemption": 0,
	            "count": 0
	          },
	          "B15": {
	            "tax": 0,
	            "sales": 0,
	            "total": 0,
	            "exemption": 0,
	            "count": 0
	          }
	        };
	
	        _this.byPaymentType = {
	          "cash_amount": 0,
	          "check_amount": 0,
	          "coupon_amount": 0,
	          "credit_card_amount": 0,
	          "other_amount_1": 0,
	          "other_amount_2": 0,
	          "other_amount_3": 0,
	          "other_amount_4": 0,
	          "charity": 0,
	          "debit_card_amount": 0,
	          "credit_note_amount": 0,
	          "card_payment": 0,
	          "other_amount": 0
	        };
	
	        _this.validTransactions.forEach(function (value, index, yargs) {
	
	          _this.byPaymentType["cash_amount"] += value.cash_amount;
	          _this.byPaymentType["check_amount"] += value.check_amount;
	          _this.byPaymentType["coupon_amount"] += value.coupon_amount;
	          _this.byPaymentType["credit_card_amount"] += value.credit_card_amount;
	          _this.byPaymentType["other_amount_1"] += value.other_amount_1;
	          _this.byPaymentType["other_amount_2"] += value.other_amount_2;
	          _this.byPaymentType["other_amount_3"] += value.other_amount_3;
	          _this.byPaymentType["other_amount_4"] += value.other_amount_4;
	          _this.byPaymentType["charity"] += value.charity;
	          _this.byPaymentType["debit_card_amount"] += value.debit_card_amount;
	          _this.byPaymentType["credit_note_amount"] += value.credit_note_amount;
	          _this.byPaymentType["card_payment"] += value.card_payment;
	          _this.byPaymentType["other_amount"] += value.other_amount;
	
	          _this.summaryByNCFTransactions[value.ncf_id]["tax"] += value.vat;
	          _this.summaryByNCFTransactions[value.ncf_id]["total"] += value.amount - value.exemption;
	          _this.summaryByNCFTransactions[value.ncf_id]["sales"] += value.subtotal;
	          _this.summaryByNCFTransactions[value.ncf_id]["exemption"] += value.exemption;
	
	          _this.grandTotal["tax"] += value.vat;
	          _this.grandTotal["total"] += value.amount - value.exemption;
	          _this.grandTotal["sales"] += value.subtotal;
	          _this.grandTotal["exemption"] += value.exemption;
	          _this.grandTotal["count"] += 1;
	
	          _this.countByNCF[value.ncf_id] += 1;
	        });
	
	        _this.creditNotes.forEach(function (value, index, yargs) {
	
	          _this.byPaymentType["cash_amount"] -= value.cash_amount;
	          _this.byPaymentType["check_amount"] -= value.check_amount;
	          _this.byPaymentType["coupon_amount"] -= value.coupon_amount;
	          _this.byPaymentType["credit_card_amount"] -= value.credit_card_amount;
	          _this.byPaymentType["other_amount_1"] -= value.other_amount_1;
	          _this.byPaymentType["other_amount_2"] -= value.other_amount_2;
	          _this.byPaymentType["other_amount_3"] -= value.other_amount_3;
	          _this.byPaymentType["other_amount_4"] -= value.other_amount_4;
	          _this.byPaymentType["charity"] -= value.charity;
	          _this.byPaymentType["debit_card_amount"] -= value.debit_card_amount;
	          _this.byPaymentType["credit_note_amount"] -= value.credit_note_amount;
	          _this.byPaymentType["card_payment"] -= value.card_payment;
	          _this.byPaymentType["other_amount"] -= value.other_amount;
	
	          _this.summaryByCreditNote[value.ncf_id]["tax"] += value.vat;
	          _this.summaryByCreditNote[value.ncf_id]["total"] += value.amount - value.exemption;
	          _this.summaryByCreditNote[value.ncf_id]["sales"] += value.subtotal;
	          _this.summaryByCreditNote[value.ncf_id]["exemption"] += value.exemption;
	          _this.summaryByCreditNote[value.ncf_id]["count"] += 1;
	
	          _this.grandTotal["tax"] -= value.vat;
	          _this.grandTotal["total"] -= value.amount - value.exemption;
	          _this.grandTotal["sales"] -= value.subtotal;
	          _this.grandTotal["exemption"] -= value.exemption;
	          _this.grandTotal["count"] += 1;
	
	          _this.countByNCF["B04"] += 1;
	        });
	      };
	      this.series1 = [];
	      this.series2 = [];
	    }
	  }, {
	    key: 'selectFiles',
	    value: function selectFiles() {
	      this.selectedFiles = [];
	    }
	  }, {
	    key: 'configurateChart',
	    value: function configurateChart(type) {
	      var _ = this.trans;
	      switch (type) {
	        case 'MONTH':
	          this.chartParams.labels = [];
	          this.chartParams.data = [[], []];
	          this.chartParams.series = [_('Ingresos'), _('VAT')];
	          break;
	        case 'HOUR':
	          this.chartParams.labels = [];
	          this.chartParams.data = [];
	          this.chartParams.series = [_('Ingresos')];
	          break;
	      }
	    }
	  }, {
	    key: 'setChartType',
	    value: function setChartType(type) {
	      if (this.activeChartType != type) {
	        this.activeChartType = type;
	        this.configurateChart(type);
	      } else {
	        return;
	      }
	    }
	  }, {
	    key: 'getLinear',
	    value: function getLinear(source) {
	      var result = [];
	      for (var i in source) {
	        for (var j in source[i]) {
	          result.push(source[i][j]);
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'getTransactions',
	    value: function getTransactions(source) {
	      //This and the one before may be the only two pure functions I've ever written
	      return source.reduce(function (acumulator, current, index) {
	        for (var i in current.transactions) {
	          acumulator.push(current.transactions[i]);
	        }
	        return acumulator;
	      }, []);
	    }
	  }, {
	    key: 'getSalesTotals',
	    value: function getSalesTotals(source) {
	      var _this2 = this;
	
	      var grouped = source.reduce(function (accumulator, current, index) {
	        var extractTime = function extractTime(t) {
	          return _this2.moment(t.toString(), 'YYYYMMDD').month();
	        };
	        var length = accumulator.length;
	        var last = length - 1;
	        if (length == 0) {
	          accumulator.push([extractTime(current.transaction_date), current.amount]);
	        } else if (accumulator[last][0] == extractTime(current.transaction_date)) {
	          accumulator[last][1] += current.amount;
	        } else {
	          accumulator.push([extractTime(current.transaction_date), current.amount]);
	        }
	        return accumulator;
	      }, []);
	
	      return grouped.map(function (current, index) {
	        return [current[0], current[1]];
	      });
	    }
	  }, {
	    key: 'getVATTotals',
	    value: function getVATTotals(source) {
	      var _this3 = this;
	
	      var grouped = source.reduce(function (accumulator, current, index) {
	        var extractTime = function extractTime(t) {
	          return _this3.moment(t.toString(), 'YYYYMMDD').month();
	        };
	        var length = accumulator.length;
	        var last = length - 1;
	        if (length == 0) {
	          accumulator.push([extractTime(current.transaction_date), current.vat]);
	        } else if (accumulator[last][0] == extractTime(current.transaction_date)) {
	          accumulator[last][1] += current.vat;
	        } else {
	          accumulator.push([extractTime(current.transaction_date), current.vat]);
	        }
	        return accumulator;
	      }, []);
	      return grouped.map(function (current, index) {
	        return [current[0], current[1]];
	      });
	    }
	  }, {
	    key: 'buildLineChart',
	    value: function buildLineChart() {
	      var _this4 = this;
	
	      var transactions = this.getTransactions(this.getLinear(this.results.map(function (x) {
	        return x.daily;
	      })));
	      var sorted = transactions.sort(function (a, b) {
	        return a.transaction_date - b.transaction_date;
	      });
	      var salesTotals = this.getSalesTotals(sorted);
	      var vatTotals = this.getVATTotals(sorted);
	      this.configurateChart('MONTH');
	      salesTotals.forEach(function (item) {
	        _this4.chartParams.labels.push(_this4.moment(item[0], 'MM').format('MMMM').replace(/\b\w/g, function (l) {
	          return l.toUpperCase();
	        }));
	        _this4.chartParams.data[0].push(item[1]);
	      });
	      vatTotals.forEach(function (item) {
	        _this4.chartParams.data[1].push(item[1]);
	      });
	    }
	  }, {
	    key: 'buildBarChart',
	    value: function buildBarChart() {
	      var _this5 = this;
	
	      var linear = function linear(source) {
	        var result = [];
	        for (var i in source) {
	          for (var j in source[i]) {
	            result.push(source[i][j]);
	          }
	        }
	        return result;
	      };
	      var transactions = linear(this.results.map(function (x) {
	        return x.daily;
	      })).reduce(function (acumulator, current, index) {
	        for (var i in current.transactions) {
	          acumulator.push(current.transactions[i]);
	        }
	        return acumulator;
	      }, []);
	      var sorted = transactions.sort(function (a, b) {
	        return a.transaction_time - b.transaction_time;
	      });
	      var grouped = sorted.reduce(function (accumulator, current, index) {
	        var extractTime = function extractTime(t) {
	          return _this5.moment(t.toString().padStart(6, '0'), 'HHmmss').hour();
	        };
	        var length = accumulator.length;
	        var last = length - 1;
	        if (length == 0) {
	          accumulator.push([extractTime(current.transaction_time), current.amount]);
	        } else if (accumulator[last][0] == extractTime(current.transaction_time)) {
	          accumulator[last][1] += current.amount;
	        } else {
	          accumulator.push([extractTime(current.transaction_time), current.amount]);
	        }
	        return accumulator;
	      }, []);
	      var formatted = grouped.map(function (current, index) {
	        return [current[0], current[1]];
	      });
	      this.configurateChart('HOUR');
	      formatted.forEach(function (item) {
	        _this5.chartParams.labels.push(item[0]);
	        _this5.chartParams.data.push(item[1]);
	      });
	    }
	  }, {
	    key: 'uploadAllFiles',
	    value: function uploadAllFiles() {
	      var _ = this.trans;
	      if (this.fileUploader.queue.some(function (i) {
	        return i.isUploading;
	      })) {
	        this.notify.info(_("Por favor espere a la carga de los archivos en cola."));
	        return;
	      }
	      this.fileUploader.uploadAll();
	      this.loading.start();
	      this.overlay.show();
	    }
	  }, {
	    key: 'downloadAsCSV',
	    value: function downloadAsCSV() {
	      var _ = this.trans;
	      var transactions = this.getTransactions(this.getLinear(this.results.map(function (x) {
	        return x.daily;
	      }))).sort(function (a, b) {
	        return a.ncf.localeCompare(b.ncf);
	      });
	      // COMPLETE IMMUTABILITY
	      var translations = (0, _freeze2.default)({
	        'transaction_date': _('Fecha'),
	        'transaction_time': _('Hora'),
	        'document_type': _('Tipo de documento'),
	        'customer_rnc': _('RNC/Ced. del cliente'),
	        'ncf': _('Comprobante'),
	        'affected_rnc': _('RNC Afectado'),
	        'amount': _('Monto'),
	        'cash_amount': _("Monto Efectivo"),
	        'discount': _("Descuento"),
	        'vat': _('ITBIS'),
	        'vat2': _('ITBIS 2'),
	        'no_vat_item_count': _('Exento de impuestos')
	      });
	
	      var VATStatus = (0, _freeze2.default)({
	        1: _('Exoneración ITBIS'),
	        2: _('Cancelado'),
	        3: _('Exoneración ITBIS/Cancelado'),
	        4: _('Nota Crédito Automática - Inconsistencia Fiscal')
	      });
	
	      var headers = (0, _keys2.default)(translations);
	      var csvRows = [];
	      var csvContent = "";
	      transactions.forEach(function (t) {
	        csvRows.push(headers.map(function (h) {
	          return h != 'vat' ? t[h] : t._sub_document_type == 1 || t.sub_document_type == 2 ? '0' : t[h];
	        }).concat(VATStatus[t.sub_document_type]).join(','));
	      });
	      //TODO: Decide on CRLF/LF issue but idk
	      csvContent += headers.map(function (h) {
	        return translations[h];
	      }).concat("Estado ITBIS").join(',') + "\r\n";
	      csvContent += csvRows.join("\r\n");
	      var href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
	      var hiddenElement = document.createElement('a');
	      hiddenElement.href = href;
	      hiddenElement.download = this.moment().format('YMDHHmm') + '.csv';
	      hiddenElement.click();
	      hiddenElement.remove();
	    }
	  }, {
	    key: 'export607',
	    value: function export607() {
	      var _ = this.trans;
	      var translations = (0, _freeze2.default)({
	        'customer_rnc': _('RNC'),
	        'rnc_tipo': _('TIPO'),
	        'ncf': _('NCF'),
	        'affected_rnc': _('NCF Modificado'),
	        'tipo_ingreso': _('Tipo de Ingreso'),
	        'transaction_date': _('Fecha'),
	        'retention_date': _('Fecha de Retencion'),
	        'subtotal': _('Monto Fact'),
	        'vat': _('ITBIS'),
	        'vat_third': _('ITBIS Tercero'),
	        'vat_perc': _('ITBIS Percibido'),
	        'rent': _('Renta'),
	        'isr': _('ISR'),
	        'excise_tax': _('Selectivo'),
	        'tip_amount': _('Propina'),
	        'cash_amount': _('Efectivo'),
	        'check_amount': _('Cheque/Dep/Trans'),
	        'card_payment': _('Tarjeta'),
	        'credit_note_amount': _('Ventas Credito'),
	        'charity': _("Bono"),
	        'swap_amount': _("Permuta"),
	        'other_amount': _('Otros')
	      });
	
	      var amountFields = (0, _freeze2.default)(['subtotal', 'vat', 'vat_third', 'vat_perc', 'rent', 'isr', 'excise_tax', 'tip_amount', 'cash_amount', 'check_amount', 'card_payment', 'credit_note_amount', 'charity', 'swap_amount', 'other_amount']);
	
	      var headers = (0, _keys2.default)(translations);
	      var csvRows = [];
	      var csvContent = "";
	      this.sortedTransactions.forEach(function (t) {
	        amountFields.map(function (h) {
	          return t[h] = t[h] || "";
	        });
	        csvRows.push(headers.map(function (h) {
	          return t[h];
	        }).join(','));
	      });
	      //TODO: Decide on CRLF/LF issue but idk
	      csvContent += headers.map(function (h) {
	        return translations[h];
	      }).join(',') + "\r\n";
	      csvContent += csvRows.join("\r\n");
	      var href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
	      var hiddenElement = document.createElement('a');
	      hiddenElement.href = href;
	      hiddenElement.download = 'Reports-607-' + this.moment().format('YMDHHmm') + '.csv';
	      hiddenElement.click();
	      hiddenElement.remove();
	      //this.service.export607();
	    }
	  }, {
	    key: 'summary',
	    value: function summary() {
	      var _this6 = this;
	
	      var _ = this.trans;
	      var translations = (0, _freeze2.default)({
	        'B01': _('Ventas Credito Fiscal'),
	        'B02': _('Ventas Consumidor Final'),
	        'B14': _('Ventas Regimen Especial'),
	        'B15': _('Ventas Gubernamental'),
	        'B04': _('Nota de Credito'),
	        'B04B01': _('Nota de Credito Credito Fiscal'),
	        'B04B02': _('Nota de Credito Consumidor Final'),
	        'B04B14': _('Nota de Credito Regimen Especial'),
	        'B04B15': _('Nota de Credito Gubernamental'),
	        'tax': _('ITBIS'),
	        'exemption': _('Exento'),
	        'sales': _('Neto'),
	        'total': _('Total'),
	
	        'subtotal': _('Monto Fact'),
	        'vat': _('ITBIS'),
	        'vat_third': _('ITBIS Tercero'),
	        'vat_perc': _('ITBIS Percibido'),
	        'rent': _('Renta'),
	        'isr': _('ISR'),
	        'excise_tax': _('Selectivo'),
	        'tip_amount': _('Propina'),
	        'cash_amount': _('Efectivo'),
	        'check_amount': _('Cheque/Dep/Trans'),
	        'card_payment': _('Tarjeta'),
	        'credit_note_amount': _('Ventas Credito'),
	        'charity': _("Bono"),
	        'swap_amount': _("Permuta"),
	        'other_amount': _('Otros')
	      });
	
	      var csvRows = [];
	      var csvContent = "";
	
	      var traversalOrder = ["B01", "B02", "B14", "B15"];
	      var summaryPart = this.summaryByNCFTransactions;
	      traversalOrder.forEach(function (h) {
	        var detail = summaryPart[h];
	        csvRows.push(translations[h] + ',,');
	        csvRows.push(',' + translations['tax'] + ',' + detail['tax'].toFixed(2));
	        csvRows.push(',' + translations['sales'] + ',' + detail['sales'].toFixed(2));
	        csvRows.push(',' + translations['total'] + ',' + detail['total'].toFixed(2));
	        csvRows.push(',' + translations['exemption'] + ',' + detail['exemption'].toFixed(2));
	        csvRows.push('');
	      });
	
	      var summaryCreditPart = this.summaryByCreditNote;
	      traversalOrder.forEach(function (h) {
	        var detail = summaryCreditPart[h];
	        csvRows.push(translations['B04' + h] + ',,');
	        csvRows.push(',' + translations['tax'] + ',' + detail['tax'].toFixed(2));
	        csvRows.push(',' + translations['sales'] + ',' + detail['sales'].toFixed(2));
	        csvRows.push(',' + translations['total'] + ',' + detail['total'].toFixed(2));
	        csvRows.push(',' + translations['exemption'] + ',' + detail['exemption'].toFixed(2));
	        csvRows.push('');
	      });
	      csvRows.push('');
	      csvRows.push('');
	      csvRows.push('');
	      (0, _keys2.default)(this.grandTotal).forEach(function (h) {
	        if (h != 'count') csvRows.push(translations[h] + ',' + _this6.grandTotal[h].toFixed(2));
	      });
	      csvRows.push('');
	      csvRows.push('');
	      csvRows.push('');
	
	      var traversalNCFOrder = ["B01", "B02", "B04", "B14", "B15"];
	      traversalNCFOrder.forEach(function (h) {
	        var detail = _this6.countByNCF[h];
	        csvRows.push(translations[h] + ',' + detail);
	      });
	
	      csvRows.push('');
	      csvRows.push('');
	      csvRows.push('');
	
	      var paymentTypeTraversal = ['cash_amount', 'check_amount', 'card_payment', 'credit_note_amount', 'charity', 'swap_amount', 'other_amount'];
	      paymentTypeTraversal.forEach(function (h) {
	        var payTotal = _this6.byPaymentType[h] || 0;
	        csvRows.push(translations[h] + ',' + payTotal.toFixed(2));
	      });
	
	      //TODO: Decide on CRLF/LF issue but idk
	
	      csvContent += csvRows.join("\r\n");
	      var href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
	      var hiddenElement = document.createElement('a');
	      hiddenElement.href = href;
	      hiddenElement.download = 'IT-1 Summanry-' + this.moment().format('YMDHHmm') + '.csv';
	      hiddenElement.click();
	      hiddenElement.remove();
	      //this.service.export607();
	    }
	  }, {
	    key: 'isCurrentlyUploading',
	    value: function isCurrentlyUploading() {
	      return this.fileUploader.queue.some(function (i) {
	        return i.isUploading;
	      });
	    }
	  }, {
	    key: 'clean',
	    value: function clean(type) {
	      this.configurateChart(type);
	      this.fileUploader.clearQueue();
	      this.results = [];
	    }
	  }]);
	  return FiscalSalesAnalyserController;
	}();
	
	exports.default = FiscalSalesAnalyserController;
	
	
	FiscalSalesAnalyserController.$inject = ['FiscalPrinterService', '$state', 'AuthService', 'FileUploader', 'moment', '$q', 'cfpLoadingBar', 'Notification', 'FileSaver', 'Blob', '$translate', '$loadingOverlay'];

/***/ }),
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1214);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fiscal-sales-analyser.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fiscal-sales-analyser.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".FiscalSalesAnalyser{color:red}", ""]);
	
	// exports


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _fiscalSalesVisualizer = __webpack_require__(1216);
	
	var _fiscalSalesVisualizer2 = _interopRequireDefault(_fiscalSalesVisualizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalSalesVisualizerModule = _angular2.default.module('FiscalSalesVisualizer', [_angularjs2.default]).component('fiscalSalesVisualizer', _fiscalSalesVisualizer2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('fiscalSalesVisualizer', {
	    url: '/fiscal-sales-visualizer',
	    data: {
	      authRequired: true,
	      permsRequired: ['sales-visualizer']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'fiscalSalesVisualizer'
	      }
	    }
	  });
	}]).name;
	
	exports.default = FiscalSalesVisualizerModule;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fiscalSalesVisualizer = __webpack_require__(1217);
	
	var _fiscalSalesVisualizer2 = _interopRequireDefault(_fiscalSalesVisualizer);
	
	var _fiscalSalesVisualizer3 = __webpack_require__(1218);
	
	var _fiscalSalesVisualizer4 = _interopRequireDefault(_fiscalSalesVisualizer3);
	
	__webpack_require__(1219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalSalesVisualizerComponent = {
	  bindings: {},
	  template: _fiscalSalesVisualizer2.default,
	  controller: _fiscalSalesVisualizer4.default
	};
	
	exports.default = FiscalSalesVisualizerComponent;

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

	module.exports = ""

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalSalesVisualizerController = function FiscalSalesVisualizerController() {
	  (0, _classCallCheck3.default)(this, FiscalSalesVisualizerController);
	};
	
	exports.default = FiscalSalesVisualizerController;
	
	
	FiscalSalesVisualizerController.$inject = [];

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1220);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fiscal-sales-visualizer.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fiscal-sales-visualizer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".FiscalSalesVisualizer{color:red}", ""]);
	
	// exports


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _fiscalSalesZreport = __webpack_require__(1222);
	
	var _fiscalSalesZreport2 = _interopRequireDefault(_fiscalSalesZreport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalSalesZreportModule = _angular2.default.module('FiscalSalesZreport', [_angularjs2.default]).component('fiscalSalesZreport', _fiscalSalesZreport2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('fiscalSalesZreport', {
	    url: '/fiscal-sales-zreport',
	    data: {
	      authRequired: true,
	      permsRequired: ['sales-zreport']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'fiscalSalesZreport'
	      }
	    }
	  });
	}]).name;
	
	exports.default = FiscalSalesZreportModule;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fiscalSalesZreport = __webpack_require__(1223);
	
	var _fiscalSalesZreport2 = _interopRequireDefault(_fiscalSalesZreport);
	
	var _fiscalSalesZreport3 = __webpack_require__(1224);
	
	var _fiscalSalesZreport4 = _interopRequireDefault(_fiscalSalesZreport3);
	
	__webpack_require__(1225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalSalesZreportComponent = {
	  bindings: {},
	  template: _fiscalSalesZreport2.default,
	  controller: _fiscalSalesZreport4.default
	};
	
	exports.default = FiscalSalesZreportComponent;

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12 col-sm-10 col-xs-11\">\n                {{'Reporte Z' | translate}}\n            </div>\n        </div>\n    </h1>\n    <div class=\"col-md-12 table_container no_padding\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <div class=\"fixed-table-toolbar\">\n                        <div class=\"pull-right\">\n\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.uploadAllFiles()\" ng-disabled=\"!$ctrl.fileUploader.queue.length\"><i class=\"fa fa-bar-chart\" aria-hidden=\"true\"></i> {{'Generar reporte' | translate}} </button>\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.rows = [];\" ng-disabled=\"!$ctrl.rows.length > 0\"><i class=\"fa fa-eraser\" aria-hidden=\"true\"></i> {{'Limpiar' | translate}} </button>\n\n                        </div>\n\n                        <!-- <div class=\"search col-md-4\">\n                            <div class=\"field\">\n                                <input type=\"file\" nv-file-select uploader=\"$ctrl.fileUploader\" class=\"form-control\" id=\"sales-analyser-input\" multiple />\n                            </div>\n                        </div> -->\n\n                        <div class=\"col-md-4\">\n                            <input type=\"file\" id=\"sales-analyser-input\" nv-file-select uploader=\"$ctrl.fileUploader\" class=\"form-control input_py input_file\" />\n                          <label for=\"sales-analyser-input\" class=\"btn btn-tertiary labelFile\">\n                            <i class=\"icon fa fa-check\"></i>\n                            <span class=\"fileName\">{{ $ctrl.fileName }}</span>\n                          </label>\n                        </div>\n\n                    </div>\n                    <div class=\"fixed-table-container\">\n                        <div class=\"fixed-table-body\">\n                            <table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n                                <!-- <thead>\n                                    <tr>\n\n                                        <th>NIF inicial</th>\n                                        <th>NIF final</th>\n                                        <th>NIF fuera de secuencia</th>\n                                        <th>Total de registros</th>\n                                        <th>Total de ventas</th>\n                                        <th>Total de transacciones con propina</th>\n                                        <th>Total de impuestos</th>\n                                        <th>Total de registros reales</th>\n                                        <th>Total de ventas real</th>\n                                        <th>Total de transacciones con propina real</th>\n                                        <th>Total de impuestos real</th>\n                                        <th>ID reporte Z</th>\n                                    </tr>\n                                </thead> -->\n                                <thead>\n                                    <tr>\n                                        <th colspan=\"2\"></th>\n                                        <th colspan=\"2\">VAT</th>\n                                        <th colspan=\"2\">TIP #</th>\n                                        <th colspan=\"2\">AMOUNT</th>\n                                        <th colspan=\"2\">RECORD#</th>\n                                    </tr>\n                                    <tr>\n                                        <th>ID</th>\n                                        <th>NIF Off</th>\n                                        <th>Summary</th>\n                                        <th>Real</th>\n\n                                        <th>Summary</th>\n                                        <th>Real</th>\n\n                                        <th>Summary</th>\n                                        <th>Real</th>\n\n                                        <th>Summary</th>\n                                        <th>Real</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr class=\"text-center\" ng-repeat=\"row in $ctrl.rows\">\n                                        <td>{{row.z_report_id}}</td>\n                                        <td>{{row.nif_off_seq | number}}</td>\n                                        <td>{{row.vat_total | currency}}</td>\n                                        <td>{{row.real_vat_total | currency}}</td>\n                                        <td>{{row.tipped_transaction_count | number}}</td>\n                                        <td>{{row.real_tipped_transaction_count | number}}</td>\n                                        <td>{{row.sales_total | currency}}</td>\n                                        <td>{{row.real_sales_total | currency}}</td>\n                                        <td>{{row.record_count | number}}</td>\n                                        <td>{{row.real_record_count}}</td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalSalesZreportController = function () {
	  function FiscalSalesZreportController(FiscalPrinterService, $state, AuthService, FileUploader, moment) {
	    (0, _classCallCheck3.default)(this, FiscalSalesZreportController);
	
	    this.service = FiscalPrinterService;
	    this.state = $state;
	    this.auth = AuthService;
	    this.fileUploader = new FileUploader({
	      url: this.service.host + '/api/accounts/fiscal-printer/z-report',
	      headers: {
	        Authorization: 'Bearer ' + this.auth.getToken(),
	        'X-Account-Token': this.auth.getAccountToken()
	      },
	      removeAfterUpload: true
	    });
	    this.moment = moment;
	  }
	
	  (0, _createClass3.default)(FiscalSalesZreportController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.rows = [];
	      this.fileUploader.onSuccessItem = function (item, response, status, headers) {
	        _this.rows = _this.rows.concat(response.results);
	      };
	    }
	  }, {
	    key: 'uploadAllFiles',
	    value: function uploadAllFiles() {
	      this.fileUploader.uploadAll();
	    }
	  }]);
	  return FiscalSalesZreportController;
	}();
	
	exports.default = FiscalSalesZreportController;
	
	
	FiscalSalesZreportController.$inject = ['FiscalPrinterService', '$state', 'AuthService', 'FileUploader', 'moment'];

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1226);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fiscal-sales-zreport.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fiscal-sales-zreport.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".FiscalSalesZreport{color:red}", ""]);
	
	// exports


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _dailyClosing = __webpack_require__(1228);
	
	var _dailyClosing2 = _interopRequireDefault(_dailyClosing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DailyClosingModule = _angular2.default.module('DailyClosing', [_angularjs2.default]).component('dailyclosing', _dailyClosing2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dailyClosing', {
	    url: '/daily-closing',
	    data: {
	      authRequired: true,
	      permsRequired: ['daily-closing']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'dailyclosing'
	      }
	    }
	  });
	}]).name;
	
	exports.default = DailyClosingModule;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dailyClosing = __webpack_require__(1229);
	
	var _dailyClosing2 = _interopRequireDefault(_dailyClosing);
	
	var _dailyClosing3 = __webpack_require__(1230);
	
	var _dailyClosing4 = _interopRequireDefault(_dailyClosing3);
	
	__webpack_require__(1231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DailyClosingComponent = {
	  bindings: {},
	  template: _dailyClosing2.default,
	  controller: _dailyClosing4.default
	};
	
	exports.default = DailyClosingComponent;

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{'Cierre diario' | translate}}\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form class=\"hidden-xs\">\n            <div class=\"form col-md-12 no-padding\">\n                <div class=\"input-group\">\n                    <label for=\"to\" class=\"input-group-addon\">{{'Fecha' | translate}}</label>\n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.reportParams.date_to\" value=\"\" id=\"to\" class=\"form-control input_py\" format=\"DD/MM/YYYY\"\n                        autocomplete=\"off\" moment-picker=\"$ctrl.reportParams.date_to\" today=\"true\" start-view=\"month\">\n                    <span class=\"input-group-btn\">\n                            <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findReport()\">{{'Buscar' | translate}}</button>\n                        </span>\n                </div>\n            </div>\n        </form>\n        <form class=\"visible-xs\">\n            <div class=\"form_xs\">\n                <div class=\"form-group\">\n                    <p class=\"label_m\" for=\"desde\">{{'Fecha' | translate}}</p>\n                    <input class=\"form-control input_py\" name=\"to\" today=\"true\" moment-picker=\"$ctrl.dateTo\" ng-model=\"$ctrl.dateTo\" format=\"DD/MM/YYYY\" autocomplete=\"off\"\n                        start-view=\"month\" readonly>\n                </div>\n                <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findReport()\">{{'Buscar' | translate}}</button>\n            </div>\n        </form>\n    </div>\n\n    <div class=\"col-md-12 table_container\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <div class=\"fixed-table-body\">\n                        <table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n                            <thead>\n                                <tr>\n                                    <th>{{'Familia' | translate}}</th>\n                                    <th>{{'Al cierre' | translate}}</th>\n                                    <th>{{'MTD' | translate}}</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"row in $ctrl.rows\">\n                                    <td>{{row.family || '-' }}</td>\n                                    <td>{{row.today || 0 | currency}}</td>\n                                    <td>{{row.mtd || 0 | currency}}</td>\n                                </tr>\n                                <tr ng-if=\"$ctrl.mtdTotal && $ctrl.todayTotal\">\n                                    <td>{{'Totales' | translate}}:</td>\n                                    <td>{{$ctrl.todayTotal | currency}}</td>\n                                    <td>{{$ctrl.mtdTotal | currency}}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                        <br>\n                        <table class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\" ng-if=\"$ctrl.topCashier && $ctrl.topArticle\">\n                            <thead>\n                                <tr>\n                                    <th>{{'Producto más vendido' | translate}}</th>\n                                    <th>{{'Mejor vendedor' | translate}}</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr>\n                                    <td>{{ $ctrl.topArticle.description }}</td>\n                                    <td>{{ $ctrl.topCashier.cashier || 'N/A' }}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                        <br>\n                        <table class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\" ng-if=\"$ctrl.customerData\">\n                            <thead>\n                                <tr>\n                                    <th>{{'Período' | translate}}</th>\n                                    <th>{{'Clientes' | translate}}</th>\n                                    <th>{{'Promedio' | translate}}</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr>\n                                    <td>{{'Al cierre' | translate}}</td>\n                                    <td>{{ $ctrl.customerData.today }}</td>\n                                    <td>{{ ($ctrl.todayTotal / $ctrl.customerData.today) | currency }}</td>\n                                </tr>\n                                <tr>\n                                    <td>{{'MTD' | translate}}</td>\n                                    <td>{{ $ctrl.customerData.mtd }}</td>\n                                    <td>{{ ($ctrl.mtdTotal / $ctrl.customerData.mtd) | currency }}</td>\n                                </tr>\n                                <tr></tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DailyClosingController = function () {
	  function DailyClosingController(ContentService, $state, moment) {
	    (0, _classCallCheck3.default)(this, DailyClosingController);
	
	    this.service = ContentService;
	    this.state = $state;
	    this.moment = moment;
	  }
	
	  (0, _createClass3.default)(DailyClosingController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.customerData = null;
	      this.rows = [];
	      this.topArticle = '';
	      this.topCashier = '';
	      this.reportParams = {
	        date_to: undefined
	      };
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'findReport',
	    value: function findReport() {
	      var _this = this;
	
	      this.subscriptions.push(this.service.findClosingHourReport({
	        date_to: this.reportParams.date_to.toISOString()
	      }).subscribe(function (data) {
	        _this.rows = data.sales;_this.topArticle = data.top_product;_this.topCashier = data.top_cashier;_this.customerData = data.customers;_this.calculateTotals(data.sales);
	      }));
	    }
	  }, {
	    key: 'calculateTotals',
	    value: function calculateTotals(sales) {
	      var todayTotal = sales.filter(function (x) {
	        return !!x.today;
	      }).reduce(function (x, y) {
	        return { today: x.today + y.today };
	      }).today;
	      this.todayTotal = todayTotal;
	      var mtdTotal = sales.filter(function (x) {
	        return !!x.mtd;
	      }).reduce(function (x, y) {
	        return { mtd: x.mtd + y.mtd };
	      }).mtd;
	      this.mtdTotal = mtdTotal;
	    }
	  }]);
	  return DailyClosingController;
	}();
	
	exports.default = DailyClosingController;
	
	
	DailyClosingController.$inject = ['ContentService', '$state', 'moment'];

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1232);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./daily-closing.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./daily-closing.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".DailyClosing{color:red}", ""]);
	
	// exports


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _inviteUsers = __webpack_require__(1234);
	
	var _inviteUsers2 = _interopRequireDefault(_inviteUsers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteUsersModule = _angular2.default.module('InviteUsers', [_angularjs2.default]).component('inviteUsers', _inviteUsers2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("inviteUsers", {
	    url: '/inviteUsers',
	    data: {
	      authRequired: true,
	      permsRequired: ['manage-perm', 'invite-user', 'view-profiles']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'inviteUsers'
	      }
	    }
	
	  });
	}]).name;
	
	exports.default = InviteUsersModule;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inviteUsers = __webpack_require__(1235);
	
	var _inviteUsers2 = _interopRequireDefault(_inviteUsers);
	
	var _inviteUsers3 = __webpack_require__(1236);
	
	var _inviteUsers4 = _interopRequireDefault(_inviteUsers3);
	
	__webpack_require__(1237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteUsersComponent = {
	  bindings: {},
	  template: _inviteUsers2.default,
	  controller: _inviteUsers4.default
	};
	
	exports.default = InviteUsersComponent;

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-10 col-sm-10 col-xs-11\">\n                {{'Invitar Usuarios' | translate}}\n            </div>\n        </div>\n    </h1>\n    <div class=\"col-md-12\">\n        <form name=\"inviteForm\" novalidate>\n            <div class=\"input-group\">\n                <input type=\"text\" name=\"email\" ng-model=\"$ctrl.emails\" class=\"form-control input_py\" placeholder=\"Email (pueden ser varios separados por coma)\"\n                    validator=\"multiemail,required\" autofocus>\n                <span class=\"input-group-btn\">\n                  <button type=\"submit\" class=\"btn btn-primary btn_standar\" validation-submit=\"inviteForm\"  ng-click=\"$ctrl.inviteUser()\"  if-perm disable-if=\"invite-user\">{{'Invitar' | translate}}</button>\n                </span>\n            </div>\n        </form>\n    </div>\n    <br>\n    <br>\n    <br>\n    <div class=\"col-md-4 perms-padding\" ng-repeat=\"perm in $ctrl.permslist track by $index\">\n        <div class=\"checkbox_custom\">\n            <label class=\"label_switch\" for=\"perm-{{perm.perm}}\">{{perm.label}}</label>\n            <input type=\"checkbox\" id=\"checkbox1\" name=\"perm-{{perm.perm}}\" type=\"checkbox\" name=\"perm-{{perm.perm}}\" ng-model=\"$ctrl.permslist[$index].enabled\"\n                ng-change=\"togglePermInProfile(perm)\" ng-disabled=\"!$ctrl.currentProfile.is_admin && perm.perm === 'is-admin'\"\n                ng-click=\"togglePerm(perm)\" class=\"pull-right\" />\n            <div class=\"switch\"></div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteUsersController = function () {
		function InviteUsersController(PermissionsService, ContentService, AuthService, $validation, $translate) {
			(0, _classCallCheck3.default)(this, InviteUsersController);
	
			this.permsService = PermissionsService;
			this.service = ContentService;
			this.auth = AuthService;
			this.validation = $validation;
			this.trans = $translate.instant;
		}
	
		(0, _createClass3.default)(InviteUsersController, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.subscriptions = [];
	
				var _ = this.trans;
				this.validation.setExpression({
					multiemail: /^$|^(([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\,(\s)?)?)+$/
				}).setDefaultMsg({
					multiemail: {
						error: _("No es un correo o listado de correos válido")
					}
				});
				this.permslist = {};
				this.subscriptions.push(this.permsService.getPermissions().subscribe(function (permissions) {
					_this.permslist = permissions;
				}));
				this.currentProfile = this.auth.getProfile();
			}
		}, {
			key: '$onDestroy',
			value: function $onDestroy() {
				this.subscriptions.forEach(function (sub) {
					return sub.unsubscribe();
				});
			}
		}, {
			key: 'inviteUser',
			value: function inviteUser() {
				var _this2 = this;
	
				var perms = this.permslist.filter(function (perm) {
					return perm.enabled;
				}).map(function (perm) {
					return perm.perm;
				});
				this.subscriptions.push(this.service.inviteUser(this.emails, perms).subscribe(function () {
					_this2.emails = null;_this2.permslist.forEach(function (p) {
						return p.enabled = false;
					});
				}));
			}
		}]);
		return InviteUsersController;
	}();
	
	exports.default = InviteUsersController;
	
	
	InviteUsersController.$inject = ['PermissionsService', 'ContentService', 'AuthService', '$validation', '$translate'];

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1238);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./invite-users.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./invite-users.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".InviteUsers .checkbox_custom label_switch{margin:5px 0 0}", ""]);
	
	// exports


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _printedBills = __webpack_require__(1240);
	
	var _printedBills2 = _interopRequireDefault(_printedBills);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintedBillsModule = _angular2.default.module('PrintedBills', [_angularjs2.default]).component('printedbills', _printedBills2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('printedBills', {
	    url: '/printed-bills',
	    data: {
	      authRequired: true,
	      permsRequired: ['printed-bills']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'printedbills'
	      }
	    }
	  });
	}]).name;
	
	exports.default = PrintedBillsModule;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _printedBills = __webpack_require__(1241);
	
	var _printedBills2 = _interopRequireDefault(_printedBills);
	
	var _printedBills3 = __webpack_require__(1242);
	
	var _printedBills4 = _interopRequireDefault(_printedBills3);
	
	__webpack_require__(1243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintedBillsComponent = {
	  bindings: {},
	  template: _printedBills2.default,
	  controller: _printedBills4.default
	};
	
	exports.default = PrintedBillsComponent;

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{'Facturas impresas' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{$ctrl.rows.length || 0}}\n                </span>\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form class=\"\">\n            <div class=\"printed_bill_container col-md-12 no-padding\">\n                \t<div class=\"col-md-12 hidden-xs\">\n\t                \t<div class=\"col-md-3 printInvoice_padding\">\n\t                        <input type=\"checkbox\" id=\"filter-by-date\" class=\"pi_checkbox\" ng-model=\"$ctrl.filterBy.date\">\n\t\t\t\t\t\t    <label for=\"filter-by-date\">{{'Por Fecha' | translate}}</label>\n\t                    </div> \t\n\t\t                <div class=\"col-md-9\">\n\t\t\t                <div class=\"input-group\">\n\t\t\t                    <label for=\"datefrom\" class=\"input-group-addon\">{{'Fecha desde' | translate}}</label>\n\t\t\t                    <input type=\"text\" name=\"datefrom\" ng-model=\"$ctrl.reportParams.date_from\" value=\"\" id=\"datefrom\" class=\"form-control printInvoice_input  | translateinput_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.reportParams.date_from\" start-view=\"month\" ng-disabled=\"!$ctrl.filterBy.date\">\n\t\t\t                    <label for=\"dateto\" class=\"input-group-addon\">{{'Fecha hasta' | translate}}</label>\n\t\t\t                    <input type=\"text\" name=\"dateto\" ng-model=\"$ctrl.reportParams.date_to\" value=\"\" id=\"dateto\" class=\"form-control printInvoice_input input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.reportParams.date_to\" start-view=\"month\" ng-disabled=\"!$ctrl.filterBy.date\">\n\t\t\t                </div>\n\t\t            \t</div>\n\t            \t</div>\n\t\t\t<div class=\"row visible-xs date-printed\">\n\t\t\t\t<div class=\"col-md-3 printInvoice_padding\">\n\t                        <input type=\"checkbox\" id=\"filter-by-date\" class=\"pi_checkbox\" ng-model=\"$ctrl.filterBy.date\">\n\t\t\t\t\t\t    <label for=\"filter-by-date\">{{'Por Fecha' | translate}}</label>\n\t                    </div> \t\n\t\t\t\t\t<div class=\"col-xs-6 form-group  padding_right\">\n\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n\t\t\t\t\t  <input type=\"text\" name=\"datefrom\" ng-model=\"$ctrl.reportParams.date_from\" value=\"\" id=\"datefrom\" class=\"form-control printInvoice_input input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.reportParams.date_from\" start-view=\"month\" ng-disabled=\"!$ctrl.filterBy.date\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-xs-6 form-group padding_left\">\n\t\t\t\t\t\t<p class=\"label_m\" for=\"desde\">{{'Hasta' | translate}}</p>\n\t\t\t\t\t\t<input type=\"text\" name=\"dateto\" ng-model=\"$ctrl.reportParams.date_to\" value=\"\" id=\"dateto\" class=\"form-control printInvoice_input input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" moment-picker=\"$ctrl.reportParams.date_to\" start-view=\"month\" ng-disabled=\"!$ctrl.filterBy.date\">\n\t\t\t\t\t</div>\n\t\t\t</div> \n\t            \t<div class=\"col-md-12 border-top\">\n\t            \t\t<div class=\"col-md-3 printInvoice_padding\">\n\t                    \t<input type=\"checkbox\" id=\"filter-by-amount\" class=\"pi_checkbox\" ng-model=\"$ctrl.filterBy.amount\">\n\t                        <label for=\"filter-by-amount\">{{'Por Monto' | translate}}</label>\n                    \t</div>\n\t            \t\t<div class=\"col-md-9\">\n\t\t\t                <div class=\"input-group\">\n\t\t\t                    <label for=\"amountfrom\" class=\"input-group-addon\">{{'Monto' | translate}}</label>\n\t\t\t                    <input type=\"text\" name=\"amountfrom\" class=\"form-control printInvoice_input input_py\" ng-model=\"$ctrl.reportParams.amount\" value=\"\" id=\"amountfrom\" ng-disabled=\"!$ctrl.filterBy.amount\">\n\t\t\t                </div>\n\t                \t</div>\n\t            \t</div>\n\t           \n\t                <div class=\"col-md-12 border-top\">\n\t                \t<div class=\"col-md-3 printInvoice_padding\">\n\t                        <input type=\"checkbox\" id=\"filter-by-product\" class=\"pi_checkbox\" ng-model=\"$ctrl.filterBy.product\">\n\t                        <label for=\"filter-by-product\">{{'Por producto' | translate}}</label> \n                    \t</div>\n\t\t                <div class=\"col-md-9\">\n\t\t\t                <div class=\"input-group\">\n\t\t\t                    <label for=\"product\" class=\"input-group-addon\">{{'Producto' | translate}}</label>\n\t\t\t                    <input type=\"text\" name=\"product\" class=\"form-control printInvoice_input input_py\" id=\"product\" ng-model=\"$ctrl.reportParams.product\" ng-disabled=\"!$ctrl.filterBy.product\">\n\t\t\t                </div>\n\t\t                </div>\n\t                </div>\n\t                <div class=\"col-md-12 text-center\">\n\t\t               \n\t\t                   <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findReport()\" ng-disabled=\"!$ctrl.filterBy.date && !$ctrl.filterBy.amount && !$ctrl.filterBy.product\">{{'Buscar' | translate}}</button>\n\t\t                \n\t                </div>\n\t                \n            </div>\n        </form>\n    </div>\n    <div class=\"col-md-12 table_container no_padding\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n                        <thead>\n                            <th>{{'Número de factura' | translate}}</th>\n                            <th>{{'Fecha' | translate}}</th>\n                            <th>{{'Pax' | translate}}</th>\n                            <th>{{'Descuento' | translate}}</th>\n                            <th>{{'Total' | translate}}</th>\n                            <th>{{'% Ley' | translate}}</th>\n                        </thead>\n                        <tbody>\n                            <tr class=\"text-center clickable\" ng-click=\"$ctrl.openBillDetails(row.id)\" if-perm disable-if=\"account-bills, invoice-orders\"\n                                ng-repeat=\"row in $ctrl.rows\">\n                                <td data-label=\"Número de factura:\"> {{row.billid}} </td>\n                                <td data-label=\"Fecha:\" class=\"text-center\"> {{row.date | amUtc | amDateFormat:'LLL'}} </td>\n                                <td data-label=\"Pax:\" class=\"text-center\"> {{ row.pax }} </td>\n                                <td data-label=\"Descuento:\" class=\"text-right\"> {{row.discount | currency }} </td>\n                                <td data-label=\"Total:\" class=\"text-right\"> {{ row.total | currency }} </td>\n                                <td data-label=\"% Ley:\" class=\"text-right\"> {{ row.tax10 | currency }} </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<script type='text/ng-template' id=\"invoice-details-template.html\">\n\t<div class=\"modal-header\">\n    \t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t\t{{'Detalle de Factura' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    \t</h3>\n  \t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n    <nav>\n        <ul class=\"Tabs\">\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: !showOrders}\" ng-click=\"showOrders=false\"\n\t\t\t\tif-perm disable-if=\"account-bills\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Factura' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: showOrders}\" ng-click=\"getOrders(); showOrders=true\"\n\t\t\t\tif-perm disable-if=\"invoice-orders\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Órdenes' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\">\n                <button class=\"btn btn-default pull-right\" ng-click=\"printToCart('printSectionId')\">\n                    <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                </button>\n            </li>\n            <li class=\"Tabs__presentation-slider\" role=\"presentation\"></li>\n        </ul>\n    </nav>\n\n\t\t<!-- start print -->\n\t\t<div id=\"printSectionId\" class=\"Section_Print\">\n\t\t\t<div class=\"Powered\">\n\t\t\t\t<span>{{'RNC' | translate}}: </span>{{account.identification || '-'}} <br>\n\t\t\t\t<span>{{'Dirección' | translate}}: </span>{{ account.address || '-'}} <br>\n\t\t\t\t<span>{{'Telefono' | translate}}: </span>{{ account.phone || '-'}}\n\t\t\t</div>\n\t\t\t<div class=\"logo_invoice\">\n\t\t\t\t<img src=\"{{ logoUrl }}\" alt=\"\">\n\t\t\t</div>\n\t\t\t<div class=\"print_separator\"></div>\n\t\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-condensed tableforprint\">\n\t\t\t\t\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-right\" colspan=\"2\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong><span>{{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<!-- <tr>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Mesa No.:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Atendida por:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td \"3\">\n\t\t\t\t\t\t<strong>Pax:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr> -->\n\t\t\t\t\n\t\t\t\t<tr>\n\t\t\t\t\t<th class=\"text-center\" \"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Descuento' | translate}}</th>\n\t\t\t\t\t<th class=\"text-center\">{{'Total' | translate}}</th>\n\t\t\t\t\t\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td class=\"text-center\" \"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.discount | currency }}</td>\n\t\t\t\t\t<td class=\"text-center\">{{ detail.total | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"><hr></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'Notas' | translate}}:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'Subtotal' | translate}}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{'Comensales' | translate}}: <span>{{ invoice.pax }}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'Descuento' | translate}}</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.discount | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"2\">\n\t\t\t\t\t\t<span>{{'Atendido por' | translate}}: </span>\n\t\t\t\t\t\t<span>{{ invoice.cashier || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{'% Ley' | translate}}:</span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{'IVA' | translate}}:</span> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{ invoice.tax10 | currency }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>{{'Exoneracion IVA' | translate}}:</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span>0.000</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr class=\"text-center\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span></span> \n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<strong>{{ invoice.total | currency }}</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<!-- <td \"3\">\n\t\t\t\t\t\t<strong>Impuestos incluidos:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td> -->\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\t</div>\n\t<!-- end print -->\n\n\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-bordered table-condensed\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong> {{ invoice.date | amUtc | amDateFormat:'DD/MMM/YYYY'  }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Emitido a' | translate}}:</strong> {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Mesa No.' | translate}}:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Atendida por' | translate}}:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Descuento' | translate}}:</strong> {{ invoice.discount | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Pax' | translate}}:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong> {{ invoice.total | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Impuestos incluidos' | translate}}:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Impuesto IVA' | translate}}:</strong> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'% Ley' | translate}}:</strong> {{ invoice.tax10 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th colspan=\"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th>{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th>{{'Total' | translate}}</th>\n\t\t\t\t\t<th>{{'Desc.' | translate}}</th>\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td colspan=\"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.total | currency }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.discount | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=\"orders\" ng-show=\"showOrders\">\n\t\t\t<table id=\"pruena\" class=\"table table-bordered table-condensed\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>{{'Factura' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Acción' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Fecha' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Camarero' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Estado' | translate}}</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat=\"order in orders\">\n\t\t\t\t\t\t<td data-label=\"Factura\">\n\t\t\t\t\t\t\t<a href=\"\" data-ajax_load=\"\" data-container=\"#billpayment\" class=\"btn btn-xs btn-primary\"\n\t\t\t\t\t\t\t\tng-click=\"fetchDetails(order)\">\n\t\t\t\t\t\t\t\t{{ order.id }}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td data-label=\"Acción\">{{ order.action || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Fecha\">{{ order.date | amUtc | amDateFormat:'LLL' }}</td>\n\t\t\t\t\t\t<td data-label=\"Camarero\">{{ order.cashier || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Estado\">{{ order.status || '-' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t\t<table class=\"table table-bordered table-condensed\" ng-show=\"displayingOrder\">\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr><td colspan=\"4\">{{ displayingOrder.action || '-' }}</td></tr>\n\t\t\t\t\t<tr class=\"table_list_heading\">\n\t\t\t\t\t\t<th class=\"detail_table hidden-xs hidden-sm\" width=\"100\"><b>{{'De la Factura' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"De la Factura:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.billid || '-' }}</td>\n\t\t\t\t\t\t<th class=\" hidden-xs hidden-sm\" width=\"100\"><b>{{'Fecha' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.date | amUtc | amLocal| amDateFormat:'LLL' }}\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>{{'Camarero' | translate}}:</b></th>\n\t\t\t\t\t\t<td data-label=\"Camarero:\">{{ displayingOrder.cashier || '-' }}</td>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>Mesa:</b></th>\n\t\t\t\t\t\t<td data-label=\"Mesa:\" colspan=\"2\">{{ displayingOrder.table_type || '-' }} {{ displayingOrder.table_code || '' }}</td>\n\t\t\t\t\t</tr>\n\n\t\t\t\t\t<tr class=\"table_graund\" ng-repeat=\"detail in displayingOrder.details\">\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.name  || '-' }}</td>\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.qty  || 0 }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">\n\t\t\t{{'Salir' | translate}}\n\t\t</button>\n\t</div>\n</script>"

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintedBillsController = function () {
	  function PrintedBillsController(ContentService, $state, moment, ProfilePermissionsService, $uibModal) {
	    (0, _classCallCheck3.default)(this, PrintedBillsController);
	
	    this.service = ContentService;
	    this.state = $state;
	    this.moment = moment;
	    this.permissionsService = ProfilePermissionsService;
	    this.modal = $uibModal;
	  }
	
	  (0, _createClass3.default)(PrintedBillsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.reportParams = {
	        date_to: undefined,
	        date_from: undefined,
	        amount: undefined,
	        product: undefined
	      };
	      this.filterBy = {
	        date: true,
	        amount: false,
	        product: false
	      };
	      this.rows = [];
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'findReport',
	    value: function findReport() {
	      var _this = this;
	
	      var date_to = this.reportParams.date_to ? this.reportParams.date_to.toISOString() : undefined;
	      var date_from = this.reportParams.date_from ? this.reportParams.date_from.toISOString() : undefined;
	
	      this.subscriptions.push(this.service.findPrintedBillsReport({
	        date_to: this.filterBy.date ? date_to : undefined,
	        date_from: this.filterBy.date ? date_from : undefined,
	        amount: this.filterBy.amount ? this.reportParams.amount : undefined,
	        product: this.filterBy ? this.reportParams.product : undefined
	      }).subscribe(function (data) {
	        _this.rows = data.rows;
	      }));
	    }
	  }, {
	    key: 'openBillDetails',
	    value: function openBillDetails(invoiceId) {
	      var that = this;
	      if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')) {
	        this.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'invoice-details-template.html',
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "$uibModalInstance", "AccountInformationService", function controller($scope, $uibModalInstance, AccountInformationService) {
	            "ngInject";
	
	            $scope.invoice = {};
	            $scope.orders = [];
	            $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
	
	            that.subscriptions.push(that.service.getInvoice(invoiceId).subscribe(function (invoice) {
	              return $scope.invoice = invoice;
	            }, function (error) {
	              return console.log("Error while getting the invoice");
	            }));
	
	            that.subscriptions.push(AccountInformationService.getAccountInfo().subscribe(function (resp) {
	              $scope.account = resp;
	            }));
	
	            $scope.getOrders = function () {
	              if ($scope.orders.length <= 0) {
	                that.subscriptions.push(that.service.getOrders(invoiceId).subscribe(function (orders) {
	                  return $scope.orders = orders;
	                }, function (error) {
	                  return console.log("Error while getting the orders");
	                }));
	              }
	            };
	            $scope.fetchDetails = function (order) {
	              if (!order.details || order.details.length <= 0) {
	                that.subscriptions.push(that.service.getOrderDetails(invoiceId, order.id).subscribe(function (details) {
	                  order.details = details;
	                  $scope.displayingOrder = order;
	                }, function (error) {
	                  return console.log("Error while getting the details for this order");
	                }));
	              }
	            };
	
	            $scope.printToCart = function (printSectionId) {
	              var innerContents = document.getElementById(printSectionId).innerHTML;
	              var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	              popupWinindow.document.open();
	              var styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              var styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
	              popupWinindow.document.write('<html><head><title>Imprimir factura #' + $scope.invoice.number + '</title><style>' + styleprint.innerHTML + '</style><style>' + styleprintBootstrap.innerHTML + '</style></head><body onload="window.print()">' + innerContents + '</html>');
	              popupWinindow.document.close();
	            };
	
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	          }]
	        });
	      }
	    }
	  }]);
	  return PrintedBillsController;
	}();
	
	exports.default = PrintedBillsController;
	
	
	PrintedBillsController.$inject = ['ContentService', '$state', 'moment', 'ProfilePermissionsService', '$uibModal'];

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1244);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./printed-bills.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./printed-bills.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "printedbills .input-group{margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _salesByCategory = __webpack_require__(1246);
	
	var _salesByCategory2 = _interopRequireDefault(_salesByCategory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByCategoryModule = _angular2.default.module('SalesByCategory', [_angularjs2.default]).component('salesbycategory', _salesByCategory2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesByCategory', {
	    url: '/sales-by-category',
	    data: {
	      authRequired: true,
	      permsRequired: ['sales-by-category']
	    },
	    params: {
	      dateTo: null,
	      dateFrom: null,
	      famId: null,
	      title: null
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'salesbycategory'
	      }
	    },
	    resolve: {
	      itemsObservable: ["ContentService", "$transition$", function itemsObservable(ContentService, $transition$) {
	        var params = $transition$.params();
	        if (params && params.dateTo && params.dateFrom && params.famId) {
	          return ContentService.findSalesByCategory({
	            date_to: params.dateTo.toISOString(),
	            date_from: params.dateFrom.toISOString()
	          }, params.famId);
	        } else {
	          return null;
	        }
	      }],
	      dates: ["$transition$", function dates($transition$) {
	        var params = $transition$.params();
	        if (params && params.dateTo && params.dateFrom) {
	          return {
	            dateFrom: params.dateFrom,
	            dateTo: params.dateTo,
	            title: params.title
	          };
	        } else {
	          return null;
	        }
	      }]
	
	    }
	  });
	}]).name;
	
	exports.default = SalesByCategoryModule;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesByCategory = __webpack_require__(1247);
	
	var _salesByCategory2 = _interopRequireDefault(_salesByCategory);
	
	var _salesByCategory3 = __webpack_require__(1248);
	
	var _salesByCategory4 = _interopRequireDefault(_salesByCategory3);
	
	__webpack_require__(1249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByCategoryComponent = {
	  bindings: {
	    itemsObservable: '<',
	    dates: '<'
	  },
	  template: _salesByCategory2.default,
	  controller: _salesByCategory4.default
	};
	
	exports.default = SalesByCategoryComponent;

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <span ng-if=\"$ctrl.isGroupedByCategory() || !$ctrl.rows.length\">{{'Ventas por Categoría' | translate}}</span>\n                <span ng-if=\"$ctrl.isGroupedByItem()\">{{'Ventas de la categoría' | translate}} {{$ctrl.title | lowercase | capitalise}}</span>\n                <span ng-if=\"$ctrl.isGroupedByInvoice()\">{{'Ventas del artículo' | translate}} {{$ctrl.title | lowercase | capitalise}}</span>\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.rows.length || 0 }}\n                </span>\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form name=\"salesByVendorForm\" class=\"hidden-xs\">\n            <div class=\"form col-md-12 no-padding\">\n                <input type=\"hidden\" name=\"sorter\" value=\"\">\n                <input type=\"hidden\" name=\"cashier_id\" value=\"\">\n                <input type=\"hidden\" name=\"pos_id\" value=\"\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>    \n                    <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" id=\"from\" class=\"form-control input_py\"\n\t\t\t\t\t\t\tformat=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\">\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>    \n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" id=\"to\" class=\"form-control input_py\"\n\t\t\t\t\t\t\tformat=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\">  \n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.findSalesByCategory()\">{{'Buscar' | translate}}</button>    \n                    </span>\n                </div>\n            </div>\n        </form>\n        <form class=\"visible-xs\">\n            <div class=\"form_xs\">\n                <div class=\"form-group\">\n                    <p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n                    <input class=\"form-control input_py\" name=\"from\" moment-picker=\"$ctrl.dateFrom\" ng-model=\"$ctrl.dateFrom\" format=\"DD/MM/YYYY\" today=\"true\" autocomplete=\"off\" start-view=\"month\">\n                </div>\n                <div class=\"form-group\">\n                    <p class=\"label_m\" for=\"desde\">{{'Hasta' | translate}}</p>\n                    <input class=\"form-control input_py\" name=\"to\" moment-picker=\"$ctrl.dateTo\" ng-model=\"$ctrl.dateTo\" format=\"DD/MM/YYYY\" today=\"true\" autocomplete=\"off\" start-view=\"month\">\n                </div>\n                <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.findSalesByCategory()\">{{'Buscar' | translate}}</button>    \n            </div>\n        </form>\n    </div>\n\t<div class=\"col-md-12 table_container\">\n\t\t<div class=\"card\">\n\t\t\t<div class=\"card-content\">\n\t\t\t\t<div class=\"bootstrap-table\">\n\t\t\t\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t\t\t\t<div class=\"search col-md-4 \">\n\t\t\t\t\t\t\t<div class=\"field\">\n\t\t\t\t\t\t\t\t<input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n\t\t\t\t\t\t\t\t<label for=\"input-search\">{{'Filtrar búsqueda' | translate}}</label>\n\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t</div>\n                    </div>\n                    <div class=\"fixed-table-container\">\n                        <div class=\"fixed-table-body\">\n                            <table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n                                <thead class=\"col_width\">\n                                    <tr ng-if=\"$ctrl.isGroupedByCategory()\">\n                                        <th>{{'Categoria' | translate}}</th>\n                                        <th>{{'Desc.' | translate}}</th>\n                                        <th>{{'Total' | translate}}</th>\n                                    </tr>\n                                    <tr ng-if=\"$ctrl.isGroupedByItem()\">\n                                        <th>{{'Artículo' | translate}}</th>\n                                        <th>{{'Cantidad Total' | translate}}</th>\n                                        <th>{{'Cantidad Facturada' | translate}}</th>\n                                        <th>{{'Total Facturado' | translate}}</th>\n                                        <th>{{'Desc. por Artículo' | translate}}</th>\n                                        <th>{{'Desc. Facturado' | translate}}</th>\n                                        <th>{{'Cantidad OTH/Broken' | translate}}</th>\n                                        <th>{{'Total OTH/Broken' | translate}}</th>\n                                        <th>{{'Cantidad Cancelada' | translate}}</th>\n                                        <th>{{'Total Cancelado' | translate}}</th>\n                                        <th>{{'Cantidad Devuelta' | translate}}</th>\n                                        <th>{{'Total Devuelto' | translate}}</th>    \n                                    </tr>\n                                    <tr ng-if=\"$ctrl.isGroupedByInvoice()\">\n\t\t\t\t\t\t\t\t\t\t<th>{{'Fecha' | translate}}</th>\n\t\t\t\t\t\t\t\t\t\t<th>{{'NCF' | translate}}</th>\n\t\t\t\t\t\t\t\t\t\t<th>{{'Nombre' | translate}}</th>\n                                        <th>{{'RNC' | translate}}</th>\n\t\t\t\t\t\t\t\t\t\t<th>{{'Pax' | translate}}</th>\n\t\t\t\t\t\t\t\t\t\t<th>{{'Desc.' | translate}}</th>\n\t\t\t\t\t\t\t\t\t\t<th>{{'Total' | translate}}</th>\n\t\t\t\t\t\t\t\t\t\t<th>{{'Exoneracion' | translate}}</th>\n\t\t\t\t\t\t\t\t\t\t<th>{{'Prop.Extra' | translate}}</th>\n\t\t\t\t\t\t\t\t\t\t<th>{{'Propina' | translate}}</th>\n\t\t\t\t\t\t\t\t\t\t<th>{{'IVA' | translate}}</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByCategory()\" ng-click=\"$ctrl.drillDownOnCategory(row.pifamm_id)\">\n                                        <td class=\"text-center\">{{row.pifamm_name || '-' | lowercase | capitalise}}</td>\n                                        <td class=\"text-center\">{{row.discount | currency}}</td>\n                                        <td class=\"text-center\">{{row.total | currency}}</td>\n                                    </tr>\n                                    <tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByItem()\" ng-click=\"$ctrl.drillDownOnItem(row.item_id, row.description)\">\n                                        <td data-label=\"Artículo\" class=\"text-center\">{{ row.description | lowercase | capitalise }}</td>\n                                        <td data-label=\"Cantidad total\" class=\"text-right\">{{ row.total_qty }}</td>\n                                        <td data-label=\"Cantidad facturada\" class=\"text-right\">{{ row.qty_billed }}</td>\n                                        <td data-label=\"Total facturado\" class=\"text-right\">{{ row.total_billed | currency }}</td>\n                                        <td data-label=\"Desc. por articulo\" class=\"text-right\">{{ row.item_discount | currency }}</td>\n                                        <td data-label=\"Desc. facturado\" class=\"text-right\">{{ row.discount_billed | currency }}</td>\n                                        <td data-label=\"Cantidad OTH/Broken\" class=\"text-right\">{{ row.oth_qty }}</td>\n                                        <td data-label=\"Total OTH/Broken\" class=\"text-right\">{{ row.oth_total | currency }}</td>\n                                        <td data-label=\"Cantidad cancelada\" class=\"text-right\">{{ row.cancelation_qty }}</td>\n                                        <td data-label=\"Total cancelado\" class=\"text-right\">{{ row.cancelation_total | currency }}</td>\n                                        <td data-label=\"Cantidad devuelta\" class=\"text-right\">{{ row.return_qty }}</td>\n                                        <td data-label=\"Total devuelto\" class=\"text-right\">{{ row.return_total | currency }}</td>\n                                    </tr>\n                                    <tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-click=\"$ctrl.openBillDetails(row.id)\">\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"text-center\">{{ row.date | amUtc | amDateFormat:'DD-MMM-YYYY hh:mm' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"NCF:\" class=\"text-center\">{{ row.ncf || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Nombre:\" class=\"text-center\">{{ row.name || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"RNC:\" class=\"text-center\">{{ row.rnc || '-' }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Pax:\" class=\"text-center\">{{ row.pax }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Desc.:\" class=\"text-right\">{{ row.discount | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Total:\" class=\"text-right\">{{ row.total | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Exoneracion:\" class=\"text-right\">{{ row.taxexemption | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"Prop.Extra:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"%Ley:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n\t\t\t\t\t\t\t\t\t\t<td data-label=\"IVA:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n                                    </tr>\n                                </tbody>\n                                <tfoot>\n                                    <tr ng-if=\"$ctrl.isGroupedByCategory()\">\n                                        <th></th>\n                                        <th class=\"text-right\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</th>\n                                        <th class=\"text-right\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</th>\n                                    </tr>\n                                    <tr ng-if=\"$ctrl.isGroupedByItem()\">\n                                        <th colspan=\"3\"></th>\n                                        <th data-field=\"salary\" class=\"text-right\">\n                                            <div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n                                        </th>\n                                        <th></th>\n                                        <th data-field=\"salary\" class=\"text-right\">\n                                            <div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n                                        </th>\n                                        <th></th>\n                                        <th data-field=\"salary\" class=\"text-right\">\n                                            <div class=\"th-inner\">{{ filtered | map: $ctrl.getOth | sum: 0 | currency }}</div>\n                                        </th>\n                                        <th></th>\n                                        <th data-field=\"salary\" class=\"text-right\">\n                                            <div class=\"th-inner\">{{ filtered | map: $ctrl.getVoid | sum: 0 | currency }}</div>\n                                        </th>\n                                        <th></th>\n                                        <th data-field=\"salary\" class=\"text-right\">\n                                            <div class=\"th-inner\">{{ filtered | map: $ctrl.getReturned | sum: 0 | currency }}</div>\n                                        </th>\n                                    </tr>\n                                    <tr ng-if=\"$ctrl.isGroupedByInvoice()\" >\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Pax:\" colspan=\"{{ $ctrl.isGroupedByInvoice() ? 5 : 2 }}\" data-field=\"name\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getPax | sum: 0 }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Desc.:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Exoneración:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTaxExemption | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Prop.Extra:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getExtraTip | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total Propina:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTax10 | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t<th data-label=\"Total IVA:\" data-field=\"salary\" class=\"text-right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"th-inner\">{{ filtered | map: $ctrl.getTax16 | sum: 0 | currency }}</div>\n\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t</tr>\n                                </tfoot>\n                            </table>\n                        </div>        \n                    </div>\n                </div>\n            </div>\n            <div class=\"clearfix\"></div>            \n        </div>\n\t</div>\n</div>\n<script type='text/ng-template' id=\"invoice-details-template.html\">\n\t<div class=\"modal-header\">\n    \t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t\t{{'Detalle de Factura' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    \t</h3>\n  \t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n    <nav>\n        <ul class=\"Tabs\">\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: !showOrders}\" ng-click=\"showOrders=false\"\n\t\t\t\tif-perm disable-if=\"account-bills\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Factura' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: showOrders}\" ng-click=\"getOrders(); showOrders=true\"\n\t\t\t\tif-perm disable-if=\"invoice-orders\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Órdenes' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\">\n                <button class=\"btn btn-default pull-right\" ng-click=\"printToCart('printSectionId')\">\n                    <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                </button>\n            </li>\n            <li class=\"Tabs__presentation-slider\" role=\"presentation\"></li>\n        </ul>\n    </nav>\n\n    <!-- start print -->\n            <div id=\"printSectionId\" class=\"Section_Print\">\n                <div class=\"logo_invoice\">\n                    <img src=\"{{ logoUrl }}\" alt=\"\">\n                <div class=\"Powered\">\n                    <span>{{'RNC' | translate}}: </span>{{account.identification || '-'}} <br>\n                    <span>{{'Dirección' | translate}}: </span>{{ account.address || '-'}} <br>\n                    <span>{{'Telefono' | translate}}: </span>{{ account.phone || '-'}}\n                </div>\n                </div>\n                <div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n                <table class=\"table table-condensed tableforprint\">\n                    \n                    <tr>\n                        <td>\n                            <strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n                        </td>\n                        <td class=\"text-right\">\n                            <strong>{{'Fecha' | translate}}:</strong> <span>{{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise  }}</span>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            <strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            {{'RNC' | translate}} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n                        </td>\n                    </tr>\n                    <!-- <tr>\n                        <td \"3\">\n                            <strong>Mesa No.:</strong> {{ invoice.table }}\n                        </td>\n                        <td \"3\">\n                            <strong>Atendida por:</strong> {{ invoice.cashier || '-' }}\n                        </td>\n                        <td \"3\">\n                            <strong>Pax:</strong> {{ invoice.pax }}\n                        </td>\n                    </tr> -->\n                    \n                    <tr><td><hr></td></tr>\n                    <tr>\n                        <th class=\"text-center\" \"3\">{{'Detalles' | translate}}</th>\n                        <th class=\"text-center\">{{'Cantidad' | translate}}</th>\n                        <th class=\"text-center\">{{'Descuento' | translate}}</th>\n                        <th class=\"text-center\">{{'Total' | translate}}</th>\n                        \n                    </tr>\n                    <tr ng-repeat=\"detail in invoice.details\">\n                        <td class=\"text-center\" \"3\">{{ detail.description || '-' }}</td>\n                        <td class=\"text-center\">{{ detail.quantity || 0 }}</td>\n                        <td class=\"text-center\">{{ detail.discount | currency }}</td>\n                        <td class=\"text-center\">{{ detail.total | currency }}</td>\n                    </tr>\n                    <tr><td colspan=\"6\"><hr></td></tr>\n                    <tr>\n                        <td>\n                            <strong>{{'Notas' | translate}}:</strong>\n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{'Subtotal' | translate}}</span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>0.000</span>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            {{'Comensales' | translate}}: <span>{{ invoice.pax }}</span> \n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{'Descuento' | translate}}</span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{ invoice.discount | currency }}</span>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td colspan=\"2\">\n                            <span>{{'Atendido por' | translate}}: </span>\n                            <span>{{ invoice.cashier || '-' }}</span>\n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{'% Ley' | translate}}:</span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{ invoice.tax10 | currency }}</span>\n                        </td>\n                    </tr>\n                    <tr class=\"text-center\">\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span>{{'IVA' | translate}}:</span> {{ invoice.tax16 | currency }}\n                        </td>\n                        <td>\n                            <span>{{ invoice.tax10 | currency }}</span>\n                        </td>\n                    </tr>\n                    <tr class=\"text-center\">\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span>{{'Exoneracion IVA' | translate}}:</span>\n                        </td>\n                        <td>\n                            <span>0.000</span>\n                        </td>\n                    </tr>\n                    <tr class=\"text-center\">\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <strong>{{'Total' | translate}}:</strong>\n                        </td>\n                        <td>\n                            <strong>{{ invoice.total | currency }}</strong>\n                        </td>\n                        <!-- <td \"3\">\n                            <strong>Impuestos incluidos:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n                        </td> -->\n                    </tr>\n                </table>\n            </div>\n            </div>\n    <!-- end print -->\n\n\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-bordered table-condensed\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong> {{ invoice.date | amUtc | amDateFormat:'DD/MMM/YYYY'  }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Emitido a' | translate}}:</strong> {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Mesa No.' | translate}}:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Atendida por' | translate}}:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Desc.' | translate}}:</strong> {{ invoice.discount | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Pax' | translate}}:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong> {{ invoice.total | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Impuestos incluidos' | translate}}:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'IVA' | translate}}:</strong> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'% Ley' | translate}}:</strong> {{ invoice.tax10 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th colspan=\"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th>{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th>{{'Total' | translate}}</th>\n\t\t\t\t\t<th>{{'Desc.' | translate}}</th>\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details\">\n\t\t\t\t\t<td colspan=\"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.total | currency }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.discount | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=\"orders\" ng-show=\"showOrders\">\n\t\t\t<table id=\"pruena\" class=\"table table-bordered table-condensed\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>{{'Factura' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Acción' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Fecha' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Vendedor' | translate}}</th>\n\t\t\t\t\t\t<th>{{'Estado' | translate}}</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat=\"order in orders\">\n\t\t\t\t\t\t<td data-label=\"Factura\">\n\t\t\t\t\t\t\t<a href=\"\" data-ajax_load=\"\" data-container=\"#billpayment\" class=\"btn btn-xs btn-primary\"\n\t\t\t\t\t\t\t\tng-click=\"fetchDetails(order)\">\n\t\t\t\t\t\t\t\t{{ order.id }}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td data-label=\"Acción\">{{ order.action || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Fecha\">{{ order.date | amUtc | amDateFormat:'DD/MMM/YYYY' }}</td>\n\t\t\t\t\t\t<td data-label=\"Vendedor\">{{ order.cashier || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Estado\">{{ order.status || '-' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t\t<table class=\"table table-bordered table-condensed\" ng-show=\"displayingOrder\">\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr><td colspan=\"4\">{{ displayingOrder.action || '-' }}</td></tr>\n\t\t\t\t\t<tr class=\"table_list_heading\">\n\t\t\t\t\t\t<th class=\"detail_table hidden-xs hidden-sm\" width=\"100\"><b>{{'De la Factura' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"De la Factura:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.billid || '-' }}</td>\n\t\t\t\t\t\t<th class=\" hidden-xs hidden-sm\" width=\"100\"><b>{{'Fecha' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.date | amUtc | amDateFormat:'LLL' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>{{'Vendedor' | translate}}:</b></th>\n\t\t\t\t\t\t<td data-label=\"Vendedor:\">{{ displayingOrder.cashier || '-' }}</td>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>Mesa:</b></th>\n\t\t\t\t\t\t<td data-label=\"Mesa:\" colspan=\"2\">{{ displayingOrder.table_type || '-' }} {{ displayingOrder.table_code || '' }}</td>\n\t\t\t\t\t</tr>\n\n\t\t\t\t\t<tr class=\"table_graund\" ng-repeat=\"detail in displayingOrder.details\">\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.name  || '-' }}</td>\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.qty  || 0 }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">\n\t\t\t{{'Salir' | translate}}\n\t\t</button>\n\t</div>\n</script>\n"

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByCategoryController = function () {
	  function SalesByCategoryController(ContentService, isMobile, moment, ProfilePermissionsService, $uibModal) {
	    (0, _classCallCheck3.default)(this, SalesByCategoryController);
	
	    this.service = ContentService;
	    this.isMobile = isMobile;
	    this.moment = moment;
	    this.permissionsService = ProfilePermissionsService;
	    this.modal = $uibModal;
	  }
	
	  (0, _createClass3.default)(SalesByCategoryController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      if (this.dates) {
	        this.dateFrom = this.dates.dateFrom;
	        this.dateTo = this.dates.dateTo;
	        this.title = this.dates.title;
	      }
	      this.dateFrom = this.moment(this.dateFrom || new Date());
	      this.dateTo = this.moment(this.dateTo || new Date());
	      this.rows = [];
	      if (this.itemsObservable) {
	        this.itemsObservable.subscribe(function (data) {
	          _this.rows = data.rows;
	        }, function () {});
	      }
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'findSalesByCategory',
	    value: function findSalesByCategory() {
	      var _this2 = this;
	
	      this.subscriptions.push(this.service.findSalesByCategory({
	        date_to: this.dateTo.toISOString(),
	        date_from: this.dateFrom.toISOString()
	      }).subscribe(function (data) {
	        _this2.rows = data.rows;
	      }, function () {}));
	    }
	  }, {
	    key: 'drillDownOnCategory',
	    value: function drillDownOnCategory(fam_id) {
	      var _this3 = this;
	
	      this.subscriptions.push(this.service.findSalesByCategory({
	        date_to: this.dateTo.toISOString(),
	        date_from: this.dateFrom.toISOString()
	      }, fam_id).subscribe(function (data) {
	        _this3.rows = data.rows;
	      }, function () {}));
	    }
	  }, {
	    key: 'drillDownOnItem',
	    value: function drillDownOnItem(iid, name) {
	      var _this4 = this;
	
	      this.subscriptions.push(this.service.findSalesByCategory({
	        date_to: this.dateTo.toISOString(),
	        date_from: this.dateFrom.toISOString(),
	        item_id: iid
	      }).subscribe(function (data) {
	        _this4.rows = data.rows;
	        _this4.title = name;
	      }));
	    }
	  }, {
	    key: 'openBillDetails',
	    value: function openBillDetails(invoiceId) {
	      var that = this;
	      if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')) {
	        this.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'invoice-details-template.html',
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "$uibModalInstance", "AccountInformationService", function controller($scope, $uibModalInstance, AccountInformationService) {
	            "ngInject";
	
	            $scope.invoice = {};
	            $scope.orders = [];
	            $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
	            that.subscriptions.push(that.service.getInvoice(invoiceId).subscribe(function (invoice) {
	              return $scope.invoice = invoice;
	            }, function (error) {
	              return console.log("Error while getting the invoice");
	            }));
	
	            $scope.getOrders = function () {
	              if ($scope.orders.length <= 0) {
	                that.subscriptions.push(that.service.getOrders(invoiceId).subscribe(function (orders) {
	                  return $scope.orders = orders;
	                }, function (error) {
	                  return console.log("Error while getting the orders");
	                }));
	              }
	            };
	
	            that.subscriptions.push(AccountInformationService.getAccountInfo().subscribe(function (resp) {
	              $scope.account = resp;
	            }));
	
	            $scope.fetchDetails = function (order) {
	              if (!order.details || order.details.length <= 0) {
	                that.subscriptions.push(that.service.getOrderDetails(invoiceId, order.id).subscribe(function (details) {
	                  order.details = details;
	                  $scope.displayingOrder = order;
	                }, function (error) {
	                  return console.log("Error while getting the details for this order");
	                }));
	              }
	            };
	
	            $scope.printToCart = function (printSectionId) {
	              var innerContents = document.getElementById(printSectionId).innerHTML;
	              var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	              popupWinindow.document.open();
	              popupWinindow.document.write('<html><head><title>Imprimir factura #' + $scope.invoice.number + '</title><link rel="stylesheet" type="text/css" href="assets/bootstrap.css" /><link rel="stylesheet" type="text/css" href="assets/printstyle.css" /></head><body onload="window.print()">' + innerContents + '</html>');
	              popupWinindow.document.close();
	            };
	
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	          }]
	        });
	      }
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal(item) {
	      return item.total_billed || item.total || 0;
	    }
	  }, {
	    key: 'getDiscount',
	    value: function getDiscount(item) {
	      return item.discount_billed || item.discount || 0;
	    }
	  }, {
	    key: 'getOth',
	    value: function getOth(item) {
	      return item.oth_total || 0;
	    }
	  }, {
	    key: 'getVoid',
	    value: function getVoid(item) {
	      return item.cancelation_total || 0;
	    }
	  }, {
	    key: 'getReturned',
	    value: function getReturned(item) {
	      return item.return_total || 0;
	    }
	  }, {
	    key: 'getPax',
	    value: function getPax(item) {
	      return item.pax || 0;
	    }
	  }, {
	    key: 'getExtraTip',
	    value: function getExtraTip(item) {
	      return item.extra_tip || 0;
	    }
	  }, {
	    key: 'getTaxExemption',
	    value: function getTaxExemption(item) {
	      return item.taxexemption || 0;
	    }
	  }, {
	    key: 'getTax10',
	    value: function getTax10(item) {
	      return item.tax10 || 0;
	    }
	  }, {
	    key: 'getTax16',
	    value: function getTax16(item) {
	      return item.tax16 || 0;
	    }
	  }, {
	    key: 'isGroupedByCategory',
	    value: function isGroupedByCategory() {
	      return this.rows && this.rows.length && this.rows[0].hasOwnProperty('pifamm_id');
	    }
	  }, {
	    key: 'isGroupedByItem',
	    value: function isGroupedByItem() {
	      return this.rows && this.rows.length && this.rows[0].hasOwnProperty('item_id');
	    }
	  }, {
	    key: 'isGroupedByInvoice',
	    value: function isGroupedByInvoice() {
	      return this.rows && this.rows.length && this.rows[0].hasOwnProperty('date') && this.rows[0].hasOwnProperty('rnc');
	    }
	  }]);
	  return SalesByCategoryController;
	}();
	
	exports.default = SalesByCategoryController;
	
	
	SalesByCategoryController.$inject = ['ContentService', 'isMobile', 'moment', 'ProfilePermissionsService', '$uibModal'];

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1250);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-category.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-category.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".SalesByCategory{color:red}", ""]);
	
	// exports


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _requestSuccess = __webpack_require__(1252);
	
	var _requestSuccess2 = _interopRequireDefault(_requestSuccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestSuccessModule = _angular2.default.module('RequestSuccess', [_angularjs2.default]).component('requestSuccess', _requestSuccess2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('requestSuccess', {
	    params: {
	      email: null
	    },
	    url: '/request-success',
	    views: {
	      'menu': "",
	      'content': {
	        component: 'requestSuccess'
	      }
	    },
	    resolve: {
	      email: ["$transition$", function email($transition$) {
	        return $transition$.params().email || '';
	      }]
	    }
	  });
	}]).name;
	
	exports.default = RequestSuccessModule;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requestSuccess = __webpack_require__(1253);
	
	var _requestSuccess2 = _interopRequireDefault(_requestSuccess);
	
	var _requestSuccess3 = __webpack_require__(1254);
	
	var _requestSuccess4 = _interopRequireDefault(_requestSuccess3);
	
	__webpack_require__(1255);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestSuccessComponent = {
	  bindings: {
	    email: '<'
	  },
	  template: _requestSuccess2.default,
	  controller: _requestSuccess4.default
	};
	
	exports.default = RequestSuccessComponent;

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n  <div class=\"wrapper\">\n  </div>\n  <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n      <form class=\"form-signin\" name=\"passwordRequestForm\" novalidate>\n          <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n          <h3 class=\"form-signin-heading\">{{'Recuperar Contraseña' | translate}}</h3>\n          <i class=\"fa fa-paper-plane-o recover_icon\" aria-hidden=\"true\"></i>\n          <div class=\"form-group\">\n                <p>{{'Se han enviado intrucciones a' | translate}}:</p>\n                <p>{{ $ctrl.email }}</p>\n                <p>{{'para reestablecer tu contraseña, sigue las intrucciones en tu correo' | translate}}.</p>\n          </div>\n        <p class=\"create-account\">\n          <a ui-sref=\"login\"><i class=\"fa fa-chevron-circle-left\" aria-hidden=\"true\"></i> {{'Volver al inicio' | translate}}</a>\n        </p>\n      </form>\n  </div>\n</body>"

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestSuccessController = function RequestSuccessController() {
	  (0, _classCallCheck3.default)(this, RequestSuccessController);
	};
	
	exports.default = RequestSuccessController;
	
	
	RequestSuccessController.$inject = [];

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1256);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./request-success.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./request-success.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".RequestSuccess{color:red}", ""]);
	
	// exports


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _recoverySuccess = __webpack_require__(1258);
	
	var _recoverySuccess2 = _interopRequireDefault(_recoverySuccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecoverySuccessModule = _angular2.default.module('RecoverySuccess', [_angularjs2.default]).component('recoverySuccess', _recoverySuccess2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('recoverySuccess', {
	    url: '/recovery-success',
	    views: {
	      'menu': "",
	      'content': {
	        component: 'recoverySuccess'
	      }
	    }
	  });
	}]).name;
	
	exports.default = RecoverySuccessModule;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recoverySuccess = __webpack_require__(1259);
	
	var _recoverySuccess2 = _interopRequireDefault(_recoverySuccess);
	
	var _recoverySuccess3 = __webpack_require__(1260);
	
	var _recoverySuccess4 = _interopRequireDefault(_recoverySuccess3);
	
	__webpack_require__(1261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecoverySuccessComponent = {
	  bindings: {},
	  template: _recoverySuccess2.default,
	  controller: _recoverySuccess4.default
	};
	
	exports.default = RecoverySuccessComponent;

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n  <div class=\"wrapper\">\n  </div>\n  <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n    <form class=\"form-signin\" name=\"passwordRequestForm\" novalidate>\n        <img class=\"app_logo\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n        <h3 class=\"form-signin-heading\">{{'Recuperar Contraseña' | translate}}</h3>\n        <i class=\"fa fa-check recover_icon\" aria-hidden=\"true\"></i>\n        <div class=\"form-group\">\n            <p>{{'Su contraseña ha sido reestablecida con exito' | translate}}.</p>\n          <p>{{'Presione volver al inicio para ingresar' | translate}} </p>\n        </div>\n      <p class=\"create-account\">\n        <a ui-sref=\"login\"><i class=\"fa fa-chevron-circle-left\" aria-hidden=\"true\"></i> {{'Volver al inicio' | translate}}</a>\n      </p>\n    </form>\n  </div>\n</body>"

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecoverySuccessController = function RecoverySuccessController() {
	  (0, _classCallCheck3.default)(this, RecoverySuccessController);
	};
	
	exports.default = RecoverySuccessController;
	
	
	RecoverySuccessController.$inject = [];

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1262);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./recovery-success.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./recovery-success.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".RecoverySuccess{color:red}", ""]);
	
	// exports


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _paymentNotice = __webpack_require__(1264);
	
	var _paymentNotice2 = _interopRequireDefault(_paymentNotice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentNoticeModule = _angular2.default.module('PaymentNotice', [_angularjs2.default]).component('paymentNotice', _paymentNotice2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('paymentNotice', {
	    views: {
	      'menu': "",
	      'content': {
	        component: 'paymentNotice'
	      }
	    }
	  });
	}]).name;
	
	exports.default = PaymentNoticeModule;

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentNotice = __webpack_require__(1265);
	
	var _paymentNotice2 = _interopRequireDefault(_paymentNotice);
	
	var _paymentNotice3 = __webpack_require__(1266);
	
	var _paymentNotice4 = _interopRequireDefault(_paymentNotice3);
	
	__webpack_require__(1267);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentNoticeComponent = {
	  bindings: {},
	  template: _paymentNotice2.default,
	  controller: _paymentNotice4.default
	};
	
	exports.default = PaymentNoticeComponent;

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n  <div class=\"wrapper\">\n  </div>\n\n  <div class=\"col-xs-12 col-md-6 col-md-push-3\">\n    <form class=\"form-signin\" name=\"loginForm\" novalidate>\n      <p class=\"text-left\"><img class=\"app_logo_notify\" src=\"img/pi_logo.svg\" alt=\"PiReports\"></p>\n      \n      <h3 class=\"form-signin-heading\">{{'Oops!'| translate}}</h3>\n\n      <p class=\"notify_copy\">{{'Esta cuenta se mantiene inactiva, por favor ponganse en contacto con su administrador.'| translate}}</p>\n      <img class=\"app_logo_notify\" src=\"img/card.svg\" alt=\"Tarjeta\">\n      <img class=\"app_logo_notify\" src=\"img/contact_admin.svg\" alt=\"Contactar administrador\">\n      <div class=\"strike\">\n        <span></span>\n      </div>\n      <img class=\"app_logo_notify\" src=\"img/payment-error.svg\" alt=\"Tarjeta\">\n      <img class=\"app_logo_notify\" src=\"img/payment-pass.svg\" alt=\"Contactar administrador\">\n\n      <p class=\"create-account pull-left\" ng-if=\"$ctrl.hasProfiles\">\n        <a ui-sref=\"profileSelection\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i> Volver</a>\n      </p>\n      <br class=\"jump_formlogin\">  \n      <p class=\"create-account\">\n        <a ng-click=\"$ctrl.logout()\"><i class=\"fa fa-power-off\" aria-hidden=\"true\"></i> {{'Cerrar Sesión' | translate}}</a>\n      </p>\n    </form>\n  </div>\n</body>"

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentNoticeController = function () {
	  function PaymentNoticeController($state, AuthService) {
	    (0, _classCallCheck3.default)(this, PaymentNoticeController);
	
	    this.state = $state;
	    this.auth = AuthService;
	  }
	
	  (0, _createClass3.default)(PaymentNoticeController, [{
	    key: 'logout',
	    value: function logout() {
	      var _this = this;
	
	      this.auth.logout().subscribe(function (data) {
	        _this.state.go('login');
	      }, function () {
	        _this.state.go('login');
	      });
	    }
	  }, {
	    key: 'goManagePayments',
	    value: function goManagePayments() {
	      this.state.go('accountInformation', {
	        activeTab: 3
	      });
	    }
	  }]);
	  return PaymentNoticeController;
	}();
	
	exports.default = PaymentNoticeController;
	
	
	PaymentNoticeController.$inject = ['$state', 'AuthService'];

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1268);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./payment-notice.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./payment-notice.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "payment-notice .text-left{text-align:left;font-family:Roboto,sans-serif}payment-notice .app_logo_notify{width:110px}payment-notice .notify_copy{font-family:Roboto,sans-serif;text-align:justify;margin-bottom:16px}", ""]);
	
	// exports


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _handies = __webpack_require__(1270);
	
	var _handies2 = _interopRequireDefault(_handies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HandiesModule = _angular2.default.module('Handies', [_angularjs2.default]).component('handies', _handies2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('handies', {
	    url: '/handies',
	    data: {
	      authRequired: true,
	      permsRequired: ['view-handies']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'handies'
	      }
	    }
	  });
	}]).name;
	
	exports.default = HandiesModule;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handies = __webpack_require__(1271);
	
	var _handies2 = _interopRequireDefault(_handies);
	
	var _handies3 = __webpack_require__(1272);
	
	var _handies4 = _interopRequireDefault(_handies3);
	
	__webpack_require__(1273);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HandiesComponent = {
	  bindings: {},
	  template: _handies2.default,
	  controller: _handies4.default
	};
	
	exports.default = HandiesComponent;

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-sm-12 col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-10 col-sm-10 col-xs-11\">\n                {{'Handies' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{ $ctrl.handies.length || 0}}\n                </span>\n            </div>\n            <div class=\"col-md-2\">\n                <a class=\"float-right btn btn-success btn-sm btn_transitions\" href=\"\" ng-click=\"$ctrl.openHandyModal()\" if-perm disable-if=\"register-handy\">\n                    <span class=\"glyphicon glyphicon-plus\"></span>\n                    <span>{{'Registrar nuevo handy' | translate}}</span>\n                </a>\n            </div>\n        </div>\n    </h1>\n    <div class=\"col-md-12 table_container no_padding\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <div class=\"fixed-table-toolbar\">\n                        <div class=\"columns columns-right pull-right hidden\">\n                            <div class=\"keep-open btn-group\" title=\"Columns\">\n                                <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\">\n                                    <i class=\"fa fa-columns\"></i> <span class=\"caret\"></span>\n                                </button>\n                            </div>\n                        </div>\n                        <div class=\"search col-md-4 \">\n                            <div class=\"field\">\n                                <input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n                                <label for=\"input-search\">{{'Filtrar POS' | translate}}</label>\n                            </div> \n                        </div>\n                    </div>\n                    <div class=\"fixed-table-container\">\n                        <div class=\"fixed-table-body\">\n                            <table id=\"bootstrap-table\" class=\"table\">\n                                <thead>\n                                    <tr>\n                                        <th>Nombre</th>\n                                        <th>POS</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr ng-repeat=\"handy in $ctrl.handies | filter:filterCrit as filtered\">\n                                        <th>{{handy.description}}</th>\n                                        <th>{{handy.pos}}</th>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<script type='text/ng-template' id=\"new-handy-template.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-title\" ng-if=\"!handy.id\">\n\t\t\t\t{{'Registrar Handy' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n\t\t</h3>\n\t\t<h3 class=\"modal-title\" id=\"modal-title\" ng-if=\"!!handy.id\">\n\t\t\t\t{{'Editar Handy' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n\t\t</h3>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n\n    </div>\n</script>"

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HandiesController = function () {
	  function HandiesController(ContentService, $uibModal) {
	    (0, _classCallCheck3.default)(this, HandiesController);
	
	    this.service = ContentService;
	    this.modal = $uibModal;
	  }
	
	  (0, _createClass3.default)(HandiesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.handies = [];
	      this.service.getAccountHandies().subscribe(function (data) {
	        _this.handies = data.handies;
	      });
	    }
	  }, {
	    key: 'openHandyModal',
	    value: function openHandyModal(handy) {
	      var _this2 = this;
	
	      var that = this;
	      this.service.getPOSList().subscribe(function (points) {
	        _this2.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'new-handy-template.html',
	          controller: ["$scope", "$state", "$uibModalInstance", function controller($scope, $state, $uibModalInstance) {
	            'ngInject';
	
	            $scope.handy = handy;
	            $scope.points = points;
	            $scope.name = '';
	            $scope.pos_id = '';
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	            $scope.registerHandy = function () {
	              that.service.registerHandy({
	                description: $scope.name,
	                pos_id: $scope.pos_id
	              }).subscribe(function (handy) {
	                that.handies.push(handy);
	                $scope.closeThisDialog();
	              });
	            };
	          }]
	        });
	      });
	    }
	  }]);
	  return HandiesController;
	}();
	
	exports.default = HandiesController;
	
	
	HandiesController.$inject = ['ContentService', '$uibModal'];

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1274);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./handies.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./handies.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".Handies{color:red}", ""]);
	
	// exports


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _subscription = __webpack_require__(1276);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscriptionModule = _angular2.default.module('Subscription', [_angularjs2.default]).component('subscription', _subscription2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('accountSubscription', {
	    params: {},
	    data: {
	      authRequired: true,
	      paymentExempt: true,
	      permsRequired: ['manage-subscription']
	    },
	    views: {
	      'menu': "",
	      'content': {
	        component: 'subscription',
	        bindings: {
	          pointOfSalesCount: 'pointOfSalesCount',
	          spinPadCount: 'spinPadCount'
	        }
	      }
	    },
	    resolve: {
	      pointOfSalesUnitPrice: function pointOfSalesUnitPrice() {
	        return 30.00;
	      },
	      spinPadUnitPrice: function spinPadUnitPrice() {
	        return 5.00;
	      }
	    }
	  });
	}]).name;
	
	exports.default = SubscriptionModule;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _subscription = __webpack_require__(1277);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _subscription3 = __webpack_require__(1278);
	
	var _subscription4 = _interopRequireDefault(_subscription3);
	
	__webpack_require__(1279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscriptionComponent = {
	  bindings: {
	    pointOfSalesUnitPrice: '<',
	    spinPadUnitPrice: '<'
	  },
	  template: _subscription2.default,
	  controller: _subscription4.default
	};
	
	exports.default = SubscriptionComponent;

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

	module.exports = "<body id=\"gradient\">\n    <div class=\"wrapper\">\n    </div>\n    <div class=\"col-md-12 text-center\">\n\n      <div class=\"form-signin mr-3\">\n        <h3 class=\"form-signin-heading\">{{'Suscripción' | translate}}</h3>\n        <table class=\"table table-striped mt-2\">\n          <tbody>\n            <tr>\n              <th>\n                {{'Punto de Ventas' | translate}}<br />\n                <small><i>{{\"Por unidad/Por Mes\"|translate}}</i></small>\n              </th>\n              <td>{{ $ctrl.pointOfSalesUnitPrice | currency: 'USD ' }}</td>\n            </tr>\n            <tr>\n              <th>\n                {{'Handy' | translate}}<br />\n                <small><i>{{\"Por uso/Por mes\"|translate}}</i></small>\n              </th>\n              <td>{{ $ctrl.spinPadUnitPrice | currency: 'USD ' }}</td>\n            </tr>\n          </tbody>\n        </table>\n        <div class=\"w-100 text-right pr-4px mt-2\">\n          <b>{{'Total' | translate}}: </b> <span><i>{{ $ctrl.spinPadUnitPrice * $ctrl.spinPadCount + $ctrl.pointOfSalesUnitPrice * $ctrl.pointOfSalesCount | currency: 'USD ' }}</i></span>\n        </div>\n      </div>\n\n      <form class=\"form-signin relative-pos ml-3\" id=\"account-subscription-form\" name=\"subscriptionForm\" ng-submit=\"$ctrl.subscribe()\" novalidate>\n  \n        <img class=\"app_logo m-a\" src=\"img/pi_logo.svg\" alt=\"PiReports\">\n\n        <fieldset id=\"stripe-form\" class=\"form-group mt-3\">\n          <legend>{{'Método de pago' | translate}}</legend>\n          <div class=\"form-group\">\n            <input type=\"text\" name=\"cardholder\" validator=\"required\" class=\"form-control input_py\" ng-model=\"$ctrl.card.holder\" placeholder=\"{{'Tarjetahabiente' | translate}}\">\n          </div>\n          <div class=\"form-group\">\n            <input type=\"text\" name=\"card-email\" validator=\"required\" class=\"form-control input_py\" ng-model=\"$ctrl.card.email\" placeholder=\"{{'Email' | translate}}\">\n          </div>\n        </fieldset>\n        <fieldset class=\"form-group\">\n          <!-- a Stripe Element will be inserted here. -->\n          <div id=\"card-element\"></div>\n          <!-- Used to display form errors -->\n          <div id=\"card-errors\" role=\"alert\"></div>\n        </fieldset>\n\n        <fieldset id=\"coupon\" class=\"form-group mt-3\">\n          <legend>{{'Canjear Cupón' | translate}}</legend>\n          <div class=\"form-group\">\n            <input type=\"text\" name=\"account-coupon\" class=\"form-control input_py\" ng-model=\"$ctrl.card.coupon\" placeholder=\"{{'Coupón' | translate}}\">\n          </div>\n        </fieldset>\n  \n        <button class=\"btn btn-md btn-primary btn-block btn_py\" type=\"submit\" validation-submit=\"subscriptionForm\" ng-click=\"$ctrl.subscribe()\">\n          {{'Iniciar Suscripción' | translate}}\n        </button>\n        <div class=\"w-100\">\n          <p class=\"create-account pull-left\" ng-if=\"$ctrl.hasProfiles\">\n          <a ui-sref=\"profileSelection\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i> Volver</a>\n        </p>\n          <p class=\"create-account\">\n          <a ng-click=\"$ctrl.logout()\"><i class=\"fa fa-power-off\" aria-hidden=\"true\"></i> {{'Cerrar Sesión' | translate}}</a>\n        </p>\n        </div>\n      </form>\n\n    </div>\n</body>"

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscriptionController = function () {
	  function SubscriptionController(SubscriptionService, AuthService, $window, $state) {
	    (0, _classCallCheck3.default)(this, SubscriptionController);
	
	    this.subscriptionService = SubscriptionService;
	    this.authService = AuthService;
	    this.window = $window;
	    this.state = $state;
	  }
	
	  (0, _createClass3.default)(SubscriptionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	      this.hasProfiles = this.window.localStorage.profilesCount && parseInt(this.window.localStorage.profilesCount) > 0;
	
	      this.card = {};
	      this.stripe = this.window.stripe;
	      var elements = this.stripe.elements();
	      var style = {
	        base: {
	          color: '#32325d',
	          lineHeight: '24px',
	          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
	          fontSmoothing: 'antialiased',
	          fontSize: '16px',
	          '::placeholder': {
	            color: '#000000'
	          }
	        },
	        invalid: {
	          color: '#fa755a',
	          iconColor: '#fa755a'
	        }
	      };
	      this.cardElement = elements.create('card', { style: style });
	      this.cardElement.mount(document.getElementById('card-element'));
	      this.cardElement.addEventListener('change', function (event) {
	        var displayError = document.getElementById('card-errors');
	        if (event.error) {
	          displayError.textContent = event.error.message;
	        } else {
	          displayError.textContent = '';
	        }
	      });
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'subscribe',
	    value: function subscribe() {
	      var _this = this;
	
	      this.stripe.createToken(this.cardElement).then(function (response) {
	        var token = response.token,
	            error = response.error;
	
	        if (error) {
	          var errorElement = document.getElementById('card-errors');
	          errorElement.textContent = error.message;
	
	          return;
	        }
	
	        var clientCard = angular.extend(_this.card, token);
	        _this.subscriptions.push(_this.subscriptionService.subscribeCustomerViaStripe(clientCard).subscribe(function () {
	          return _this.state.go('dashboard');
	        }));
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      this.subscriptions.push(this.authService.logout().subscribe(function (data) {
	        return _this2.state.go('login');
	      }, function (error) {}));
	    }
	  }]);
	  return SubscriptionController;
	}();
	
	exports.default = SubscriptionController;
	
	
	SubscriptionController.$inject = ['SubscriptionService', 'AuthService', '$window', '$state'];

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1280);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./subscription.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./subscription.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "subscription table>tbody td,subscription table>tbody th{border:unset!important}subscription .form-signin{margin-top:3rem;margin-bottom:3rem;display:inline-grid;width:330px;padding:30px 15px}subscription .m-a{margin:0 auto}subscription .pr-4px{padding-right:4px}", ""]);
	
	// exports


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _rawMaterials = __webpack_require__(1282);
	
	var _rawMaterials2 = _interopRequireDefault(_rawMaterials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RawMaterialsModule = _angular2.default.module('RawMaterials', [_angularjs2.default]).component('rawmaterials', _rawMaterials2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('rawMaterials', {
	    url: '/raw-materials',
	    data: {
	      authRequired: true
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'rawmaterials'
	      }
	    }
	  });
	}]).name;
	
	exports.default = RawMaterialsModule;

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rawMaterials = __webpack_require__(1283);
	
	var _rawMaterials2 = _interopRequireDefault(_rawMaterials);
	
	var _rawMaterials3 = __webpack_require__(1284);
	
	var _rawMaterials4 = _interopRequireDefault(_rawMaterials3);
	
	__webpack_require__(1285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RawMaterialsComponent = {
	  bindings: {},
	  template: _rawMaterials2.default,
	  controller: _rawMaterials4.default
	};
	
	exports.default = RawMaterialsComponent;

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-8\">\n                {{'Materias Primas' | translate}}\n                <span class=\"badge badge-primary\">\n                    {{$ctrl.materials.length}}\n                </span>\n            </div>\n            <div class=\"col-md-4 text-right\">\n                <div class=\"btn-group\">\n                    <a href=\"\" ng-click=\"$ctrl.openMaterialDialog()\" class=\"btn btn-success btn-sm\">\n                        <span class=\"glyphicon glyphicon-plus\"></span>\n                        <span>{{'Registrar Materia'| translate}}</span>\n                    </a>\n                </div>\n            </div>\n        </div>\n    </h1>\n    <div class=\"col-md-12 table_container no_padding\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <table id=\"bootstrap-table\" class=\"table table-article\">\n                        <thead>\n                            <th>{{'Nombre' | translate}}</th>\n                            <th>{{'Existencia' | translate}}</th>\n                            <th>{{'Notas' | translate}}</th>\n                            <th>{{'Acciones' |translate}}</th>\n                        </thead>\n                        <tbody>\n                            <tr class=\"text-center\" ng-repeat=\"material in $ctrl.materials track by $index\">\n                                <td data-label=\"{{'Nombre' | translate}}\">{{material.name}}</td>\n                                <td data-label=\"{{'Existencia' | translate}}\">\n                                    <div class=\"existentag\"><span>{{material.existence}}&nbsp</span></div>\n                                    <span class=\"input-number-decrement\" adjust decrease model=\"$ctrl.amountsDeclared\" property=\"material.id\" step=\"0.01\">–</span><input class=\"input-number\" type=\"number\" id=\"article-{{$index}}\" ng-model=\"$ctrl.amountsDeclared[material.id]\" value=\"0\"><span class=\"input-number-increment\" adjust increase model=\"$ctrl.amountsDeclared\" property=\"material.id\" step=\"0.01\">+</span>\n\n                                    <a href=\"\" \n                                        class=\"btn btn-simple btn-primary btn-icon saveicon\"\n                                        ng-disabled=\"!$ctrl.amountsDeclared[material.id]\"\n                                        ng-click=\"$ctrl.changeMaterialExistence(material)\">\n                                        <i class=\"fa fa-save\"></i>\n                                    </a>\n                                </td>\n                                <td data-label=\"{{'Notas' | translate}}\">{{material.notes || '-'}}</td>\n                                <td data-label=\"{{'Acciones' | translate}}\">\n                                    <a class=\"btn btn-simple btn-primary btn-icon\" ng-click=\"$ctrl.associateProducts(material)\">\n                                        <i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>\n                                    </a>\n                                    <a rel=\"tooltip\" title=\"\" class=\"btn btn-simple btn-warning btn-icon\" \n                                        ng-click=\"$ctrl.openMaterialDialog(material)\" \n                                        data-original-title=\"Editar\"\n                                        if-perm disable-if=\"edit-ncf\">  \n                                        <i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i>\n                                    </a>\n                                    <a rel=\"tooltip\" title=\"\"\n                                        class=\"btn btn-simple btn-danger btn-icon\"\n                                        mwl-confirm\n                                        title=\"{{'¿Esta seguro?' | translate}}\"\n                                        message=\"{{'ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?' | translate}}\"\n                                        confirm-text=\"Eliminar\"\n                                        cancel-text=\"Cancelar\"\n                                        placement=\"left\"\n                                        on-confirm=\"$ctrl.deleteMaterial(material, $index)\"\n                                        on-cancel=\"\"\n                                        confirm-button-type=\"danger\"\n                                        cancel-button-type=\"default\"\n                                        if-perm disable-if=\"delete-ncf\">\n                                        <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                                    </a>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<script type=\"text/ng-template\" id=\"raw-material-form.html\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" id=\"modal-title\" ng-if=\"!material.id\">{{'Nueva materia' | translate}}</h3>\n        <h3 class=\"modal-title\" id=\"modal-title\" ng-if=\"!!material.id\">{{'Editar materia' | translate}}</h3>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n        <form name=\"materialForm\" novalidate>\n            <div class=\"form-group\">\n                <label for=\"name\">Nombre</label>\n                <input id=\"name\" type=\"text\" class=\"form-control input_py\" ng-model=\"material.name\">\n            </div>\n            <div class=\"form-group\">\n                <label for=\"notes\">Notas</label>\n                <input id=\"notes\" type=\"textarea\" class=\"form-control input_py\" ng-model=\"material.notes\">\n            </div>\n            <div class=\"form-group\" ng-if=\"!material.id\">\n                <label for=\"quantity\">Existencia</label>\n                <input type=\"number\" id=\"quantity\" class=\"form-control input_py\" ng-model=\"material.existence\">\n            </div>\n        </form>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"submit\" class=\"btn btn-primary btn_standar\" ng-if=\"!!material.id\" ng-click=\"editMaterial()\">{{'Editar' | translate}}</button>\n        <button type=\"submit\" class=\"btn btn-primary btn_standar\" ng-if=\"!material.id\" ng-click=\"registerMaterial()\">{{'Crear' | translate}}</button>\n        <button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">{{'Cancelar' | translate}}</button>\n    </div>\n</script>"

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RawMaterialsController = function () {
	  function RawMaterialsController(ContentService, $uibModal, $state) {
	    (0, _classCallCheck3.default)(this, RawMaterialsController);
	
	    this.service = ContentService;
	    this.modal = $uibModal;
	    this.state = $state;
	  }
	
	  (0, _createClass3.default)(RawMaterialsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      this.materials = [];
	
	      this.subscriptions.push(this.service.getArticlesList().subscribe(function (articles) {
	        _this.articles = articles;
	      }));
	
	      this.subscriptions.push(this.service.getAllMaterials().subscribe(function (data) {
	        _this.materials = data.materials;
	        console.log("loading...");
	      }));
	
	      this.amountsDeclared = {};
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'deleteMaterial',
	    value: function deleteMaterial(material, index) {
	      var _this2 = this;
	
	      this.subscriptions.push(this.service.deleteMaterial(material.id).subscribe(function () {
	        _this2.materials.pop(index);
	      }));
	    }
	  }, {
	    key: 'changeMaterialExistence',
	    value: function changeMaterialExistence(material) {
	      var _this3 = this;
	
	      this.subscriptions.push(this.service.changeMaterialExistence({
	        quantity: this.amountsDeclared[material.id]
	      }, material.id).subscribe(function () {
	        material.existence += _this3.amountsDeclared[material.id];
	        _this3.amountsDeclared[material.id] = 0;
	      }));
	    }
	  }, {
	    key: 'associateProducts',
	    value: function associateProducts(material) {
	      this.state.go('rawMaterialArticles', {
	        id: material.id,
	        material: material
	      });
	    }
	  }, {
	    key: 'openMaterialDialog',
	    value: function openMaterialDialog(material) {
	      var that = this;
	      this.modal.open({
	        animation: true,
	        size: 'lg',
	        templateUrl: 'raw-material-form.html',
	        appendClassName: 'ngdialog-theme-plain',
	        controller: ["$scope", "$uibModalInstance", function controller($scope, $uibModalInstance) {
	          "ngInject";
	
	          $scope.material = material || {
	            existence: 0
	          };
	          $scope.closeThisDialog = function () {
	            return $uibModalInstance.close();
	          };
	          $scope.optionsList = that.articles;
	
	          $scope.registerMaterial = function () {
	            that.subscriptions.push(that.service.registerMaterial({
	              name: $scope.material.name,
	              notes: $scope.material.notes,
	              existence: $scope.material.existence
	            }).subscribe(function (material) {
	              that.materials.push(material);
	              that.materials.sort(function (a, b) {
	                return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
	              });
	              $scope.closeThisDialog();
	            }));
	          };
	          $scope.editMaterial = function () {
	            that.subscriptions.push(that.service.editMaterial({
	              name: $scope.material.name,
	              notes: $scope.material.notes
	            }, $scope.material.id).subscribe(function (material) {
	              $scope.closeThisDialog();
	            }));
	          };
	        }]
	      });
	    }
	  }]);
	  return RawMaterialsController;
	}();
	
	exports.default = RawMaterialsController;
	
	
	RawMaterialsController.$inject = ['ContentService', '$uibModal', '$state'];

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1286);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./raw-materials.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./raw-materials.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".RawMaterials{color:red}.existentag{position:relative;display:inline-block;height:30px;line-height:30px;padding:0 1em 0 1.75em;background-color:#337ab7;border-radius:50px 3px 3px 50px;color:#fff;font-size:13px;text-decoration:none;-webkit-transition:.2s;transition:.2s}.existentag:after{position:absolute;top:50%;left:10px;z-index:2;display:block;content:\"\";width:6px;height:6px;margin-top:-3px;background-color:#fff;border-radius:100%}", ""]);
	
	// exports


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _rawMaterialArticles = __webpack_require__(1288);
	
	var _rawMaterialArticles2 = _interopRequireDefault(_rawMaterialArticles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RawMaterialArticlesModule = _angular2.default.module('RawMaterialArticles', [_angularjs2.default]).component('rawmaterialarticles', _rawMaterialArticles2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('rawMaterialArticles', {
	    url: '/raw-materials/:id/articles',
	    data: {
	      authRequired: true
	    },
	    params: {
	      material: null
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'rawmaterialarticles'
	      }
	    },
	    resolve: {
	      material: ["$transition$", function material($transition$) {
	        'ngInject';
	
	        return $transition$.params().material;
	      }]
	    }
	  });
	}]).name;
	
	exports.default = RawMaterialArticlesModule;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rawMaterialArticles = __webpack_require__(1289);
	
	var _rawMaterialArticles2 = _interopRequireDefault(_rawMaterialArticles);
	
	var _rawMaterialArticles3 = __webpack_require__(1290);
	
	var _rawMaterialArticles4 = _interopRequireDefault(_rawMaterialArticles3);
	
	__webpack_require__(1291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RawMaterialArticlesComponent = {
	  bindings: {
	    material: '<'
	  },
	  template: _rawMaterialArticles2.default,
	  controller: _rawMaterialArticles4.default
	};
	
	exports.default = RawMaterialArticlesComponent;

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{$ctrl.material.description | translate}}\n            </div>\n        </div>\n    </h1>\n    <div class=\"col-md-12- table-container no_padding\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <div class=\"row fixed-table-toolbar\">\n                        <div class=\"columns\">\n                            <div class=\"col-md-12\">\n                                <angucomplete-alt id=\"ex2\"\n                                    placeholder=\"{{'Buscar Artículos' | translate}}\"\n                                    pause=\"300\"\n                                    selected-object=\"$ctrl.selectArticle\"\n                                    local-data=\"$ctrl.articles\"\n                                    local-search=\"$ctrl.searchArticles\"\n                                    title-field=\"description\"\n                                    minlength=\"1\"\n                                    input-class=\"form-control form-control-small\"\n                                    match-class=\"highlight\" \n                                />\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"fixed-table-article\">\n                        <div class=\"fixed-table-body\">\n                            <table id=\"bootstrap-table\" class=\"table table-article\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n                                <thead>\n                                    <tr>\n                                        <th>{{'Artículo'| translate}}</th>\n                                        <th>{{'Familia' | translate}}</th>\n                                        <th>{{'Cantidad asociada' | translate}}</th>\n                                        <th>{{'Acciones' | translate}}</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr class=\"text-center\" ng-repeat=\"article in $ctrl.associatedArticles track by $index\">\n                                        <td data-label=\"{{'Descripción' | translate}}:\" class=\"text-center\">{{ article.description || '-' }}</td>\n                                        <td data-label=\"{{'Familia' | translate}}:\" class=\"text-center\">{{ article.family || '-' }}</td>\n                                        <td data-label=\"{{'Cantidad asociada' | translate}}:\" class=\"text-center\">\n                                            <!-- <div class=\"col-xs-2\">\n                                                <input type=\"number\" id=\"article-{{$index}}\" class=\"form-control form-control-small\" ng-model=\"article.amount\">\n                                            </div> -->\n\n\n                                                <span class=\"input-number-decrement\" adjust model=\"article\" property=\"'amount'\" decrease step=\"0.01\" min=\"0\">–</span><input class=\"input-number\" type=\"number\" step=\"0.001\" min=\"0\" id=\"article-{{$index}}\" ng-model=\"article.amount\"><span class=\"input-number-increment\" adjust increase step=\"0.01\" model=\"article\" property=\"'amount'\" min=\"0\">+</span>\n                                        </td>\n                                        <td data-label=\"{{'Acciones' | translate}}:\">\n                                            <a  ng-click=\"$ctrl.associateArticle(article)\"\n                                                class=\"btn btn-simple btn-primary btn-icon\"\n                                                ng-if=\"!article.associated\"\n                                                ng-disabled=\"!article.amount\">\n                                                <i class=\"fa fa-save\" aria-hidden=\"true\"></i>\n                                            </a>\n                                            <a rel=\"tooltip\" title=\"\"\n                                                class=\"btn btn-simple btn-danger btn-icon\"\n                                                mwl-confirm\n                                                title=\"{{'¿Esta seguro?' | translate}}\"\n                                                message=\"{{'ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?' | translate}}\"\n                                                confirm-text=\"Eliminar\"\n                                                cancel-text=\"Cancelar\"\n                                                placement=\"left\"\n                                                on-confirm=\"$ctrl.disassociateArticle( article)\"\n                                                on-cancel=\"\"\n                                                confirm-button-type=\"danger\"\n                                                cancel-button-type=\"default\">\n                                                <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                                            </a>\n                                        </td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(333);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RawMaterialArticlesController = function () {
	  function RawMaterialArticlesController(ContentService, $state) {
	    (0, _classCallCheck3.default)(this, RawMaterialArticlesController);
	
	    this.service = ContentService;
	    this.state = $state;
	  }
	
	  (0, _createClass3.default)(RawMaterialArticlesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.subscriptions = [];
	
	      if (!this.material) {
	        this.state.go('rawMaterials');
	        return;
	      };
	
	      this.subscriptions.push(this.service.getArticlesList().subscribe(function (articles) {
	        _this.articles = articles;
	        var included = (0, _keys2.default)(_this.material.articles).map(function (k) {
	          return parseInt(k);
	        });
	        _this.associatedArticles = _this.articles.filter(function (article) {
	          return included.includes(article.id);
	        }).reduce(function (acc, article) {
	          article.associated = true;
	          article.amount = _this.material.articles[article.id];
	          acc.push(article);
	          return acc;
	        }, []).sort(function (a, b) {
	          return a.description < b.description ? -1 : a.description > b.description ? 1 : 0;
	        });
	      }));
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'searchArticles',
	    value: function searchArticles(filter, articles) {
	      return articles.filter(function (article) {
	        return article.description.toLowerCase().includes(filter.toLowerCase());
	      });
	    }
	  }, {
	    key: 'selectArticle',
	    value: function selectArticle(article) {
	      if (article) {
	        this.$parent.$ctrl.associatedArticles.push(article.originalObject);
	      }
	    }
	  }, {
	    key: 'associateArticle',
	    value: function associateArticle(article) {
	      var parent = this;
	      this.subscriptions.push(this.service.associateArticle(this.material.id, article.id, { amount: article.amount }).subscribe(function () {
	        article.associated = true;
	        parent.associatedArticles.sort(function (a, b) {
	          return a.description < b.description ? -1 : a.description > b.description ? 1 : 0;
	        });
	      }));
	    }
	  }, {
	    key: 'disassociateArticle',
	    value: function disassociateArticle(article) {
	      var parent = this;
	      this.subscriptions.push(this.service.disassociateArticle(this.material.id, article.id).subscribe(function () {
	        parent.associatedArticles.pop(article);
	        parent.associatedArticles.sort(function (a, b) {
	          return a.description < b.description ? -1 : a.description > b.description ? 1 : 0;
	        });
	      }));
	    }
	  }]);
	  return RawMaterialArticlesController;
	}();
	
	exports.default = RawMaterialArticlesController;
	
	
	RawMaterialArticlesController.$inject = ['ContentService', '$state'];

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1292);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./raw-material-articles.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./raw-material-articles.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".RawMaterialArticles{color:red}.angucomplete-dropdown{overflow-y:auto;max-height:200px}.highlight{color:#1934c9}.input-number{width:80px;padding:0 12px;vertical-align:top;text-align:center;outline:none}.input-number,.input-number-decrement,.input-number-increment{border:1px solid #ccc;height:34px;user-select:none}.input-number-decrement,.input-number-increment{display:inline-block;width:30px;line-height:32px;background:#f1f1f1;color:#444;text-align:center;font-weight:700;cursor:pointer}.input-number-decrement:active,.input-number-increment:active{background:#ddd}.input-number-decrement{border-right:none;border-radius:4px 0 0 4px}.input-number-increment{border-left:none;border-radius:0 4px 4px 0}.table-article>tbody>tr>td{vertical-align:middle}.saveicon{margin-bottom:3px;padding:7px 10px!important}.fixed-table-article{margin-top:20px}.input-number::-webkit-inner-spin-button,.input-number::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);
	
	// exports


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _salesBySubfamily = __webpack_require__(1294);
	
	var _salesBySubfamily2 = _interopRequireDefault(_salesBySubfamily);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesBySubfamilyModule = _angular2.default.module('SalesBySubfamily', [_angularjs2.default]).component('salesbysubfamily', _salesBySubfamily2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesBySubfamily', {
	    //Never mind the furthermore, the plea is self defense.
	    url: '/sales-by-subfamily',
	    data: {
	      authRequired: 'true',
	      permsRequired: ['subfamily-report']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'salesbysubfamily'
	      }
	    }
	  });
	}]).name;
	
	exports.default = SalesBySubfamilyModule;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesBySubfamily = __webpack_require__(1295);
	
	var _salesBySubfamily2 = _interopRequireDefault(_salesBySubfamily);
	
	var _salesBySubfamily3 = __webpack_require__(1296);
	
	var _salesBySubfamily4 = _interopRequireDefault(_salesBySubfamily3);
	
	__webpack_require__(1297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesBySubfamilyComponent = {
	  //Zilch
	  bindings: {},
	  template: _salesBySubfamily2.default,
	  controller: _salesBySubfamily4.default
	};
	
	exports.default = SalesBySubfamilyComponent;

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

	module.exports = "<!-- China Clipper calling Alameda -->\n<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\" ng-if=\"!$ctrl.title\">\n            <div class=\"col-md-12\">\n                {{'Ventas por etiqueta' | translate}}\n                <div class=\"badge badge-primary\">\n                    {{$ctrl.rows.length || 0}}\n                </div>\n            </div>\n        </div>\n        <div class=\"row\" ng-if=\"$ctrl.title\">\n            <div class=\"col-md-12\">\n                {{$ctrl.title | lowercase | capitalise}}\n                <div class=\"badge badge-primary\">\n                    {{$ctrl.rows.length || 0}}\n                </div>\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form name=\"salesByVendorForm\" class=\"hidden-xs\">\n            <div class=\"form col-md-12 no-padding\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>    \n                    <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" id=\"from\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\">\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>    \n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" id=\"to\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\">  \n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.getSalesByTag()\">{{'Buscar' | translate}}</button>    \n                    </span>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class=\"col-md-12 table_container\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <div class=\"fixed-table-toolbar\">\n                        <div class=\"columns pull-right\">\n                            <button ng-click=\"$ctrl.getSalesByCategory()\" class=\"btn btn-primary\" ng-if=\"$ctrl.isGroupedByTag()\">\n                                {{'Ordenar por categoría' | translate}}\n                            </button>\n                            <button ng-click=\"$ctrl.groupByCategory()\" class=\"btn btn-primary\" ng-if=\"$ctrl.isGroupedByCategory()\">\n                                {{'Ordenar por etiqueta' | translate}}\n                            </button>\n                        </div>\n                        <div class=\"search col-md-4 \">\n                            <div class=\"field\">\n                                <input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n                                <label for=\"input-search\">{{'Filtrar búsqueda' | translate}}</label>\n                            </div> \n                        </div>\n                    </div>\n                    <div class=\"fixed-table-container\">\n                        <table id=\"bootstrap-table\" class=\"table\">\n                            <thead>\n                                <tr ng-if=\"$ctrl.isGroupedByTag()\">\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"family\">\n                                        {{'Categoría' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"tag\">\n                                        {{'Etiqueta' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"discount\">\n                                        {{'Desc.' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"total\">\n                                        {{'Total' | translate}}\n                                    </th>\n                                </tr>\n                                <tr ng-if=\"$ctrl.isGroupedByCategory()\">\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"pifamm_name\">\n                                        {{'Categoria' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"discount\">\n                                        {{'Desc.' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"total\">\n                                        {{'Total' | translate}}\n                                    </th>\n                                </tr>\n                                <tr ng-if=\"$ctrl.isGroupedByItem()\">\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"description\">\n                                        {{'Artículo' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"total_qty\">\n                                        {{'Cantidad Total' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"qty_billed\">\n                                        {{'Cantidad Facturada' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"total_billed\">\n                                        {{'Total Facturado' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"item_discount\">\n                                        {{'Desc. por Artículo' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"discount_billed\">\n                                        {{'Desc. Facturado' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"oth_qty\">\n                                        {{'Cantidad OTH/Broken' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"oth_total\">\n                                        {{'Total OTH/Broken' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"cancelation_qty\">\n                                        {{'Cantidad Cancelada' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"cancelation_total\">\n                                        {{'Total Cancelado' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"return_qty\">\n                                        {{'Cantidad Devuelta' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"return_total\">\n                                        {{'Total Devuelto' | translate}}\n                                    </th>    \n                                </tr>\n                                <tr ng-if=\"$ctrl.isGroupedByInvoice()\">\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"date\">\n                                        {{'Fecha' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"ncf\">\n                                        {{'NCF' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"name\">\n                                        {{'Nombre' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"rnc\">\n                                        {{'RNC' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"pax\">\n                                        {{'Pax' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"discount\">\n                                        {{'Desc.' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"total\">\n                                        {{'Total' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"taxexemption\">\n                                        {{'Exoneracion' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"extra_tip\">\n                                        {{'Prop.Extra' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"tax_10\">\n                                        {{'Propina' | translate}}\n                                    </th>\n                                    <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"tax_16\">\n                                        {{'IVA' | translate}}\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByTag()\" ng-click=\"$ctrl.drillDownOnTag(row)\">\n                                    <td>{{row.family | lowercase | capitalise}}</td>\n                                    <td>{{row.tag || '' | lowercase | capitalise}}</td>\n                                    <td>{{row.discount | currency}}</td>\n                                    <td>{{row.total | currency}}</td>\n                                </tr>\n                                <tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByCategory()\" ng-click=\"$ctrl.drillDownOnCategory(row.pifamm_id)\">\n                                    <td class=\"text-center\">{{row.pifamm_name || '-' | lowercase | capitalise}}</td>\n                                    <td class=\"text-center\">{{row.discount | currency}}</td>\n                                    <td class=\"text-center\">{{row.total | currency}}</td>\n                                </tr>\n                                <tr class=\"text-center clickable\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByItem()\" ng-click=\"$ctrl.drillDownOnItem(row.item_id, row.description)\">\n                                    <td data-label=\"Artículo\" class=\"text-center\">{{ row.description | lowercase | capitalise }}</td>\n                                    <td data-label=\"Cantidad total\" class=\"text-right\">{{ row.total_qty }}</td>\n                                    <td data-label=\"Cantidad facturada\" class=\"text-right\">{{ row.qty_billed }}</td>\n                                    <td data-label=\"Total facturado\" class=\"text-right\">{{ row.total_billed | currency }}</td>\n                                    <td data-label=\"Desc. por articulo\" class=\"text-right\">{{ row.item_discount | currency }}</td>\n                                    <td data-label=\"Desc. facturado\" class=\"text-right\">{{ row.discount_billed | currency }}</td>\n                                    <td data-label=\"Cantidad OTH/Broken\" class=\"text-right\">{{ row.oth_qty }}</td>\n                                    <td data-label=\"Total OTH/Broken\" class=\"text-right\">{{ row.oth_total | currency }}</td>\n                                    <td data-label=\"Cantidad cancelada\" class=\"text-right\">{{ row.cancelation_qty }}</td>\n                                    <td data-label=\"Total cancelado\" class=\"text-right\">{{ row.cancelation_total | currency }}</td>\n                                    <td data-label=\"Cantidad devuelta\" class=\"text-right\">{{ row.return_qty }}</td>\n                                    <td data-label=\"Total devuelto\" class=\"text-right\">{{ row.return_total | currency }}</td>    \n                                </tr>\n                                <tr class=\"text-center clickable\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\" ng-if=\"$ctrl.isGroupedByInvoice()\" ng-click=\"$ctrl.openBillDetails(row.id)\">\n                                    <td data-label=\"Fecha:\" class=\"text-center\">{{ row.date | amUtc | amDateFormat:'DD-MMM-YYYY hh:mm' }}</td>\n                                    <td data-label=\"NCF:\" class=\"text-center\">{{ row.ncf || '-' }}</td>\n                                    <td data-label=\"Nombre:\" class=\"text-center\">{{ row.name || '-' }}</td>\n                                    <td data-label=\"RNC:\" class=\"text-center\">{{ row.rnc || '-' }}</td>\n                                    <td data-label=\"Pax:\" class=\"text-center\">{{ row.pax }}</td>\n                                    <td data-label=\"Desc.:\" class=\"text-right\">{{ row.discount | currency }}</td>\n                                    <td data-label=\"Total:\" class=\"text-right\">{{ row.total | currency }}</td>\n                                    <td data-label=\"Exoneracion:\" class=\"text-right\">{{ row.taxexemption | currency }}</td>\n                                    <td data-label=\"Prop.Extra:\" class=\"text-right\">{{ row.extra_tip | currency }}</td>\n                                    <td data-label=\"%Ley:\" class=\"text-right\">{{ row.tax10 | currency }}</td>\n                                    <td data-label=\"IVA:\" class=\"text-right\">{{ row.tax16 | currency }}</td>\n                                </tr>\n                            </tbody>\n                            <tfoot>\n                                <tr ng-if=\"$ctrl.isGroupedByTag() || $ctrl.isGroupedByCategory()\">\n                                    <th></th>\n                                    <th></th>\n                                    <th class=\"text-right\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</th>\n                                    <th class=\"text-right\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</th>\n                                </tr>\n                                <tr  ng-if=\"$ctrl.isGroupedByItem()\" >\n                                    <th colspan=\"3\"></th>\n                                    <th data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n                                    </th>\n                                    <th ></th>\n                                    <th data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n                                    </th>\n                                    <th></th>\n                                    <th data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getOth | sum: 0 | currency }}</div>\n                                    </th>\n                                    <th></th>\n                                    <th data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getVoid | sum: 0 | currency }}</div>\n                                    </th>\n                                    <th></th>\n                                    <th data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getReturned | sum: 0 | currency }}</div>\n                                    </th>\n                                </tr>\n                                <tr ng-if=\"$ctrl.isGroupedByInvoice()\">\n                                    <th data-label=\"Total Pax:\" colspan=\"{{ $ctrl.isGroupedByInvoice() ? 5 : 2 }}\" data-field=\"name\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getPax | sum: 0 }}</div>\n                                    </th>\n                                    <th data-label=\"Total Desc.:\" data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getDiscount | sum: 0 | currency }}</div>\n                                    </th>\n                                    <th data-label=\"Total:\" data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getTotal | sum: 0 | currency }}</div>\n                                    </th>\n                                    <th data-label=\"Total Exoneración:\" data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getTaxExemption | sum: 0 | currency }}</div>\n                                    </th>\n                                    <th data-label=\"Total Prop.Extra:\" data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getExtraTip | sum: 0 | currency }}</div>\n                                    </th>\n                                    <th data-label=\"Total Propina:\" data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getTax10 | sum: 0 | currency }}</div>\n                                    </th>\n                                    <th data-label=\"Total IVA:\" data-field=\"salary\" class=\"text-right\">\n                                        <div class=\"th-inner\">{{ filtered | map: $ctrl.getTax16 | sum: 0 | currency }}</div>\n                                    </th>\n                                </tr>\n                            </tfoot>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<script type='text/ng-template' id=\"invoice-details-template.html\">\n\t<div class=\"modal-header\">\n    \t<h3 class=\"modal-title\" id=\"modal-title\">\n\t\t\t\t{{'Detalle de Factura' | translate}}\n\t\t\t\t<a href=\"\" class=\"close_modal\" ng-click=\"closeThisDialog();\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n    \t</h3>\n  \t</div>\n\t<div class=\"modal-body\" id=\"modal-body\">\n    <nav>\n        <ul class=\"Tabs\">\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: !showOrders}\" ng-click=\"showOrders=false\"\n\t\t\t\tif-perm disable-if=\"account-bills\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Factura' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\" ng-class=\"{active: showOrders}\" ng-click=\"getOrders(); showOrders=true\"\n\t\t\t\tif-perm disable-if=\"invoice-orders\">\n\t\t\t\t\t\t\t<a href=\"#\">{{'Órdenes' | translate}}</a>\n\t\t\t\t\t\t</li>\n            <li class=\"Tabs__tab Tab\">\n                <button class=\"btn btn-default pull-right\" ng-click=\"printToCart('printSectionId')\">\n                    <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                </button>\n            </li>\n            <li class=\"Tabs__presentation-slider\" role=\"presentation\"></li>\n        </ul>\n    </nav>\n\n    <!-- start print -->\n            <div id=\"printSectionId\" class=\"Section_Print\">\n                <div class=\"logo_invoice\">\n                    <img src=\"{{ logoUrl }}\" alt=\"\">\n                <div class=\"Powered\">\n                    <span>{{'RNC' | translate}}: </span>{{account.identification || '-'}} <br>\n                    <span>{{'Dirección' | translate}}: </span>{{ account.address || '-'}} <br>\n                    <span>{{'Telefono' | translate}}: </span>{{ account.phone || '-'}}\n                </div>\n                </div>\n                <div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n                <table class=\"table table-condensed tableforprint\">\n                    \n                    <tr>\n                        <td>\n                            <strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n                        </td>\n                        <td class=\"text-right\">\n                            <strong>{{'Fecha' | translate}}:</strong> <span>{{ invoice.date | amUtc | amDateFormat:'LLLL' | capitalise  }}</span>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            <strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            {{'RNC' | translate}} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n                        </td>\n                    </tr>\n                    <!-- <tr>\n                        <td \"3\">\n                            <strong>Mesa No.:</strong> {{ invoice.table }}\n                        </td>\n                        <td \"3\">\n                            <strong>Atendida por:</strong> {{ invoice.cashier || '-' }}\n                        </td>\n                        <td \"3\">\n                            <strong>Pax:</strong> {{ invoice.pax }}\n                        </td>\n                    </tr> -->\n                    \n                    <tr><td><hr></td></tr>\n                    <tr>\n                        <th class=\"text-center\" \"3\">{{'Detalles' | translate}}</th>\n                        <th class=\"text-center\">{{'Cantidad' | translate}}</th>\n                        <th class=\"text-center\">{{'Descuento' | translate}}</th>\n                        <th class=\"text-center\">{{'Total' | translate}}</th>\n                        \n                    </tr>\n                    <tr ng-repeat=\"detail in invoice.details\">\n                        <td class=\"text-center\" \"3\">{{ detail.description || '-' }}</td>\n                        <td class=\"text-center\">{{ detail.quantity || 0 }}</td>\n                        <td class=\"text-center\">{{ detail.discount | currency }}</td>\n                        <td class=\"text-center\">{{ detail.total | currency }}</td>\n                    </tr>\n                    <tr><td colspan=\"6\"><hr></td></tr>\n                    <tr>\n                        <td>\n                            <strong>{{'Notas' | translate}}:</strong>\n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{'Subtotal' | translate}}</span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>0.000</span>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            {{'Comensales' | translate}}: <span>{{ invoice.pax }}</span> \n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{'Descuento' | translate}}</span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{ invoice.discount | currency }}</span>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td colspan=\"2\">\n                            <span>{{'Atendido por' | translate}}: </span>\n                            <span>{{ invoice.cashier || '-' }}</span>\n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{'% Ley' | translate}}:</span> \n                        </td>\n                        <td class=\"text-center\">\n                            <span>{{ invoice.tax10 | currency }}</span>\n                        </td>\n                    </tr>\n                    <tr class=\"text-center\">\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span>{{'IVA' | translate}}:</span> {{ invoice.tax16 | currency }}\n                        </td>\n                        <td>\n                            <span>{{ invoice.tax10 | currency }}</span>\n                        </td>\n                    </tr>\n                    <tr class=\"text-center\">\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span>{{'Exoneracion IVA' | translate}}:</span>\n                        </td>\n                        <td>\n                            <span>0.000</span>\n                        </td>\n                    </tr>\n                    <tr class=\"text-center\">\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <span></span> \n                        </td>\n                        <td>\n                            <strong>{{'Total' | translate}}:</strong>\n                        </td>\n                        <td>\n                            <strong>{{ invoice.total | currency }}</strong>\n                        </td>\n                        <!-- <td \"3\">\n                            <strong>Impuestos incluidos:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n                        </td> -->\n                    </tr>\n                </table>\n            </div>\n            </div>\n    <!-- end print -->\n\n\t\t<div class=\"invoice-detail\" ng-show=\"!showOrders || showOrders==='false'\"> \n\t\t\t<table class=\"table table-bordered table-condensed\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'No. Factura' | translate}}:</strong> {{ invoice.number }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'NCF' | translate}}:</strong> {{ invoice.ncf || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Fecha' | translate}}:</strong> {{ invoice.date | amUtc | amDateFormat:'DD/MMM/YYYY'  }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Emitido a' | translate}}:</strong> {{ invoice.name || '-' }} <span ng-show=\"invoice.rnc\">{{ invoice.rnc || '-' }}</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Mesa No.' | translate}}:</strong> {{ invoice.table }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Atendida por' | translate}}:</strong> {{ invoice.cashier || '-' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Desc.' | translate}}:</strong> {{ invoice.discount | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Pax' | translate}}:</strong> {{ invoice.pax }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Total' | translate}}:</strong> {{ invoice.total | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'Impuestos incluidos' | translate}}:</strong> {{ invoice.tax_included ? 'Si' : 'No' }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'IVA' | translate}}:</strong> {{ invoice.tax16 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td colspan=\"3\">\n\t\t\t\t\t\t<strong>{{'% Ley' | translate}}:</strong> {{ invoice.tax10 | currency }}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr><td colspan=\"6\"></td></tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th class=\"text-left\" sort=\"orderedBy\" sort-by=\"description\" colspan=\"3\">{{'Detalles' | translate}}</th>\n\t\t\t\t\t<th class=\"text-left\" sort=\"orderedBy\" sort-by=\"quantity\">{{'Cantidad' | translate}}</th>\n\t\t\t\t\t<th class=\"text-left\" sort=\"orderedBy\" sort-by=\"total\">{{'Total' | translate}}</th>\n\t\t\t\t\t<th class=\"text-left\" sort=\"orderedBy\" sort-by=\"discount\">{{'Desc.' | translate}}</th>\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"detail in invoice.details | orderBy:orderedBy\">\n\t\t\t\t\t<td colspan=\"3\">{{ detail.description || '-' }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.quantity || 0 }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.total | currency }}</td>\n\t\t\t\t\t<td class=\"text-right\">{{ detail.discount | currency }}</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=\"orders\" ng-show=\"showOrders\">\n\t\t\t<table id=\"pruena\" class=\"table table-bordered table-condensed\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"text-left\" sort=\"orderedBy\" sort-by=\"id\">{{'Factura' | translate}}</th>\n\t\t\t\t\t\t<th class=\"text-left\" sort=\"orderedBy\" sort-by=\"action\">{{'Acción' | translate}}</th>\n\t\t\t\t\t\t<th class=\"text-left\" sort=\"orderedBy\" sort-by=\"date\">{{'Fecha' | translate}}</th>\n\t\t\t\t\t\t<th class=\"text-left\" sort=\"orderedBy\" sort-by=\"cashier\">{{'Vendedor' | translate}}</th>\n\t\t\t\t\t\t<th class=\"text-left\" sort=\"orderedBy\" sort-by=\"status\">{{'Estado' | translate}}</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat=\"order in orders | orderBy:orderedBy\">\n\t\t\t\t\t\t<td data-label=\"Factura\">\n\t\t\t\t\t\t\t<a href=\"\" data-ajax_load=\"\" data-container=\"#billpayment\" class=\"btn btn-xs btn-primary\"\n\t\t\t\t\t\t\t\tng-click=\"fetchDetails(order)\">\n\t\t\t\t\t\t\t\t{{ order.id }}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td data-label=\"Acción\">{{ order.action || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Fecha\">{{ order.date | amUtc | amDateFormat:'DD/MMM/YYYY' }}</td>\n\t\t\t\t\t\t<td data-label=\"Vendedor\">{{ order.cashier || '-' }}</td>\n\t\t\t\t\t\t<td data-label=\"Estado\">{{ order.status || '-' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t\t<table class=\"table table-bordered table-condensed\" ng-show=\"displayingOrder\">\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr><td colspan=\"4\">{{ displayingOrder.action || '-' }}</td></tr>\n\t\t\t\t\t<tr class=\"table_list_heading\">\n\t\t\t\t\t\t<th class=\"detail_table hidden-xs hidden-sm\" width=\"100\"><b>{{'De la Factura' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"De la Factura:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.billid || '-' }}</td>\n\t\t\t\t\t\t<th class=\" hidden-xs hidden-sm\" width=\"100\"><b>{{'Fecha' | translate}}</b></th>\n\t\t\t\t\t\t<td data-label=\"Fecha:\" class=\"detail_table\" width=\"100\">{{ displayingOrder.date | amUtc | amDateFormat:'LLL' }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>{{'Vendedor' | translate}}:</b></th>\n\t\t\t\t\t\t<td data-label=\"Vendedor:\">{{ displayingOrder.cashier || '-' }}</td>\n\t\t\t\t\t\t<th class=\"hidden-xs hidden-sm\"><b>Mesa:</b></th>\n\t\t\t\t\t\t<td data-label=\"Mesa:\" colspan=\"2\">{{ displayingOrder.table_type || '-' }} {{ displayingOrder.table_code || '' }}</td>\n\t\t\t\t\t</tr>\n\n\t\t\t\t\t<tr class=\"table_graund\" ng-repeat=\"detail in displayingOrder.details\">\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.name  || '-' }}</td>\n\t\t\t\t\t\t<td colspan=\"2\">{{ detail.qty  || 0 }}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"button\" class=\"btn btn-danger btn_standar pull-left\" ng-click=\"closeThisDialog();\">\n\t\t\t{{'Salir' | translate}}\n\t\t</button>\n\t</div>\n</script>"

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesBySubfamilyController = function () {
	  function SalesBySubfamilyController(ContentService, moment, ProfilePermissionsService, $uibModal) {
	    (0, _classCallCheck3.default)(this, SalesBySubfamilyController);
	
	    this.service = ContentService;
	    this.moment = moment;
	    this.permissionsService = ProfilePermissionsService;
	    this.modal = $uibModal;
	    this.grouping = 'TAG';
	  }
	
	  (0, _createClass3.default)(SalesBySubfamilyController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.rows = [];
	      this.dateFrom = this.moment(this.dateFrom || new Date());
	      this.dateTo = this.moment(this.dateTo || new Date());
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'getSalesByTag',
	    value: function getSalesByTag() {
	      var _this = this;
	
	      this.subscriptions.push(this.service.getSalesByTag({
	        date_to: this.dateTo.toISOString(),
	        date_from: this.dateFrom.toISOString()
	      }).subscribe(function (data) {
	        _this.rows = data.rows;
	      }, function () {}));
	    }
	  }, {
	    key: 'getSalesByCategory',
	    value: function getSalesByCategory() {
	      var _this2 = this;
	
	      this.subscriptions.push(this.service.findSalesByCategory({
	        date_to: this.dateTo.toISOString(),
	        date_from: this.dateFrom.toISOString()
	      }).subscribe(function (data) {
	        _this2.rows = data.rows;
	      }, function () {}));
	    }
	  }, {
	    key: 'drillDownOnTag',
	    value: function drillDownOnTag(tag) {
	      var _this3 = this;
	
	      this.subscriptions.push(this.service.getSalesByTag({
	        date_to: this.dateTo.toISOString(),
	        date_from: this.dateFrom.toISOString()
	      }, tag.tag_id).subscribe(function (data) {
	        _this3.rows = data.rows;
	        _this3.title = tag.tag || '';
	      }, function () {}));
	    }
	  }, {
	    key: 'drillDownOnItem',
	    value: function drillDownOnItem(item_id, name) {
	      var _this4 = this;
	
	      this.subscriptions.push(this.service.getSalesByTag({
	        date_to: this.dateTo.toISOString(),
	        date_from: this.dateFrom.toISOString(),
	        item_id: item_id
	      }).subscribe(function (data) {
	        _this4.rows = data.rows;
	        _this4.title = name;
	      }));
	    }
	  }, {
	    key: 'openBillDetails',
	    value: function openBillDetails(invoiceId) {
	      var that = this;
	      if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')) {
	        this.modal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'invoice-details-template.html',
	          appendClassName: 'ngdialog-theme-plain',
	          controller: ["$scope", "$uibModalInstance", "AccountInformationService", function controller($scope, $uibModalInstance, AccountInformationService) {
	            "ngInject";
	
	            $scope.invoice = {};
	            $scope.orders = [];
	            $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
	            that.subscriptions.push(that.service.getInvoice(invoiceId).subscribe(function (invoice) {
	              return $scope.invoice = invoice;
	            }, function (error) {
	              return console.log("Error while getting the invoice");
	            }));
	
	            $scope.getOrders = function () {
	              if ($scope.orders.length <= 0) {
	                that.subscriptions.push(that.service.getOrders(invoiceId).subscribe(function (orders) {
	                  return $scope.orders = orders;
	                }, function (error) {
	                  return console.log("Error while getting the orders");
	                }));
	              }
	            };
	
	            that.subscriptions.push(AccountInformationService.getAccountInfo().subscribe(function (resp) {
	              $scope.account = resp;
	            }));
	
	            $scope.fetchDetails = function (order) {
	              if (!order.details || order.details.length <= 0) {
	                that.subscriptions.push(that.service.getOrderDetails(invoiceId, order.id).subscribe(function (details) {
	                  order.details = details;
	                  $scope.displayingOrder = order;
	                }, function (error) {
	                  return console.log("Error while getting the details for this order");
	                }));
	              }
	            };
	
	            $scope.printToCart = function (printSectionId) {
	              var innerContents = document.getElementById(printSectionId).innerHTML;
	              var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
	              popupWinindow.document.open();
	              popupWinindow.document.write('<html><head><title>Imprimir factura #' + $scope.invoice.number + '</title><link rel="stylesheet" type="text/css" href="assets/bootstrap.css" /><link rel="stylesheet" type="text/css" href="assets/printstyle.css" /></head><body onload="window.print()">' + innerContents + '</html>');
	              popupWinindow.document.close();
	            };
	
	            $scope.closeThisDialog = function () {
	              return $uibModalInstance.close();
	            };
	          }]
	        });
	      }
	    }
	  }, {
	    key: 'isGroupedByTag',
	    value: function isGroupedByTag() {
	      return this.rows && this.rows.length && this.rows[0].hasOwnProperty('tag_id');
	    }
	  }, {
	    key: 'isGroupedByCategory',
	    value: function isGroupedByCategory() {
	      return this.rows && this.rows.length && this.rows[0].hasOwnProperty('pifamm_id') && !this.rows[0].hasOwnProperty('tag_id');
	    }
	  }, {
	    key: 'isGroupedByItem',
	    value: function isGroupedByItem() {
	      return this.rows && this.rows.length && this.rows[0].hasOwnProperty('item_id');
	    }
	  }, {
	    key: 'isGroupedByInvoice',
	    value: function isGroupedByInvoice() {
	      return this.rows && this.rows.length && this.rows[0].hasOwnProperty('date') && this.rows[0].hasOwnProperty('rnc');
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal(item) {
	      return item.total_billed || item.total || 0;
	    }
	  }, {
	    key: 'getDiscount',
	    value: function getDiscount(item) {
	      return item.discount_billed || item.discount || 0;
	    }
	  }, {
	    key: 'getOth',
	    value: function getOth(item) {
	      return item.oth_total || 0;
	    }
	  }, {
	    key: 'getVoid',
	    value: function getVoid(item) {
	      return item.cancelation_total || 0;
	    }
	  }, {
	    key: 'getReturned',
	    value: function getReturned(item) {
	      return item.return_total || 0;
	    }
	  }, {
	    key: 'getPax',
	    value: function getPax(item) {
	      return item.pax || 0;
	    }
	  }, {
	    key: 'getExtraTip',
	    value: function getExtraTip(item) {
	      return item.extra_tip || 0;
	    }
	  }, {
	    key: 'getTaxExemption',
	    value: function getTaxExemption(item) {
	      return item.taxexemption || 0;
	    }
	  }, {
	    key: 'getTax10',
	    value: function getTax10(item) {
	      return item.tax10 || 0;
	    }
	  }, {
	    key: 'getTax16',
	    value: function getTax16(item) {
	      return item.tax16 || 0;
	    }
	  }]);
	  return SalesBySubfamilyController;
	}();
	
	exports.default = SalesBySubfamilyController;
	
	
	SalesBySubfamilyController.$inject = ['ContentService', 'moment', 'ProfilePermissionsService', '$uibModal'];

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1298);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-subfamily.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-subfamily.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".SalesBySubfamily{color:red}", ""]);
	
	// exports


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _salesByFiscalNumber = __webpack_require__(1300);
	
	var _salesByFiscalNumber2 = _interopRequireDefault(_salesByFiscalNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByFiscalNumberModule = _angular2.default.module('SalesByFiscalNumber', [_angularjs2.default]).component('salesbyfiscalnumber', _salesByFiscalNumber2.default).filter('ncfType', ["$translate", function ($translate) {
	  "ngInject";
	
	  var _ = $translate.instant;
	  return function (token) {
	    var ncfTypes = {
	      '01': _('Crédito fiscal'),
	      '02': _('Consumidor Final'),
	      '03': _('Notas de Débito'),
	      '04': _('Notas de Crédito'),
	      '14': _('Regimen Especial'),
	      '15': _('Gubernamental')
	    };
	    return ncfTypes[token];
	  };
	}]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesByFiscalNumber', {
	    url: '/sales-by-ncf',
	    data: {
	      authRequired: true,
	      permsRequired: ['sales-by-ncf']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        'component': 'salesbyfiscalnumber'
	      }
	    }
	  });
	}]).name;
	
	exports.default = SalesByFiscalNumberModule;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesByFiscalNumber = __webpack_require__(1301);
	
	var _salesByFiscalNumber2 = _interopRequireDefault(_salesByFiscalNumber);
	
	var _salesByFiscalNumber3 = __webpack_require__(1302);
	
	var _salesByFiscalNumber4 = _interopRequireDefault(_salesByFiscalNumber3);
	
	__webpack_require__(1303);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByFiscalNumberComponent = {
	  bindings: {},
	  template: _salesByFiscalNumber2.default,
	  controller: _salesByFiscalNumber4.default
	};
	
	exports.default = SalesByFiscalNumberComponent;

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                {{'Ventas por Tipo de Comprobante' | translate}}\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form name=\"salesByVendorForm\" class=\"hidden-xs\">\n            <div class=\"form col-md-12 no-padding\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>    \n                    <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" id=\"from\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\">\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>    \n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" id=\"to\" class=\"form-control input_py\" format=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\">  \n                    <span class=\"input-group-btn\">\n                        <button name=\"submitBtn\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.getSalesByNCF()\">{{'Buscar' | translate}}</button>    \n                    </span>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class=\"col-md-12 table_container\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <div class=\"fixed-table-toolbar\">\n                        <div class=\"search col-md-4\">\n                            <div class=\"field\">\n                                <input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n                                <label for=\"input-search\">{{'Filtrar búsqueda' | translate}}</label>\n                            </div> \n                        </div>\n                    </div>\n                    <div class=\"fixed-table-container\">\n                        <table id=\"bootstrap-table\" class=\"table\">\n                            <thead>\n                                <th class=\"text-center\" sort=\"$ctrl.orderedBy\" sort-by=\"ncf_type\">{{'Tipo NCF' | translate}}</th>\n                                <th class=\"text-center\" sort=\"$ctrl.orderedBy\" sort-by=\"amount\">{{'Cantidad' | translate}}</th>\n                                <th class=\"text-center\" sort=\"$ctrl.orderedBy\" sort-by=\"total\">{{'Ventas' | translate}}</th>\n                                <th class=\"text-center\" sort=\"$ctrl.orderedBy\" sort-by=\"tax\">{{'Impuestos' | translate}}</th>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\">\n                                    <td>{{row.ncf_type | ncfType }}</td>\n                                    <td>{{row.amount}}</td>\n                                    <td>{{row.total  | currency}}</td>\n                                    <td>{{row.tax | currency}}</td>\n                                </tr>\n                            </tbody>\n                            <tfoot>\n                                <th></th>\n                                <th></th>\n                                <th>{{ filtered | map:$ctrl.getTotal | sum: 0 | currency}}</th>\n                                <th>{{ filtered | map:$ctrl.getTax | sum: 0 | currency}}</th>\n                            </tfoot>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesByFiscalNumberController = function () {
	  function SalesByFiscalNumberController(ContentService, moment) {
	    (0, _classCallCheck3.default)(this, SalesByFiscalNumberController);
	
	    this.service = ContentService;
	    this.moment = moment;
	  }
	
	  (0, _createClass3.default)(SalesByFiscalNumberController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.subscriptions = [];
	
	      this.dateFrom = this.moment();
	      this.dateTo = this.moment();
	      this.rows;
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'getSalesByNCF',
	    value: function getSalesByNCF() {
	      var _this = this;
	
	      this.subscriptions.push(this.service.getSalesByNCF(this.dateFrom.toISOString(), this.dateTo.toISOString()).subscribe(function (data) {
	        _this.rows = data.rows;
	      }));
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal(row) {
	      return row.total;
	    }
	  }, {
	    key: 'getTax',
	    value: function getTax(row) {
	      return row.tax;
	    }
	  }]);
	  return SalesByFiscalNumberController;
	}();
	
	exports.default = SalesByFiscalNumberController;
	
	
	SalesByFiscalNumberController.$inject = ['ContentService', 'moment'];

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1304);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-fiscal-number.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-by-fiscal-number.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".SalesByFiscalNumber{color:red}", ""]);
	
	// exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(461);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _salesDetailsReport = __webpack_require__(1306);
	
	var _salesDetailsReport2 = _interopRequireDefault(_salesDetailsReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesDetailsReportModule = _angular2.default.module('SalesDetailsReport', [_angularjs2.default]).component('salesDetailsReport', _salesDetailsReport2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesDetailsReport', {
	    url: '/un-named-report',
	    data: {
	      authRequired: true,
	      permsRequired: ['sales-details-report']
	    },
	    views: {
	      'menu': 'menu',
	      'content': {
	        component: 'salesDetailsReport'
	      }
	    }
	  });
	}]).name;
	
	exports.default = SalesDetailsReportModule;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesDetailsReport = __webpack_require__(1307);
	
	var _salesDetailsReport2 = _interopRequireDefault(_salesDetailsReport);
	
	var _salesDetailsReport3 = __webpack_require__(1308);
	
	var _salesDetailsReport4 = _interopRequireDefault(_salesDetailsReport3);
	
	__webpack_require__(1327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesDetailsReportComponent = {
	  bindings: {},
	  template: _salesDetailsReport2.default,
	  controller: _salesDetailsReport4.default
	};
	
	exports.default = SalesDetailsReportComponent;

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-10 col-md-offset-2 main\">\n    <h1 class=\"page-header\">\n        <div class=\"row\">\n            <div class=\"col-md-8 col-sm-8 col-xs-12\">\n                {{'Reporte Multiple' | translate}}\n            </div>\n        </div>\n    </h1>\n    <div class=\"active border-bottom\">\n        <form name=\"salesByArtForm\" class=\"hidden-xs\" novalidate>\n            <div class=\"form col-md-12 no-padding\" style=\"padding: 0;\">\n        \n                <input type=\"hidden\" name=\"sorter\" value=\"\">\n                \n                <input type=\"hidden\" name=\"cashier_id\" value=\"\">\n                \n                <input type=\"hidden\" name=\"pos_id\" value=\"\">\n                <div class=\"input-group\">\n                    <label for=\"from\" class=\"input-group-addon\">{{'Desde' | translate}}</label>    \n                    <input type=\"text\" name=\"from\" ng-model=\"$ctrl.dateFrom\" format=\"DD/MM/YYYY\" autocomplete=\"off\"\n                            id=\"from\" class=\"form-control input_py\" today=\"true\" moment-picker=\"$ctrl.dateFrom\" start-view=\"month\" readonly>\n                    <label for=\"to\" class=\"input-group-addon\">{{'Hasta' | translate}}</label>    \n                    <input type=\"text\" name=\"to\" ng-model=\"$ctrl.dateTo\" id=\"to\" class=\"form-control input_py\"\n                            format=\"DD/MM/YYYY\" autocomplete=\"off\" today=\"true\" moment-picker=\"$ctrl.dateTo\" start-view=\"month\" readonly>          \n                </div>\n            </div>\n        </form>\n        <form class=\"visible-xs\">\n            <div class=\"form_xs\">\n                <div class=\"col-xs-6 form-group no_padding_left\">\n                    <p class=\"label_m\" for=\"desde\">{{'Desde' | translate}}</p>\n                    <input class=\"form-control input_py\" name=\"from\" moment-picker=\"$ctrl.dateFrom\"\n                        ng-model=\"$ctrl.dateFrom\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n                </div>\n                <div class=\"col-xs-6 form-group no_padding_right\">\n                    <p class=\"label_m\" for=\"desde\">{{'Hasta' | translate}}</p>\n                    <input class=\"form-control input_py\" name=\"to\" moment-picker=\"$ctrl.dateTo\"\n                        ng-model=\"$ctrl.dateTo\" today=\"true\" format=\"DD/MM/YYYY\" autocomplete=\"off\" start-view=\"month\" readonly>\n                </div>\n            </div>\n        </form>\n    </div>\n\n    <div class=\"row\">\n          <br>\n          <br>\n          <br>\n        <div class=\"col-md-6\">\n            <p class=\"label_m invisible\" for=\"desde\">{{'Camareros'}}</p>\n            <div class=\"input-group form-group\">\n                <label for=\"from\" class=\"input-group-addon\">{{'Mesa Desde' | translate}}</label>    \n                <input class=\"form-control input_py\" name=\"to\" autocomplete=\"off\" start-view=\"month\" ng-model=\"$ctrl.temporalTableFrom\" ng-blur=\"$ctrl.checkIfTableRangeFilled()\">\n                <label for=\"to\" class=\"input-group-addon\">{{'Mesa Hasta' | translate}}</label>    \n                <input class=\"form-control input_py\" name=\"to\" autocomplete=\"off\" start-view=\"month\" ng-model=\"$ctrl.temporalTableTo\" ng-blur=\"$ctrl.checkIfTableRangeFilled()\">\n            </div>\n            <span class=\"tag\" draggable=\"true\" ng-repeat=\"tRange in $ctrl.tableRanges\" ng-click=\"$ctrl.removeTableRange(tRange)\">\n                {{ tRange }} <span class=\"remove\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></span>\n            </span>\n        </div>\n        <div class=\"col-md-2\">\n            <p class=\"label_m\" for=\"desde\">{{'Camareros' | translate}}</p>\n            <input class=\"form-control input_py\" type=\"text\" name=\"cashier\" autocomplete=\"off\"\n                ng-model=\"$ctrl.temporalCashier\"\n                placeholder=\"{{ 'Busca por código o nombre' | translate }}\"\n                uib-typeahead=\"$ctrl.cashierRepr(cashier) for cashier in $ctrl.getChashiersMatching($viewValue)\"\n                typeahead-loading=\"loadingCashiers\" typeahead-no-results=\"noCashiersResults\"\n                typeahead-wait-ms=\"500\" typeahead-editable=\"false\"\n                typeahead-on-select=\"$ctrl.onCashierSelected($item, $model, $label, $event)\">\n            <span class=\"tag\" draggable=\"true\" ng-repeat=\"cashier in $ctrl.selectedCashiers track by cashier.code\" ng-click=\"$ctrl.removeCashier(cashier)\">\n                {{ $ctrl.cashierRepr(cashier) }} <span class=\"remove\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></span>\n            </span>\n        </div>\n        <div class=\"col-md-2\">\n            <p class=\"label_m\" for=\"desde\">{{'Categorías' | translate}}</p>\n            <input class=\"form-control input_py\" type=\"text\" name=\"category\" autocomplete=\"off\"\n                ng-model=\"$ctrl.temporalCategory\"\n                placeholder=\"{{ 'Busca por nombre' | translate }}\"\n                uib-typeahead=\"$ctrl.categoryRepr(category) for category in $ctrl.getCategoriesMatching($viewValue)\"\n                typeahead-loading=\"loadingCategories\" typeahead-no-results=\"noCategoriesResults\"\n                typeahead-wait-ms=\"500\" typeahead-editable=\"false\"\n                typeahead-on-select=\"$ctrl.onCategorySelected($item, $model, $label, $event)\">\n            <span class=\"tag\" draggable=\"true\" ng-repeat=\"category in $ctrl.selectedCategories track by category.id\" ng-click=\"$ctrl.removeCategory(category)\">\n                {{ $ctrl.categoryRepr(category) }} <span class=\"remove\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></span>\n            </span>\n        </div>\n        <div class=\"col-md-2\">\n            <p class=\"label_m\" for=\"desde\">{{'Etiquetas' | translate}}</p>\n            <input class=\"form-control input_py\" type=\"text\" name=\"tag\" autocomplete=\"off\"\n                ng-model=\"$ctrl.temporalTag\"\n                placeholder=\"{{ 'Busca por nombre' | translate }}\"\n                uib-typeahead=\"$ctrl.tagRepr(tag) for tag in $ctrl.getTagsMatching($viewValue)\"\n                typeahead-loading=\"loadingTags\" typeahead-no-results=\"noTagsResults\"\n                typeahead-wait-ms=\"500\" typeahead-editable=\"false\"\n                typeahead-on-select=\"$ctrl.onTagSelected($item, $model, $label, $event)\">\n            <span class=\"tag\" draggable=\"true\" ng-repeat=\"tag in $ctrl.selectedTags track by tag.id\" ng-click=\"$ctrl.removeTag(tag)\">\n                {{ $ctrl.tagRepr(tag) }} <span class=\"remove\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></span>\n            </span>\n        </div>\n    </div>\n\n    <div class=\"row submitrow\">\n        <div class=\"col-md-3 col-md-offset-6\">\n            <button name=\"submitBtn\" type=\"button\" class=\"btn btn-danger btn-block\" ng-click=\"$ctrl.resetFilters()\"><i class=\"fa fa-repeat\" aria-hidden=\"true\"></i> {{'Reiniciar filtros' | translate}}</button>\n        </div>\n        <div class=\"col-md-3\">\n            <button name=\"submitBtn\" type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"$ctrl.generateReport()\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> {{'Buscar' | translate}}</button>\n        </div>\n    </div>\n\n\n    <div class=\"col-md-12 table_container\">\n        <div class=\"card\">\n            <div class=\"card-content\">\n                <div class=\"bootstrap-table\">\n                    <div class=\"fixed-table-toolbar\">\n                        <div class=\"columns pull-right\">\n                            <button type=\"button\" class=\"btn btn-success\" ng-csv=\"$ctrl.getExportRows()\" csv-header=\"$ctrl.csvHeaders\" csv-column-order=\"$ctrl.csvHeaderOrder\" filename=\"reporte-detalles-de-ventas.csv\" ng-disabled=\"$ctrl.rows.length <= 0\">\n                                <i class=\"fa fa-file-o\" aria-hidden=\"true\"></i> {{'Exportar CSV' | translate}}\n                            </button>\n                        </div>\n\n                        <div class=\"search col-md-4\">\n                            <div class=\"field\">\n                                <input type=\"text\" class=\"input-search\" id=\"input-search\" name=\"input-search\" ng-model=\"filterCrit\" required>\n                                <label for=\"input-search\">{{'Filtrar búsqueda' | translate}}</label>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"fixed-table-container\">\n                        <table id=\"bootstrap-table\" class=\"table\" ng-class=\"{'table-striped': $ctrl.inMobileView, 'table-hover': !$ctrl.inMobileView}\">\n                            <thead>\n                                <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"date\">{{'Fecha' | translate}}</th>\n                                <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"item\">{{'Artículo' | translate}}</th>\n                                <th class=\"text-center\" sort=\"$ctrl.orderedBy\" sort-by=\"sold_qty\">{{'Cantidad' | translate}}</th>\n                                <th class=\"text-right\" sort=\"$ctrl.orderedBy\" sort-by=\"item_price\">{{'Precio' | translate}}</th>\n                                <th class=\"text-right\" sort=\"$ctrl.orderedBy\" sort-by=\"sold_discount\">{{'Descontado' | translate}}</th>\n                                <th class=\"text-right\" sort=\"$ctrl.orderedBy\" sort-by=\"sold_billdiscount\">{{'BillDiscount' | translate}}</th>\n                                <th class=\"text-right\" sort=\"$ctrl.orderedBy\" sort-by=\"total_discount\">{{'Total Descontado' | translate}}</th>\n                                <th class=\"text-right\" sort=\"$ctrl.orderedBy\" sort-by=\"sold_total\">{{'Monto' | translate}}</th>\n                                <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"cashier\">{{'Camarero' | translate}}</th>\n                                <th class=\"text-center\" sort=\"$ctrl.orderedBy\" sort-by=\"table\">{{'Mesa' | translate}}</th>\n                                <th class=\"text-center\" sort=\"$ctrl.orderedBy\" sort-by=\"table_type\">{{'Tipo de Mesa' | translate}}</th>\n                                <th class=\"text-center\" sort=\"$ctrl.orderedBy\" sort-by=\"tag\">{{'Etiqueta' | translate}}</th>\n                                <th class=\"text-left\" sort=\"$ctrl.orderedBy\" sort-by=\"family\">{{'Categoría' | translate}}</th>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"row in $ctrl.rows | orderBy:$ctrl.orderedBy | filter:filterCrit as filtered\">\n                                    <td data-label=\"{{'Fecha' | translate}}\" class=\"text-left\">{{ row.date | amUtc | amDateFormat:'LLL' }}</td>\n                                    <td data-label=\"{{'Artículo' | translate}}\" class=\"text-left\">{{ row.item }}</td>\n                                    <td data-label=\"{{'Cantidad' | translate}}\" class=\"text-center\">{{ row.sold_qty }}</td>\n                                    <td data-label=\"{{'Precio' | translate}}\" class=\"text-right\">{{ row.item_price | currency }}</td>\n                                    <td data-label=\"{{'Descontado' | translate}}\" class=\"text-right\">{{ row.sold_discount | currency }}</td>\n                                    <td data-label=\"{{'BillDiscount' | translate}}\" class=\"text-right\">{{ row.sold_billdiscount | currency }}</td>\n                                    <td data-label=\"{{'Total Descontado' | translate}}\" class=\"text-right\">{{ row.total_discount | currency }}</td>\n                                    <td data-label=\"{{'Monto' | translate}}\" class=\"text-right\">{{ row.sold_total | currency }}</td>\n                                    <td data-label=\"{{'Camarero' | translate}}\" class=\"text-left\">{{ row.cashier }}</td>\n                                    <td data-label=\"{{'Mesa' | translate}}\" class=\"text-center\">{{ row.table }}</td>\n                                    <td data-label=\"{{'Tipo de Mesa' | translate}}\" class=\"text-center\">{{ row.table_type }}</td>\n                                    <td data-label=\"{{'Etiqueta' | translate}}\" class=\"text-center\">{{ row.tag }}</td>\n                                    <td data-label=\"{{'Categoría' | translate}}\" class=\"text-left\">{{ row.family }}</td>\n                                </tr>\n                            </tbody>\n                            <tfoot>\n                                <th><!-- Fecha --></th>\n                                <th><!-- Articulo --></th>\n                                <th><!-- Cantidad --></th>\n                                <th><!-- Precio --></th>\n                                <th data-label=\"{{'Total Descontado' | translate}}\" class=\"text-right\">\n                                    {{ filtered | map:$ctrl.getSoldDiscount | sum: 0 | currency}}\n                                </th>\n                                <th data-label=\"{{'Total BillDiscount' | translate}}\" class=\"text-right\">\n                                    {{ filtered | map:$ctrl.getSoldBillDiscount | sum: 0 | currency}}\n                                </th>\n                                <th data-label=\"{{'Todos los Descuentos' | translate}}\" class=\"text-right\">\n                                    {{ filtered | map:$ctrl.getTotalDiscount | sum: 0 | currency}}\n                                </th>\n                                <th data-label=\"{{'Total Monto' | translate}}\" class=\"text-right\">\n                                    {{ filtered | map:$ctrl.getSoldTotal | sum: 0 | currency}}\n                                </th>\n                                <th><!-- Camarero --></th>\n                                <th><!-- Mesa --></th>\n                                <th><!-- Tipo de Mesa --></th>\n                                <th><!-- Etiqueta --></th>\n                                <th><!-- Categoria --></th>\n                            </tfoot>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>"

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _typescript = __webpack_require__(1309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesDetailsReportController = function () {
	  function SalesDetailsReportController(ContentService, isMobile, $translate, moment) {
	    (0, _classCallCheck3.default)(this, SalesDetailsReportController);
	
	    this.service = ContentService;
	    this.isMobile = isMobile;
	    this.$translate = $translate;
	    this.moment = moment;
	  }
	
	  (0, _createClass3.default)(SalesDetailsReportController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _ = this.$translate.instant;
	
	      this.subscriptions = [];
	
	      this.temporalTableFrom = undefined;
	      this.temporalTableTo = undefined;
	      this.tableRanges = [];
	
	      this.temporalCashier = undefined;
	      this.selectedCashiers = [];
	
	      this.temporalCategory = undefined;
	      this.selectedCategories = [];
	
	      this.temporalTag = undefined;
	      this.selectedTags = [];
	
	      this.rows = [];
	
	      this.csvHeaders = [_('Fecha'), _('Artículo'), _('Cantidad'), _('Precio'), _('Descontado'), _('BillDiscount'), _('Total Descontado'), _('Monto'), _('Camarero'), _('Mesa'), _('Tipo de Mesa'), _('Etiqueta'), _('Categoría')];
	      this.csvHeaderOrder = ['date', 'item', 'sold_qty', 'item_price', 'sold_discount', 'sold_billdiscount', 'total_discount', 'sold_total', 'cashier', 'table', 'table_type', 'tag', 'family'];
	
	      this.dateFrom = undefined;
	      this.dateTo = undefined;
	
	      this.orderedBy = undefined;
	      this.inMobileView = this.isMobile.phone;
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	    }
	  }, {
	    key: 'getChashiersMatching',
	    value: function getChashiersMatching(searchTerm) {
	      return this.service.getCashiersBySearchTerm(searchTerm).toPromise();
	    }
	  }, {
	    key: 'cashierRepr',
	    value: function cashierRepr(cashier) {
	      return !!cashier ? cashier.code + ' - ' + (cashier.name || '(Nada)') : '';
	    }
	  }, {
	    key: 'onCashierSelected',
	    value: function onCashierSelected(item, model, label, event) {
	      this.temporalCashier = undefined;
	      this.selectedCashiers.push(item);
	    }
	  }, {
	    key: 'removeCashier',
	    value: function removeCashier(cashierToRemove) {
	      this.selectedCashiers.splice(this.selectedCashiers.findIndex(function (cashier) {
	        return cashier.id === cashierToRemove.id;
	      }), 1);
	    }
	  }, {
	    key: 'getCategoriesMatching',
	    value: function getCategoriesMatching(searchTerm) {
	      return this.service.getCategoriesBySearchTerm(searchTerm).toPromise();
	    }
	  }, {
	    key: 'categoryRepr',
	    value: function categoryRepr(category) {
	      return !!category ? '' + (category.name || '(Nada)') : '';
	    }
	  }, {
	    key: 'onCategorySelected',
	    value: function onCategorySelected(item, model, label, event) {
	      this.temporalCategory = undefined;
	      this.selectedCategories.push(item);
	    }
	  }, {
	    key: 'removeCategory',
	    value: function removeCategory(categoryToRemove) {
	      this.selectedCategories.splice(this.selectedCategories.findIndex(function (category) {
	        return category.id === categoryToRemove.id;
	      }), 1);
	    }
	  }, {
	    key: 'getTagsMatching',
	    value: function getTagsMatching(searchTerm) {
	      return this.service.getTagsBySearchTerm(searchTerm).toPromise();
	    }
	  }, {
	    key: 'tagRepr',
	    value: function tagRepr(tag) {
	      return !!tag ? '' + (tag.name || '(Nada)') : '';
	    }
	  }, {
	    key: 'onTagSelected',
	    value: function onTagSelected(item, model, label, event) {
	      this.temporalTag = undefined;
	      this.selectedTags.push(item);
	    }
	  }, {
	    key: 'removeTag',
	    value: function removeTag(tagToRemove) {
	      this.selectedTags.splice(this.selectedTags.findIndex(function (tag) {
	        return tag.id === tagToRemove.id;
	      }), 1);
	    }
	  }, {
	    key: 'checkIfTableRangeFilled',
	    value: function checkIfTableRangeFilled() {
	      if (this.temporalTableFrom && this.temporalTableTo) {
	        this.tableRanges.push(this.temporalTableFrom + '-' + this.temporalTableTo);
	
	        this.temporalTableFrom = undefined;
	        this.temporalTableTo = undefined;
	      }
	    }
	  }, {
	    key: 'removeTableRange',
	    value: function removeTableRange(tableRangeToRemove) {
	      this.tableRanges.splice(this.tableRanges.findIndex(function (tableRange) {
	        return tableRange === tableRangeToRemove;
	      }), 1);
	    }
	  }, {
	    key: 'getSoldTotal',
	    value: function getSoldTotal(saleDetail) {
	      return saleDetail.sold_total;
	    }
	  }, {
	    key: 'getSoldDiscount',
	    value: function getSoldDiscount(saleDetail) {
	      return saleDetail.sold_discount;
	    }
	  }, {
	    key: 'getSoldBillDiscount',
	    value: function getSoldBillDiscount(saleDetail) {
	      return saleDetail.sold_billdiscount;
	    }
	  }, {
	    key: 'getTotalDiscount',
	    value: function getTotalDiscount(saleDetail) {
	      return saleDetail.total_discount;
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      this.temporalTableFrom = undefined;
	      this.temporalTableTo = undefined;
	      this.tableRanges = [];
	
	      this.temporalCashier = undefined;
	      this.selectedCashiers = [];
	
	      this.temporalCategory = undefined;
	      this.selectedCategories = [];
	
	      this.temporalTag = undefined;
	      this.selectedTags = [];
	
	      this.rows = [];
	
	      this.dateFrom = undefined;
	      this.dateTo = undefined;
	
	      this.orderedBy = undefined;
	    }
	  }, {
	    key: 'generateReport',
	    value: function generateReport() {
	      var _this = this;
	
	      this.subscriptions.push(this.service.getSalesDetails(this.dateFrom.format(), this.dateTo.format(), this.tableRanges, this.selectedCashiers.map(function (cashier) {
	        return cashier.id;
	      }), this.selectedCategories.map(function (category) {
	        return category.id;
	      }), this.selectedTags.map(function (tag) {
	        return tag.id;
	      })).subscribe(function (results) {
	        return _this.rows = results;
	      }));
	    }
	  }, {
	    key: 'getExportRows',
	    value: function getExportRows() {
	      var _this2 = this;
	
	      console.log(this.rows);
	
	      return this.rows.map(function (row) {
	        var newRow = angular.copy(row, {});
	        if (newRow.date) {
	          newRow.date = _this2.moment(newRow.date).format('DD/MM/YYYY');
	        }
	        return newRow;
	      });
	    }
	  }]);
	  return SalesDetailsReportController;
	}();
	
	exports.default = SalesDetailsReportController;
	
	
	SalesDetailsReportController.$inject = ['ContentService', 'isMobile', '$translate', 'moment'];

/***/ }),
/* 1309 */,
/* 1310 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1328);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-details-report.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sales-details-report.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".submitrow{margin-top:2em}.invisible{visibility:hidden}.tag{display:inline-block;color:#222;background-color:#fafafa;border:1px solid #95a5a6;padding:2px 8px;margin:1px 2px;border-radius:7px;white-space:nowrap;cursor:default}", ""]);
	
	// exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _auth = __webpack_require__(496);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _passwordRecovery = __webpack_require__(1116);
	
	var _passwordRecovery2 = _interopRequireDefault(_passwordRecovery);
	
	var _accountInformation = __webpack_require__(1123);
	
	var _accountInformation2 = _interopRequireDefault(_accountInformation);
	
	var _login = __webpack_require__(951);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _content = __webpack_require__(1095);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _register = __webpack_require__(1330);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _poller = __webpack_require__(1331);
	
	var _poller2 = _interopRequireDefault(_poller);
	
	var _dashboard = __webpack_require__(1332);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _permissions = __webpack_require__(1333);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _profilePermissions = __webpack_require__(1196);
	
	var _profilePermissions2 = _interopRequireDefault(_profilePermissions);
	
	var _admin = __webpack_require__(1334);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _master = __webpack_require__(1335);
	
	var _master2 = _interopRequireDefault(_master);
	
	var _exceptions = __webpack_require__(1336);
	
	var _exceptions2 = _interopRequireDefault(_exceptions);
	
	var _fiscalPrinter = __webpack_require__(1337);
	
	var _fiscalPrinter2 = _interopRequireDefault(_fiscalPrinter);
	
	var _countries = __webpack_require__(1338);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _timezones = __webpack_require__(1339);
	
	var _timezones2 = _interopRequireDefault(_timezones);
	
	var _subscribe = __webpack_require__(1340);
	
	var _subscribe2 = _interopRequireDefault(_subscribe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serviceModule = _angular2.default.module('app.serviceModule', []).service('$poller', _poller2.default).service('AuthService', _auth2.default).service('PasswordRecoveryService', _passwordRecovery2.default).service('AccountInformationService', _accountInformation2.default).service('LoginService', _login2.default).service('ContentService', _content2.default).service('RegisterService', _register2.default).service('DashboardService', _dashboard2.default).service('PermissionsService', _permissions2.default).service('ProfilePermissionsService', _profilePermissions2.default).service('AdminService', _admin2.default).service('ExceptionsService', _exceptions2.default).service('MasterService', _master2.default).service('FiscalPrinterService', _fiscalPrinter2.default).service('CountriesService', _countries2.default).service('TimezonesService', _timezones2.default).service('SubscriptionService', _subscribe2.default).name;
	
	exports.default = serviceModule;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(497);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegisterService = function () {
	  function RegisterService($http, host) {
	    (0, _classCallCheck3.default)(this, RegisterService);
	
	    this.http = $http;
	    this.host = host;
	  }
	
	  (0, _createClass3.default)(RegisterService, [{
	    key: 'isEmailAvailability',
	    value: function isEmailAvailability(email) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/users/check-email',
	        params: { email: email }
	      }).then(function (resp) {
	        return !resp.data.exists;
	      }, function (resp) {
	        return false;
	      }));
	    }
	  }, {
	    key: 'register',
	    value: function register(name, email, password) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/users',
	        data: { name: name, email: email, password: password }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp.data;
	      }));
	    }
	  }, {
	    key: 'registerAccount',
	    value: function registerAccount(name, country, identification, address, phone) {
	      return _Rx2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/accounts',
	        data: {
	          company: name,
	          country: country,
	          identification: identification,
	          address: address,
	          phone: phone
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return undefined;
	      }));
	    }
	  }]);
	  return RegisterService;
	}();
	
	exports.default = RegisterService;
	
	
	RegisterService.$inject = ['$http', 'host'];

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(497);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PollerService = function () {
	    function PollerService($http, $timeout) {
	        (0, _classCallCheck3.default)(this, PollerService);
	
	        this.$http = $http;
	        this.$timeout = $timeout;
	        this._timeouts = {};
	    }
	
	    (0, _createClass3.default)(PollerService, [{
	        key: 'poll',
	        value: function poll(api, params, headers) {
	            return this.$http({
	                method: 'GET',
	                url: api,
	                params: params
	            }, headers).then(function (response) {
	                return response.data;
	            }, function (response) {
	                return {};
	            });
	        }
	    }, {
	        key: 'startPolling',
	        value: function startPolling(api) {
	            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var _this = this;
	
	            var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	            var tick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10000;
	
	            /**
	             * Beware, this long-polling service exclusively makes GET requests.
	             */
	            this._timeouts[api] = {};
	            return _Rx2.default.Observable.create(function (observer) {
	                var callback = function callback(data) {
	                    observer.next(data);
	                };
	                var startAgain = function startAgain() {
	                    if (!_this._timeouts.hasOwnProperty(api)) {
	                        return;
	                    }
	                    _this._timeouts[api] = _this.$timeout(function () {
	                        _this.poll(api, params, headers).then(callback)['finally'](startAgain);
	                    }, tick);
	                };
	                _this.poll(api, params, headers).then(callback)['finally'](startAgain);
	            });
	        }
	    }, {
	        key: 'stopPolling',
	        value: function stopPolling(api) {
	            if (this._timeouts.hasOwnProperty(api)) {
	                this.$timeout.cancel(this._timeouts[api]);
	                delete this._timeouts[api];
	            }
	        }
	    }]);
	    return PollerService;
	}();
	
	exports.default = PollerService;
	
	
	PollerService.$inject = ['$http', '$timeout'];

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(497);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardService = function () {
	    function DashboardService(host, $poller, $http) {
	        (0, _classCallCheck3.default)(this, DashboardService);
	
	        this.host = host;
	        this.$poller = $poller;
	        this.$http = $http;
	    }
	
	    (0, _createClass3.default)(DashboardService, [{
	        key: 'getCashierList',
	        value: function getCashierList(date) {
	            return _Rx2.default.Observable.fromPromise(this.$http({
	                method: 'GET',
	                url: this.host + '/api/accounts/cashiers',
	                params: { date: date }
	            }).then(function (resp) {
	                return resp.data.cashiers;
	            }, function (resp) {
	                return [];
	            }));
	        }
	    }, {
	        key: 'getRecentOrders',
	        value: function getRecentOrders(date) {
	            var cashier_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	            var table_code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	            var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	
	            this.$poller.stopPolling(this.host + '/api/accounts/orders/recents');
	            return this.$poller.startPolling(this.host + '/api/accounts/orders/recents', {
	                date: date,
	                cashier_id: cashier_id,
	                table_code: table_code,
	                limit: limit
	            });
	        }
	    }, {
	        key: 'getRecentSales',
	        value: function getRecentSales(salesDate, offset) {
	            this.$poller.stopPolling(this.host + '/api/accounts/cashier-sales/recents');
	            return this.$poller.startPolling(this.host + '/api/accounts/cashier-sales/recents', {
	                date: salesDate,
	                offset: offset
	            });
	        }
	    }, {
	        key: 'stopAllPolling',
	        value: function stopAllPolling() {
	            this.$poller.stopPolling(this.host + '/api/accounts/orders/recents');
	            this.$poller.stopPolling(this.host + '/api/accounts/cashier-sales/recents');
	        }
	    }]);
	    return DashboardService;
	}();
	
	exports.default = DashboardService;
	
	
	DashboardService.$inject = ['host', '$poller', '$http'];

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _rxjs = __webpack_require__(497);
	
	var _rxjs2 = _interopRequireDefault(_rxjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PermissionsService = function () {
	    function PermissionsService($http, host) {
	        (0, _classCallCheck3.default)(this, PermissionsService);
	
	        this.http = $http;
	        this.host = host;
	    }
	
	    (0, _createClass3.default)(PermissionsService, [{
	        key: 'getPermissions',
	        value: function getPermissions() {
	            return _rxjs2.default.Observable.fromPromise(this.http({
	                method: 'GET',
	                url: this.host + '/api/permissions'
	            }).then(function (resp) {
	                return resp.data.permissions;
	            }, function (resp) {
	                return resp;
	            }));
	        }
	    }]);
	    return PermissionsService;
	}();
	
	exports.default = PermissionsService;
	
	
	PermissionsService.$inject = ['$http', 'host'];

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _rxjs = __webpack_require__(497);
	
	var _rxjs2 = _interopRequireDefault(_rxjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminService = function () {
	  function AdminService($http, host) {
	    (0, _classCallCheck3.default)(this, AdminService);
	
	    this.http = $http;
	    this.host = host;
	  }
	
	  (0, _createClass3.default)(AdminService, [{
	    key: 'retrieveAllAccounts',
	    value: function retrieveAllAccounts() {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/admin/accounts'
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'viewAccount',
	    value: function viewAccount(account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/admin/accounts/' + account.id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'toggleAccountStatus',
	    value: function toggleAccountStatus(account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'PATCH',
	        url: this.host + '/api/admin/accounts/' + account.id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {}));
	    }
	  }, {
	    key: 'getClientKeys',
	    value: function getClientKeys(account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/admin/accounts/client-ids/' + account.id
	      }).then(function (resp) {
	        return resp.data.client_ids;
	      }, function (resp) {
	        return [];
	      }));
	    }
	  }, {
	    key: 'generateClientKey',
	    value: function generateClientKey(account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/admin/accounts/client-ids/' + account.id
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'removeClientKey',
	    value: function removeClientKey(account, clientKey) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/admin/accounts/client-ids/' + account.id,
	        params: { client_id: clientKey }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getAccountProfiles',
	    value: function getAccountProfiles(account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/admin/accounts/profiles/' + account.id
	      }).then(function (resp) {
	        return resp.data.profiles;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getAccountPointsOfSale',
	    value: function getAccountPointsOfSale(account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/admin/accounts/points-of-sale',
	        params: {
	          account_id: account.id
	        }
	      }).then(function (resp) {
	        return resp.data.points_of_sales;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'registerPOS',
	    value: function registerPOS(pos, account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/admin/accounts/points-of-sale',
	        data: angular.extend(pos, { account_id: account.id })
	      }).then(function (resp) {
	        return resp.data;
	      }));
	    }
	  }, {
	    key: 'changePOS',
	    value: function changePOS(pos, account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/admin/accounts/points-of-sale/' + pos.id,
	        data: angular.extend(pos, { account_id: account.id })
	      }));
	    }
	  }, {
	    key: 'deletePOS',
	    value: function deletePOS(pos, account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/admin/accounts/points-of-sale/' + pos.id,
	        params: { account_id: account.id }
	      }));
	    }
	  }, {
	    key: 'registerCollector',
	    value: function registerCollector() {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/admin/collectors',
	        data: {}
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'associateCollector',
	    value: function associateCollector(cid, aid) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'PATCH',
	        url: this.host + '/api/admin/collectors/' + cid,
	        data: {
	          account_id: aid
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'disassociateCollector',
	    value: function disassociateCollector(cid, aid) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'PUT',
	        url: this.host + '/api/admin/collectors/' + cid,
	        data: {
	          account_id: aid
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getAllCollectors',
	    value: function getAllCollectors(aid) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/admin/collectors',
	        params: {
	          account_id: aid
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'deleteCollector',
	    value: function deleteCollector(cid) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/admin/collectors/' + cid
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'observePOS',
	    value: function observePOS(collector, pos, account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'POST',
	        url: this.host + '/api/admin/accounts/collectors/' + collector.id + '/pos',
	        data: {
	          pos_id: pos.id,
	          account_id: account.id
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'unobservePOS',
	    value: function unobservePOS(collector, pos, account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'DELETE',
	        url: this.host + '/api/admin/accounts/collectors/' + collector.id + '/pos/' + pos.id,
	        params: {
	          account_id: account.id
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getAccountBackups',
	    value: function getAccountBackups(account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/admin/accounts/backups',
	        params: {
	          account_id: account.id
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'getAccountDTTs',
	    value: function getAccountDTTs(account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'GET',
	        url: this.host + '/api/admin/accounts/dtts',
	        params: {
	          account_id: account.id
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }, {
	    key: 'processDTTs',
	    value: function processDTTs(account) {
	      return _rxjs2.default.Observable.fromPromise(this.http({
	        method: 'PATCH',
	        url: this.host + '/api/admin/accounts/dtts',
	        data: {
	          account_id: account.id
	        }
	      }).then(function (resp) {
	        return resp.data;
	      }, function (resp) {
	        return resp;
	      }));
	    }
	  }]);
	  return AdminService;
	}();
	
	exports.default = AdminService;
	
	
	AdminService.$inject = ['$http', 'host'];

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _rxjs = __webpack_require__(497);
	
	var _rxjs2 = _interopRequireDefault(_rxjs);
	
	var _auth = __webpack_require__(496);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MasterService = function () {
	    function MasterService($http, host, AuthService) {
	        (0, _classCallCheck3.default)(this, MasterService);
	
	        this.http = $http;
	        this.host = host;
	        this.auth = AuthService;
	    }
	
	    (0, _createClass3.default)(MasterService, [{
	        key: 'isMasterAccount',
	        value: function isMasterAccount() {
	            return this.auth.parseJwt(this.auth.getAccountToken()).role == "MASTER";
	        }
	    }, {
	        key: 'getAdminAccounts',
	        value: function getAdminAccounts() {
	            return _rxjs2.default.Observable.fromPromise(this.http({
	                method: 'GET',
	                url: this.host + '/api/master/accounts'
	            }).then(function (resp) {
	                return resp.data;
	            }, function (resp) {
	                return resp;
	            }));
	        }
	    }, {
	        key: 'createAdminAccount',
	        value: function createAdminAccount(data) {
	            return _rxjs2.default.Observable.fromPromise(this.http({
	                method: 'POST',
	                url: this.host + '/api/master/accounts',
	                data: data
	            }).then(function (resp) {
	                return resp.data;
	            }, function (resp) {
	                return resp;
	            }));
	        }
	    }]);
	    return MasterService;
	}();
	
	exports.default = MasterService;
	
	
	MasterService.$inject = ['$http', 'host', 'AuthService'];

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExceptionsService = function () {
	  function ExceptionsService($translate) {
	    (0, _classCallCheck3.default)(this, ExceptionsService);
	
	    this.$translate = $translate;
	  }
	
	  (0, _createClass3.default)(ExceptionsService, [{
	    key: 'getErrorMessage',
	    value: function getErrorMessage(errorCode) {
	      var _ = this.$translate.instant;
	      return {
	        'PR0001': _('Ya existe un punto de ventas con este número'),
	        'PR0002': _('Este punto de ventas ya está enlazado a este colector'),
	        'PR0003': _('Este punto de ventas no está enlazado a este colector'),
	        'PR0006': _('Este punto de venta está siendo observado por un colector.'),
	        'IA0001': _('Metodo de autenticación no permitido'),
	        'IA0002': _('La cuenta ya esta enlazada con el metodo de autenticación seleccionado'),
	        'IA0003': _('Las credenciales son incorrectas, intente nuevamente'),
	        'IA0004': _('La direccion de correo electronico no ha sido agregado'),
	        'IA0005': _('Este email ha sido registrado con otro usuario anteriormente'),
	        'IA0006': _('La cuenta ha sido enlazada con Facebook anteriormente'),
	        'IA0007': _('La cuenta ha sido enlazada con Google anteriormente'),
	        'IA0008': _('La cuenta ha sido enlazada con Twitter anteriomente'),
	        'IA0009': _('El usuario ha sido activado previamente'),
	        'IA0010': _('El usuario ha sido desactivado previamente'),
	        'IA0011': _('Una cuenta con este nombre ya existe en el sistema, utilize un nombre diferente'),
	        'IA0012': _('No tiene invitaciones pendientes'),
	        'IA0013': _('El token de recuperación es inválido'),
	        'IA0014': _('Su usuario ya posee una contraseña, puede cambiarla si gusta'),
	        'IA0015': _('El token de verificación de correo es inválido'),
	        'IA0016': _('Debe iniciar sesión para realizar esta acción'),
	        'IA0017': _('El usuario que intenta agregar ya es parte de esta cuenta'),
	        'IA0018': _('Imposible activar este usuario, ha sido activado previamente'),
	        'IA0019': _('Imposible desactivar este usuario, ha sido desactivado previamente'),
	        'IA0020': _('Imposible eliminar este usuario, ha sido eliminado previamente'),
	        'IA0021': _('Este usuario len ha sido otorgados derechos administrativos previamente'),
	        'IA0022': _('Este usuario ya no posee derechos administrativos'),
	        'IA0023': _('Toda cuenta debe de tener al menos un usuario administrador'),
	        'IA0024': _('Este usuario ya cuenta con el permiso que intenta asignarle'),
	        'IA0025': _('Este permiso no ha sido otorgado al usuario, imposible revocar'),
	        'IA0026': _('Para poder proceder debe crear una contraseña'),
	
	        'PAYMENT_PENDING': _('Existe un pago pendiente, imposible proceder.')
	      }[errorCode] || _('Un error ha ocurrido, y ha sido reportado');
	    }
	  }]);
	  return ExceptionsService;
	}();
	
	exports.default = ExceptionsService;
	
	
	ExceptionsService.$inject = ['$translate'];

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FiscalPrinterService = function FiscalPrinterService($http, host) {
	  (0, _classCallCheck3.default)(this, FiscalPrinterService);
	
	  this.http = $http;
	  this.host = host;
	};
	
	exports.default = FiscalPrinterService;
	
	
	FiscalPrinterService.$inject = ['$http', 'host'];

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CountriesService = function () {
	  function CountriesService($http, host, notify) {
	    (0, _classCallCheck3.default)(this, CountriesService);
	
	    this.$http = $http;
	    this.host = host;
	    this.notify = notify;
	  }
	
	  (0, _createClass3.default)(CountriesService, [{
	    key: 'getCountries',
	    value: function getCountries() {
	      var _this = this;
	
	      return this.$http({
	        method: 'GET',
	        url: this.host + '/api/countries'
	      }).then(function (resp) {
	        return resp.data.countries;
	      }, function (resp) {
	        _this.notify.error({
	          message: "Ha ocurrido un error en la comunicación con nuestros servidores, intente nuevamente."
	        });
	        return resp.data;
	      });
	    }
	  }]);
	  return CountriesService;
	}();
	
	exports.default = CountriesService;
	
	
	CountriesService.$inject = ['$http', 'host', 'Notification'];

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimezonesService = function () {
	  function TimezonesService($http, host, notify) {
	    (0, _classCallCheck3.default)(this, TimezonesService);
	
	    this.$http = $http;
	    this.host = host;
	    this.notify = notify;
	  }
	
	  (0, _createClass3.default)(TimezonesService, [{
	    key: 'getTimezones',
	    value: function getTimezones() {
	      var _this = this;
	
	      return this.$http({
	        method: 'GET',
	        url: this.host + '/api/timezones'
	      }).then(function (resp) {
	        return resp.data.timezones;
	      }, function (resp) {
	        _this.notify.error({
	          message: "Ha ocurrido un error en la comunicación con nuestros servidores, intente nuevamente."
	        });
	        return resp.data;
	      });
	    }
	  }]);
	  return TimezonesService;
	}();
	
	exports.default = TimezonesService;
	
	
	TimezonesService.$inject = ['$http', 'host', 'Notification'];

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(465);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(466);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _rxjs = __webpack_require__(497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscriptionService = function () {
	    function SubscriptionService($http, host) {
	        (0, _classCallCheck3.default)(this, SubscriptionService);
	
	        this.http = $http;
	        this.host = host;
	
	        this._paymentStatus$ = new _rxjs.Subject();
	        this._graceNoticeWasDisplayed = false;
	    }
	
	    (0, _createClass3.default)(SubscriptionService, [{
	        key: 'updatePaymentStatus',
	        value: function updatePaymentStatus(newStatus) {
	            this._paymentStatus$.next(newStatus);
	        }
	    }, {
	        key: 'paymentStatus',
	        value: function paymentStatus() {
	            return this._paymentStatus$;
	        }
	    }, {
	        key: 'setGraceNoticeDisplayed',
	        value: function setGraceNoticeDisplayed() {
	            this._graceNoticeWasDisplayed = true;
	        }
	    }, {
	        key: 'wasGraceNoticeDisplayed',
	        value: function wasGraceNoticeDisplayed() {
	            return this._graceNoticeWasDisplayed;
	        }
	    }, {
	        key: 'subscribeCustomerViaStripe',
	        value: function subscribeCustomerViaStripe(data) {
	            return _rxjs.Observable.fromPromise(this.http({
	                method: 'POST',
	                url: this.host + '/api/accounts/subscription',
	                data: data
	            }).then(function (resp) {
	                return resp.data;
	            }));
	        }
	        // unsubscribe() {
	        //     return Observable.fromPromise(this.http({
	        //         method: 'DELETE', url: `${this.host}/api/accounts/subscription`
	        //      }));
	        // }
	
	    }, {
	        key: 'addPaymentMethod',
	        value: function addPaymentMethod(data) {
	            return _rxjs.Observable.fromPromise(this.http({
	                method: 'POST',
	                url: this.host + '/api/accounts/payment-methods',
	                data: data
	            }).then(function (resp) {
	                return resp.data;
	            }));
	        }
	    }, {
	        key: 'deletePaymentMethod',
	        value: function deletePaymentMethod(token) {
	            return _rxjs.Observable.fromPromise(this.http({
	                method: 'DELETE',
	                url: this.host + '/api/accounts/payment-methods/' + token
	            }));
	        }
	    }, {
	        key: 'setDefaultPaymentMethod',
	        value: function setDefaultPaymentMethod(token) {
	            return _rxjs.Observable.fromPromise(this.http({
	                method: 'PATCH',
	                url: this.host + '/api/accounts/payment-methods/' + token
	            }));
	        }
	    }, {
	        key: 'getCustomerCards',
	        value: function getCustomerCards() {
	            return _rxjs.Observable.fromPromise(this.http({
	                method: 'GET',
	                url: this.host + '/api/accounts/payment-methods'
	            }).then(function (resp) {
	                return resp.data;
	            }).catch(function (resp) {
	                return resp;
	            }));
	        }
	    }]);
	    return SubscriptionService;
	}();
	
	exports.default = SubscriptionService;
	
	
	SubscriptionService.$inject = ['$http', 'host'];

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _autofillSyncDirective = __webpack_require__(1342);
	
	var _ifPerm = __webpack_require__(1343);
	
	var _clickMeOnEnter = __webpack_require__(1344);
	
	var _tapOutside = __webpack_require__(1345);
	
	var _tapOutside2 = _interopRequireDefault(_tapOutside);
	
	var _stripeElement = __webpack_require__(1346);
	
	var _adjust = __webpack_require__(1347);
	
	var _adjust2 = _interopRequireDefault(_adjust);
	
	var _sortBy = __webpack_require__(1348);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var directiveModule = _angular2.default.module('app.directiveModule', [])
	// .directive('autoFillSync', AutoFillSync)
	.directive('ifPerm', _ifPerm.IfPerm).directive('clickMeOnEnter', _clickMeOnEnter.ClickMeOnEnter).directive('tapOutside', _tapOutside2.default).directive('stripeElement', _stripeElement.StripeElementDirective).directive('adjust', _adjust2.default).directive('sort', _sortBy2.default).name;
	
	exports.default = directiveModule;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AutofillSync = undefined;
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Directive to synchronize fields that are pre filled by browser,
	
	Credits to
	https://stackoverflow.com/questions/14965968/angularjs-browser-autofill-workaround-by-using-a-directive
	*/
	var AutofillSync = exports.AutofillSync = ["$timeout", function AutofillSync($timeout) {
	    'ngInject';
	
	    return {
	        require: 'ngModel',
	        restrict: 'A',
	        link: function link($scope, elem, attrs, ngModel) {
	            var origVal = elem.val();
	            var newVal;
	            $timeout(function () {
	                newVal = elem.val();
	                if ( /*ngModel.$pristine &&*/origVal !== newVal) {
	                    ngModel.$setViewValue(newVal);
	                }
	            }, 500);
	
	            elem.on('$destroy', function () {
	                origVal = null;
	                newVal = null;
	            });
	        }
	    };
	}];

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IfPerm = undefined;
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IfPerm = exports.IfPerm = ["ProfilePermissionsService", function IfPerm(ProfilePermissionsService) {
	  'ngInject';
	
	  var $permissions = ProfilePermissionsService;
	  return {
	    restrict: 'A',
	    link: function link($scope, $element, $attrs) {
	      var showPermList, hidePermList, disablePermList;
	
	      function meet(perms) {
	        return $permissions.isAdmin() || $permissions.hasAtLeastOneOf(perms);
	      }
	
	      if (_angular2.default.isDefined($attrs.showIf)) {
	        showPermList = $attrs.showIf.split(',').map(function (i) {
	          return i.trim();
	        }).filter(function (i) {
	          return !!i;
	        });
	        if (!meet(showPermList)) {
	          $element.addClass('hidden');
	        }
	      } else if (_angular2.default.isDefined($attrs.hideIf)) {
	        hidePermList = $attrs.hideIf.split(',').map(function (i) {
	          return i.trim();
	        }).filter(function (i) {
	          return !!i;
	        });
	        if (meet(hidePermList)) {
	          $element.addClass('hidden');
	        }
	      } else if (_angular2.default.isDefined($attrs.disableIf)) {
	        disablePermList = $attrs.disableIf.split(',').map(function (i) {
	          return i.trim();
	        }).filter(function (i) {
	          return !!i;
	        });
	        if (!meet(disablePermList)) {
	          $element.attr('disabled', 'disabled');
	          $element.addClass('disabled');
	        }
	      }
	
	      $element.on('$destroy', function () {
	        showPermList = null;
	        hidePermList = null;
	        disablePermList = null;
	      });
	    }
	  };
	}];

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClickMeOnEnter = undefined;
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClickMeOnEnter = exports.ClickMeOnEnter = ["$timeout", "$window", function ClickMeOnEnter($timeout, $window) {
	  "ngInject";
	
	  return {
	    restrict: 'A',
	    link: function link($scope, $element, $attrs) {
	      _angular2.default.element($window).on('keypress', function (evt) {
	        if (evt.which === 13) {
	          evt.preventDefault();
	          $element[0].click();
	        }
	        return false;
	      });
	      $element.on('$destroy', function () {});
	    }
	  };
	}];

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	TapOutside.$inject = ["$document", "isMobile"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = TapOutside;
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TapOutside($document, isMobile) {
	    "ngInject";
	
	    return {
	        restrict: 'A',
	        scope: {
	            tapOutside: '&'
	        },
	        link: function link(scope, el, attr) {
	            $document.on('click', function (e) {
	                if (el !== e.target && !el[0].contains(e.target) && !e.target.hasAttribute('menu-trigger') && !el[0].classList.contains(attr.hiddenClass) && isMobile) {
	                    scope.$apply(function () {
	                        scope.$eval(scope.tapOutside);
	                    });
	                };
	            });
	        }
	    };
	}

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StripeElementDirective = undefined;
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StripeElementDirective = exports.StripeElementDirective = ["$window", "$parse", function StripeElementDirective($window, $parse) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        scope: {
	            tokenHandler: '&',
	            complete: '=',
	            style: '<'
	        },
	        link: function link($scope, $element, attrs) {
	            var stripe = $window.stripe;
	            var elements = stripe.elements();
	            var style = $scope.style || {
	                base: {
	                    color: '#32325d',
	                    lineHeight: '24px',
	                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
	                    fontSmoothing: 'antialiased',
	                    fontSize: '16px',
	                    '::placeholder': {
	                        color: '#000000'
	                    }
	                },
	                invalid: {
	                    color: '#fa755a',
	                    iconColor: '#fa755a'
	                }
	            };
	            var card = elements.create('card', { style: style });
	            card.mount($element[0]);
	            card.addEventListener('change', function (event) {
	                var displayError = document.getElementById(attrs.errorElement);
	                if (event.error) {
	                    displayError.textContent = event.error.message;
	                } else {
	                    displayError.textContent = '';
	                }
	                if (event.complete) {
	                    $scope.$apply(function () {
	                        $scope.complete = event.complete;
	                    });
	                }
	            });
	
	            var form = document.getElementById(attrs.parentForm);
	            form.addEventListener('submit', function (event) {
	                event.preventDefault();
	                stripe.createToken(card).then(function (result) {
	                    if (result.error) {
	                        var errorElement = document.getElementById(attrs.errorElement);
	                        errorElement.textContent = result.error.message;
	                    } else {
	                        $scope.$apply(function () {
	                            $parse(tokenHandler)(scope);
	                        });
	                    }
	                });
	            });
	        }
	    };
	}];

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AdjustDirective;
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* 
	    The purpose of this directive is to adjust floating points without such
	    wondrous behaviour like 0.2 + 0.1 = 0.3000000000000000003 and other misc
	    IEEE 754 shenanigans that in no way are making me bald younger.
	*/
	
	function AdjustDirective() {
	    "ngInject";
	
	    return {
	        scope: {
	            model: "=",
	            property: "=",
	            min: "="
	        },
	        link: function link(scope, el, attr, $ctrl) {
	            el.on('click', function () {
	                var value = scope.model[scope.property] || 0;
	                if (_angular2.default.isDefined(attr.increase)) {
	                    value += parseFloat(attr.step);
	                } else if (_angular2.default.isDefined(attr.decrease)) {
	                    value -= parseFloat(attr.step);
	                }
	                var rounded = parseFloat(value.toPrecision(3));
	                scope.$apply(function () {
	                    scope.model[scope.property] = _angular2.default.isDefined(scope.min) && rounded < scope.min ? scope.min : rounded;
	                });
	            });
	        }
	    };
	}

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	sortBy.$inject = ["$compile", "$parse"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = sortBy;
	
	var _angular = __webpack_require__(369);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortBy($compile, $parse) {
	    "ngInject";
	
	    return {
	        restrict: 'ACEM',
	        scope: {
	            sort: '='
	        },
	        link: function link($scope, el, attr) {
	            var title = el.text();
	            el.text('');
	            var elem = _angular2.default.element('<div class="th-inner sortable" ng-class="{\'asc\': sort === \'' + attr.sortBy + '\', \'desc\': sort === \'-' + attr.sortBy + '\'}">' + title + '</div>');
	            var tooltip = $compile(elem)($scope);
	            el.append(tooltip);
	            el.addClass('clickable');
	            el.on('click', function ($event) {
	                if ($scope.sort === attr.sortBy) {
	                    $scope.$apply(function () {
	                        $scope.sort = '-' + attr.sortBy;
	                    });
	                } else {
	                    $scope.$apply(function () {
	                        $scope.sort = attr.sortBy;
	                    });
	                }
	            });
	        }
	    };
	}

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(1350);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  bindings: {},
	  template: _app2.default
	};
	
	exports.default = appComponent;

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	module.exports = "<ui-view name=\"menu\"></ui-view>\n<ui-view name=\"content\"></ui-view>\n"

/***/ }),
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1362,
		"./af.js": 1362,
		"./ar": 1363,
		"./ar-dz": 1364,
		"./ar-dz.js": 1364,
		"./ar-kw": 1365,
		"./ar-kw.js": 1365,
		"./ar-ly": 1366,
		"./ar-ly.js": 1366,
		"./ar-ma": 1367,
		"./ar-ma.js": 1367,
		"./ar-sa": 1368,
		"./ar-sa.js": 1368,
		"./ar-tn": 1369,
		"./ar-tn.js": 1369,
		"./ar.js": 1363,
		"./az": 1370,
		"./az.js": 1370,
		"./be": 1371,
		"./be.js": 1371,
		"./bg": 1372,
		"./bg.js": 1372,
		"./bm": 1373,
		"./bm.js": 1373,
		"./bn": 1374,
		"./bn.js": 1374,
		"./bo": 1375,
		"./bo.js": 1375,
		"./br": 1376,
		"./br.js": 1376,
		"./bs": 1377,
		"./bs.js": 1377,
		"./ca": 1378,
		"./ca.js": 1378,
		"./cs": 1379,
		"./cs.js": 1379,
		"./cv": 1380,
		"./cv.js": 1380,
		"./cy": 1381,
		"./cy.js": 1381,
		"./da": 1382,
		"./da.js": 1382,
		"./de": 1383,
		"./de-at": 1384,
		"./de-at.js": 1384,
		"./de-ch": 1385,
		"./de-ch.js": 1385,
		"./de.js": 1383,
		"./dv": 1386,
		"./dv.js": 1386,
		"./el": 1387,
		"./el.js": 1387,
		"./en-SG": 1388,
		"./en-SG.js": 1388,
		"./en-au": 1389,
		"./en-au.js": 1389,
		"./en-ca": 1390,
		"./en-ca.js": 1390,
		"./en-gb": 1391,
		"./en-gb.js": 1391,
		"./en-ie": 1392,
		"./en-ie.js": 1392,
		"./en-il": 1393,
		"./en-il.js": 1393,
		"./en-nz": 1394,
		"./en-nz.js": 1394,
		"./eo": 1395,
		"./eo.js": 1395,
		"./es": 1396,
		"./es-do": 1397,
		"./es-do.js": 1397,
		"./es-us": 1398,
		"./es-us.js": 1398,
		"./es.js": 1396,
		"./et": 1399,
		"./et.js": 1399,
		"./eu": 1400,
		"./eu.js": 1400,
		"./fa": 1401,
		"./fa.js": 1401,
		"./fi": 1402,
		"./fi.js": 1402,
		"./fo": 1403,
		"./fo.js": 1403,
		"./fr": 1404,
		"./fr-ca": 1405,
		"./fr-ca.js": 1405,
		"./fr-ch": 1406,
		"./fr-ch.js": 1406,
		"./fr.js": 1404,
		"./fy": 1407,
		"./fy.js": 1407,
		"./ga": 1408,
		"./ga.js": 1408,
		"./gd": 1409,
		"./gd.js": 1409,
		"./gl": 1410,
		"./gl.js": 1410,
		"./gom-latn": 1411,
		"./gom-latn.js": 1411,
		"./gu": 1412,
		"./gu.js": 1412,
		"./he": 1413,
		"./he.js": 1413,
		"./hi": 1414,
		"./hi.js": 1414,
		"./hr": 1415,
		"./hr.js": 1415,
		"./hu": 1416,
		"./hu.js": 1416,
		"./hy-am": 1417,
		"./hy-am.js": 1417,
		"./id": 1418,
		"./id.js": 1418,
		"./is": 1419,
		"./is.js": 1419,
		"./it": 1420,
		"./it-ch": 1421,
		"./it-ch.js": 1421,
		"./it.js": 1420,
		"./ja": 1422,
		"./ja.js": 1422,
		"./jv": 1423,
		"./jv.js": 1423,
		"./ka": 1424,
		"./ka.js": 1424,
		"./kk": 1425,
		"./kk.js": 1425,
		"./km": 1426,
		"./km.js": 1426,
		"./kn": 1427,
		"./kn.js": 1427,
		"./ko": 1428,
		"./ko.js": 1428,
		"./ku": 1429,
		"./ku.js": 1429,
		"./ky": 1430,
		"./ky.js": 1430,
		"./lb": 1431,
		"./lb.js": 1431,
		"./lo": 1432,
		"./lo.js": 1432,
		"./lt": 1433,
		"./lt.js": 1433,
		"./lv": 1434,
		"./lv.js": 1434,
		"./me": 1435,
		"./me.js": 1435,
		"./mi": 1436,
		"./mi.js": 1436,
		"./mk": 1437,
		"./mk.js": 1437,
		"./ml": 1438,
		"./ml.js": 1438,
		"./mn": 1439,
		"./mn.js": 1439,
		"./mr": 1440,
		"./mr.js": 1440,
		"./ms": 1441,
		"./ms-my": 1442,
		"./ms-my.js": 1442,
		"./ms.js": 1441,
		"./mt": 1443,
		"./mt.js": 1443,
		"./my": 1444,
		"./my.js": 1444,
		"./nb": 1445,
		"./nb.js": 1445,
		"./ne": 1446,
		"./ne.js": 1446,
		"./nl": 1447,
		"./nl-be": 1448,
		"./nl-be.js": 1448,
		"./nl.js": 1447,
		"./nn": 1449,
		"./nn.js": 1449,
		"./pa-in": 1450,
		"./pa-in.js": 1450,
		"./pl": 1451,
		"./pl.js": 1451,
		"./pt": 1452,
		"./pt-br": 1453,
		"./pt-br.js": 1453,
		"./pt.js": 1452,
		"./ro": 1454,
		"./ro.js": 1454,
		"./ru": 1455,
		"./ru.js": 1455,
		"./sd": 1456,
		"./sd.js": 1456,
		"./se": 1457,
		"./se.js": 1457,
		"./si": 1458,
		"./si.js": 1458,
		"./sk": 1459,
		"./sk.js": 1459,
		"./sl": 1460,
		"./sl.js": 1460,
		"./sq": 1461,
		"./sq.js": 1461,
		"./sr": 1462,
		"./sr-cyrl": 1463,
		"./sr-cyrl.js": 1463,
		"./sr.js": 1462,
		"./ss": 1464,
		"./ss.js": 1464,
		"./sv": 1465,
		"./sv.js": 1465,
		"./sw": 1466,
		"./sw.js": 1466,
		"./ta": 1467,
		"./ta.js": 1467,
		"./te": 1468,
		"./te.js": 1468,
		"./tet": 1469,
		"./tet.js": 1469,
		"./tg": 1470,
		"./tg.js": 1470,
		"./th": 1471,
		"./th.js": 1471,
		"./tl-ph": 1472,
		"./tl-ph.js": 1472,
		"./tlh": 1473,
		"./tlh.js": 1473,
		"./tr": 1474,
		"./tr.js": 1474,
		"./tzl": 1475,
		"./tzl.js": 1475,
		"./tzm": 1476,
		"./tzm-latn": 1477,
		"./tzm-latn.js": 1477,
		"./tzm.js": 1476,
		"./ug-cn": 1478,
		"./ug-cn.js": 1478,
		"./uk": 1479,
		"./uk.js": 1479,
		"./ur": 1480,
		"./ur.js": 1480,
		"./uz": 1481,
		"./uz-latn": 1482,
		"./uz-latn.js": 1482,
		"./uz.js": 1481,
		"./vi": 1483,
		"./vi.js": 1483,
		"./x-pseudo": 1484,
		"./x-pseudo.js": 1484,
		"./yo": 1485,
		"./yo.js": 1485,
		"./zh-cn": 1486,
		"./zh-cn.js": 1486,
		"./zh-hk": 1487,
		"./zh-hk.js": 1487,
		"./zh-tw": 1488,
		"./zh-tw.js": 1488
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1361;


/***/ }),
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1587);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./table.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./table.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".card{border-radius:6px;box-shadow:0 -4px 10px hsla(0,0%,87%,.5),0 6px 10px hsla(0,0%,87%,.5);background-color:#fff;color:#252422;margin-bottom:20px;padding:15px 15px 10px;position:relative}.bs-checkbox{width:36px}.fixed-table-toolbar .bars,.fixed-table-toolbar .columns,.fixed-table-toolbar .search{position:relative;margin-top:10px;margin-bottom:10px;line-height:34px}.fixed-table-container{margin:40px 0 0}.fixed-table-article,.fixed-table-container{position:relative;clear:both;overflow-x:auto;padding:12px 0 0}.fixed-table-article{margin:12px 0 0}.bootstrap-table .table{margin-bottom:0!important;border-bottom:1px solid #cfcfca;border-collapse:collapse!important;border-radius:1px}.bootstrap-table .fixed-table-pagination .pagination-detail,.bootstrap-table .fixed-table-pagination div.pagination{margin-top:15px;margin-bottom:15px}.fixed-table-pagination .page-list{display:inline-block}.bootstrap-table .fixed-table-pagination .page-list .btn-group{margin-right:5px}.fixed-table-pagination .btn-group{position:relative;display:inline-block;vertical-align:middle}.fixed-table-pagination div.pagination .pagination,.pagination{margin:0}.pagination>li{display:inline}.table-icons{display:inline-block;min-width:110px}.btn.btn-icon,.navbar .navbar-nav>li>a.btn.btn-icon{border-radius:4px;padding:2px 10px}.btn-simple{border:0;padding:7px 18px}.t_verdor{margin-bottom:40px}.table{margin:0}thead{background:#eee}thead th{border-right:1px solid #ddd}thead th:last-child{border:none}tbody td{border-right:1px solid #ddd}tbody td:last-child{border:none}tfoot{background:#eee}tfoot th{border-right:1px solid #ddd}tfoot th:last-child{border:none}.article_w{width:70px}.quanty_f{width:80px}.total_f{width:91px}.multi_delete{position:fixed;right:49px;z-index:10;top:20.5%}.multi_delete a{padding:5px 20px}.columns-right{margin:0 15px}.sortable{position:relative;cursor:pointer}.sortable:after{font-family:FontAwesome;content:\"\\F0DC\";position:absolute;right:0;color:#999}.sortable.asc:after{content:\"\\F0D8\"}.sortable.desc:after{content:\"\\F0D7\"}.sortable:hover:after{color:#333}", ""]);
	
	// exports


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1589);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./animate.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./animate.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * animate.css -http://daneden.me/animate\n * Version - 3.5.2\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\n *\n * Copyright (c) 2017 Daniel Eden\n */.animated{animation-duration:1s;animation-fill-mode:both}.animated.infinite{animation-iteration-count:infinite}.animated.hinge{animation-duration:2s}.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY{animation-duration:.75s}@keyframes bounce{0%,20%,53%,80%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1);transform:translateZ(0)}40%,43%{animation-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-30px,0)}70%{animation-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-15px,0)}90%{transform:translate3d(0,-4px,0)}}.bounce{animation-name:bounce;transform-origin:center bottom}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{animation-name:flash}@keyframes pulse{0%{transform:scaleX(1)}50%{transform:scale3d(1.05,1.05,1.05)}to{transform:scaleX(1)}}.pulse{animation-name:pulse}@keyframes rubberBand{0%{transform:scaleX(1)}30%{transform:scale3d(1.25,.75,1)}40%{transform:scale3d(.75,1.25,1)}50%{transform:scale3d(1.15,.85,1)}65%{transform:scale3d(.95,1.05,1)}75%{transform:scale3d(1.05,.95,1)}to{transform:scaleX(1)}}.rubberBand{animation-name:rubberBand}@keyframes shake{0%,to{transform:translateZ(0)}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0)}20%,40%,60%,80%{transform:translate3d(10px,0,0)}}.shake{animation-name:shake}@keyframes headShake{0%{transform:translateX(0)}6.5%{transform:translateX(-6px) rotateY(-9deg)}18.5%{transform:translateX(5px) rotateY(7deg)}31.5%{transform:translateX(-3px) rotateY(-5deg)}43.5%{transform:translateX(2px) rotateY(3deg)}50%{transform:translateX(0)}}.headShake{animation-timing-function:ease-in-out;animation-name:headShake}@keyframes swing{20%{transform:rotate(15deg)}40%{transform:rotate(-10deg)}60%{transform:rotate(5deg)}80%{transform:rotate(-5deg)}to{transform:rotate(0deg)}}.swing{transform-origin:top center;animation-name:swing}@keyframes tada{0%{transform:scaleX(1)}10%,20%{transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{transform:scaleX(1)}}.tada{animation-name:tada}@keyframes wobble{0%{transform:none}15%{transform:translate3d(-25%,0,0) rotate(-5deg)}30%{transform:translate3d(20%,0,0) rotate(3deg)}45%{transform:translate3d(-15%,0,0) rotate(-3deg)}60%{transform:translate3d(10%,0,0) rotate(2deg)}75%{transform:translate3d(-5%,0,0) rotate(-1deg)}to{transform:none}}.wobble{animation-name:wobble}@keyframes jello{0%,11.1%,to{transform:none}22.2%{transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{transform:skewX(6.25deg) skewY(6.25deg)}44.4%{transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{transform:skewX(.390625deg) skewY(.390625deg)}88.8%{transform:skewX(-.1953125deg) skewY(-.1953125deg)}}.jello{animation-name:jello;transform-origin:center}@keyframes bounceIn{0%,20%,40%,60%,80%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:scale3d(.3,.3,.3)}20%{transform:scale3d(1.1,1.1,1.1)}40%{transform:scale3d(.9,.9,.9)}60%{opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{transform:scale3d(.97,.97,.97)}to{opacity:1;transform:scaleX(1)}}.bounceIn{animation-name:bounceIn}@keyframes bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}.bounceInDown{animation-name:bounceInDown}@keyframes bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}.bounceInLeft{animation-name:bounceInLeft}@keyframes bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}.bounceInRight{animation-name:bounceInRight}@keyframes bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}.bounceInUp{animation-name:bounceInUp}@keyframes bounceOut{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}to{opacity:0;transform:scale3d(.3,.3,.3)}}.bounceOut{animation-name:bounceOut}@keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.bounceOutDown{animation-name:bounceOutDown}@keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}.bounceOutLeft{animation-name:bounceOutLeft}@keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}.bounceOutRight{animation-name:bounceOutRight}@keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}.bounceOutUp{animation-name:bounceOutUp}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-100%,0)}to{opacity:1;transform:none}}.fadeInDown{animation-name:fadeInDown}@keyframes fadeInDownBig{0%{opacity:0;transform:translate3d(0,-2000px,0)}to{opacity:1;transform:none}}.fadeInDownBig{animation-name:fadeInDownBig}@keyframes fadeInLeft{0%{opacity:0;transform:translate3d(-100%,0,0)}to{opacity:1;transform:none}}.fadeInLeft{animation-name:fadeInLeft}@keyframes fadeInLeftBig{0%{opacity:0;transform:translate3d(-2000px,0,0)}to{opacity:1;transform:none}}.fadeInLeftBig{animation-name:fadeInLeftBig}@keyframes fadeInRight{0%{opacity:0;transform:translate3d(100%,0,0)}to{opacity:1;transform:none}}.fadeInRight{animation-name:fadeInRight}@keyframes fadeInRightBig{0%{opacity:0;transform:translate3d(2000px,0,0)}to{opacity:1;transform:none}}.fadeInRightBig{animation-name:fadeInRightBig}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,100%,0)}to{opacity:1;transform:none}}.fadeInUp{animation-name:fadeInUp}@keyframes fadeInUpBig{0%{opacity:0;transform:translate3d(0,2000px,0)}to{opacity:1;transform:none}}.fadeInUpBig{animation-name:fadeInUpBig}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{animation-name:fadeOutDown}@keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,2000px,0)}}.fadeOutDownBig{animation-name:fadeOutDownBig}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;transform:translate3d(-100%,0,0)}}.fadeOutLeft{animation-name:fadeOutLeft}@keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{animation-name:fadeOutLeftBig}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0)}}.fadeOutRight{animation-name:fadeOutRight}@keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;transform:translate3d(2000px,0,0)}}.fadeOutRightBig{animation-name:fadeOutRightBig}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{animation-name:fadeOutUp}@keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{animation-name:fadeOutUpBig}@keyframes flip{0%{transform:perspective(400px) rotateY(-1turn);animation-timing-function:ease-out}40%{transform:perspective(400px) translateZ(150px) rotateY(-190deg);animation-timing-function:ease-out}50%{transform:perspective(400px) translateZ(150px) rotateY(-170deg);animation-timing-function:ease-in}80%{transform:perspective(400px) scale3d(.95,.95,.95);animation-timing-function:ease-in}to{transform:perspective(400px);animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;animation-name:flip}@keyframes flipInX{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipInX}@keyframes flipInY{0%{transform:perspective(400px) rotateY(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateY(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateY(10deg);opacity:1}80%{transform:perspective(400px) rotateY(-5deg)}to{transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipInY}@keyframes flipOutX{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateX(-20deg);opacity:1}to{transform:perspective(400px) rotateX(90deg);opacity:0}}.flipOutX{animation-name:flipOutX;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@keyframes flipOutY{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateY(-15deg);opacity:1}to{transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipOutY}@keyframes lightSpeedIn{0%{transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{transform:skewX(20deg);opacity:1}80%{transform:skewX(-5deg);opacity:1}to{transform:none;opacity:1}}.lightSpeedIn{animation-name:lightSpeedIn;animation-timing-function:ease-out}@keyframes lightSpeedOut{0%{opacity:1}to{transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{animation-name:lightSpeedOut;animation-timing-function:ease-in}@keyframes rotateIn{0%{transform-origin:center;transform:rotate(-200deg);opacity:0}to{transform-origin:center;transform:none;opacity:1}}.rotateIn{animation-name:rotateIn}@keyframes rotateInDownLeft{0%{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}to{transform-origin:left bottom;transform:none;opacity:1}}.rotateInDownLeft{animation-name:rotateInDownLeft}@keyframes rotateInDownRight{0%{transform-origin:right bottom;transform:rotate(45deg);opacity:0}to{transform-origin:right bottom;transform:none;opacity:1}}.rotateInDownRight{animation-name:rotateInDownRight}@keyframes rotateInUpLeft{0%{transform-origin:left bottom;transform:rotate(45deg);opacity:0}to{transform-origin:left bottom;transform:none;opacity:1}}.rotateInUpLeft{animation-name:rotateInUpLeft}@keyframes rotateInUpRight{0%{transform-origin:right bottom;transform:rotate(-90deg);opacity:0}to{transform-origin:right bottom;transform:none;opacity:1}}.rotateInUpRight{animation-name:rotateInUpRight}@keyframes rotateOut{0%{transform-origin:center;opacity:1}to{transform-origin:center;transform:rotate(200deg);opacity:0}}.rotateOut{animation-name:rotateOut}@keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}to{transform-origin:left bottom;transform:rotate(45deg);opacity:0}}.rotateOutDownLeft{animation-name:rotateOutDownLeft}@keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}to{transform-origin:right bottom;transform:rotate(-45deg);opacity:0}}.rotateOutDownRight{animation-name:rotateOutDownRight}@keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}to{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}}.rotateOutUpLeft{animation-name:rotateOutUpLeft}@keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}to{transform-origin:right bottom;transform:rotate(90deg);opacity:0}}.rotateOutUpRight{animation-name:rotateOutUpRight}@keyframes hinge{0%{transform-origin:top left;animation-timing-function:ease-in-out}20%,60%{transform:rotate(80deg);transform-origin:top left;animation-timing-function:ease-in-out}40%,80%{transform:rotate(60deg);transform-origin:top left;animation-timing-function:ease-in-out;opacity:1}to{transform:translate3d(0,700px,0);opacity:0}}.hinge{animation-name:hinge}@keyframes jackInTheBox{0%{opacity:0;transform:scale(.1) rotate(30deg);transform-origin:center bottom}50%{transform:rotate(-10deg)}70%{transform:rotate(3deg)}to{opacity:1;transform:scale(1)}}.jackInTheBox{animation-name:jackInTheBox}@keyframes rollIn{0%{opacity:0;transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;transform:none}}.rollIn{animation-name:rollIn}@keyframes rollOut{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{animation-name:rollOut}@keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{animation-name:zoomIn}@keyframes zoomInDown{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{animation-name:zoomInDown}@keyframes zoomInLeft{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{animation-name:zoomInLeft}@keyframes zoomInRight{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{animation-name:zoomInRight}@keyframes zoomInUp{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{animation-name:zoomInUp}@keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.zoomOut{animation-name:zoomOut}@keyframes zoomOutDown{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{animation-name:zoomOutDown}@keyframes zoomOutLeft{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center}}.zoomOutLeft{animation-name:zoomOutLeft}@keyframes zoomOutRight{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center}}.zoomOutRight{animation-name:zoomOutRight}@keyframes zoomOutUp{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{animation-name:zoomOutUp}@keyframes slideInDown{0%{transform:translate3d(0,-100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInDown{animation-name:slideInDown}@keyframes slideInLeft{0%{transform:translate3d(-100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInLeft{animation-name:slideInLeft}@keyframes slideInRight{0%{transform:translate3d(100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInRight{animation-name:slideInRight}@keyframes slideInUp{0%{transform:translate3d(0,100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInUp{animation-name:slideInUp}@keyframes slideOutDown{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,100%,0)}}.slideOutDown{animation-name:slideOutDown}@keyframes slideOutLeft{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(-100%,0,0)}}.slideOutLeft{animation-name:slideOutLeft}@keyframes slideOutRight{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(100%,0,0)}}.slideOutRight{animation-name:slideOutRight}@keyframes slideOutUp{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,-100%,0)}}.slideOutUp{animation-name:slideOutUp}", ""]);
	
	// exports


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1591);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./newtemplate.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./newtemplate.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "*,:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.no_scroll{overflow:hidden}body{padding-top:50px}ul{list-style-type:none}#loading-bar .bar{background-color:#0f2c4d!important}.info_reg{height:526px}.text-center{text-align:center!important}.border-top{margin:9px 0 0;padding:24px 0 0 13px}.printInvoice_input{border:1px solid #ccc}.printInvoice_padding{padding:8px 0 0!important}.scroll_table_container{height:300px;overflow-y:auto}.printed_bill_container div{padding:0}.close_modal{text-decoration:none;position:absolute;right:8px}.refresh{height:56px;width:56px;margin:15px auto;text-align:center;padding:15px 0 0;border-radius:50%;box-shadow:0 0 5px rgba(0,0,0,.3);cursor:pointer}.refresh i{font-size:22px;color:#4285f4}.wrapper{background:#50a3a2;background:-webkit-linear-gradient(top left,#50a3a2 50%,#53e3a6 150%);position:fixed;overflow:hidden;z-index:-1}.bg-bubbles,.wrapper{top:0;left:0;width:100%;height:100%}.bg-bubbles{position:absolute;z-index:1}.bg-bubbles li{position:absolute;list-style:none;display:block;width:40px;height:40px;background-color:hsla(0,0%,100%,.15);bottom:-160px;-webkit-animation:square 25s infinite;animation:square 25s infinite;-webkit-transition-timing-function:linear;transition-timing-function:linear}.bg-bubbles li:first-child{left:10%}.bg-bubbles li:nth-child(2){left:20%;width:80px;height:80px;-webkit-animation-delay:2s;animation-delay:2s;-webkit-animation-duration:17s;animation-duration:17s}.bg-bubbles li:nth-child(3){left:25%;-webkit-animation-delay:4s;animation-delay:4s}.bg-bubbles li:nth-child(4){left:40%;width:60px;height:60px;-webkit-animation-duration:22s;animation-duration:22s;background-color:hsla(0,0%,100%,.25)}.bg-bubbles li:nth-child(5){left:70%}.bg-bubbles li:nth-child(6){left:80%;width:120px;height:120px;-webkit-animation-delay:3s;animation-delay:3s;background-color:hsla(0,0%,100%,.2)}.bg-bubbles li:nth-child(7){left:32%;width:160px;height:160px;-webkit-animation-delay:7s;animation-delay:7s}.bg-bubbles li:nth-child(8){left:55%;width:20px;height:20px;-webkit-animation-delay:15s;animation-delay:15s;-webkit-animation-duration:40s;animation-duration:40s}.bg-bubbles li:nth-child(9){left:25%;width:10px;height:10px;-webkit-animation-delay:2s;animation-delay:2s;-webkit-animation-duration:40s;animation-duration:40s;background-color:hsla(0,0%,100%,.3)}.bg-bubbles li:nth-child(10){left:90%;width:160px;height:160px;-webkit-animation-delay:11s;animation-delay:11s}@-webkit-keyframes square{0%{-webkit-transform:translateY(0);transform:translateY(0)}to{-webkit-transform:translateY(-700px) rotate(600deg);transform:translateY(-700px) rotate(600deg)}}@keyframes square{0%{-webkit-transform:translateY(0);transform:translateY(0)}to{-webkit-transform:translateY(-700px) rotate(600deg);transform:translateY(-700px) rotate(600deg)}}.label_m{text-align:center}.label_m,.label_verdor{font-weight:700;margin:0}.label_verdor{display:inline-block}.search .field{position:relative}.search label{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAQAAAC1QeVaAAAAxElEQVR4AXXPIUuDcRDA4Zv4AUSwTLEKVoNlySyCYLO98CCsahGrX0AW/QhmBRHEJghLS4JFBBXDgrJi2In78w8v4v3S8XDh4nd0DTxLEzd2RC2EnrH07trQVDrXqbhs7FvfnBDWDKWTigOpL2oWvZpYKPjio1zVHEt7BdOtaLUtHRX8MmqjRjooeCVttPBOWi+4JT1aLaDjVLpU/5ytn840Dj1IaWSpYmi8yVlTF54qh9K8nn27usJK5fC3yvfhPx7a/AE9dYwDEfKrlAAAAABJRU5ErkJggg==) no-repeat 0 50%;color:#b2b2b2;width:150px;left:50%;position:absolute;transform:translate(-50%,-50%);top:50%;transition:left .4s,transform .4s;padding-left:1.25em}.search .input-search{border:1px solid #dfdfdf;border-radius:4px;display:block;font:400 1em/1.5em sans-serif;padding:.5em 1.75em;width:100%}.search .input-search:focus+label,.search .input-search:valid+label{left:.5em;transform:translateY(-50%)}.search .input-search:valid+label{text-indent:-9999px}.form .input_py{border-right:0;border-left:0}.pi_checkbox:checked,.pi_checkbox:not(:checked){position:absolute;left:-9999px}.pi_checkbox:checked+label,.pi_checkbox:not(:checked)+label{position:relative;padding-left:1.95em;cursor:pointer}.pi_checkbox:checked+label:before,.pi_checkbox:not(:checked)+label:before{content:\"\";position:absolute;left:0;top:0;width:1.25em;height:1.25em;border:2px solid #ccc;background:#fff;border-radius:4px;box-shadow:inset 0 1px 3px rgba(0,0,0,.1)}.pi_checkbox:checked+label:after,.pi_checkbox:not(:checked)+label:after{content:\"\\2714\";position:absolute;top:.1em;left:1px;font-size:1.3em;line-height:.8;color:#123b52;transition:all .2s}.pi_checkbox:not(:checked)+label:after{opacity:0;transform:scale(0)}.pi_checkbox:checked+label:after{opacity:1;transform:scale(1)}.showlogo_container{width:50%;margin:0 auto;overflow:hidden}.showlogo_container img{width:100%}.margin-top{margin-top:15px}.margin-bottom{margin-bottom:15px;display:inline-block}.label_show{display:none}.no_padding{padding:0}.app_logo{width:180px}.headerbar{height:80px;background-color:#f8f8f8;border:0}.user_access,.user_info{float:right}.user_info{width:60px;height:60px;border-radius:50%;background:#123b52;margin:12px 0 0}.user_info i{color:#fff;text-align:center;font-size:40px;padding:8px 0 0 16px}.bell_notification{float:right;margin:12px 0 0}.bell_notification i{color:#123b52;text-align:center;font-size:35px;padding:12px 10px 0 0}.bell_non{float:right;margin:12px 0 0}.bell_non i{color:#9e9e9e;text-align:center;font-size:35px;padding:12px 10px 0 0}.user_basic_infos{margin-top:26px;font-weight:700;margin-right:11px;color:#069;width:125px;line-height:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.nav_circle_logo{text-align:center;margin:20px 0 0}.nav-sidebar{margin-right:-21px;margin-bottom:20px;margin-left:-20px}.nav-sidebar>li>a{padding-right:20px;padding-left:5px}.nav-sidebar li a{color:#fff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.nav-sidebar li{text-indent:5px;line-height:30px}.nav-sidebar li.active a,.nav-sidebar li a:active,.nav-sidebar li a:focus,.nav-sidebar li a:hover{background:hsla(0,0%,100%,.25);color:#fff;text-decoration:none}.subnavegador>li.active,.subnavegador>li:hover{background:#123b52!important;color:#fff;text-decoration:none;cursor:pointer;border-left:2px solid #fff}.fadeIn.ng-hide{-webkit-animation:fadeOut 1s;animation:fadeOut 1s;display:block!important}.subnavegador{padding:0 0 0 10px;background:#082333}.subnavegador>li{padding:0}.subnavegador>li a{margin:0;display:block;width:100%;height:100%}.main{padding:20px}.main .page-header{margin-top:0}.btn_py{background:#2196f3}.btn,.btn_py{transition:.3s ease-out}.btn-secondary{width:100%}.btn-secondary:hover{background:#b3b3b3}.user_drop{top:80px}.user_drop:after{border:10px solid transparent;border-bottom-color:#123b52;content:\"\";display:block;height:0;right:22px;position:absolute;top:-21px;width:0}.manageable_height{height:500px;overflow-y:auto}.bell_drop{top:80px;left:-119px;width:270px}.bell_drop>li>a{white-space:normal}.bell_drop:after{border:10px solid transparent;border-bottom-color:#123b52;content:\"\";s:block;height:0;left:125px;position:absolute;top:-21px;width:0}.search_container{padding:0 15px}input:read-only{background-color:#fff!important}@media only screen and (max-width:425px){.moment-picker{left:-webkit-calc(50% - 100px)!important}.moment-picker .moment-picker-container:after,.moment-picker .moment-picker-container:before{display:none!important}}.sidebar_custom{position:fixed;top:51px;width:220px;bottom:0;left:0;z-index:1000;display:flex;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;flex-direction:column;-ms-flex-direction:column;-webkit-flex-direction:column;padding:20px 0 0;overflow-x:hidden;overflow-y:auto;background-color:#123b52;border-right:1px solid #eee;transition:.5s ease-out}.sidebar_custom i img{width:35px}.sidebar_custom i{padding:0 15px 0 0}.Tabs{position:relative;background-color:#fff;margin:0;padding:0;list-style:none}.Tabs:after{content:\" \";display:table;clear:both}.Tabs__tab{float:left;width:33.333%;text-align:center}.Tabs__tab:first-child.active~.Tabs__presentation-slider{left:0}.Tabs__tab:nth-child(2).active~.Tabs__presentation-slider{left:33.333%}.Tabs__tab:nth-child(3).active~.Tabs__presentation-slider{left:66.666%}.Tabs__presentation-slider{position:absolute;bottom:0;left:0;width:33.333%;height:4px;background-color:#2196f3;-webkit-transition:left .25s;transition:left .25s}.Tab{font-family:Roboto Slab}.Tab>a{display:block;padding:10px 12px;text-decoration:none;color:#666;-webkit-transition:color .15s;transition:color .15s}.Tab.active>a{background:#f6f6f6}.Tab:hover>a{color:#222}.company_information{padding:25px 15px 10px!important}.btn-tertiary{color:#555;padding:0;line-height:32px;width:auto;display:block;border:1px solid #ccc}.btn-tertiary:focus,.btn-tertiary:hover{color:#888;border-color:#888}.input_file{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.input_file+labelFile{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:0 10px;cursor:pointer}.input_file+.labelFile .icon:before{content:\"\\F093\"}.input_file+.labelFile.has-file .icon:before{content:\"\\F00C\";color:#5aac7b}.display_logo_company{float:right}.icon_relative{position:relative!important}.user_language_icon .dropdown{display:inline-block}.user_language_icon{transition:all .3s}.language_drop a{padding:9px 10px 9px 8px!important;cursor:pointer}.language_active{background:#eee}.language_active a:after{content:\"\\F00C\";font-family:FontAwesome;color:#000;font-weight:700;cursor:pointer;margin:0 0 0 5px}.user_language i{color:#fff;text-align:center;font-size:40px;cursor:pointer}.user_language_icon a:hover{background:none;color:#fff;border:0}.language_drop{min-width:auto;top:-130px;left:-10px}.mt-1{margin-top:1rem}.mt-2{margin-top:2rem}.mt-3{margin-top:3rem}.mr-1{margin-right:1rem}.mr-2{margin-right:2rem}.mr-3{margin-right:3rem}.ml-1{margin-left:1rem}.ml-2{margin-left:2rem}.ml-3{margin-left:3rem}.mb-1{margin-bottom:1rem}.mb-2{margin-bottom:2rem}.mb-3{margin-bottom:3rem}.bagforpay a{font-size:14px;text-decoration:none;color:#fff}.b-0{border:0!important}.w-100{width:100%}.no_padding_left{padding-left:0!important}.no_padding_right{padding-right:0!important}.padding_left{padding-left:15px!important}.padding_right{padding-right:15px!important}.date-printed{padding:0 15px!important}.analyser_margin{margin:10px 0}.grup_btn{text-align:right}@media (min-width:1316px){.main{padding-right:30px;padding-left:0}}@media (min-width:768px){.btn-secondary{width:auto}.label_show{display:block}}@media (max-width:321px){.bell_drop{left:-68px}.bell_drop:after{left:75px}}.clickable,.clickable a{cursor:pointer}.clickable a{width:194px;overflow:hidden;text-overflow:ellipsis}.clickable:hover{background-color:#fafafa}input.disabled{background-color:#dfdfdf}@media screen{.show-on-print{display:none}}#loading-bar .bar{height:.3em;background-color:#5cb85c;border-color:#5cb85c}", ""]);
	
	// exports


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1593);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./mobile.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./mobile.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "@media only screen and (max-width:320px){.create-account{float:none!important}.jump_formlogin{display:block}.form-signin{padding:30px 15px 25px}.display_logo_company{float:none}}@media only screen and (max-width:425px){.form-signin{margin:0 auto}.display_logo_company{float:none}.account_tab{font-size:20px!important}}.try_table{width:100%}@media only screen and (max-width:992px){.account_tab{font-size:30px}.navbar-brand{display:none}.main{padding:10px 15px 0!important}.sidebar_custom_m{left:-400px;transition:.5s ease-out}.nav-sidebar>li>a{padding-left:5px}.subnavegador{padding:0 0 0 25px}.search{padding:0;margin-bottom:8px}.search label{left:56%}.pi-circle-menu{width:160px;margin:0 auto}.menu-icon{margin:21px 0 0 10px;width:35px;display:inline-block;cursor:pointer}.menu-icon .menu-icon-line,.menu-icon:after,.menu-icon:before{border-radius:3px;background:#123b52;content:\"\";display:block;height:4px;margin:6px 0;width:100%;-webkit-transition:all .25s ease;transition:all .25s ease}.effect1:after{-webkit-transform:translateY(-11px) rotate(225deg);transform:translateY(-11px) rotate(225deg)}.effect1 .menu-icon-line{-webkit-transform:rotate(180deg);transform:rotate(180deg);opacity:0}.effect1:before{-webkit-transform:translateY(8px) rotate(135deg);transform:translateY(8px) rotate(135deg)}.user_time{font-size:85%}.user_info{width:50px;height:50px;margin:15px 0 0}.user_info i{font-size:30px;padding:10px 0 0 14px}.user_drop{top:75px;left:-10px}.info_reg{height:auto}.upload_file{float:none!important}.table>tbody>tr>td{padding:8px 3px;border:1px solid #ddd}form.visible-xs button{width:100%;margin-top:10px}.fixed-table-container{margin:0}.table thead{display:none}.table tr{margin-bottom:10px;display:block;border-bottom:2px solid #ddd}.table td{display:block;text-align:right!important;font-size:13px;border-bottom:1px dotted #ccc}.table td:last-child{border-bottom:0}.table td:before{content:attr(data-label);float:left;text-transform:uppercase;font-weight:700}.table tfoot tr{margin-bottom:10px;display:block;border-bottom:2px solid #ddd}.table tfoot th{display:block;text-align:right!important;font-size:13px;border-bottom:1px dotted #ccc}.table tfoot th:last-child{border-bottom:0}.table tfoot th:before{content:attr(data-label);float:left;text-transform:uppercase;font-weight:700}td strong{float:left}.table_graund{background:#eee}.detail_table{width:100%}.columns-right{margin-bottom:20px;padding-left:4%}.columns,.columns-right{float:none!important;margin-left:0;padding-right:0;display:inline-block}.no_padding{padding:0}.bs-checkbox{width:100%}.user_drop:after{right:18px}.menu-acordion{margin-top:20px}}@media only screen and (max-width:425px){.moment-picker{left:-webkit-calc(50% - 100px)!important}.moment-picker .moment-picker-container:after,.moment-picker .moment-picker-container:before{display:none!important}}@media only screen and (max-width:1200px){.main{padding-left:50px}}", ""]);
	
	// exports


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1595);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./printstyle.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./printstyle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".Section_Print{display:none}.logo_invoice{margin:0 0 10px;padding:10px;display:inline-block;float:right}.logo_invoice img{width:115px;margin:0 0 10px}.Powered{display:inline-block;margin:30px 0 10px;padding:10px}.Powered span{color:#123b52;font-weight:700}.print_separator{width:100%;display:inline-block;float:right;border-bottom:solid}.tableforprint tr td hr{margin:2px 0}.tableforprint tr td{border-top:0!important}", ""]);
	
	// exports


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1597);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./overlay.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./overlay.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "#ng-loading-overlay{background:hsla(0,0%,100%,.5)!important}#ng-hide-remove.ng-hide-remove,#ng-loading-overlay.ng-show{display:block!important}#ng-loading-overlay.ng-hide{opacity:0}#ng-loading-overlay.ng-hide-add,#ng-loading-overlay.ng-hide-remove{transition:all .4s linear}", ""]);
	
	// exports


/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	module.exports = {"Acciones":"Actions","Actualizar":"Update","Administrador":"Administrator","Administradoras":"Administrators","Administrar Usuarios":"Administrate Users","Agrupado por":"Grouped by","Analizador de Archivos":"File Analyzer","Asociar":"Associate","Asociar colector":"Associate collectpor","Atendida por":"Attended by","Atendido por":"Attended by","Ayer":"Yesterday","Backups":"Backups","Broken":"Broken","Buscar":"Search","Cajero":"Cashier","Camarero":"Waiter","Cambiar Nombre":"Rename","Cancelaciones":"Cancellations","Cancelar":"Cancel","Cantidad":"Quantity","Cantidad Cancelada":"Quantity Cancelled","Cantidad Devuelta":"Quantity Returned","Cantidad Facturada":"Quantity Billed","Cantidad Total":"Total Quantity","Carga de archivos de backup":"Upload backups","Carga de Archivos de Backup":"Upload Backups","Carga de Archivos DTT":"Upload DTTs","Cargar Backups":"Upload backups","Cargar DTT":"Upload DTTs","Categoria":"Category","Cerrar":"Close","Cierre diario":"Daily closing","Ciudad":"City","Colectar":"Collect","Colector":"Collector","Colectores":"Collectors","Comensales":"Diners","Control de Cuentas":"Account Control","Correo":"Mail","Correo Electronico":"Email","Crear":"Create","Crear administrador":"Create administrator","Crear cuenta":"Create account","Crear Cuenta":"Create Acccount","Crear nueva cuenta":"Create Acccount","Crear Punto de Venta":"Create point of sales","Dashboard":"Dashboard","Datos":"Data","De":"From","De la Factura":"Of Bill","Descuento":"Discount","Descuento Facturado":"Billed Discount","Desde":"From","Detalle de Factura":"Bill Detail","Detalles":"Details","Dtts":"DTTs","DTTs":"DTTs","Editar":"Edit","Editar colector":"Edit collector","Editar NCF":"Edit NCF","Editar Punto de Venta":"Edit Point of Sales","Efectivo":"Effective","Eliminar":"Delete","Eliminar seleccionados":"Delete selected","Email":"Email","Email del usuario":"User email","Emitido a":"Emitted to","Enlaza tu cuenta":"Link your account","Enviar":"Send","Error 404":"404 Error","Estado":"State","Exoneracion":"Exemption","Exoneracion IVA":"Tax Exemption","Exportar":"Export","Exportar CSV":"Export CSV","Factura":"Bill","Facturas impresas":"Printed bills","Facturas sin cerrar":"Unclosed bills","Familia":"Family","Fecha":"Date","Fecha desde":"Date from","Fecha hasta":"Date to","Filas visible":"Visible row","Filas visibles":"Visible rows","Filtrado por":"Filtered by","Filtrar backups":"Filter backups","Filtrar dtts":"Filter DTTs","Filtrar facturas":"Filter bills","Filtrar ncf":"Fiter NCF","Filtrar POS":"Filter POS","Filtrar usuarios":"Filter users","Generar colector":"Generate collectors","Generar reporte":"Generate reports","Hasta":"From","Hora":"Hour","Hora de Corte":"Closing hour","Horario de Cierre":"Closing hour","Hoy":"Today","ID":"ID","Identificador":"ID","Impresora Fiscal":"Fiscal printer","Impuesto IVA":"Sales Tax","Impuestos incluidos":"Included Tax","Ingresa con":"Login with","Invitaciones":"Invitations","Invitaciones pendientes":"Pending invitations","Invitar":"Invite","Invitar nuevo usuario":"Invite new user","Invitar Usuario":"Invite User","Invitar Usuarios":"Invite Users","Ir al inicio":"Go home","IVA":"Sales Tax","Journals colectados":"Collected Journal","Journals Colectados":"Collected Journals","Limpiar":"Clean","Listado de NCFs":"NCFs list","Media":"Average","Media Broken":"Average Broken","Media Cancelaciones":"Average Cancelled","Media Efectivo":"Average effective","Media OTH":"Average OTH","Mensual":"Monthly","Mesa":"Table","Monto":"Amount","NCF":"NCF","Ncf de Facturas":"Bill NCF","Nombre":"Name","Nombre de Cuenta":"Account Name","Nombre de la cuenta":"Account Name","Nombre del archivo":"Filename","Nombre del usuario":"User name","Nombre POS":"POS name","No procesado":"Unprocessed","Notas":"Notes","Nuevo colector":"New collector","Operativas":"Operative","OTH":"OTH","Pax":"Pax","Perfiles":"Profiles","Permisos de":"Permissions assigned to","Por Fecha":"By date","Por Hora":"By hour","Por Monto":"By amount","Por producto":"By product","POS":"POS","Precio":"Price","Procesado":"Processed","Procesar":"Process","Procesar DTTs":"Process DTTs","Producto":"Product","Propina":"Gratuity","Propina extra":"Gratuity","Propina Extra":"Gratuity","Puerto":"Port","Puntos de venta":"Point of sales","Puntos de Ventas":"Points of sale","Referencia":"Reference","Registrar colector":"Register colector","Registrarme":"Register","Registrar nuevo NCF":"Register new NCF","Registrar Nuevo NCF":"Register new NCF","Registrar nuevo POS":"Register new POS","Registrar Punto de Venta":"Register POS","Registrate":"Register","Registrate con":"Register using","Reiniciar":"Reset","Renombrado":"Rename","Reporte de Ventas":"Sales Report","Reportes":"Reports","Reporte Z":"Z Report","Resultados":"Results","RNC":"RNC","Salir":"Exit","Secuencia":"Sequence","segundos":"seconds","Seleccione Uno":"Select One","Sequencia":"Sequencs","Subido en":"Uploaded on","Subir":"Upload","Subir archivo":"Upload file","Subir backup":"Upload backup","Subir Backups":"Upload Backups","Subir DTT":"Upload DTTs","Subir DTTs":"Upload DTTs","Subtotal":"Subtotal","Telefono":"Phone","Todo":"All","Total":"Total","Total Cancelado":"Total Cancelled","Total Descuento":"Total Discounted","Total Devuelto":"Total Returned","Total Facturado":"Total Billed","Total IVA":"Total Tax","Totalizado por Camarero":"Amounted by Waiter","Totalizado por Categoria":"Amounted by Category","Totalizado por Factura":"Amounted by Bill","Totalizado por fecha":"Amounted by date","Totalizado por Fecha":"Amounted by date","Totalizado por Mesa":"Amounted by table","Totalizado por POS":"Amounted by POS","Total Pax":"Total Diners","Total Propina":"Total Gratuity","Tus archivos subidos":"Your uploaded files","Unid":"Unit","Usted no tiene permiso para ver las ventas":"You do not possess enough permissions to view sales.","Usuario":"User","Usuarios":"Users","Usuarios en esta Cuenta":"Users in this account","VB":"VB","Vendedor":"Seller","Ventas":"Sales","Ventas por Vendedor":"Sales by Seller","Volver":"Return","Volver al inicio":"Go home","Información de cuenta":"Account information","Invitación pendiente de":"Pending invitation from","Ventas por Artículos":"Sales by Article","Desc.s/OTH":"Disc./OTH","Localización de Facturas":"Find Bill(s)","Listado de Artículos":"Article List","Facturas de pago único":"Payment Only Bills","Configuración":"Configuration","Información de Cuenta":"Account Information","Información General":"General Information","Nombre(s)":"Name(s)","Apellido(s)":"Surname(s)","Cambiar Contraseña":"Change Password","Nueva Contraseña":"New Password","Información de la compañía":"Company Information","Identificación":"Identification","Compañía":"Company","Dirección":"Address","Teléfono":"Phone","Guardar Información":"Save","Crea tu Compañía":"Create your Company","Cerrar Sesión":"Log Out","Tamaño":"Size","ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?":"This action cannot be undone. Do you still wish to proceed?","seleccionado(s)":"selected","Órdenes Recientes":"Recent Orders","Usted no tiene permiso para ver las órdenes":"You do not have permission to view recent orders.","Últimos 10 minutos":"Last 10 minutes","Últimos 30 minutos":"Last 30 minutes","Última Hora":"Last hour","Últimas 3 Horas":"Last 3 hours","La dirección no fue encontrada":"Address not found","Su navegador volverá a la página anterior en":"Your browser will go back to the previous page in:","Usted también puedes":"You may also","% Ley":"Service Tax","Total % Ley":"Service Tax Total","Análisis de archivo de impresora fiscal":"Fiscal printer file analysis","Descripción":"Description","¿Esta seguro?":"Are you sure?","Filtrar artículos":"Filter articles","¿Olvidaste tu Contraseña?":"Forgot your password?","Descuentos/OTH":"Discounts/OTH","Totalizado por Categoría":"By Category","Filtrar búsqueda":"Filter","%Ley":"Service Tax","Desc.":"Disc.","Prop.Extra":"Tip","Órdenes":"Orders","No. Factura":"Bill No.","Mesa No.":"Table No.","Acción":"Action","Contraseña":"Password","Confirmar Contraseña":"Confirm Password","Recuperar Contraseña":"Recover Password","Enviar Recuperación":"Send Confirmation","Puntos de Ventas (POS)":"POS (Point of Sales)","Número POS":"POS Number","Sitio del Número":"Site Number","Dirección IP":"IP Address","Número de POS":"POS Number","Número de Sitio POS":"POS Site Number","Número de Puerto":"Port Number","Número de factura":"Bill Number","Seleccione la compañía":"Select the company","Crear Compañía":"Create company","Su contraseña ha sido reestablecida con exito":"Your password has been restored successfully.","Presione volver al inicio para ingresar":"Press go home to enter","Se han enviado intrucciones a":"Instructions have been sent to","para reestablecer tu contraseña, sigue las intrucciones en tu correo":"in order to restore your password. Please check your mail.","Ventas por Categoría":"Sales by Category","Ventas de la categoría":"Sales in category","Ventas del artículo":"Sales by article","Artículo":"Article","Desc. por Artículo":"Disc. per Article","Desc. Facturado":"Disc. Billed","Cantidad OTH/Broken":"OTH/Broken Quantity","Total OTH/Broken":"OTH/Broken Total","Descuento por Artículo":"Disccount per Article","Broken/Lost":"Broken/Lost","Anul. Apres":"Null","Media Anul. Apres":"Average Null","Gráficos":"Charts","Filtrar ventas":"Filter sales","Información":"Information","País":"Country","Código Postal":"Postal Code","NCF de Facturas":"Bill NCF","Cuenta":"Account","Lenguaje":"Language","Idioma":"Language","Seleccione un Idioma":"Select a Language","Español":"Spanish","Inglés":"English","Francés":"French","Cambiar Idioma":"Change Language","Moneda":"Currency","Seleccione una moneda":"Select a currency","Zona horaria":"Timezone","Logo de la Compañía":"Company Logo","Logo":"Logo","Mostrar logo":"Show logo","en cola":"in queue","Totalizado por Vendedor":"Total by Cashier","Seleccionar Compañia":"Select Company","Llave":"Key","ITBIS":"Sales Tax","Entrar":"Enter","Al cierre":"At closing hour","MTD":"MTD","Totales":"Totals","Producto más vendido":"Best seller","Mejor vendedor":"Top seller","Período":"Period","Clientes":"Clients","Promedio":"Average","Exoneración IVA":"Tax Exemption","La direccion de correo electronico no ha sido agregado":null,"Este email ha sido registrado con otro usuario anteriormente":null,"La cuenta ha sido enlazada con Facebook anteriormente":null,"La cuenta ha sido enlazada con Google anteriormente":null,"La cuenta ha sido enlazada con Twitter anteriomente":null,"El usuario ha sido activado previamente":null,"El usuario ha sido desactivado previamente":null,"No tiene invitaciones pendientes":null,"El usuario que intenta agregar ya es parte de esta cuenta":null,"Este usuario len ha sido otorgados derechos administrativos previamente":null,"Este usuario ya no posee derechos administrativos":null,"Toda cuenta debe de tener al menos un usuario administrador":null,"Este usuario ya cuenta con el permiso que intenta asignarle":null,"Handies":null,"Pagos":null,"Método de pago":null,"Tarjetahabiente":null,"Tarjeta":null,"Suscribir":null,"Tarjetas":null,"Detalles del pago pendiente":null,"Descripcion":null,"Unidad":null,"Sub-Total":null,"Registrar nuevo handy":null,"Registrar Handy":null,"Editar Handy":null,"Oops!":null,"Esta cuenta se mantiene inactiva, por favor ponganse en contacto con su administrador.":null,"Filtrar handies":null,"Suscripción":null,"Punto de Ventas":null,"Handy":null,"Pads Remoto":null,"Iniciar Suscripción":null,"Ventas por etiquetas":"Sales by Tag","Materias Primas":"Raw Materials","Su nombre ha sido cambiado exitosamente":"Your name has been successfully changed","Su idioma ha sido cambiado exitosamente":"Your language has been successfully changed","El logo ha sido agregado exitosamente":"Logo successfully added","El logo debe ser en un formato de imagen":"Logo must be a image formate","Cuenta creada exitosamente":"Account created successfully","Ingresos":"Income","VAT":"VAT","Tipo de documento":"Document type","Comprobante":"NCF","RNC Afectado":"RNC affected","Exento de impuestos":"Tax exempted","Cancelado":"Cancelled","Buscar Artículos":"Find articles","Cantidad asociada":"Associated amount","Registrar Materia":"Register material","Existencia":"Existence","Nueva materia":"New material","Editar materia":"Edit material","Ventas por etiqueta":"Sales by tag","Ordenar por categoría":"Order by category","Ordenar por etiqueta":"Order by tag","Categoría":"Category","Etiqueta":"Tag","ACTIVA":"ACTIVE","INACTIVA":"INACTIVE","El Client Key ha sido copiado al portapapeles":"Client key has been copied to the clipboard","Totalizado por Etiqueta":"Amounted by tag"}

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	module.exports = {"Acciones":"Acciones","Actualizar":"Actualizar","Administrador":"Administrador","Administradoras":"Administradoras","Administrar Usuarios":"Administrar Usuarios","Agrupado por":"Agrupado por","Analizador de Archivos":"Analizador de Archivos","Asociar":"Asociar","Asociar colector":"Asociar colector","Atendida por":"Atendida por","Atendido por":"Atendido por","Ayer":"Ayer","Backups":"Backups","Broken":"Broken","Buscar":"Buscar","Cajero":"Cajero","Camarero":"Camarero","Cambiar Nombre":"Cambiar Nombre","Cancelaciones":"Cancelaciones","Cancelar":"Cancelar","Cantidad":"Cantidad","Cantidad Cancelada":"Cantidad Cancelada","Cantidad Devuelta":"Cantidad Devuelta","Cantidad Facturada":"Cantidad Facturada","Cantidad Total":"Cantidad Total","Carga de archivos de backup":"Carga de archivos de backup","Carga de Archivos de Backup":"Carga de Archivos de Backup","Carga de Archivos DTT":"Carga de Archivos DTT","Cargar Backups":"Cargar Backups","Cargar DTT":"Cargar DTT","Categoria":"Categoria","Cerrar":"Cerrar","Cierre diario":"Cierre diario","Ciudad":"Ciudad","Colectar":"Colectar","Colector":"Colector","Colectores":"Colectores","Comensales":"Comensales","Control de Cuentas":"Control de Cuentas","Correo":"Correo","Correo Electronico":"Correo Electronico","Crear":"Crear","Crear administrador":"Crear administrador","Crear cuenta":"Crear cuenta","Crear Cuenta":"Crear Cuenta","Crear nueva cuenta":"Crear nueva cuenta","Crear Punto de Venta":"Crear Punto de Venta","Dashboard":"Dashboard","Datos":"Datos","De":"De","De la Factura":"De la Factura","Descuento":"Descuento","Descuento Facturado":"Descuento Facturado","Desde":"Desde","Detalle de Factura":"Detalle de Factura","Detalles":"Detalles","Dtts":"Dtts","DTTs":"DTTs","Editar":"Editar","Editar colector":"Editar colector","Editar NCF":"Editar NCF","Editar Punto de Venta":"Editar Punto de Venta","Efectivo":"Efectivo","Eliminar":"Eliminar","Eliminar seleccionados":"Eliminar seleccionados","Email":"Email","Email del usuario":"Email del usuario","Emitido a":"Emitido a","Enlaza tu cuenta":"Enlaza tu cuenta","Enviar":"Enviar","Error 404":"Error 404","Estado":"Estado","Exoneracion":"Exoneracion","Exoneracion IVA":"Exoneracion IVA","Exportar":"Exportar","Exportar CSV":"Exportar CSV","Factura":"Factura","Facturas impresas":"Facturas impresas","Facturas sin cerrar":"Facturas sin cerrar","Familia":"Familia","Fecha":"Fecha","Fecha desde":"Fecha desde","Fecha hasta":"Fecha hasta","Filas visible":"Filas visible","Filas visibles":"Filas visibles","Filtrado por":"Filtrado por","Filtrar backups":"Filtrar backups","Filtrar dtts":"Filtrar dtts","Filtrar facturas":"Filtrar facturas","Filtrar ncf":"Filtrar ncf","Filtrar POS":"Filtrar POS","Filtrar usuarios":"Filtrar usuarios","Generar colector":"Generar colector","Generar reporte":"Generar reporte","Hasta":"Hasta","Hora":"Hora","Hora de Corte":"Hora de Corte","Horario de Cierre":"Horario de Cierre","Hoy":"Hoy","ID":"ID","Identificador":"Identificador","Impresora Fiscal":"Impresora Fiscal","Impuesto IVA":"Impuesto IVA","Impuestos incluidos":"Impuestos incluidos","Ingresa con":"Ingresa con","Invitaciones":"Invitaciones","Invitaciones pendientes":"Invitaciones pendientes","Invitar":"Invitar","Invitar nuevo usuario":"Invitar nuevo usuario","Invitar Usuario":"Invitar Usuario","Invitar Usuarios":"Invitar Usuarios","Ir al inicio":"Ir al inicio","IVA":"IVA","Journals colectados":"Journals colectados","Journals Colectados":"Journals Colectados","Limpiar":"Limpiar","Listado de NCFs":"Listado de NCFs","Media":"Media","Media Broken":"Media Broken","Media Cancelaciones":"Media Cancelaciones","Media Efectivo":"Media Efectivo","Media OTH":"Media OTH","Mensual":"Mensual","Mesa":"Mesa","Monto":"Monto","NCF":"NCF","Ncf de Facturas":"Ncf de Facturas","Nombre":"Nombre","Nombre de Cuenta":"Nombre de Cuenta","Nombre de la cuenta":"Nombre de la cuenta","Nombre del archivo":"Nombre del archivo","Nombre del usuario":"Nombre del usuario","Nombre POS":"Nombre POS","No procesado":"No procesado","Notas":"Notas","Nuevo colector":"Nuevo colector","Operativas":"Operativas","OTH":"OTH","Pax":"Pax","Perfiles":"Perfiles","Permisos de":"Permisos de","Por Fecha":"Por Fecha","Por Hora":"Por Hora","Por Monto":"Por Monto","Por producto":"Por producto","POS":"POS","Precio":"Precio","Procesado":"Procesado","Procesar":"Procesar","Procesar DTTs":"Procesar DTTs","Producto":"Producto","Propina":"Propina","Propina extra":"Propina extra","Propina Extra":"Propina Extra","Puerto":"Puerto","Puntos de venta":"Puntos de venta","Puntos de Ventas":"Puntos de Ventas","Referencia":"Referencia","Registrar colector":"Registrar colector","Registrarme":"Registrarme","Registrar nuevo NCF":"Registrar nuevo NCF","Registrar Nuevo NCF":"Registrar Nuevo NCF","Registrar nuevo POS":"Registrar nuevo POS","Registrar Punto de Venta":"Registrar Punto de Venta","Registrate":"Registrate","Registrate con":"Registrate con","Reiniciar":"Reiniciar","Renombrado":"Renombrado","Reporte de Ventas":"Reporte de Ventas","Reportes":"Reportes","Reporte Z":"Reporte Z","Resultados":"Resultados","RNC":"RNC","Salir":"Salir","Secuencia":"Secuencia","segundos":"segundos","Seleccione Uno":"Seleccione Uno","Sequencia":"Sequencia","Subido en":"Subido en","Subir":"Subir","Subir archivo":"Subir archivo","Subir backup":"Subir backup","Subir Backups":"Subir Backups","Subir DTT":"Subir DTT","Subir DTTs":"Subir DTTs","Subtotal":"Subtotal","Telefono":"Telefono","Todo":"Todo","Total":"Total","Total Cancelado":"Total Cancelado","Total Descuento":"Total Descuento","Total Devuelto":"Total Devuelto","Total Facturado":"Total Facturado","Total IVA":"Total IVA","Totalizado por Camarero":"Totalizado por Camarero","Totalizado por Categoria":"Totalizado por Categoria","Totalizado por Factura":"Totalizado por Factura","Totalizado por fecha":"Totalizado por fecha","Totalizado por Fecha":"Totalizado por Fecha","Totalizado por Mesa":"Totalizado por Mesa","Totalizado por POS":"Totalizado por POS","Total Pax":"Total Pax","Total Propina":"Total Propina","Tus archivos subidos":"Tus archivos subidos","Unid":"Unid","Usted no tiene permiso para ver las ventas":"Usted no tiene permiso para ver las ventas","Usuario":"Usuario","Usuarios":"Usuarios","Usuarios en esta Cuenta":"Usuarios en esta Cuenta","VB":"VB","Vendedor":"Vendedor","Ventas":"Ventas","Ventas por Vendedor":"Ventas por Vendedor","Volver":"Volver","Volver al inicio":"Volver al inicio","Información de cuenta":"Información de cuenta","Invitación pendiente de":"Invitación pendiente de","Ventas por Artículos":"Ventas por Artículos","Desc.s/OTH":"Desc.s/OTH","Localización de Facturas":"Localización de Facturas","Listado de Artículos":"Listado de Artículos","Facturas de pago único":"Facturas de pago único","Configuración":"Configuración","Información de Cuenta":"Información de Cuenta","Información General":"Información General","Nombre(s)":"Nombre(s)","Apellido(s)":"Apellido(s)","Cambiar Contraseña":"Cambiar Contraseña","Nueva Contraseña":"Nueva Contraseña","Información de la compañía":"Información de la compañía","Identificación":"Identificación","Compañía":"Compañía","Dirección":"Dirección","Teléfono":"Teléfono","Guardar Información":"Guardar Información","Crea tu Compañía":"Crea tu Compañía","Cerrar Sesión":"Cerrar Sesión","Tamaño":"Tamaño","ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?":"ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?","seleccionado(s)":"seleccionado(s)","Órdenes Recientes":"Órdenes Recientes","Usted no tiene permiso para ver las órdenes":"Usted no tiene permiso para ver las órdenes","Últimos 10 minutos":"Últimos 10 minutos","Últimos 30 minutos":"Últimos 30 minutos","Última Hora":"Última Hora","Últimas 3 Horas":"Últimas 3 Horas","La dirección no fue encontrada":"La dirección no fue encontrada","Su navegador volverá a la página anterior en":"Su navegador volverá a la página anterior en","Usted también puedes":"Usted también puedes","% Ley":"% Ley","Total % Ley":"Total % Ley","Análisis de archivo de impresora fiscal":"Análisis de archivo de impresora fiscal","Descripción":"Descripción","¿Esta seguro?":"¿Esta seguro?","Filtrar artículos":"Filtrar artículos","¿Olvidaste tu Contraseña?":"¿Olvidaste tu Contraseña?","Descuentos/OTH":"Descuentos/OTH","Totalizado por Categoría":"Totalizado por Categoría","Filtrar búsqueda":"Filtrar búsqueda","%Ley":"%Ley","Desc.":"Desc.","Prop.Extra":"Prop.Extra","Órdenes":"Órdenes","No. Factura":"No. Factura","Mesa No.":"Mesa No.","Acción":"Acción","Contraseña":"Contraseña","Confirmar Contraseña":"Confirmar Contraseña","Recuperar Contraseña":"Recuperar Contraseña","Enviar Recuperación":"Enviar Recuperación","Puntos de Ventas (POS)":"Puntos de Ventas (POS)","Número POS":"Número POS","Sitio del Número":"Sitio del Número","Dirección IP":"Dirección IP","Número de POS":"Número de POS","Número de Sitio POS":"Número de Sitio POS","Número de Puerto":"Número de Puerto","Número de factura":"Número de factura","Seleccione la compañía":"Seleccione la compañía","Crear Compañía":"Crear Compañía","Su contraseña ha sido reestablecida con exito":"Su contraseña ha sido reestablecida con exito","Presione volver al inicio para ingresar":"Presione volver al inicio para ingresar","Se han enviado intrucciones a":"Se han enviado intrucciones a","para reestablecer tu contraseña, sigue las intrucciones en tu correo":"para reestablecer tu contraseña, sigue las intrucciones en tu correo","Ventas por Categoría":"Ventas por Categoría","Ventas de la categoría":"Ventas de la categoría","Ventas del artículo":"Ventas del artículo","Artículo":"Artículo","Desc. por Artículo":"Desc. por Artículo","Desc. Facturado":"Desc. Facturado","Cantidad OTH/Broken":"Cantidad OTH/Broken","Total OTH/Broken":"Total OTH/Broken","Descuento por Artículo":"Descuento por Artículo","Broken/Lost":"Broken/Lost","Anul. Apres":"Anul. Apres","Media Anul. Apres":"Media Anul. Apres","Gráficos":"Gráficos","Filtrar ventas":"Filtrar ventas","Información":"Información","País":"País","Código Postal":"Código Postal","NCF de Facturas":"NCF de Facturas","Cuenta":"Cuenta","Lenguaje":"Lenguaje","Idioma":"Idioma","Seleccione un Idioma":"Seleccione un Idioma","Español":"Español","Inglés":"Inglés","Francés":"Francés","Cambiar Idioma":"Cambiar Idioma","Moneda":"Moneda","Seleccione una moneda":"Seleccione una moneda","Zona horaria":"Zona horaria","Logo de la Compañía":"Logo de la Compañía","Logo":"Logo","Mostrar logo":"Mostrar logo","en cola":"en cola","Totalizado por Vendedor":"Totalizado por Vendedor","Seleccionar Compañia":"Seleccionar Compañia","Llave":"Llave","ITBIS":"ITBIS","Entrar":"Entrar","Al cierre":"Al cierre","MTD":"MTD","Totales":"Totales","Producto más vendido":"Producto más vendido","Mejor vendedor":"Mejor vendedor","Período":"Período","Clientes":"Clientes","Promedio":"Promedio","Exoneración IVA":"Exoneración IVA","La direccion de correo electronico no ha sido agregado":"La direccion de correo electronico no ha sido agregado","Este email ha sido registrado con otro usuario anteriormente":"Este email ha sido registrado con otro usuario anteriormente","La cuenta ha sido enlazada con Facebook anteriormente":"La cuenta ha sido enlazada con Facebook anteriormente","La cuenta ha sido enlazada con Google anteriormente":"La cuenta ha sido enlazada con Google anteriormente","La cuenta ha sido enlazada con Twitter anteriomente":"La cuenta ha sido enlazada con Twitter anteriomente","El usuario ha sido activado previamente":"El usuario ha sido activado previamente","El usuario ha sido desactivado previamente":"El usuario ha sido desactivado previamente","No tiene invitaciones pendientes":"No tiene invitaciones pendientes","El usuario que intenta agregar ya es parte de esta cuenta":"El usuario que intenta agregar ya es parte de esta cuenta","Este usuario len ha sido otorgados derechos administrativos previamente":"Este usuario len ha sido otorgados derechos administrativos previamente","Este usuario ya no posee derechos administrativos":"Este usuario ya no posee derechos administrativos","Toda cuenta debe de tener al menos un usuario administrador":"Toda cuenta debe de tener al menos un usuario administrador","Este usuario ya cuenta con el permiso que intenta asignarle":"Este usuario ya cuenta con el permiso que intenta asignarle","Handies":"Handies","Ventas por etiquetas":"Ventas por etiquetas","Materias Primas":"Materias Primas","Su nombre ha sido cambiado exitosamente":"Su nombre ha sido cambiado exitosamente","Su idioma ha sido cambiado exitosamente":"Su idioma ha sido cambiado exitosamente","El logo ha sido agregado exitosamente":"El logo ha sido agregado exitosamente","El logo debe ser en un formato de imagen":"El logo debe ser en un formato de imagen","Cuenta creada exitosamente":"Cuenta creada exitosamente","Pagos":"Pagos","Método de pago":"Método de pago","Tarjetahabiente":"Tarjetahabiente","Tarjeta":"Tarjeta","Suscribir":"Suscribir","Tarjetas":"Tarjetas","Detalles del pago pendiente":"Detalles del pago pendiente","Descripcion":"Descripcion","Unidad":"Unidad","Sub-Total":"Sub-Total","VAT":"VAT","Registrar nuevo handy":"Registrar nuevo handy","Registrar Handy":"Registrar Handy","Editar Handy":"Editar Handy","Oops!":"Oops!","Esta cuenta se mantiene inactiva, por favor ponganse en contacto con su administrador.":"Esta cuenta se mantiene inactiva, por favor ponganse en contacto con su administrador.","Filtrar handies":"Filtrar handies","Totalizado por Etiqueta":"Totalizado por Etiqueta","Suscripción":"Suscripción","Punto de Ventas":"Punto de Ventas","Handy":"Handy","Pads Remoto":"Pads Remoto","Iniciar Suscripción":"Iniciar Suscripción","El Client Key ha sido copiado al portapapeles":"El Client Key ha sido copiado al portapapeles","Ingresos":"Ingresos","Tipo de documento":"Tipo de documento","Comprobante":"Comprobante","RNC Afectado":"RNC Afectado","Exento de impuestos":"Exento de impuestos","Cancelado":"Cancelado","Buscar Artículos":"Buscar Artículos","Cantidad asociada":"Cantidad asociada","Registrar Materia":"Registrar Materia","Existencia":"Existencia","Nueva materia":"Nueva materia","Editar materia":"Editar materia","Ventas por etiqueta":"Ventas por etiqueta","Ordenar por categoría":"Ordenar por categoría","Ordenar por etiqueta":"Ordenar por etiqueta","Categoría":"Categoría","Etiqueta":"Etiqueta","ACTIVA":"ACTIVA","INACTIVA":"INACTIVA"}

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	module.exports = {"Información de cuenta":null,"Salir":null,"Invitación pendiente de":null,"Reportes":null,"Ventas":null,"Ventas por Artículos":null,"Desc.s/OTH":null,"Localización de Facturas":null,"Listado de Artículos":null,"Ventas por Vendedor":null,"Facturas sin cerrar":null,"Facturas de pago único":null,"Cierre diario":null,"Facturas impresas":null,"Impresora Fiscal":null,"NCF de Facturas":null,"Analizador de Archivos":null,"Reporte Z":null,"Datos":null,"Backups":null,"Dtts":null,"Journals Colectados":null,"Configuración":null,"Puntos de Ventas":null,"Colectores":null,"Horario de Cierre":null,"Administrar Usuarios":null,"Invitar Usuarios":null,"Hora de Corte":null,"Actualizar":null,"Cancelar":null,"Invitar Usuario":null,"Email":null,"Enviar":null,"Usuarios en esta Cuenta":null,"Nombre":null,"Correo Electronico":null,"Usuario":null,"Cuenta":null,"Información General":null,"Nombre(s)":null,"Apellido(s)":null,"Cambiar Nombre":null,"Lenguaje":null,"Idioma":null,"Seleccione un Idioma":null,"Español":null,"Inglés":null,"Francés":null,"Cambiar Idioma":null,"Cambiar Contraseña":null,"Nueva Contraseña":null,"Enlaza tu cuenta":null,"Información de la compañía":null,"Identificación":null,"Compañía":null,"Dirección":null,"Teléfono":null,"País":null,"Moneda":null,"Seleccione una moneda":null,"Zona horaria":null,"Guardar Información":null,"Logo de la Compañía":null,"Logo":null,"Mostrar logo":null,"Crear nueva cuenta":null,"Nombre de Cuenta":null,"Crear Cuenta":null,"Invitaciones pendientes":null,"Crea tu Compañía":null,"Crear":null,"Cerrar Sesión":null,"Subir Backups":null,"Eliminar seleccionados":null,"Filtrar backups":null,"Renombrado":null,"Subido en":null,"Tamaño":null,"Acciones":null,"ADVERTENCIA! Esta acción no es reversible, ¿está seguro que desea continuar?":null,"Carga de Archivos de Backup":null,"Cargar Backups":null,"seleccionado(s)":null,"Tus archivos subidos":null,"Nombre del archivo":null,"Subir":null,"Reiniciar":null,"Journals colectados":null,"Procesar":null,"No procesado":null,"Procesado":null,"Filtrar dtts":null,"Registrar colector":null,"Colectar":null,"Puntos de venta":null,"Estado":null,"Editar":null,"Eliminar":null,"Nuevo colector":null,"Editar colector":null,"Identificador":null,"Dashboard":null,"Órdenes Recientes":null,"Filtrado por":null,"Todo":null,"Mesa":null,"Usted no tiene permiso para ver las órdenes":null,"Producto":null,"Precio":null,"Últimos 10 minutos":null,"Últimos 30 minutos":null,"Última Hora":null,"Últimas 3 Horas":null,"Hoy":null,"Ayer":null,"Usted no tiene permiso para ver las ventas":null,"Vendedor":null,"Total":null,"DTTs":null,"Subir DTTs":null,"Carga de Archivos DTT":null,"Cargar DTT":null,"Error 404":null,"La dirección no fue encontrada":null,"Su navegador volverá a la página anterior en":null,"segundos":null,"Usted también puedes":null,"Ir al inicio":null,"Fecha":null,"Factura":null,"Buscar":null,"Desde":null,"Exportar CSV":null,"Filtrar facturas":null,"Hora":null,"NCF":null,"RNC":null,"Descuento":null,"Pax":null,"Propina":null,"% Ley":null,"Impuesto IVA":null,"Total Descuento":null,"Total Pax":null,"Total Propina":null,"Total % Ley":null,"Total IVA":null,"Análisis de archivo de impresora fiscal":null,"en cola":null,"Subir archivo":null,"Mensual":null,"Por Hora":null,"Limpiar":null,"Exportar":null,"Generar reporte":null,"Invitar":null,"Listado de NCFs":null,"Registrar nuevo NCF":null,"Filtrar ncf":null,"Descripción":null,"Secuencia":null,"¿Esta seguro?":null,"Filas visible":null,"Registrar Nuevo NCF":null,"Editar NCF":null,"Sequencia":null,"Filtrar artículos":null,"ID":null,"Referencia":null,"Familia":null,"Ingresa con":null,"¿Olvidaste tu Contraseña?":null,"Registrate":null,"Hasta":null,"Agrupado por":null,"Totalizado por fecha":null,"Totalizado por Camarero":null,"Totalizado por Mesa":null,"Totalizado por Factura":null,"Totalizado por POS":null,"Totalizado por Categoría":null,"Totalizado por Vendedor":null,"Filtrar búsqueda":null,"Categoria":null,"POS":null,"Propina Extra":null,"IVA":null,"Propina extra":null,"%Ley":null,"Cajero":null,"Desc.":null,"Prop.Extra":null,"Filas visibles":null,"Detalle de Factura":null,"Órdenes":null,"Telefono":null,"No. Factura":null,"Detalles":null,"Cantidad":null,"Notas":null,"Subtotal":null,"Comensales":null,"Atendido por":null,"Exoneracion IVA":null,"Emitido a":null,"Mesa No.":null,"Atendida por":null,"Impuestos incluidos":null,"Acción":null,"Camarero":null,"De la Factura":null,"Contraseña":null,"Confirmar Contraseña":null,"Recuperar Contraseña":null,"Enviar Recuperación":null,"Volver al inicio":null,"De":null,"Seleccionar Compañia":null,"Usuarios":null,"Invitar nuevo usuario":null,"Invitaciones":null,"Filtrar usuarios":null,"Administrador":null,"Correo":null,"Permisos de":null,"Puntos de Ventas (POS)":null,"Registrar nuevo POS":null,"Filtrar POS":null,"Nombre POS":null,"Número POS":null,"Sitio del Número":null,"Puerto":null,"Dirección IP":null,"Registrar Punto de Venta":null,"Editar Punto de Venta":null,"Número de POS":null,"Número de Sitio POS":null,"Número de Puerto":null,"Por Fecha":null,"Fecha desde":null,"Fecha hasta":null,"Por Monto":null,"Monto":null,"Por producto":null,"Número de factura":null,"Seleccione la compañía":null,"Crear Compañía":null,"Su contraseña ha sido reestablecida con exito":null,"Presione volver al inicio para ingresar":null,"Registrate con":null,"Registrarme":null,"Se han enviado intrucciones a":null,"para reestablecer tu contraseña, sigue las intrucciones en tu correo":null,"Ventas por Categoría":null,"Ventas de la categoría":null,"Ventas del artículo":null,"Artículo":null,"Cantidad Total":null,"Cantidad Facturada":null,"Total Facturado":null,"Desc. por Artículo":null,"Desc. Facturado":null,"Cantidad OTH/Broken":null,"Total OTH/Broken":null,"Cantidad Cancelada":null,"Total Cancelado":null,"Cantidad Devuelta":null,"Total Devuelto":null,"Exoneracion":null,"Descuento por Artículo":null,"Descuento Facturado":null,"Llave":null,"ITBIS":null,"Cancelaciones":null,"OTH":null,"Broken/Lost":null,"Anul. Apres":null,"Efectivo":null,"Unid":null,"Broken":null,"VB":null,"Media":null,"Media Cancelaciones":null,"Media OTH":null,"Media Broken":null,"Media Anul. Apres":null,"Media Efectivo":null,"Reporte de Ventas":null,"Totalizado por Fecha":null,"Totalizado por Categoria":null,"Gráficos":null,"Resultados":null,"Filtrar ventas":null,"Control de Cuentas":null,"Operativas":null,"Administradoras":null,"Volver":null,"Información":null,"Ciudad":null,"Código Postal":null,"Asociar colector":null,"Crear Punto de Venta":null,"Subir backup":null,"Subir DTT":null,"Procesar DTTs":null,"Perfiles":null,"Crear administrador":null,"Nombre de la cuenta":null,"Email del usuario":null,"Nombre del usuario":null,"Crear cuenta":null,"Colector":null,"Seleccione Uno":null,"Asociar":null,"Cerrar":null,"Generar colector":null,"Carga de archivos de backup":null,"Entrar":null,"Al cierre":null,"MTD":null,"Totales":null,"Producto más vendido":null,"Mejor vendedor":null,"Período":null,"Clientes":null,"Promedio":null,"Exoneración IVA":null,"La direccion de correo electronico no ha sido agregado":null,"Este email ha sido registrado con otro usuario anteriormente":null,"La cuenta ha sido enlazada con Facebook anteriormente":null,"La cuenta ha sido enlazada con Google anteriormente":null,"La cuenta ha sido enlazada con Twitter anteriomente":null,"El usuario ha sido activado previamente":null,"El usuario ha sido desactivado previamente":null,"No tiene invitaciones pendientes":null,"El usuario que intenta agregar ya es parte de esta cuenta":null,"Este usuario len ha sido otorgados derechos administrativos previamente":null,"Este usuario ya no posee derechos administrativos":null,"Toda cuenta debe de tener al menos un usuario administrador":null,"Este usuario ya cuenta con el permiso que intenta asignarle":null,"Handies":null,"Ventas por etiquetas":null,"Materias Primas":null,"Su nombre ha sido cambiado exitosamente":null,"Su idioma ha sido cambiado exitosamente":null,"El logo ha sido agregado exitosamente":null,"El logo debe ser en un formato de imagen":null,"Cuenta creada exitosamente":null,"Pagos":null,"Método de pago":null,"Tarjetahabiente":null,"Tarjeta":null,"Suscribir":null,"Tarjetas":null,"Detalles del pago pendiente":null,"Descripcion":null,"Unidad":null,"Sub-Total":null,"Ingresos":null,"VAT":null,"Registrar nuevo handy":null,"Registrar Handy":null,"Editar Handy":null,"Oops!":null,"Esta cuenta se mantiene inactiva, por favor ponganse en contacto con su administrador.":null,"Filtrar handies":null,"Totalizado por Etiqueta":null,"Etiqueta":null,"Suscripción":null,"Punto de Ventas":null,"Handy":null,"Pads Remoto":null,"Iniciar Suscripción":null,"ACTIVA":null,"INACTIVA":null,"El Client Key ha sido copiado al portapapeles":null,"Tipo de documento":null,"Comprobante":null,"RNC Afectado":null,"Exento de impuestos":null,"Cancelado":null,"Buscar Artículos":null,"Cantidad asociada":null,"Registrar Materia":null,"Existencia":null,"Nueva materia":null,"Editar materia":null,"Ventas por etiqueta":null,"Ordenar por categoría":null,"Ordenar por etiqueta":null,"Categoría":null}

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js